import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {environment} from 'environments/environment';
import {FlatpickrOptions, Ng2FlatpickrComponent} from 'ng2-flatpickr';
import * as feather from 'feather-icons';
import {HeaderService} from 'app/services/header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Address, Client, Email, Telephone} from '../../../../models/client';
import {Fournisseur} from '../../../../models/fournisseur';
import {Item} from '../../../../models/Item';
import {TvaSummary} from '../../../../models/TvaSummary';
import {ProjetService} from '../../../../services/projet.service';
import {AjoutProjetComponent} from '../../../parametre/project-parametre/ajout-projet/ajout-projet.component';
import {FournisseurService} from '../../../../services/Fournisseur/fournisseur.service';
import {AddFournissComponent} from '../add-fourniss/add-fourniss.component';
import {ProductsService} from '../../../../services/products/products.service';
import {Product} from '../../../../models/Product';
import {Tva, TvaService} from '../../../parametre/taxe-tva/parametre-tva/tva.service';
import {CategorieService} from '../../../../services/categorie-unite-marque/categorie.service';
import {MarqueService} from '../../../../services/categorie-unite-marque/marque.service';
import {UniteService} from '../../../../services/categorie-unite-marque/unite.service';
import {Categorie} from '../../../../models/categorie';
import {Marque} from '../../../../models/marque';
import {Unite} from '../../../../models/Unite';
import {ClientService} from '../../../../services/Client/client.service';
import {AddClientModalComponent} from '../add-client-modal/add-client-modal.component';
import {DocumentService} from '../../../../services/document/document.service';
import {ConversionStateService} from '../../../../services/document/conversion-state.service';
import {
    filterHeaderButtonsWhenConversionLocked,
    isSourceDocumentLockedByConversion,
    parseConvertedChildrenFromApiResponse
} from '../../../../services/document/document-conversion-lock.util';
import {LogicielCaisseTicketService} from '../../../../services/logiciel-caisse/logiciel-caisse-ticket.service';
import {DocumentPayload, ProjetPivot} from '../../../../models/document';
import {forkJoin, from, Observable, of, throwError} from 'rxjs';
import {catchError, switchMap, map, concatMap, toArray, finalize, tap, take} from 'rxjs/operators';
import {DocumentPreviewService} from '../../../../services/document/document-preview.service';
import {Taxe, TaxeService} from '../../../parametre/taxe-tva/parametre-taxe/taxe.service';
import {EditWarehouseComponent} from '../../stock/gestionStock/edit-warehouse/edit-warehouse.component';
import {WarehouseService} from '../../../../services/warehouse/warehouse.service';
import {AddProductModalComponent} from './add-product-modal/add-product-modal.component';
import {Eye, EyeOff} from 'angular-feather/icons';
import {FeatherModule} from 'angular-feather';
import {StationService} from '../../../../services/station.service';
import {BanqueService} from '../../../../services/Banque/banque.service';
import {Banque} from '../../../../models/banque.model';
import {
    ParametreDocumentSettingsService,
    VenteAchatParametreRow
} from '../../../../services/parametre-document/parametre-document-settings.service';
import {
    BaseCalculPrixAchat,
    isTruthyTinyInt,
    normalizeBaseCalculPrixAchat
} from '../../../../services/parametre-document/parametre-doc-api-normalize';
import { resolveModeleReferenceForType } from '../../../../services/parametre-document/parametre-document-type-ids';
import {getStationIdFromLocalStorage} from '../../../../services/parametre-document/parametre-document-state.service';
import { resolveDocumentProductMatrixDisplay } from '../../../../services/parametre-document/document-product-line-display.util';
import {
    getEnterpriseNameFromStation,
    listUserStationsFromLocalStorage,
    resolveEnterpriseDisplayName,
    setConnectedEnterpriseStationId,
    UserStationLike,
} from '../../../../services/enterprise-context';
import {StockService} from '../../../../services/stock/stock.service';
import { normalizeNonNegativeIntegerQuantity } from '../../../../services/stock/normalize-non-negative-quantity.util';
import {AppNotificationsService} from '../../../../services/app-notifications/app-notifications.service';
import {EmailComposeComponent} from '../../Vente/devis/parametre-bar/email-compose/email-compose.component';
import {ReferenceModel} from '../../../parametre/parametre-document/parametre-document.component';
import {
    applyDocumentImportProductApiShape,
    normalizeImportHeaderLabel,
    parseProductXlsxImportSheet,
    parseTvaImportValue,
    readImportCellTrimmed
} from './document-product-xlsx-import.helper';
import {
    EtablissementEntrepotLink,
    EtablissementRow,
    LogicielCaisseParametreAssociationsService,
} from '../../../../services/logiciel-caisse/logiciel-caisse-parametre-associations.service';
import {LogicielCaisseAuthService} from '../../../../services/logiciel-caisse/logiciel-caisse-auth.service';
import {
    CaisseClient,
    LogicielCaisseClientService
} from '../../../../services/logiciel-caisse/logiciel-caisse-client.service';
import {LogicielCaisseEntrepotService} from '../../../../services/logiciel-caisse/logiciel-caisse-entrepot.service';
import {LogicielCaisseStockGestionService} from '../../../../services/logiciel-caisse/logiciel-caisse-stock-gestion.service';
import {
    LcBonReceptionEntreeLigne,
    LogicielCaisseStockReceptionService
} from '../../../../services/logiciel-caisse/logiciel-caisse-stock-reception.service';
import {UsersCoordinationService} from '../../../../services/logiciel-caisse/users-coordination.service';

/** Option unifiée station ERP + établissement LC pour le select document. */
export interface DocumentOrgSelectOption {
    key: string;
    type: 'station' | 'etablissement';
    id: number;
    label: string;
}

/** Clé JSON (hidden_fournisseur_fields) pour l'entrepôt logiciel-caisse — hors FK erp_main.entrepots. */
const LC_ENTREPOT_HIDDEN_KEY = 'logiciel_caisse_entrepot_id';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
})
export class DocumentComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('warningModal') warningModal!: TemplateRef<any>;
    @ViewChild('referenceModal') referenceModal!: TemplateRef<any>;
    @ViewChild('margeModal') margeModal!: TemplateRef<any>;
    @ViewChild('depotWarningModal') depotWarningModal!: TemplateRef<any>;
    @ViewChild('stockRuptureModal', { static: true, read: TemplateRef }) stockRuptureModal!: TemplateRef<any>;
    @ViewChild('variantSelectionModal') variantSelectionModalTpl!: TemplateRef<any>;
    @ViewChild('ajout') ajoutComponent!: AjoutProjetComponent;
    @ViewChild('ajoutFournisseur') ajoutFournisseurComponent!: AddFournissComponent;
    @ViewChild('ajoutClient') ajoutClientComponent!: AddClientModalComponent;
    @ViewChild(EditWarehouseComponent) editWarehouseModal!: EditWarehouseComponent;
    @ViewChild(AddProductModalComponent) addProductModal!: AddProductModalComponent;
    @ViewChild('emailModal') emailComposeComponent!: EmailComposeComponent;
    @ViewChild('documentProductImportInput') documentProductImportInput?: ElementRef<HTMLInputElement>;
    @ViewChild('documentDateFlatpickr') documentDateFlatpickr?: Ng2FlatpickrComponent;
    @ViewChild('dateLivraisonFlatpickr') dateLivraisonFlatpickr?: Ng2FlatpickrComponent;
    private modalRef: NgbModalRef | null = null;
    private stockRuptureModalRef: NgbModalRef | null = null;
    private variantSelectionModalRef: NgbModalRef | null = null;
    variantModalRows: { product: Product; selected: boolean; quantity: number }[] = [];
    /** Lignes i = couleurs, colonnes j = tailles (matrice variantes). */
    variantModalCouleurs: string[] = [];
    variantModalTailles: string[] = [];
    private variantModalCellKeyToRowIndex = new Map<string, number>();
    variantModalPrimary: Product | null = null;
    variantModalBulkQuantity = 0;
    variantModalTableLoading = false;
    variantModalFullGroup: Product[] = [];
    private variantModalStockByProductId = new Map<number, number>();
    private variantModalStockDisponibleByProductId = new Map<number, number>();
    private variantModalLineIndex: number | null = null;
    private variantModalLineSnapshot: Item | null = null;
    /** Évite (change) ng-select désignation lors d’applyProductSelectionToLine / variantes. */
    private suppressDesignationSelectChange = false;
    /** Groupes désignation : codes-barres repliés par défaut, chargés au toggle. */
    private expandedBarcodeGroups = new Set<string>();
    private expandedCouleurGroups = new Set<string>();
    private barcodeGroupLoaded = new Set<string>();
    barcodeGroupLoading: { [groupKey: string]: boolean } = {};
    stockRuptureModalLines: { designation: string; qty: number }[] = [];
    margeModalDesignation = '';
    margeModalPercentDisplay: number | null = null;
    margeModalMontantDisplay: number | null = null;
    margeModalHint = '';
    private stockRupturePopupTimer: ReturnType<typeof setTimeout> | null = null;
    documentSettings: any = {
        remise: false,
        unite: false,
    };
    primaryColor: string = '#134AD3';
    documentLabel: string = '';
    dateFrequency: string = 'jours';
    nbrDate: number = 1;
    tvaRates: Tva[] = [];
    isLoadingTvaRates = false;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    clientId = this.currentUser?.id;
    stationId = getStationIdFromLocalStorage();

    /** Paramètre station : affichage matriciel / regroupement des lignes produit (défaut true). */
    private paramDocAffProduitMatriciel = true;

    /** Paramètres document : reporter le prix d'achat ligne sur la fiche produit (facture fournisseur). */
    private paramDocMajPrixAchatProduit = false;

    /** Base du prix unitaire d'entrée pour le CMUP (fiche produit vs ligne document). */
    private paramDocBaseCalculPrixAchat: BaseCalculPrixAchat = 'document_achat';
    file: string = environment.file_url;
    urlImages: string = environment.url_images;
    private static readonly DEFAULT_STATION_LOGO = 'assets/images/logo/logo.svg';
    stationLogo: string | null = null;
    /** True si l’URL logo a échoué au chargement (on garde quand même l’emplacement). */
    documentLogoBroken = false;
    stationName: string = resolveEnterpriseDisplayName();
    /** Stations ERP + établissements LC (select unifié). */
    orgSelectOptions: DocumentOrgSelectOption[] = [];
    selectedOrgKey: string | null = null;
    availableEtablissements: EtablissementRow[] = [];
    selectedEtablissementId: number | null = null;
    loadingEtablissements = false;
    private enterpriseBrandName = resolveEnterpriseDisplayName();
    documentCachetUrl: string | null = null;
    venteAchatRowForDoc: VenteAchatParametreRow | null = null;
    img: string = (environment as { image_url?: string }).image_url ?? 'assets/images/logo/';
    barcodeColumnIconUrl: string = `${String(this.img).replace(/\/?$/, '/')}barcode.png`;
    isTitleVisible = true;
    isDateVisible = true;
    isProjectVisible = true;
    isEntrepotVisible = true;
    isEntrepotInitialReadonly = false;
    isEntrepotDestinationReadonly = false;
    isNoteVisible = true;
    isCategorieVisible = true;
    documentType: string = 'DEVIS';
    documentReference: string = '';
    documentReferenceHeaderPending = false;
    private documentReferencePrefetchGen = 0;
    referenceModelType: number | null = null;
    referenceModelDetail: ReferenceModel | null = null;
    currentStatutId: number | null = null;
    private currentDocumentUserId: number | null = null;
    private currentTypeDocumentId: number | null = null;
    isDateReadonly = false;
    isEntrepotReadonly = false;
    isProjectReadonly = false;
    isNoteReadonly = false;
    isNameClientReadonly = false;
    isIdentifiantReadonly = false;
    isAdressReadonly = false;
    isTelephoneReadonly = false;
    isEmailReadonly = false;
    private originalProjectId: number | null = null;
    private pendingClientId: number | undefined = undefined;
    fournisseurs: Fournisseur[] = [];
    clients: Client[] = [];
    /** Liste filtrée pour ng-select (propriété stable, pas un getter). */
    clientsForSelect: Client[] = [];
    /** Filtre recherche client : professionnel (entreprise), particulier, ou négoce (vente négoce). */
    clientSearchMode: 'patente' | 'particulier' | 'negoce' = 'patente';

    /** Route /vente-negoce/** : uniquement clients type Négoce. */
    get isVenteNegoceContext(): boolean {
        return (this.router.url || '').includes('/vente-negoce/');
    }
    projects: any[] = [];
    private clientSelectLoading = false;
    items: Item[] = [];
    private isSavingDraft = false;
    tvaSummary: TvaSummary[] = [];
    documentColumnSettings: any = {
        reference: true,
        quantite: true,
        unite: false,
        taille: false,
        prixUnitaire: true,
        tva: true,
        remise: false,
        totalHt: true,
        afficherMontantsTTC: false,
        afficherCoordonneesClients: true,
        afficherCodeBarres: true,
        afficherDateEcheance: false,
        afficherDateLivraison: true,
        afficherMontantTotal: true,
        aff_montant_ttc: false,
        aff_code_bar: true,
        aff_date_echeance: false,
        aff_date_liv: true,
        aff_montant_total: true,
        aff_coordonnees: true,
        prix_unitaire: true

    };
    private taxes: any[] = [];
    documentTaxStatutOverrides: { [taxId: number]: boolean } = {};
    private fodecRate = 1;
    totals: {
        totalHT: number;
        totalRemise: number;
        totalTaxesAvantTVA: number;
        totalBaseTVA: number;
        totalTVA: number;
        totalTaxesApresTVA: number;
        totalTTC: number;
        retenueSource: number;
        netAPayer: number;
        timbreFiscal: number;
        Base_RS: number;
        Taux_RS: string;
        RS: number;
        Net_à_payer: number;
        documentLevelTaxLines: { label: string; amount: number }[];
        documentLevelTaxesTotal: number;
        taxesAfterHT: { label: string; amount: number }[];
        taxesAfterTTC: { label: string; amount: number }[];
        taxesAfterTimbre: { label: string; amount: number }[];
    } =
        {
            totalHT: 0,
            totalRemise: 0,
            totalTaxesAvantTVA: 0,
            totalBaseTVA: 0,
            totalTVA: 0,
            totalTaxesApresTVA: 0,
            totalTTC: 0,
            retenueSource: 0,
            netAPayer: 0,
            timbreFiscal: 0,
            Base_RS: 0,
            Taux_RS: '0',
            RS: 0,
            Net_à_payer: 0,
            documentLevelTaxLines: [],
            documentLevelTaxesTotal: 0,
            taxesAfterHT: [],
            taxesAfterTTC: [],
            taxesAfterTimbre: []
        };
    entreprise: any = {};
    banque: any = { nom_banque: '--', rib: '--' };
    /** Comptes bancaires actifs de la station (footer document). */
    availableBanques: Banque[] = [];
    selectedBanqueId: number | null = null;
    stationFooterCoordName = '--';
    stationFooterCoordEmail = '--';
    stationFooterCoordPhones = '--';
    selectedClient: Client | null = null;
    selectedFournisseur: Fournisseur | null = null;
    selectedCategorie: string | null = null;
    selectedProject: string = '';
    documentDate = this.getTodayLocal();
    note: string = '';
    refExterne: string = '';
    nomClient: string = '';
    identifiant: string = '';
    adresse: string = '';
    telephone: string = '';
    email: string = '';
    entrepot: string = '';
    dateLivraison?: string = null;
    documentId: number | null = null;
    documentOriginalId: number | null = null;
    numericReference = 1;
    isApproveButtonDisabled = true;
    isLoadingProjects = false;
    isLoadingFournisseurs = false;
    isLoadingClients = false;
    isLoadingEdit = false;
    isEditing = false;
    isLoadingProducts = false;
    isLoadingCategories = false;
    isLoadingWarehouses = false;
    /** Règle générale : la référence document n’est jamais éditable (même en brouillon). */
    isReferenceReadonly = true;
    /** True quand la ref a été saisie/modifiée dans le popup (doit être envoyée à la création). */
    private referenceSeedFromPopup = false;
    isDateLivReadonly = false;
    isCategorieReadonly = false;
    products: Product[] = [];
    productsForDocumentSelect: Product[] = [];
    categories: Categorie[] = [];
    selectedClientId: number | null = null;
    editMode = {
        nomClient: false,
        identifiant: false,
        numeroIdentification: false,
        adresse: false,
        email: false
    };
    editModeFournisseur = {
        nomEntreprise: false,
        numeroIdentification: false,
        responsable: false,
        telephone: false,
        adresse: false
    };
    modifiedClientFields: { [key: string]: boolean } = {
        nomClient: false,
        identifiant: false,
        numeroIdentification: false,
        adresse: false,
        email: false
    };
    modifiedFournisseurFields: { [key: string]: boolean } = {
        nomEntreprise: false,
        numeroIdentification: false,
        responsable: false,
        telephone: false,
        adresse: false
    };
    mode: 'add' | 'edit' | 'validation' = 'add';
    tvaMapping: { [key: number]: string } = {};
    selectedFournisseurId: number | null = null;
    public basicDateOptions: FlatpickrOptions = {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        defaultDate: new Date().toISOString().split('T')[0],
        allowInput: true,
        altInputClass: 'form-control flatpickr-input'
    };
    public basicDateLivraisonOptions: FlatpickrOptions = {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        defaultDate: new Date().toISOString().split('T')[0],
        allowInput: true,
        altInputClass: 'form-control flatpickr-input'
    };
    @Input() min: number = 0;
    @Input() max: number = 100;
    @Input() step: number = 1;
    value: number = 0;
    private isModalOpen = false;
    isSubmitting = false;
    warehouses: any[] = [];
    /** Liste complète des entrepôts LC (avant filtrage par établissement). */
    allWarehouses: any[] = [];
    /** Liens établissement ↔ entrepôt (API logiciel caisse). */
    private etablissementEntrepotLinks: EtablissementEntrepotLink[] = [];
    private etablissementLinksLoaded = false;
    private warehouseModalTarget: 'single' | 'initial' | 'destination' = 'single';
    selectedWarehouseId: number | null = null;
    /** Libellé figé (avoir) : entrepôt de la facture / BR source. */
    lockedWarehouseName: string | null = null;
    selectedWarehouseInitialId: number | null = null;
    selectedWarehouseDestinationId: number | null = null;
    tempAdresse: string = '';
    tempEmail: string = '';
    tempAdresseFournisseur: string = '';
    tempTelephoneFournisseur: string = '';
    showProductDescription: { [index: number]: boolean } = {};
    productDescriptions: { [index: number]: string } = {};
    productLineBarcodeQuery: { [index: number]: string } = {};
    productLineBarcodeApiHits: { [index: number]: Product[] | undefined } = {};
    productLineBarcodeSearchLoading: { [index: number]: boolean } = {};
    private barcodeLineDebounceTimers: { [index: number]: ReturnType<typeof setTimeout> } = {};
    barcodePickerModel: { [index: number]: Product | undefined } = {};
    barcodePickerUnlockEdit: { [index: number]: boolean } = {};
    private barcodePickerProductsVersion = 0;
    private barcodePickerBaseCache: Product[] | null = null;
    private barcodePickerBaseCacheFingerprint = '';
    private barcodePickerMergedByLine: { [lineIndex: number]: Product[] } = {};
    private barcodePickerMergedKeyByLine: { [lineIndex: number]: string } = {};

    private invalidateBarcodePickerItemsCache(): void {
        this.barcodePickerProductsVersion++;
        this.barcodePickerBaseCache = null;
        this.barcodePickerBaseCacheFingerprint = '';
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private getBarcodePickerBaseFingerprint(): string {
        return `${this.barcodePickerProductsVersion}_${(this.products || []).length}`;
    }

    private getCachedBarcodePickerBaseList(): Product[] {
        const fp = this.getBarcodePickerBaseFingerprint();
        if (
            this.barcodePickerBaseCache != null &&
            this.barcodePickerBaseCacheFingerprint === fp
        ) {
            return this.barcodePickerBaseCache;
        }
        this.barcodePickerBaseCache = this.getProductsWithRealBarcodeSortedForPicker();
        this.barcodePickerBaseCacheFingerprint = fp;
        return this.barcodePickerBaseCache;
    }

    trackBarcodePickerById = (_index: number, item: any): number | string =>
        item?.id != null ? Number(item.id) : _index;

    compareBarcodePickerProduct = (a: any, b: any): boolean =>
        a != null && b != null && Number(a?.id) === Number(b?.id);
    searchBarcodePickerFn = (term: string, item: any): boolean => {
        if (term == null || String(term).trim() === '') {
            return true;
        }
        const t = term.toLowerCase().trim().replace(/\s/g, '');
        const cb = String(item?.code_barre ?? item?.code_bar ?? '')
            .replace(/\s/g, '')
            .toLowerCase();
        const nom = String(item?.nom ?? '')
            .toLowerCase()
            .replace(/\s/g, '');
        const c = String(item?.couleur ?? '')
            .trim()
            .toLowerCase();
        const tl = String(item?.taille ?? '')
            .trim()
            .toLowerCase();
        const attrs = `${c} / ${tl}`.replace(/\s/g, '').toLowerCase();
        return (
            cb.includes(t) ||
            nom.includes(t) ||
            c.replace(/\s/g, '').includes(t) ||
            tl.replace(/\s/g, '').includes(t) ||
            attrs.includes(t)
        );
    };

    /** Désignation : recherche par nom, réf. fabricant ou réf. interne. */
    searchDesignationProductFn = (term: string, item: any): boolean => {
        if (term == null || String(term).trim() === '') {
            return true;
        }
        const t = String(term).toLowerCase().trim();
        const tNoSpace = t.replace(/\s/g, '');
        const nom = String(item?.nom ?? '').toLowerCase();
        const refFab = this.getProductSelectRefFabricantDisplay(item).toLowerCase();
        const refInt = String(item?.ref_interne ?? item?.reference ?? '')
            .toLowerCase()
            .trim();
        const matchRef = (ref: string) =>
            ref !== '' && ref !== '—' && ref !== '-' && (ref.includes(t) || ref.replace(/\s/g, '').includes(tNoSpace));
        return (
            nom.includes(t) ||
            nom.replace(/\s/g, '').includes(tNoSpace) ||
            matchRef(refFab) ||
            matchRef(refInt)
        );
    };

    /** Réf. fabricant affichée dans le ng-select désignation (nom / ref_fabricant). */
    getProductSelectRefFabricantDisplay(product: any): string {
        if (!product) {
            return '—';
        }
        let ref = this.normalizeRefFabricantForSelect(
            product?.ref_fabricant ?? product?.ref_fabriquant
        );
        if (!ref && product?.id != null) {
            const fromCatalog = (this.products || []).find(
                (p) => Number(p.id) === Number(product.id)
            );
            ref = this.normalizeRefFabricantForSelect(
                (fromCatalog as any)?.ref_fabricant ?? (fromCatalog as any)?.ref_fabriquant
            );
        }
        if (!ref && product?.nom) {
            const byNom = (this.products || []).find(
                (p) => String(p.nom || '').trim() === String(product.nom || '').trim()
            );
            ref = this.normalizeRefFabricantForSelect(
                (byNom as any)?.ref_fabricant ?? (byNom as any)?.ref_fabriquant
            );
        }
        return ref || '—';
    }
    compareClients(c1: any, c2: any): boolean {
        const getId = (item: any): number | null => {
            if (!item) return null;
            if (typeof item === 'object' && item.id !== undefined) return item.id;
            if (typeof item === 'number') return item;
            return null;
        };

        const id1 = getId(c1);
        const id2 = getId(c2);

        return id1 === id2;
    }

    compareFournisseurs(c1: any, c2: any): boolean {
        const getId = (item: any): number | null => {
            if (!item) return null;
            if (typeof item === 'object' && item.id !== undefined) return item.id;
            if (typeof item === 'number') return item;
            return null;
        };

        const id1 = getId(c1);
        const id2 = getId(c2);

        return id1 === id2;
    }

    trackByFournisseurId = (index: number, item: any) => {
        return item?.id;
    };
    conversionFromRef: { sourceId: number; newType: string; typeDocumentId: number; statutId: number; isAvoir?: boolean; totalsAvoir?: any } | null = null;
    /** Source d'une conversion : destination déjà créée (hors brouillon/annulé) → masquer Annuler / brouillon. */
    sourceLockedByActiveConversion = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private headerService: HeaderService,
        private router: Router,
        private modalService: NgbModal,
        private toastr: ToastrService,
        private projetService: ProjetService,
        private fournisseurService: FournisseurService,
        private productsService: ProductsService,
        private categorieService: CategorieService,
        private clientService: ClientService,
        private zone: NgZone,
        private tvaService: TvaService,
        private documentService: DocumentService,
        private conversionStateService: ConversionStateService,
        private lcTicketService: LogicielCaisseTicketService,
        private route: ActivatedRoute,
        public documentPreviewService: DocumentPreviewService,
        public taxeService: TaxeService,
        private warehouseService: WarehouseService,
        private stationService: StationService,
        private banqueService: BanqueService,
        private parametreDocumentSettingsService: ParametreDocumentSettingsService,
        private stockService: StockService,
        private appNotifications: AppNotificationsService,
        private marqueService: MarqueService,
        private uniteService: UniteService,
        private lcAssociations: LogicielCaisseParametreAssociationsService,
        private lcAuth: LogicielCaisseAuthService,
        private lcEntrepotService: LogicielCaisseEntrepotService,
        private lcStockGestion: LogicielCaisseStockGestionService,
        private lcStockReception: LogicielCaisseStockReceptionService,
        private coordinationService: UsersCoordinationService,
        private lcClientService: LogicielCaisseClientService
    ) {
        const nav = this.router.getCurrentNavigation();
        this.conversionFromState = nav?.extras?.state?.['conversionFrom'] ?? this.conversionStateService.consume();
    }
    private conversionFromState: any = null;
    /** Liaison tickets caisse → facture ERP à enregistrer après sauvegarde. */
    private ticketFactureLink: { ticketIds: number[]; ticketCodes: string[]; markConsolide: boolean } | null = null;

    typeDocumentIdMap: { [key: string]: number } = {
        'DEVIS': 7,
        'COMMANDE CLIENT': 8,
        'BON DE SORTIE': 9,
        'BON DE LIVRAISON': 10,
        'FACTURE': 11,
        'COMMANDE FOURNISSEUR': 12,
        'BON RECEPTION': 13,
        'FACTURE FOURNISSEUR': 14,
        'AVOIR': 15,
        'BON TRANSFERT': 16,
        'INVENTAIRE': 17,
        'AVOIR FOURNISSEUR': 19
    };

    private documentTypeToRefPrefix: { [key: string]: string } = {
        'DEVIS': 'DEV',
        'COMMANDE CLIENT': 'CC',
        'BON DE SORTIE': 'BS',
        'BON DE LIVRAISON': 'BL',
        'FACTURE': 'FAC',
        'COMMANDE FOURNISSEUR': 'CF',
        'BON RECEPTION': 'BR',
        'FACTURE FOURNISSEUR': 'FF',
        'AVOIR': 'AVR',
        'INVENTAIRE': 'INV',
        'BON TRANSFERT': 'BT',
        'AVOIR FOURNISSEUR': 'AF'
    };


    private typeDocumentsMeta: {
        [docType: string]: { id: number; prefix: string; refCounter: number | null };
    } = {};

    private typeIdToDocumentTypeFromApi: { [id: number]: string } = {};


    private typeDocumentPrefixRawFromApi: string | null = null;

    statutIdMap: { [key: string]: number } = {
        'Brouillon': 1,
        'Accepté': 3,
        'Payé': 5,
        'Annulé': 6,
        'Négociation': 8,
        'Crée': 9,
        'Créé': 9,
        'Valide': 10,
        'Livré': 11,
        'Non payé': 12,
        'Non Payé': 12,
        'Fermé': 13,
        'Reçu': 14,
        'Partiellement payé': 15,
        'En cours': 16,
        'Transféré': 17,
        'Non utilisé': 19,
        'Partiellement utilisé': 20,
        'Utilisé': 18
    };


    ngOnInit(): void {
        const previewData = this.documentPreviewService.getCurrentPreview();
        const defaultSettings = {
            reference: true,
            quantite: true,
            unite: false,
            taille: false,
            prixUnitaire: true,
            tva: true,
            remise: false,
            afficherMontantsTTC: false,
            afficherCodeBarres: true,
            afficherDateEcheance: false,
            afficherDateLivraison: true,
            afficherMontantTotal: true,
            afficherCoordonneesClients: true,
            aff_montant_ttc: false,
            aff_code_bar: true,
            aff_date_échéance: false,
            aff_date_liv: true,
            aff_montant_total: true,
            aff_coordonnees: true,
            prix_unitaire: true,
            afficherProduitsMatriciel: true
        };

        const saved = localStorage.getItem('documentColumnSettings');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                this.documentColumnSettings = {
                    ...defaultSettings,
                    ...parsed,
                    aff_montant_ttc: parsed.aff_montant_ttc ?? parsed.afficherMontantsTTC ?? false,
                    aff_code_bar: parsed.aff_code_bar ?? parsed.afficherCodeBarres ?? true,
                    aff_date_echeance: parsed.aff_date_echeance ?? parsed.aff_date_échéance ?? parsed.afficherDateEcheance ?? false,
                    aff_date_liv: parsed.aff_date_liv ?? parsed.afficherDateLivraison ?? true,
                    aff_montant_total: parsed.aff_montant_total ?? parsed.afficherMontantTotal ?? true,
                    aff_coordonnees: parsed.aff_coordonnees ?? parsed.aff_coordonnées ?? parsed.afficherCoordonneesClients ?? true,
                    reference: parsed.reference ?? parsed.référence ?? true,
                    quantite: parsed.quantite ?? parsed.quantité ?? true,
                    unite: parsed.unite ?? parsed.unité ?? false,
                    taille: parsed.taille ?? false,
                    prix_unitaire: parsed.prix_unitaire ?? parsed.prixUnitaire ?? true,
                    tva: parsed.tva ?? true,
                    remise: parsed.remise ?? false,
                    afficherProduitsMatriciel:
                        parsed.afficherProduitsMatriciel ??
                        parsed.aff_produit_matriciel ??
                        true
                };
            } catch (e) {
                this.documentColumnSettings = defaultSettings;
            }
        } else {
            this.documentColumnSettings = defaultSettings;
        }

        // Exigence métier: la colonne Quantité doit être affichée par défaut sur tous les documents.
        this.documentColumnSettings.quantite = true;
        this.documentColumnSettings.quantité = true;
        localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
        this.documentColumnSettings = {...this.documentColumnSettings};

        this.loadTypeDocumentsMetadata();

        if (previewData?.isDraft && previewData?.previewData) {
            this.documentType = previewData.documentType || 'DEVIS';
            this.loadCurrentTypeDocumentPrefixFromApi();
        } else {
            this.checkRoute();
        }
        this.loadReferenceModelFromParametreDocument();
        if (!this.dateLivraison) {
            this.dateLivraison = this.getTodayLocal();
        }
        this.updateHeaderConfig();
        const currentUrl = this.router.url.toLowerCase();
        if (currentUrl.includes('/vente-negoce/')) {
            this.clientSearchMode = 'negoce';
        }
        if (currentUrl.includes('/edit-')) {
            this.mode = 'edit';
        } else if (currentUrl.includes('/action/validation')) {
            this.mode = 'validation';
        } else {
            this.mode = 'add';
        }
        this.updateHeaderConfig();
        this.route.queryParams.subscribe(params => {
            const id = params['id'];
            const duplicate = params['duplicate'] === 'true';
            const sourceId = params['sourceId'];
            if (duplicate && sourceId) {
                this.mode = 'add';
                this.isEditing = false;
                this.documentId = null;
                this.loadDocumentForDuplicate(+sourceId);
            } else if (id && this.mode === 'add') {
                this.documentId = +id;
                this.mode = 'edit';
                this.isEditing = true;
                this.currentStatutId = 1;
                if (this.tryRestoreFromPreviewData(+id)) return;
                this.loadDocumentForEdit(+id);
            } else if (id && this.mode === 'edit') {
                if (this.tryRestoreFromPreviewData(+id)) return;
                this.loadDocumentForEdit(+id);
            } else if (this.mode === 'add') {
                const conversionData = this.conversionFromState ?? this.conversionStateService.consume();
                if (conversionData?.sourceType === 'ticket_caisse_batch') {
                    // refresh établissements une seule fois dans loadFormFromTicketFacture
                    this.loadFormFromTicketFacture(conversionData);
                } else if (conversionData) {
                    this.refreshAvailableEtablissements();
                    this.loadFormFromConversion(conversionData);
                } else {
                    this.refreshAvailableEtablissements();
                    this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
                    this.loadTaxes();
                    // checkForPreviewData ne recharge plus les listes si pas de brouillon
                    // (évite le double chargement clients/produits/entrepôts…).
                    this.checkForPreviewData();
                    if (!this.documentPreviewService.getCurrentPreview()?.isDraft) {
                        this.loadProjects();
                        this.loadClients();
                        this.loadFournisseurs();
                        this.loadProducts();
                        this.loadWarehouses();
                        this.loadTvaRates();
                        this.loadCategories();
                    }
                    this.loadStationData();
                    this.calculateTotals();
                    this.updateApproveButtonState();
                    this.maybePrefetchNextDocumentReference();
                }
            } else {
                this.refreshAvailableEtablissements();
                this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
                this.loadTaxes();
                this.checkForPreviewData();
                if (!this.documentPreviewService.getCurrentPreview()?.isDraft) {
                    this.loadProjects();
                    this.loadClients();
                    this.loadFournisseurs();
                    this.loadProducts();
                    this.loadWarehouses();
                    this.loadTvaRates();
                    this.loadCategories();
                }
                this.loadStationData();
                this.calculateTotals();
                this.updateApproveButtonState();
                this.maybePrefetchNextDocumentReference();
            }
            this.updateHeaderConfig();
            this.loadVenteAchatParamForCurrentDocumentType();
        });
    }

    private loadVenteAchatParamForCurrentDocumentType(): void {
        if (!this.stationId) {
            this.venteAchatRowForDoc = null;
            return;
        }
        const typeId =
            this.currentTypeDocumentId != null && !Number.isNaN(Number(this.currentTypeDocumentId))
                ? Number(this.currentTypeDocumentId)
                : this.typeDocumentIdMap[this.documentType];
        if (typeId == null || Number.isNaN(typeId) || typeId <= 0) {
            this.venteAchatRowForDoc = null;
            return;
        }
        this.parametreDocumentSettingsService.getVenteAchatByStationAndType(this.stationId, typeId).subscribe({
            next: (row) => {
                this.venteAchatRowForDoc = row;
                this.applyVenteAchatProductDescriptionDefaults();
                this.cdr.markForCheck();
            },
            error: () => {
                this.venteAchatRowForDoc = null;
                this.cdr.markForCheck();
            }
        });
    }

    private applyVenteAchatProductDescriptionDefaults(): void {
        // Description : case décochée par défaut (aff_courte_desp n’ouvre plus le textarea automatiquement).
    }

    /** Pied de page totaux (TVA + montants) — affiché pour tous les types de document achat/vente. */
    showVenteAchatTotalsSection(): boolean {
        return true;
    }

    /** Section Entreprise du footer document : toujours affichée (obligatoire). */
    showFooterEntrepriseBlock(): boolean {
        return true;
    }

    showFooterCoordonneesBlock(): boolean {
        if (this.venteAchatRowForDoc == null) {
            return true;
        }
        return isTruthyTinyInt(this.venteAchatRowForDoc.aff_inf_contact);
    }

    private getTodayLocal(): string {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private formatDateToLocalString(date: Date | string | null): string {
        if (!date) {
            return this.getTodayLocal();
        }
        let d: Date;
        if (typeof date === 'string') {
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date;
            }
            d = new Date(date);
        } else {
            d = date;
        }
        if (isNaN(d.getTime())) {
            return this.getTodayLocal();
        }
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private applyPreviewDateFields(previewData: any): void {
        const rawDoc =
            previewData?.date ??
            previewData?.date_document ??
            null;
        const rawLiv = previewData?.date_livraison ?? null;

        const hasStr = (v: unknown) => v != null && String(v).trim() !== '';

        if (hasStr(rawDoc)) {
            this.documentDate = this.formatDateToLocalString(rawDoc as string);
        } else if (hasStr(rawLiv)) {
            this.documentDate = this.formatDateToLocalString(rawLiv as string);
        } else {
            this.documentDate = this.getTodayLocal();
        }

        if (hasStr(rawLiv)) {
            this.dateLivraison = this.formatDateToLocalString(rawLiv as string);
        } else {
            this.dateLivraison = this.documentDate;
        }

        this.syncFlatpickrDateConfigs();
        this.syncFlatpickrReadonlyOnInstances();
    }

    private syncFlatpickrDateConfigs(): void {
        this.basicDateOptions = {
            ...this.basicDateOptions,
            defaultDate: this.documentDate,
            clickOpens: !this.isDateReadonly,
            allowInput: !this.isDateReadonly
        };
        this.basicDateLivraisonOptions = {
            ...this.basicDateLivraisonOptions,
            defaultDate: this.dateLivraison || this.documentDate,
            clickOpens: !this.isDateLivReadonly,
            allowInput: !this.isDateLivReadonly
        };
    }

    private applyFlatpickrReadonlyState(fpComp: Ng2FlatpickrComponent | undefined | null, readonly: boolean): void {
        const fp = fpComp?.flatpickr as {
            set?: (k: string, v: unknown) => void;
            close?: () => void;
            altInput?: HTMLInputElement;
            input?: HTMLInputElement;
        } | undefined;
        if (!fp || typeof fp.set !== 'function') {
            return;
        }
        if (readonly && typeof fp.close === 'function') {
            fp.close();
        }
        fp.set('clickOpens', !readonly);
        fp.set('allowInput', !readonly);
        if (fp.altInput) {
            fp.altInput.disabled = readonly;
            fp.altInput.readOnly = readonly;
        }
        if (fp.input) {
            fp.input.disabled = readonly;
            fp.input.readOnly = readonly;
        }
    }

    private syncFlatpickrReadonlyOnInstances(): void {
        setTimeout(() => {
            this.applyFlatpickrReadonlyState(this.documentDateFlatpickr, this.isDateReadonly);
            this.applyFlatpickrReadonlyState(this.dateLivraisonFlatpickr, this.isDateLivReadonly);
        }, 0);
    }

    private tryRestoreFromPreviewData(documentId: number): boolean {
        const preview = this.documentPreviewService.getCurrentPreview();
        if (!preview?.isDraft || !preview?.previewData) return false;
        const data = preview.previewData;
        const previewId = data.id ?? data.document_id;
        if (previewId == null || Number(previewId) !== documentId) return false;
        this.documentId = documentId;
        this.isEditing = true;
        if (preview.documentType) this.documentType = preview.documentType;
        this.loadCurrentTypeDocumentPrefixFromApi();
        this.loadVenteAchatParamForCurrentDocumentType();
        this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
        this.loadTaxes();
        this.loadProjects();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadTvaRates();
        this.loadCategories();
        this.loadStationData();
        // Date tout de suite (évite flatpickr sur « aujourd'hui » pendant le délai du reste du formulaire)
        this.applyPreviewDateFields(data);
        this.cdr.detectChanges();
        setTimeout(() => {
            this.applyPreviewData(data);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }, 500);
        this.updateApproveButtonState();
        this.updateHeaderConfig();
        return true;
    }

    private checkForPreviewData(): void {
        const previewData = this.documentPreviewService.getCurrentPreview();
        if (previewData?.isDraft && previewData?.previewData) {
            if (previewData.documentType) {
                this.documentType = previewData.documentType;
            }
            this.loadCurrentTypeDocumentPrefixFromApi();
            this.loadVenteAchatParamForCurrentDocumentType();
            this.loadDataFromPreview(previewData.previewData);
        }
        // Pas de brouillon : les listes sont chargées une seule fois par l’appelant.
    }

    private loadDataFromPreview(previewData: any): void {
        const previewDocType = previewData.typeDocument?.titre || previewData.documentType;
        if (previewDocType && previewDocType !== this.documentType) {
            this.documentType = previewDocType;
        }
        this.loadCurrentTypeDocumentPrefixFromApi();
        this.loadProjects();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadTvaRates();
        this.loadCategories();
        this.applyPreviewDateFields(previewData);
        this.cdr.detectChanges();
        setTimeout(() => {
            this.applyPreviewData(previewData);
            this.cdr.detectChanges();
        }, 1500);
    }

    private applyPreviewData(previewData: any): void {
        try {
            this.refExterne = previewData.ref_externe || previewData.reference || this.documentReference;
            this.documentReference = previewData.reference || previewData.ref_externe || '';
            this.applyPreviewDateFields(previewData);
            this.note = previewData.note || '';
            const isAchat = this.isAchatDocument();
            if (!isAchat && previewData.client_data) {
                this.applyClientData(previewData.client_data);
            } else if (isAchat && previewData.fournisseur_data) {
                this.applyFournisseurData(previewData.fournisseur_data);
            }

            if (previewData.projets && previewData.projets.length > 0) {
                this.selectedProject = previewData.projets[0].titre || previewData.projets[0].libelle || '';
            }
            this.applyItemsData(previewData.lignesDocument || previewData.lignes_document || []);
            this.applyTotalsData(previewData);
            this.applyPreviewEntrepotAndCategorie(previewData);
            setTimeout(() => {
                this.reloadStockQuantitiesForAllProducts();
            }, 1000);
            if (previewData.id) {
                this.documentId = previewData.id;
            }
            this.loadModifiedFields();
            this.updateApproveButtonState();
            this.calculateTotals();
            this.updateHeaderConfig();
            setTimeout(() => {
                this.cdr.detectChanges();
            }, 100);

        } catch (error) {
            this.toastr.error('Erreur lors du chargement des données de l\'aperçu');
        }
    }


    private applyPreviewEntrepotAndCategorie(previewData: any): void {
        if (!previewData || typeof previewData !== 'object') {
            return;
        }
        const type = this.documentType;

        if (type === 'BON TRANSFERT') {
            const initial = previewData.entrepot_id;
            const dest = previewData.entrepot_dest_id ?? previewData.entrepot_destination_id;
            if (initial != null && initial !== '') {
                const n = Number(initial);
                if (!Number.isNaN(n)) {
                    this.selectedWarehouseInitialId = n;
                }
            }
            if (dest != null && dest !== '') {
                const nd = Number(dest);
                if (!Number.isNaN(nd)) {
                    this.selectedWarehouseDestinationId = nd;
                }
            }
        } else {
            const wid = previewData.entrepot_id;
            if (wid != null && wid !== undefined && wid !== '') {
                const n = Number(wid);
                if (!Number.isNaN(n)) {
                    this.selectedWarehouseId = n;
                }
            }
        }

        if (type === 'FACTURE FOURNISSEUR') {
            let lib: string | null = null;
            const cats = previewData.categories;
            if (Array.isArray(cats) && cats.length > 0) {
                const c0 = cats[0];
                const raw = c0?.libelle ?? c0?.nom ?? c0?.titre;
                lib = raw != null && String(raw).trim() !== '' ? String(raw).trim() : null;
            }
            if (!lib && previewData.categorie_libelle != null && String(previewData.categorie_libelle).trim() !== '') {
                lib = String(previewData.categorie_libelle).trim();
            }
            if (lib) {
                this.selectedCategorie = lib;
            }
        }
    }

    private applyClientData(clientData: any): void {
        if (clientData.id) {
            const foundClient = this.clients.find(c => c.id === clientData.id);
            if (foundClient) {
                this.selectedClient = foundClient;
                this.clientId = foundClient.id;
            } else {
                const foundByName = this.clients.find(c =>
                    this.normalizeString(c.nom_prenom) === this.normalizeString(clientData.nom_client || clientData.nom_prenom)
                );
                if (foundByName) {
                    this.selectedClient = foundByName;
                    this.clientId = foundByName.id;
                } else {
                    this.toastr.warning('Client non trouvé dans la liste. Veuillez le sélectionner à nouveau.');
                    this.selectedClient = null;
                    this.clientId = null;
                }
            }
        } else {
            this.selectedClient = null;
            this.clientId = null;
        }
        this.cdr.detectChanges();
        if (this.selectedClient) {
            setTimeout(() => {
                this.initializeFeatherIcons();
            }, 200);
        }
    }

    private applyFournisseurData(fournisseurData: any): void {
        if (fournisseurData.id) {
            const foundFournisseur = this.fournisseurs.find(f => f.id === fournisseurData.id);
            if (foundFournisseur) {
                this.selectedFournisseur = foundFournisseur;
                this.selectedFournisseurId = foundFournisseur.id;
                this.clientId = foundFournisseur.id;
            } else {
                const foundByName = this.fournisseurs.find(f =>
                    this.normalizeString(f.nom_entreprise) === this.normalizeString(fournisseurData.nom_entreprise)
                );
                if (foundByName) {
                    this.selectedFournisseur = foundByName;
                    this.selectedFournisseurId = foundByName.id;
                    this.clientId = foundByName.id;
                } else {
                    this.toastr.warning('Fournisseur non trouvé dans la liste. Veuillez le sélectionner à nouveau.');
                    this.selectedFournisseur = null;
                    this.selectedFournisseurId = null;
                    this.clientId = null;
                }
            }
        } else {
            this.selectedFournisseur = null;
            this.selectedFournisseurId = null;
            this.clientId = null;
        }
        this.cdr.detectChanges();
    }
    private getTvaValueFromLigne(ligne: any): string {
        if (ligne == null) return '0';
        if (typeof ligne.tva === 'object' && ligne.tva !== null && ligne.tva.valeur != null) {
            const v = Number(ligne.tva.valeur);
            return isNaN(v) ? '0' : String(v);
        }
        if (ligne.tva !== null && ligne.tva !== undefined && ligne.tva !== '') {
            const v = Number(ligne.tva);
            if (!isNaN(v)) return String(v);
        }
        if (ligne.taux_tva !== null && ligne.taux_tva !== undefined && ligne.taux_tva !== '') {
            const v = Number(ligne.taux_tva);
            if (!isNaN(v)) return String(v);
        }
        const tvaId = ligne.tva_id ?? ligne.tvaId;
        if (tvaId != null && this.tvaRates?.length > 0) {
            const found = this.tvaRates.find((t: any) => Number(t.id) === Number(tvaId));
            if (found && found.valeur != null) return String(Number(found.valeur));
        }
        return '0';
    }
    private getTaxIdForPayload(taxe: any): number | null {
        if (!taxe || (taxe.id == null && taxe.taxes_id == null)) return null;
        const rawId = taxe.id ?? taxe.taxes_id;
        if (this.taxes?.length) {
            const found = this.taxes.find((t: any) =>
                t.id === rawId || t.id === Number(rawId) || t.id === String(rawId)
            );
            if (found) return typeof found.id === 'number' ? found.id : Number(found.id);
        }
        const num = Number(rawId);
        return Number.isNaN(num) ? null : num;
    }
    private getTaxObjectForPayload(taxe: any): { id: number; taxes_id: number; nom: string; label: string } | null {
        const taxId = this.getTaxIdForPayload(taxe);
        if (taxId == null) return null;
        const fromList = this.taxes?.find((t: any) => t.id === taxId || t.id === Number(taxId));
        const nom = fromList?.nom ?? taxe.nom ?? '';
        const label = fromList?.label ?? taxe.label ?? taxe.nom ?? '';
        return {
            id: fromList?.id ?? taxId,
            taxes_id: taxId,
            nom: String(nom),
            label: String(label)
        };
    }

    private normalizeTaxFromLigne(taxeApi: any): any {
        if (!taxeApi || typeof taxeApi !== 'object') return null;
        const id = taxeApi.taxes_id != null ? taxeApi.taxes_id : taxeApi.id;
        return {
            id: id,
            taxes_id: taxeApi.taxes_id ?? taxeApi.id,
            nom: taxeApi.nom,
            label: taxeApi.label,
            valeur: taxeApi.valeur,
            valeur_fixe: taxeApi.valeur_fixe,
            valeur_pourcentage: taxeApi.valeur_pourcentage,
            type: taxeApi.type,
            statut: taxeApi.statut,
            applique_avant_tva: taxeApi.applique_avant_tva,
            appliquee_avant_tva: taxeApi.appliquee_avant_tva,
            applique_tva: taxeApi.applique_tva ?? taxeApi.applique_a_la_tva,
            applique_a_la_tva: taxeApi.applique_tva ?? taxeApi.applique_a_la_tva,
            appliquee_a_la_tva: taxeApi.appliquee_a_la_tva,
            taxe_applique_sur_produits: taxeApi.taxe_applique_sur_produits
        };
    }

    private applyItemsData(lignes: any[]): void {
        this.items = [];
        
        lignes.forEach((ligne: any, index: number) => {
            let qntValue: number | undefined;
            if (ligne.qnt === null || ligne.qnt === undefined) {
                qntValue = undefined;
            } else if (typeof ligne.qnt === 'number') {
                qntValue = ligne.qnt;
            } else {
                const parsed = parseFloat(ligne.qnt.toString());
                qntValue = isNaN(parsed) ? undefined : parsed;
            }
            const isStockDoc = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
            const isAchat = this.isAchatDocument();
            const unitPrice = isStockDoc
                ? (parseFloat(ligne.valeur_unitaire) || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0)
                : isAchat
                    ? (parseFloat(ligne.prix_achat) || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0)
                    : this.resolveVenteDocumentPrixHtFromLigne(ligne);
            const qte = (qntValue !== null && qntValue !== undefined ? qntValue : 0);
            const remisePct = parseFloat(ligne.remise) || 0;
            const htBrutLigne = qte * unitPrice;
            const montantRemiseLigne = remisePct > 0 ? htBrutLigne * (remisePct / 100) : 0;
            const htNetLigne = (parseFloat(ligne.total_ht) != null && !isNaN(parseFloat(ligne.total_ht)))
                ? parseFloat(ligne.total_ht)
                : (htBrutLigne - montantRemiseLigne);

            const prixHtFromApi = parseFloat(ligne.prix_ht);
            const valeurUnitaireFromLigne = parseFloat(ligne.valeur_unitaire);
            const ligneVariantCt = this.extractCouleurTailleFromProductLike(ligne);
            const productItem: Item = {
            type: 'product' as const,
            designation: ligne.libelle || '',
            quantity: qntValue,
            priceHT: unitPrice,
            prixUnitaireRef: !isStockDoc && !isNaN(prixHtFromApi) ? prixHtFromApi : undefined,
            valeur_unitaire: isStockDoc ? unitPrice : (valeurUnitaireFromLigne || parseFloat(ligne.result_ht) || parseFloat(ligne.prix_ht) || 0),
            tva: this.getTvaValueFromLigne(ligne),
                totalHT: +(htNetLigne.toFixed(3)),
                htNet: +(htNetLigne.toFixed(3)),
                product_id: ligne.product_id || null,
                reference: ligne.ref_interne || ligne.reference || '-',
                code_barre:
                    ligne.code_barre != null && String(ligne.code_barre).trim() !== ''
                        ? String(ligne.code_barre).trim()
                        : ligne.code_bar != null && String(ligne.code_bar).trim() !== ''
                          ? String(ligne.code_bar).trim()
                          : '',
                remise: ligne.remise || 0,
                couleur: ligneVariantCt.couleur,
                taille: ligneVariantCt.taille,
                ajout_ligne: ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne) ? ligne.ajout_ligne.map((al: any) => ({
                    contenu_text: al.contenu_text || '',
                    rubrique: al.rubrique || '',
                    separateur: al.separateur || false,
                    sous_total: Number(al.sous_total) || 0,
                    order: Number(al.order) || 0
                })) : []
            };
            
            const itemIndex = this.items.length;
            this.items.push(productItem);
            if (ligne.taxe != null && typeof ligne.taxe === 'object') {
                const taxArray = Array.isArray(ligne.taxe) ? ligne.taxe : [ligne.taxe];
                const normalized = taxArray
                    .map((t: any) => this.normalizeTaxFromLigne(t))
                    .filter((t: any) => t != null);
                productItem['taxesProduit'] = normalized;
                productItem['fodecApplique'] = normalized.some((t: any) =>
                    t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')
                );
            } else if (ligne.taxe_id != null && this.taxes?.length) {
                const tid = Array.isArray(ligne.taxe_id) ? ligne.taxe_id[0] : ligne.taxe_id;
                const found = this.taxes.find((t: any) => t.id === tid || t.id === Number(tid));
                productItem['taxesProduit'] = found ? [found] : [];
                productItem['fodecApplique'] = found ? (found.nom?.toLowerCase().includes('fodec') || found.label?.toLowerCase().includes('fodec')) : false;
            } else {
                productItem['taxesProduit'] = [];
                productItem['fodecApplique'] = false;
            }
            if (ligne.description) {
                this.productDescriptions[itemIndex] = ligne.description;
            } else {

                this.productDescriptions[itemIndex] = '';
            }

            this.showProductDescription[itemIndex] = false;

            if (ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne) && ligne.ajout_ligne.length > 0) {
                const sortedAjoutLignes = [...ligne.ajout_ligne].sort((a: any, b: any) => 
                    (Number(a.order) || 0) - (Number(b.order) || 0)
                );
                
                sortedAjoutLignes.forEach((al: any) => {

                    if (al.separateur === true || al.separateur === 1) {
                        this.items.push({ type: 'separator' });
                    }
                    else if (al.sous_total !== null && al.sous_total !== undefined && Number(al.sous_total) > 0) {
                        this.items.push({ 
                            type: 'subtotal', 
                            subTotal: Number(al.sous_total) 
                        });
                    }
                    else if (al.rubrique !== null && al.rubrique !== undefined && String(al.rubrique).trim()) {
                        this.items.push({ 
                            type: 'heading', 
                            content: String(al.rubrique) 
                        });
                    }
                    else if (al.contenu_text !== null && al.contenu_text !== undefined && String(al.contenu_text).trim()) {
                        this.items.push({ 
                            type: 'text', 
                            content: String(al.contenu_text) 
                        });
                    }
                });

                productItem.ajout_ligne = [];
            }
        });
        this.rebuildProductsForDocumentSelect();
        this.expandedBarcodeGroups.clear();
        this.expandedCouleurGroups.clear();
        this.barcodeGroupLoaded.clear();
        this.barcodeGroupLoading = {};
        this.syncBarcodePickerModelForVisibleProductLines();
        this.items.forEach((it, idx) => {
            if (it?.type !== 'product' || !it.product_id || !this.isProductLineVisible(idx)) {
                return;
            }
            setTimeout(() => {
                this.loadStockQuantity(Number(it.product_id), it.reference || '', idx);
            }, 100 * (idx + 1));
        });
    }
    
    private ensureAvoirLinesNegated(): void {
        const productItems = this.items.filter(i => i.type === 'product');
        const hasPositiveLines = productItems.some(i => (Number(i.quantity) || 0) > 0 || (Number(i.priceHT) || 0) > 0);
        const needLoadOriginal = this.documentOriginalId && (productItems.length === 0 || hasPositiveLines);

        if (needLoadOriginal && this.documentOriginalId) {
            this.documentService.getDocumentById(this.documentOriginalId).subscribe({
                next: (res: any) => {
                    const originalDoc = res?.data?.document ?? res?.data ?? res;
                    const lignes = Array.isArray(originalDoc.lignesDocument) ? originalDoc.lignesDocument : [];
                    const negatedLignes = lignes.map((l: any) => ({
                        ...l,
                        qnt: -(Number(l.qnt) || 0),
                        prix_ht: -(Number(l.prix_ht) || Number(l.result_ht) || 0),
                        result_ht: -(Number(l.result_ht) || Number(l.prix_ht) || 0),
                        valeur_unitaire: -(Number(l.valeur_unitaire) || Number(l.result_ht) || Number(l.prix_ht) || 0),
                        prix_vente: -(Number(l.prix_vente) || Number(l.prix_ht) || Number(l.result_ht) || 0),
                        prix_achat: -(Number(l.prix_achat) || Number(l.prix_ht) || Number(l.result_ht) || 0)
                    }));
                    this.applyItemsData(negatedLignes);
                    this.calculateTotals();
                    this.cdr.detectChanges();
                },
                error: () => { this.negateAvoirLinesInPlace(); }
            });
        } else {
            this.negateAvoirLinesInPlace();
        }
    }
    private negateAvoirLinesInPlace(): void {
        this.items.forEach((item, i) => {
            if (item.type !== 'product') return;
            const q = Number(item.quantity);
            const p = Number(item.priceHT) || 0;
            const v = Number(item.valeur_unitaire) || 0;
            if (q > 0) item.quantity = -q;
            if (p > 0) {
                item.priceHT = -p;
                item.valeur_unitaire = item.valeur_unitaire != null && Number(item.valeur_unitaire) > 0 ? -Number(item.valeur_unitaire) : -p;
            } else if (v > 0) item.valeur_unitaire = -v;
        });
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    private applyTotalsData(previewData: any): void {
        const Total_TTC = Number(previewData.total_ttc) || 0;
        const Base_RS = Total_TTC;
        const Taux_RS = previewData.Taux_RS || '0';
        const tauxRSDecimal = parseFloat(Taux_RS) / 100;
        const RS = Base_RS * tauxRSDecimal;
        const Net_à_payer = Total_TTC - RS;
        const timbreFiscal = this.isAvoirDocument() ? 0 : (Number(previewData.timbre_fiscal) || 0);
        
        this.totals = {
            totalHT: Number(previewData.total_ht) || 0,
            totalTVA: Number(previewData.total_tva) || 0,
            totalTTC: Total_TTC,
            totalRemise: Number(previewData.total_remise) || 0,
            totalTaxesAvantTVA: 0,
            totalBaseTVA: Number(previewData.total_ht) || 0,
            totalTaxesApresTVA: 0,
            retenueSource: RS,
            netAPayer: Net_à_payer + timbreFiscal,
            timbreFiscal: timbreFiscal,
            Base_RS: Base_RS,
            Taux_RS: Taux_RS,
            RS: RS,
            Net_à_payer: Net_à_payer,
            documentLevelTaxLines: [],
            documentLevelTaxesTotal: 0,
            taxesAfterHT: [],
            taxesAfterTTC: [],
            taxesAfterTimbre: []
        };
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            feather.replace();
            this.cdr.detectChanges();
            this.syncFlatpickrReadonlyOnInstances();
            setTimeout(() => {
                this.initializeFeatherIcons();
            }, 100);
        }, 300);
    }

    private initializeFeatherIcons(): void {
        if (this.iconInitializationTimeout) {
            clearTimeout(this.iconInitializationTimeout);
        }

        this.iconInitializationTimeout = setTimeout(() => {
            requestAnimationFrame(() => {
                const container = document.querySelector('app-document');
                if (!container) {
                    setTimeout(() => this.initializeFeatherIcons(), 100);
                    return;
                }

                if (container.querySelector('i[data-feather]')) {
                    feather.replace();
                }

                this.cdr.markForCheck();
                this.cdr.detectChanges();
            });
        }, 50);
    }

    private replaceFeatherIconsNow(): void {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const container = document.querySelector('app-document') as HTMLElement | null;
                if (container?.querySelector('i[data-feather], span[data-feather]')) {
                    feather.replace({}, container);
                }
                this.cdr.markForCheck();
            });
        });
    }

    loadFournisseurs(fournisseurIdToSelect?: number): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingFournisseurs = false;
            this.fournisseurs = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingFournisseurs = true;
        this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100).subscribe({
            next: (response) => {
                this.fournisseurs = response.data || [];
                this.isLoadingFournisseurs = false;

                if (fournisseurIdToSelect !== undefined) {
                    const fournisseurToSelect = this.fournisseurs.find(f => f.id === fournisseurIdToSelect);
                    if (fournisseurToSelect) {
                        this.selectedFournisseur = fournisseurToSelect;
                        this.selectedFournisseurId = fournisseurIdToSelect;
                        this.clientId = fournisseurIdToSelect;

                        if (this.mode === 'add' || !this.documentId) {
                            this.modifiedClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            this.modifiedFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                        } else {
                            this.loadModifiedFields();
                        }
                        
                        this.loadProjects();
                        this.updateApproveButtonState();
                    }
                }

                this.cdr.detectChanges();
            },
            error: (err) => {
                this.isLoadingFournisseurs = false;
                this.fournisseurs = [];
                this.toastr.error('Erreur lors du chargement des fournisseurs.', 'Erreur');
                this.cdr.detectChanges();
            }
        });
    }

    loadProjects(): void {
        if (!this.stationId) {
            this.toastr.warning('Station non trouvée pour charger les projets.');
            this.projects = [];
            this.isLoadingProjects = false;
            return;
        }

        this.isLoadingProjects = true;
        this.projetService.getProjectsByIdStation(this.stationId).subscribe({
            next: (response: any) => {
                this.zone.run(() => {
                    const rawProjects = Array.isArray(response)
                        ? response
                        : (response?.projectsListe || response?.data || []);

                    this.projects = rawProjects.filter((p: any) => p.statut === true);
                    this.isLoadingProjects = false;
                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.zone.run(() => {
                    this.isLoadingProjects = false;
                    this.projects = [];
                    this.toastr.error('Erreur lors du chargement des projets.');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    loadWarehouses(selectWarehouseIdAfterLoad?: number | null): void {
        // Entrepôts depuis backend-logiciel-caisse (pas ERP) :
        // GET /api/entrepots/entrepot/all?user_id=&station_id= (IDs LC)
        this.isLoadingWarehouses = true;
        console.log('[Document][loadWarehouses] start', {
            documentType: this.documentType,
            selectWarehouseIdAfterLoad,
            isReady: this.lcAuth.isReadyForNavigation?.(),
            lcUserId: this.lcAuth.getBackUserId?.(),
            lcStationId: this.lcAuth.getBackStationId?.(),
            erpContext: this.lcAuth.getErpContext?.() ?? null,
        });

        const applyList = (warehouses: any[]) => {
            console.log('[Document][loadWarehouses] applyList reçu', {
                count: Array.isArray(warehouses) ? warehouses.length : null,
                sample: (warehouses || []).slice(0, 5),
            });
            this.enrichLcWarehousesWithErpMapping(warehouses || []).subscribe({
                next: (enriched) => {
                    this.allWarehouses = this.filterWarehousesIsGlobaleOnly(enriched || []);
                    this.isLoadingWarehouses = false;
                    this.applyEntrepotEstablishmentFilter();
                    this.afterWarehousesEnriched(selectWarehouseIdAfterLoad);
                },
                error: () => {
                    this.allWarehouses = this.filterWarehousesIsGlobaleOnly(warehouses || []);
                    this.isLoadingWarehouses = false;
                    this.applyEntrepotEstablishmentFilter();
                    this.afterWarehousesEnriched(selectWarehouseIdAfterLoad);
                }
            });
        };

        const fetchLcWarehouses = () => {
            const fetchWithLcIds = (userId: number, stationId: number) => {
                console.log('[Document][loadWarehouses] fetchWithLcIds', {
                    userId,
                    stationId,
                    source: 'back_logiciel_caisse',
                });
                this.lcEntrepotService.listForDocumentSelectByUserAndStation(userId, stationId).subscribe({
                    next: (warehouses) => applyList(warehouses),
                    error: (err) => {
                        console.error('[Document][loadWarehouses] erreur subscribe', err);
                        this.allWarehouses = [];
                        this.warehouses = [];
                        this.isLoadingWarehouses = false;
                        this.toastr.error(
                            err?.message || 'Erreur lors du chargement des entrepôts',
                            'Erreur'
                        );
                        this.cdr.detectChanges();
                    }
                });
            };

            // IDs back caisse uniquement — jamais erpUserId / erpStationId en query
            const lcUserId = this.lcAuth.getBackUserId();
            const lcStationId = this.lcAuth.getBackStationId();
            if (lcUserId && lcStationId) {
                fetchWithLcIds(lcUserId, lcStationId);
                return;
            }

            const erp = this.lcAuth.getErpContext?.() ?? null;
            if (!erp?.erpUserId || !(erp.erpStationId > 0)) {
                console.warn('[Document][loadWarehouses] aucun user_id/station_id back caisse → liste vide');
                this.allWarehouses = [];
                this.warehouses = [];
                this.isLoadingWarehouses = false;
                this.toastr.warning(
                    'Impossible de résoudre user_id / station_id back caisse pour les entrepôts.',
                    'Entrepôts'
                );
                this.cdr.detectChanges();
                return;
            }

            this.coordinationService.resolve(erp.erpUserId, erp.erpStationId).subscribe({
                next: (coord) => {
                    if (coord?.user_id_logiciel && coord?.station_id_logiciel) {
                        fetchWithLcIds(coord.user_id_logiciel, coord.station_id_logiciel);
                        return;
                    }
                    console.warn('[Document][loadWarehouses] coordination sans mapping LC → liste vide');
                    this.allWarehouses = [];
                    this.warehouses = [];
                    this.isLoadingWarehouses = false;
                    this.toastr.warning(
                        'Impossible de résoudre user_id / station_id back caisse pour les entrepôts.',
                        'Entrepôts'
                    );
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.error('[Document][loadWarehouses] coordination erreur', err);
                    this.allWarehouses = [];
                    this.warehouses = [];
                    this.isLoadingWarehouses = false;
                    this.cdr.detectChanges();
                }
            });
        };

        if (this.lcAuth.getBackUserId() && this.lcAuth.getBackStationId()) {
            console.log('[Document][loadWarehouses] IDs back caisse disponibles → fetch direct');
            fetchLcWarehouses();
            return;
        }

        console.log('[Document][loadWarehouses] bootstrap LC puis fetch');
        this.lcAuth.bootstrap().pipe(catchError(() => of(null as any))).subscribe({
            next: (status) => {
                console.log('[Document][loadWarehouses] bootstrap next', status);
                fetchLcWarehouses();
            },
            error: (err) => {
                console.error('[Document][loadWarehouses] bootstrap error', err);
                fetchLcWarehouses();
            }
        });
    }

    /**
     * Persiste l'ID ERP dans documents.entrepot_id et l'ID LC dans hidden_fournisseur_fields.
     */
    private applyLogicielCaisseEntrepotToPayload(payload: any): void {
        if (!payload || typeof payload !== 'object') {
            return;
        }
        const selected =
            this.documentType === 'BON TRANSFERT'
                ? this.selectedWarehouseInitialId
                : this.selectedWarehouseId;
        const erpId = this.resolveErpEntrepotIdFromSelection(selected);
        const lcId = this.resolveLcEntrepotIdFromSelection(selected);

        if (this.documentType === 'BON TRANSFERT') {
            const erpSrc = this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseInitialId);
            const erpDst = this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseDestinationId);
            if (erpSrc != null) {
                payload.entrepot_id = erpSrc;
            }
            if (erpDst != null) {
                payload.entrepot_dest_id = erpDst;
            }
        } else if (erpId != null) {
            payload.entrepot_id = erpId;
        }

        let hidden: any = payload.hidden_fournisseur_fields;
        if (typeof hidden === 'string') {
            try {
                hidden = JSON.parse(hidden);
            } catch {
                hidden = {};
            }
        }
        if (!hidden || typeof hidden !== 'object') {
            hidden = {};
        }
        if (lcId != null) {
            hidden[LC_ENTREPOT_HIDDEN_KEY] = lcId;
        }
        payload.hidden_fournisseur_fields = hidden;
    }

    /**
     * Charge les liens établissement ↔ entrepôt depuis l'API logiciel caisse
     * (GET /api/entrepots/etablissement-entrepots/station/:station_id) puis applique le filtrage.
     * Mis en cache : un seul appel réseau, sauf `force`.
     */
    private loadEtablissementEntrepotLinks(force = false): void {
        if (!this.lcAuth.getBackStationId()) {
            this.etablissementEntrepotLinks = [];
            this.etablissementLinksLoaded = true;
            this.applyEntrepotEstablishmentFilter();
            return;
        }
        if (this.etablissementLinksLoaded && !force) {
            this.applyEntrepotEstablishmentFilter();
            return;
        }
        this.lcAssociations.listEtablissementEntrepotLinks().subscribe({
            next: (links) => {
                this.etablissementEntrepotLinks = Array.isArray(links) ? links : [];
                this.etablissementLinksLoaded = true;
                this.applyEntrepotEstablishmentFilter();
            },
            error: () => {
                this.etablissementEntrepotLinks = [];
                this.etablissementLinksLoaded = true;
                this.applyEntrepotEstablishmentFilter();
            },
        });
    }

    /**
     * Documents : n’afficher que les entrepôts marqués is_globale.
     */
    private isWarehouseIsGlobale(w: any): boolean {
        return w?.is_globale === true || Number(w?.is_globale) === 1;
    }

    private filterWarehousesIsGlobaleOnly(list: any[]): any[] {
        return (list || []).filter((w) => this.isWarehouseIsGlobale(w));
    }

    /**
     * Restreint la liste `warehouses` aux entrepôts reliés à l'établissement sélectionné
     * (`selectedEtablissementId`). Sans établissement LC (station ERP) ou tant que les liens
     * ne sont pas chargés, la liste (déjà filtrée is_globale) est affichée.
     */
    private applyEntrepotEstablishmentFilter(): void {
        const etabId = this.selectedEtablissementId != null ? Number(this.selectedEtablissementId) : null;
        if (!etabId || etabId <= 0 || !this.etablissementLinksLoaded) {
            this.warehouses = [...this.allWarehouses];
            this.ensureSelectedWarehouseValid();
            return;
        }
        const relevant = (this.etablissementEntrepotLinks || []).filter(
            (l) => Number(l.etablissement_id) === etabId
        );
        const linkedIds = new Set(
            relevant.map((l) => Number(l.entrepot_id)).filter((n) => Number.isFinite(n) && n > 0)
        );
        const filtered = this.allWarehouses.filter((w: any) => linkedIds.has(Number(w?.id)));
        this.warehouses = filtered.length > 0 ? filtered : [...this.allWarehouses];
        this.ensureSelectedWarehouseValid();
    }

    /** Réinitialise l'entrepôt sélectionné s'il ne fait plus partie de la liste filtrée. */
    private ensureSelectedWarehouseValid(): void {
        if (this.isAvoirWarehouseLocked()) {
            this.cdr.detectChanges();
            return;
        }
        if (
            this.selectedWarehouseId != null &&
            !this.warehouses.some((w: any) => Number(w?.id) === Number(this.selectedWarehouseId))
        ) {
            this.selectedWarehouseId = null;
            this.onWarehouseChange();
        }
        this.cdr.detectChanges();
    }

    private afterWarehousesEnriched(selectWarehouseIdAfterLoad?: number | null): void {
        console.log('[Document][loadWarehouses] après mapping LC↔ERP', {
            allWarehouses: this.allWarehouses?.length,
            warehouses: this.warehouses?.length,
            mapped: (this.allWarehouses || []).filter((w: any) => w?.erp_id).length,
            selectedEtablissementId: this.selectedEtablissementId,
        });
        const wid = selectWarehouseIdAfterLoad != null ? Number(selectWarehouseIdAfterLoad) : null;
        if (wid != null && !Number.isNaN(wid)) {
            const exists = this.warehouses.some(
                (w: any) =>
                    Number(w?.id) === wid ||
                    Number(w?.lc_id) === wid ||
                    Number(w?.erp_id) === wid
            );
            if (exists) {
                const row = this.warehouses.find(
                    (w: any) =>
                        Number(w?.id) === wid ||
                        Number(w?.lc_id) === wid ||
                        Number(w?.erp_id) === wid
                );
                const selectId = Number(row?.lc_id ?? row?.id ?? wid);
                if (this.documentType === 'BON TRANSFERT') {
                    if (this.warehouseModalTarget === 'destination') {
                        this.selectedWarehouseDestinationId = selectId;
                    } else {
                        this.selectedWarehouseInitialId = selectId;
                    }
                } else {
                    this.selectedWarehouseId = selectId;
                }
                this.onWarehouseChange();
            }
        }
        this.loadEtablissementEntrepotLinks();
        this.cdr.detectChanges();
    }

    private extractWarehouseIdFromSaveResponse(res: any): number | null {
        if (res == null || typeof res !== 'object') {
            return null;
        }
        // Création duale : préférer l'id LC pour le select (liste = LC).
        const raw =
            res.lc_entrepot?.id ??
            res.id ??
            res.data?.id ??
            res.entrepot?.id ??
            res.warehouse?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    }

    /**
     * Charge tous les produits actifs de la station (pagination), pour le ng-select désignation.
     * Évite le plafond page=1&limit=100 qui masquait une partie du catalogue.
     */
    private fetchAllActiveProductsByStation(stationId: number, pageSize: number = 1000): Observable<any[]> {
        const fetchPage = (page: number, acc: any[]): Observable<any[]> =>
            this.productsService.getActiveProductsByStationId(stationId, page, pageSize).pipe(
                switchMap((response: any) => {
                    const pageRows: any[] = Array.isArray(response?.data)
                        ? response.data
                        : Array.isArray(response?.products)
                            ? response.products
                            : [];
                    const nextAcc = pageRows.length ? [...acc, ...pageRows] : acc;
                    const totalPages =
                        response?.meta?.pages ??
                        response?.meta?.nb_total_pages ??
                        Math.max(
                            1,
                            Math.ceil(((response?.meta?.total ?? nextAcc.length) || 1) / pageSize)
                        );
                    if (pageRows.length > 0 && page < totalPages) {
                        return fetchPage(page + 1, nextAcc);
                    }
                    return of(nextAcc);
                })
            );
        return fetchPage(1, []);
    }

    private mapApiProductForDocumentSelect(apiProduct: any): any {
        const prixUnitairesParse = parseFloat(apiProduct.prix_unitaires) || 0;
        const valeurUnitaireParse = parseFloat(apiProduct.valeur_unitaire) || 0;
        const refFab = this.extractRefFabricantFromProductLike(apiProduct);
        return {
            ...apiProduct,
            ref_fabricant: refFab || apiProduct.ref_fabricant,
            prix_unitaires: prixUnitairesParse,
            valeur_unitaire: valeurUnitaireParse,
            liste_prix: Array.isArray(apiProduct.liste_prix) && apiProduct.liste_prix.length > 0
                ? apiProduct.liste_prix[0]
                : null,
            informations_logistique: apiProduct.informations_logistique || []
        };
    }

    private extractRefFabricantFromProductLike(p: any): string {
        return this.normalizeRefFabricantForSelect(
            p?.ref_fabricant ??
                p?.ref_fabriquant ??
                p?.reference_fabricant ??
                p?.reference_fabriquant ??
                p?.ref_fabricant_fournisseur
        );
    }

    loadProducts(): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingProducts = false;
            this.products = [];
            this.invalidateBarcodePickerItemsCache();
            this.rebuildProductsForDocumentSelect();
            this.cdr.markForCheck();
            return;
        }

        this.isLoadingProducts = true;
        this.fetchAllActiveProductsByStation(this.stationId).subscribe({
            next: (allProducts) => {
                this.zone.run(() => {
                    this.products = (allProducts || []).map((p) => this.mapApiProductForDocumentSelect(p));
                    this.invalidateBarcodePickerItemsCache();
                    this.rebuildProductsForDocumentSelect();
                    this.syncBarcodePickerModelForVisibleProductLines();
                    this.isLoadingProducts = false;
                    this.cdr.markForCheck();
                    this.preloadStockQuantitiesForAllProducts();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingProducts = false;
                    this.products = [];
                    this.invalidateBarcodePickerItemsCache();
                    this.rebuildProductsForDocumentSelect();
                    this.toastr.error('Erreur lors du chargement des produits.', 'Erreur');
                    this.cdr.markForCheck();
                });
            }
        });

    }

    private isBarcodeEmptyOrZeroForSelect(p: any): boolean {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return true;
        }
        const s = String(c).trim();
        if (s === '' || s === '0') {
            return true;
        }
        const n = Number(s.replace(',', '.'));
        return !Number.isNaN(n) && n === 0;
    }

    private normalizeRefFabricantForSelect(raw: any): string {
        if (raw == null) {
            return '';
        }
        return String(raw).trim();
    }

    /** Comparaison ref. fabricant (insensible à la casse / espaces). */
    private refFabricantKeyForGrouping(raw: any): string {
        return this.normalizeRefFabricantForSelect(raw).toLowerCase();
    }

    private refFabricantKeysMatch(refA: string, refB: string): boolean {
        const a = this.refFabricantKeyForGrouping(refA);
        const b = this.refFabricantKeyForGrouping(refB);
        return a !== '' && a === b;
    }

    private mergeVariantGroupProducts(...groups: Array<Product[] | undefined | null>): Product[] {
        const byId = new Map<number, Product>();
        for (const group of groups) {
            for (const p of group || []) {
                const id = p?.id != null ? Number(p.id) : NaN;
                if (Number.isFinite(id) && id > 0) {
                    byId.set(id, p);
                }
            }
        }
        return Array.from(byId.values());
    }

    /** Liste ng-select désignation : uniquement produits avec ref. fabricant renseignée. */
    private productHasRefFabricantForSelect(p: Product | any): boolean {
        return !!this.extractRefFabricantFromProductLike(p);
    }

    private filterProductsWithRefFabricantForSelect(list: Product[]): Product[] {
        return (list || []).filter((p) => this.productHasRefFabricantForSelect(p));
    }

    private pickPrimaryInRefFabGroupForSelect(group: Product[]): Product {
        const zeros = group.filter((p) => this.isBarcodeEmptyOrZeroForSelect(p));
        if (zeros.length > 0) {
            return zeros[0];
        }
        return group[0];
    }

    private computePrimaryRefFabProductList(products: Product[]): Product[] {
        if (!products?.length) {
            return [];
        }
        const byRef = new Map<string, Product[]>();
        for (const p of products) {
            const ref = this.refFabricantKeyForGrouping(this.extractRefFabricantFromProductLike(p));
            if (!ref) {
                continue;
            }
            if (!byRef.has(ref)) {
                byRef.set(ref, []);
            }
            byRef.get(ref)!.push(p);
        }
        const primaryIds = new Set<number>();
        for (const [, group] of byRef) {
            const primary = this.pickPrimaryInRefFabGroupForSelect(group);
            if (primary?.id != null) {
                primaryIds.add(Number(primary.id));
            }
        }
        return products.filter(
            (p) =>
                p.id != null &&
                primaryIds.has(Number(p.id)) &&
                this.productHasRefFabricantForSelect(p)
        );
    }

    rebuildProductsForDocumentSelect(): void {
        const base = this.computePrimaryRefFabProductList(this.products);
        const ids = new Set(
            base.map((p) => p.id).filter((id): id is number => id != null && !Number.isNaN(Number(id)))
        );
        const extra: Product[] = [];
        for (const it of this.items) {
            if (it.type !== 'product' || !it.product_id) {
                continue;
            }
            const pid = Number(it.product_id);
            if (ids.has(pid)) {
                continue;
            }
            let p = this.products.find((pr) => Number(pr.id) === pid);
            if (!p && String(it.designation ?? '').trim()) {
                p = {
                    id: pid,
                    nom: String(it.designation).trim(),
                    ref_fabricant: (it as any).ref_fabricant,
                    ref_interne: it.reference,
                    couleur: it.couleur,
                    taille: it.taille,
                    code_barre: it.code_barre,
                } as Product;
            }
            if (p && this.productHasRefFabricantForSelect(p)) {
                extra.push(p);
                ids.add(pid);
            }
        }
        this.productsForDocumentSelect = this.filterProductsWithRefFabricantForSelect([
            ...base,
            ...extra,
        ]);
        this.preloadSelectStockTotalsForDocumentOptions();
    }

    private getRefFabGroupProductsForStock(p: Product | null | undefined): Product[] {
        if (!p) {
            return [];
        }
        const ref = this.normalizeRefFabricantForSelect(
            (p as any).ref_fabricant ?? (p as any).ref_fabriquant
        );
        if (!ref) {
            return p.id != null ? [p] : [];
        }
        const fromCatalog = (this.products || []).filter(
            (x) =>
                this.normalizeRefFabricantForSelect(
                    (x as any).ref_fabricant ?? (x as any).ref_fabriquant
                ) === ref
        );
        if (
            p.id != null &&
            !fromCatalog.some((x) => x?.id != null && Number(x.id) === Number(p.id))
        ) {
            return [...fromCatalog, p];
        }
        return fromCatalog.length > 0 ? fromCatalog : p.id != null ? [p] : [];
    }

    private selectOptionStockByCacheKey = new Map<string, number>();
    private selectOptionStockLoadingKeys = new Set<string>();

    /** Entrepôts LC pour filtrer gestion-globale (même règle que Gestion stock). */
    private getLcEntrepotIdsForGestionGlobale(): number[] | undefined {
        if (!this.shouldFilterStockByEntrepot()) {
            return undefined;
        }
        const selected =
            this.documentType === 'BON TRANSFERT'
                ? this.selectedWarehouseInitialId
                : this.selectedWarehouseId;
        const lcId = this.resolveLcEntrepotIdFromSelection(selected);
        return lcId != null ? [lcId] : undefined;
    }

    private buildLcStockMetaFromProduct(
        product: Product | any | null | undefined,
        fallbackId?: number,
        fallbackRef?: string
    ): {
        id: number;
        code_barre?: string | null;
        ref_interne?: string | null;
        ref_fabricant?: string | null;
    } | null {
        const id = Number(product?.id ?? fallbackId);
        if (!Number.isFinite(id) || id <= 0) {
            return null;
        }
        const p = product as any;
        return {
            id,
            code_barre: p?.code_barre ?? p?.code_bar ?? null,
            ref_interne: p?.ref_interne ?? p?.reference ?? fallbackRef ?? null,
            ref_fabricant: p?.ref_fabricant ?? p?.ref_fabriquant ?? null,
        };
    }

    private findProductForLcStockMeta(productId: number, refInterne?: string): Product | any | null {
        const pools = [this.products, this.productsForDocumentSelect, this.variantModalFullGroup];
        for (const pool of pools) {
            const hit = (pool || []).find((p: any) => p?.id != null && Number(p.id) === Number(productId));
            if (hit) {
                return hit;
            }
        }
        if (refInterne) {
            return { id: productId, ref_interne: refInterne } as any;
        }
        return { id: productId } as any;
    }

    private getSelectOptionStockCacheKey(productId: number): string {
        return this.getStockCacheKey(productId, this.getEntrepotIdForStockQuantity());
    }

    private fetchSelectOptionStockQuantity(productId: number): Observable<number> {
        const product = this.findProductForLcStockMeta(productId);
        const meta = this.buildLcStockMetaFromProduct(product, productId);
        if (!meta) {
            return of(0);
        }
        return this.lcStockGestion
            .getStockGlobaleByErpProducts([meta], {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .pipe(
                map((rec) => rec[productId]?.physique ?? 0),
                catchError(() => of(0))
            );
    }

    private ensureSelectOptionStockTotalLoaded(productId: number): void {
        const cacheKey = this.getSelectOptionStockCacheKey(productId);
        if (this.selectOptionStockByCacheKey.has(cacheKey)) {
            return;
        }
        if (this.selectOptionStockLoadingKeys.has(cacheKey)) {
            return;
        }
        this.selectOptionStockLoadingKeys.add(cacheKey);
        this.fetchSelectOptionStockQuantity(productId).subscribe({
            next: (q) => {
                const n = Number.isFinite(q) ? q : 0;
                this.selectOptionStockByCacheKey.set(cacheKey, n);
                this.selectOptionStockLoadingKeys.delete(cacheKey);
                this.cdr.detectChanges();
            },
            error: () => {
                this.selectOptionStockByCacheKey.set(cacheKey, 0);
                this.selectOptionStockLoadingKeys.delete(cacheKey);
                this.cdr.detectChanges();
            }
        });
    }

    getSelectOptionTotalStockDisplay(item: Product | null | undefined): number {
        if (item == null) {
            return 0;
        }
        const group = this.getRefFabGroupProductsForStock(item);
        let sum = 0;
        for (const pr of group) {
            if (pr?.id == null || this.isBarcodeEmptyOrZeroForSelect(pr)) {
                continue;
            }
            const id = Number(pr.id);
            if (!Number.isFinite(id)) {
                continue;
            }
            this.ensureSelectOptionStockTotalLoaded(id);
            const key = this.getSelectOptionStockCacheKey(id);
            const q = this.selectOptionStockByCacheKey.get(key);
            if (q !== undefined) {
                sum += q;
            }
        }
        // Produit simple sans code-barres : charger quand même via réf. interne.
        if (sum === 0 && group.length === 1 && item.id != null) {
            const id = Number(item.id);
            if (Number.isFinite(id)) {
                this.ensureSelectOptionStockTotalLoaded(id);
                const key = this.getSelectOptionStockCacheKey(id);
                const q = this.selectOptionStockByCacheKey.get(key);
                if (q !== undefined) {
                    return q;
                }
            }
        }
        return sum;
    }

    getSelectOptionStockStatus(item: Product | null | undefined): string {
        return this.getSelectOptionTotalStockDisplay(item) > 0 ? 'En stock' : 'En rupture';
    }

    private preloadSelectStockTotalsForDocumentOptions(): void {
        const ids = new Set<number>();
        const metas: Array<{
            id: number;
            code_barre?: string | null;
            ref_interne?: string | null;
            ref_fabricant?: string | null;
        }> = [];
        for (const item of this.productsForDocumentSelect || []) {
            for (const p of this.getRefFabGroupProductsForStock(item)) {
                if (p?.id == null || !Number.isFinite(Number(p.id))) {
                    continue;
                }
                const id = Number(p.id);
                if (ids.has(id)) {
                    continue;
                }
                const key = this.getSelectOptionStockCacheKey(id);
                if (
                    this.selectOptionStockByCacheKey.has(key) ||
                    this.selectOptionStockLoadingKeys.has(key)
                ) {
                    continue;
                }
                ids.add(id);
                const meta = this.buildLcStockMetaFromProduct(p, id);
                if (meta) {
                    metas.push(meta);
                    this.selectOptionStockLoadingKeys.add(key);
                }
            }
        }
        if (!metas.length) {
            return;
        }
        this.lcStockGestion
            .getStockGlobaleByErpProducts(metas, {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .subscribe({
                next: (rec) => {
                    for (const meta of metas) {
                        const key = this.getSelectOptionStockCacheKey(meta.id);
                        this.selectOptionStockByCacheKey.set(key, rec[meta.id]?.physique ?? 0);
                        this.selectOptionStockLoadingKeys.delete(key);
                    }
                    this.cdr.detectChanges();
                },
                error: () => {
                    for (const meta of metas) {
                        const key = this.getSelectOptionStockCacheKey(meta.id);
                        this.selectOptionStockByCacheKey.set(key, 0);
                        this.selectOptionStockLoadingKeys.delete(key);
                    }
                    this.cdr.detectChanges();
                },
            });
    }

    private preloadStockQuantitiesForAllProducts(): void {
        const shouldFilterByEntrepot = this.shouldFilterStockByEntrepot();
        const entrepotId = shouldFilterByEntrepot ? this.getEntrepotIdForStockQuantity() : null;
        
        let loadedCount = 0;
        const productsToLoad = this.products.filter(p => p.id !== undefined && p.id !== null);
        productsToLoad.forEach((product, index) => {
            const productId = product.id!;
            setTimeout(() => {
                this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                    next: (stockDetails: any) => {
                        if (!stockDetails) {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            loadedCount++;
                            if (loadedCount === productsToLoad.length) {
                                this.cdr.detectChanges();
                            }
                            return;
                        }
                        
                        let quantity = 0;
                        
                        if (shouldFilterByEntrepot && entrepotId) {
                            const stockByEntrepot = stockDetails.stocks_by_entrepot?.find((stock: any) => stock.entrepot_id === entrepotId);
                            if (stockByEntrepot) {
                                quantity = Number(stockByEntrepot.quantity || 0);
                            } else {
                                quantity = 0;
                            }
                        } else {
                            quantity = Number(stockDetails.total_quantity || 0);
                        }
                        
                        const cacheKey = this.getStockCacheKey(productId, entrepotId);
                        this.stockQuantitiesCache.set(cacheKey, quantity);
                        const prod = this.products.find(p => p.id === productId);
                        if (prod) {
                            (prod as any).availableQuantity = quantity;
                        }
                        loadedCount++;
                        
                        if (loadedCount === productsToLoad.length) {
                            this.cdr.detectChanges();
                        }
                    },
                    error: (error) => {
                        loadedCount++;
                        const cacheKey = this.getStockCacheKey(productId, entrepotId);
                        this.stockQuantitiesCache.set(cacheKey, 0);
                        const prod = this.products.find(p => p.id === productId);
                        if (prod) {
                            (prod as any).availableQuantity = 0;
                        }
                        if (loadedCount === productsToLoad.length) {
                            this.cdr.detectChanges();
                        }
                    }
                });
            }, index * 50);
        });
    }

    private isAppliqueSurTousDocumentsTax(tax: any): boolean {
        const v = tax?.applique_sur_tous_document;
        if (v === false || v === 0 || v === '0') {
            return false;
        }
        return true;
    }

    private readonly documentTypesVente = new Set([
        'DEVIS',
        'COMMANDE CLIENT',
        'FACTURE',
        'BON DE LIVRAISON',
        'BON DE SORTIE',
        'AVOIR'
    ]);

    private readonly documentTypesAchat = new Set([
        'COMMANDE FOURNISSEUR',
        'BON RECEPTION',
        'FACTURE FOURNISSEUR',
        'AVOIR FOURNISSEUR'
    ]);

    private getNormalizedDocumentTypeForTax(): string {
        return (this.documentType || '').toString().trim().toUpperCase();
    }

    private isCurrentDocumentVenteType(): boolean {
        return this.documentTypesVente.has(this.getNormalizedDocumentTypeForTax());
    }

    private isCurrentDocumentAchatType(): boolean {
        return this.documentTypesAchat.has(this.getNormalizedDocumentTypeForTax());
    }

    private isTaxUtilisationAllowedForDocument(tax: any): boolean {
        if (!tax || typeof tax !== 'object') {
            return false;
        }
        const rawTous = tax.utilisation_tous;
        const rawVente = tax.utilisation_vente;
        const rawAchat = tax.utilisation_achat;
        const hasAnyUtilisationFlag =
            rawTous !== undefined || rawVente !== undefined || rawAchat !== undefined;
        if (!hasAnyUtilisationFlag) {
            return true;
        }
        const isTruthy = (v: any): boolean =>
            v === true || v === 1 || v === '1' || v === 'true';
        if (isTruthy(rawTous)) {
            return true;
        }
        const vente = isTruthy(rawVente);
        const achat = isTruthy(rawAchat);
        if (!vente && !achat) {
            return true;
        }
        if (vente && achat) {
            return this.isCurrentDocumentVenteType() || this.isCurrentDocumentAchatType();
        }
        if (vente) {
            return this.isCurrentDocumentVenteType();
        }
        return this.isCurrentDocumentAchatType();
    }

    isTaxActiveForDocument(tax: any): boolean {
        if (!tax) {
            return false;
        }
        if (!this.isTaxUtilisationAllowedForDocument(tax)) {
            return false;
        }
        const base =
            tax.statut === true ||
            tax.statut === 1 ||
            tax.statut === '1' ||
            tax.statut === 'true';
        if (this.isAppliqueSurTousDocumentsTax(tax)) {
            return base;
        }
        const id = tax.id != null ? Number(tax.id) : null;
        if (id != null && this.documentTaxStatutOverrides[id] !== undefined) {
            return !!this.documentTaxStatutOverrides[id];
        }
        return base;
    }

    onDocumentTaxStatutChange(ev: { taxId: number; statut: boolean }): void {
        this.documentTaxStatutOverrides = {
            ...this.documentTaxStatutOverrides,
            [ev.taxId]: ev.statut
        };
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    private applyTaxStatutDocumentFromParametrage(raw: any): void {
        if (!raw || typeof raw !== 'object') {
            this.documentTaxStatutOverrides = {};
            return;
        }
        const keys = Object.keys(raw);
        if (keys.length === 0) {
            this.documentTaxStatutOverrides = {};
            return;
        }
        const out: { [id: number]: boolean } = {};
        keys.forEach(k => {
            const id = Number(k);
            if (!Number.isNaN(id)) {
                out[id] = !!raw[k];
            }
        });
        this.documentTaxStatutOverrides = out;
    }

    private loadTaxes(): void {
        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (res: any) => {
                const taxList = res?.taxes || res?.data || res?.tvaListe || [];
                if (!Array.isArray(taxList)) {
                    this.taxes = [];
                    return;
                }
                this.taxes = taxList;
                const fodecTax = this.taxes.find((t: any) =>
                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                    this.isTaxActiveForDocument(t)
                );
                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                this.items.forEach((item, i) => {
                    if (item.product_id) {
                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                            next: (p: any) => this.applyProductTaxes(p.data || p, i),
                            error: () => {
                            }
                        });
                    }
                });
                this.calculateTotals();
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.taxes = [];
                this.fodecRate = 0;
            }
        });
    }

    private updateTvaSummary(): void {
        this.tvaSummary = [];

        const tauxUtilises = new Set(
            this.items
                .filter(i => i.type === 'product' && i.tva != null && i.tva !== '')
                .map(i => i.tva!)
        );

        tauxUtilises.forEach(tauxStr => {
            const taux = Number(tauxStr);
            if (taux <= 0 || isNaN(taux)) return;
            const base = this.items
                .filter(i => i.type === 'product' && String(i.tva) === String(tauxStr))
                .reduce((sum, i) => sum + (Number(i.htNet ?? i.totalHT) || 0), 0);
            if (base <= 0) return;
            const montantTva = base * (taux / 100);
            this.tvaSummary.push({
                rate: taux,
                base: Number(base.toFixed(3)),
                amount: Number(montantTva.toFixed(3))
            });
        });
    }

    loadCategories(): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingCategories = false;
            this.categories = [];
            this.cdr.markForCheck();
            return;
        }

        this.isLoadingCategories = true;
        this.categorieService.getCategoriePerStation(this.stationId).subscribe({
            next: (categories) => {
                this.zone.run(() => {
                    this.categories = categories || [];
                    this.isLoadingCategories = false;
                    this.cdr.markForCheck();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingCategories = false;
                    this.categories = [];
                    this.toastr.error('Erreur lors du chargement des catégories.', 'Erreur');
                    this.cdr.markForCheck();
                });
            }
        });
    }

    private syncSessionFromStorage(): void {
        try {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        } catch {
            this.currentUser = {};
        }
        this.clientId = this.currentUser?.id;
        this.stationId = getStationIdFromLocalStorage();
    }

    loadStationData(): void {
        if (!this.stationId) {
            this.stationId = getStationIdFromLocalStorage();
        }

        if (!this.stationId) {
            return;
        }
        this.loadParametreDocumentCachet();
        this.loadBanquesForDocument();
        this.stationService.getStation(this.stationId).subscribe({
            next: (response) => {
                if (response && response.success && response.station) {
                    const station = response.station;
                    let adresseFormatee = '--';
                    let ville = '';
                    let pays = '';
                    
                    if (station.adresses && station.adresses.length > 0) {
                        const adresse = station.adresses[0];
                        const parts = [];
                        if (adresse.adresse) parts.push(adresse.adresse);
                        if (adresse.code_postal) parts.push(adresse.code_postal);
                        adresseFormatee = parts.join(', ') || '--';
                        ville = adresse.region || '';
                        pays = adresse.pays || '';
                    }
                    this.enterpriseBrandName = resolveEnterpriseDisplayName(
                        station.nom_entreprise || station.label
                    );
                    const selectedOrg =
                        this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) || null;
                    const displayName = selectedOrg?.label || this.enterpriseBrandName;
                    this.entreprise = {
                        nom: displayName || '--',
                        adresse: adresseFormatee,
                        ville: ville,
                        pays: pays,
                        matricule_fiscal: station.matricule_fiscale || '--'
                    };
                    if (station.logo) {
                        this.documentLogoBroken = false;
                        this.stationLogo = this.resolveStationLogoUrl(station.logo);
                    } else {
                        this.documentLogoBroken = false;
                        this.stationLogo = null;
                    }
                    this.stationName = displayName;
                    this.applyStationFooterContact(station);
                    this.stationEntrepriseSnapshot = { ...this.entreprise };
                    this.applyFooterForSelectedOrg();
                    this.cdr.markForCheck();
                }
            },
            error: (error) => {
                this.stationFooterCoordName = '--';
                this.stationFooterCoordEmail = '--';
                this.stationFooterCoordPhones = '--';
            }
        });
    }

    /** Recherche libre dans le select station / établissement. */
    searchOrgSelectFn = (term: string, item: DocumentOrgSelectOption): boolean => {
        const t = String(term ?? '').trim().toLowerCase();
        if (!t) {
            return true;
        }
        const label = String(item?.label ?? '').toLowerCase();
        const typeLabel = item?.type === 'station' ? 'station' : 'établissement etablissement';
        return label.includes(t) || typeLabel.includes(t) || String(item?.id ?? '').includes(t);
    };

    private stationOptionId(station: UserStationLike): number {
        const n = Number(station['station_id'] ?? station['id']);
        return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    }

    private etablissementOptionLabel(etab: EtablissementRow): string {
        const libelle = String(etab?.libelle || '').trim();
        const code = String(etab?.code_etablissement || '').trim();
        if (libelle && code) {
            return `${libelle} (${code})`;
        }
        return libelle || code || `Établissement #${etab?.id}`;
    }

    private buildOrgSelectOptions(etabs: EtablissementRow[]): DocumentOrgSelectOption[] {
        const options: DocumentOrgSelectOption[] = [];
        for (const s of listUserStationsFromLocalStorage()) {
            const id = this.stationOptionId(s);
            if (id <= 0) {
                continue;
            }
            const label =
                getEnterpriseNameFromStation(s) ||
                String(s['label'] || '').trim() ||
                `Station #${id}`;
            options.push({ key: `station:${id}`, type: 'station', id, label });
        }
        for (const e of etabs || []) {
            const id = Math.floor(Number(e.id));
            if (!Number.isFinite(id) || id <= 0) {
                continue;
            }
            options.push({
                key: `etab:${id}`,
                type: 'etablissement',
                id,
                label: this.etablissementOptionLabel(e),
            });
        }
        return options;
    }

    private applySelectedOrgDisplay(): void {
        const opt = this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) || null;
        if (!opt) {
            return;
        }
        this.stationName = opt.label;
        if (opt.type === 'etablissement') {
            this.selectedEtablissementId = opt.id;
        } else {
            this.selectedEtablissementId = null;
        }
        this.applyFooterForSelectedOrg(opt);
    }

    private applyOrgSelection(preferId?: number | null): void {
        const preferredEtab = Number(preferId);
        const preferredEtabKey =
            Number.isFinite(preferredEtab) && preferredEtab > 0 ? `etab:${preferredEtab}` : null;
        const currentStationKey = `station:${Number(this.stationId) || 0}`;

        if (preferredEtabKey && this.orgSelectOptions.some((o) => o.key === preferredEtabKey)) {
            this.selectedOrgKey = preferredEtabKey;
            this.selectedEtablissementId = preferredEtab;
        } else if (
            this.selectedOrgKey &&
            this.orgSelectOptions.some((o) => o.key === this.selectedOrgKey)
        ) {
            // conserve
        } else if (this.orgSelectOptions.some((o) => o.key === currentStationKey)) {
            this.selectedOrgKey = currentStationKey;
        } else {
            this.selectedOrgKey = this.orgSelectOptions[0]?.key ?? null;
        }
        this.applySelectedOrgDisplay();
        // Aligne le filtre entrepôt sur l'établissement (pré)sélectionné (ex. depuis le POS).
        this.loadEtablissementEntrepotLinks();
    }

    private fetchEtablissementsRows(): Observable<EtablissementRow[]> {
        if (!this.lcAuth.getBackStationId()) {
            return of([] as EtablissementRow[]);
        }
        try {
            return this.lcAssociations.listEtablissements().pipe(
                catchError(() => of([] as EtablissementRow[]))
            );
        } catch {
            return of([] as EtablissementRow[]);
        }
    }

    /** Stations locales tout d’suite, établissements LC en arrière-plan (cache + skip bootstrap si prêt). */
    private refreshAvailableEtablissements(preferId?: number | null): void {
        // 1) Peindre les stations immédiatement (pas d’attente réseau).
        this.orgSelectOptions = this.buildOrgSelectOptions(this.availableEtablissements);
        this.applyOrgSelection(preferId);
        this.loadingEtablissements = true;
        this.cdr.detectChanges();

        const applyRows = (rows: EtablissementRow[]) => {
            this.availableEtablissements = Array.isArray(rows) ? rows : [];
            this.orgSelectOptions = this.buildOrgSelectOptions(this.availableEtablissements);
            this.applyOrgSelection(preferId);
            this.loadingEtablissements = false;
            this.cdr.detectChanges();
        };

        const load$ = this.lcAuth.isReadyForNavigation()
            ? this.fetchEtablissementsRows()
            : this.lcAuth.bootstrap().pipe(
                  catchError(() => of('needs_setup' as const)),
                  switchMap(() => this.fetchEtablissementsRows())
              );

        load$
            .pipe(
                finalize(() => {
                    if (!this.orgSelectOptions.length) {
                        this.orgSelectOptions = this.buildOrgSelectOptions([]);
                        this.applyOrgSelection(preferId);
                    }
                    this.loadingEtablissements = false;
                    this.cdr.detectChanges();
                })
            )
            .subscribe({ next: applyRows });
    }

    /** Station / établissement modifiable en brouillon (création ou édition). */
    canEditDocumentEtablissement(): boolean {
        if (this.mode !== 'add' && this.mode !== 'edit') {
            return false;
        }
        if (this.mode === 'add' && !this.documentId) {
            return true;
        }
        const sid = Number(this.currentStatutId);
        const brouillonId = Number(this.statutIdMap['Brouillon']);
        return Number.isFinite(sid) && Number.isFinite(brouillonId) && sid === brouillonId;
    }

    /** Changement station ERP ou établissement LC. */
    onDocumentOrgSelectChange(value: unknown): void {
        if (!this.canEditDocumentEtablissement()) {
            return;
        }
        let opt: DocumentOrgSelectOption | null = null;
        if (value != null && typeof value === 'object' && 'key' in (value as object)) {
            opt = value as DocumentOrgSelectOption;
        } else {
            const key = String(value ?? '');
            opt = this.orgSelectOptions.find((o) => o.key === key) || null;
        }
        if (!opt) {
            return;
        }
        this.selectedOrgKey = opt.key;
        this.stationName = opt.label;

        if (opt.type === 'etablissement') {
            this.selectedEtablissementId = opt.id;
            this.applyFooterForSelectedOrg(opt);
            // Restreint les entrepôts aux seuls reliés à cet établissement.
            this.loadEtablissementEntrepotLinks();
            this.cdr.detectChanges();
            return;
        }

        // Station ERP : bascule le contexte document.
        this.selectedEtablissementId = null;
        if (opt.id === Number(this.stationId)) {
            this.applyFooterForSelectedOrg(opt);
            this.applyEntrepotEstablishmentFilter();
            this.cdr.detectChanges();
            return;
        }
        setConnectedEnterpriseStationId(opt.id, {
            label: opt.label,
            nom_entreprise: opt.label,
        });
        this.stationId = opt.id;
        this.lcAuth.syncWithErpContext();
        // Recharge uniquement les données liées à la station (sans re-bootstrap LC systématique).
        this.loadStationData();
        this.loadClients();
        this.loadFournisseurs();
        this.loadProducts();
        this.loadWarehouses();
        this.loadProjects();
        this.loadTvaRates();
        this.loadCategories();
        this.loadTaxes();
        this.referenceModelType = this.documentService.getDefaultReferenceModelType(this.stationId, this.typeDocumentIdMap[this.documentType]);
        this.loadCurrentTypeDocumentPrefixFromApi();
        if (!this.documentId && this.mode === 'add') {
            this.documentReference = '';
            this.refExterne = '';
        }
        this.maybePrefetchNextDocumentReference(true);
        this.cdr.detectChanges();
    }

    private resolveStationLogoUrl(logo?: string | null): string | null {
        const raw = String(logo ?? '').trim();
        if (!raw || raw.endsWith('/')) {
            return null;
        }
        if (raw.startsWith('http://') || raw.startsWith('https://')) {
            return raw;
        }
        const logoPath = raw.startsWith('/') ? raw : `/${raw}`;
        return `${this.urlImages}${logoPath}`;
    }

    /** Logo cassé / URL invalide : on masque l’image mais on conserve l’emplacement. */
    onDocumentLogoError(): void {
        this.documentLogoBroken = true;
        this.cdr.markForCheck();
    }

    /** Initiales affichées quand l’établissement n’a pas de logo. */
    getDocumentLogoInitials(): string {
        const label = String(this.stationName || '').trim();
        if (!label) {
            return 'ET';
        }
        const parts = label.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
        }
        return label.slice(0, 2).toUpperCase();
    }

    private applyStationFooterContact(station: any): void {
        const coord = station?.coordonnees?.[0];
        const prenom = (coord?.prenom ?? '').toString().trim();
        const nom = (coord?.nom ?? '').toString().trim();
        const fullName = [prenom, nom].filter(Boolean).join(' ').trim();
        this.stationFooterCoordName = fullName || '--';
        const email = (coord?.email ?? station?.email ?? '').toString().trim();
        this.stationFooterCoordEmail = email || '--';
        const telList =
            Array.isArray(station?.telephones) && station.telephones.length
                ? station.telephones
                : Array.isArray(coord?.telephones)
                  ? coord.telephones
                  : [];
        const nums = telList
            .map((t: any) => (t?.numero ?? '').toString().trim())
            .filter(Boolean);
        this.stationFooterCoordPhones = nums.length ? nums.join(', ') : '--';
    }

    /** Snapshot footer station, pour restaurer après un choix établissement. */
    private stationEntrepriseSnapshot: {
        nom: string;
        adresse: string;
        ville: string;
        pays: string;
        matricule_fiscal: string;
    } | null = null;

    /** Met à jour le bloc Entreprise du footer selon société (station) ou établissement. */
    private applyFooterForSelectedOrg(opt?: DocumentOrgSelectOption | null): void {
        const selected =
            opt ||
            this.orgSelectOptions.find((o) => o.key === this.selectedOrgKey) ||
            null;
        if (!selected) {
            return;
        }
        if (selected.type === 'etablissement') {
            const etab =
                this.availableEtablissements.find((e) => Number(e.id) === Number(selected.id)) ||
                null;
            if (!etab) {
                if (this.entreprise) {
                    this.entreprise = { ...this.entreprise, nom: selected.label };
                }
                return;
            }
            const adresseParts = [etab.adresse, etab.code_postal].filter((x) =>
                String(x || '').trim()
            );
            this.entreprise = {
                nom: selected.label || this.etablissementOptionLabel(etab),
                adresse: adresseParts.length ? adresseParts.join(', ') : '--',
                ville: String(etab.ville || '').trim(),
                pays: String(etab.pays || '').trim(),
                matricule_fiscal:
                    String(etab.numero_identification_fiscale || '').trim() || '--',
            };
            this.stationName = this.entreprise.nom;
            return;
        }
        if (this.stationEntrepriseSnapshot) {
            this.entreprise = {
                ...this.stationEntrepriseSnapshot,
                nom: selected.label || this.stationEntrepriseSnapshot.nom,
            };
            this.stationName = this.entreprise.nom;
        } else if (this.entreprise) {
            this.entreprise = { ...this.entreprise, nom: selected.label };
            this.stationName = selected.label;
        }
    }

    /** Snapshot entreprise envoyé à l’API (footer document). */
    private buildEntreprisesPayload(): Array<{
        nom_entreprise: string;
        adresse?: string;
        matricule_fiscale?: string | null;
        telephone?: string | null;
        email?: string | null;
    }> {
        const adresseParts = [
            this.entreprise?.adresse,
            this.entreprise?.ville,
            this.entreprise?.pays,
        ]
            .map((x) => String(x || '').trim())
            .filter((x) => x && x !== '--');
        const matricule = String(this.entreprise?.matricule_fiscal || '').trim();
        const tel = String(this.stationFooterCoordPhones || '').trim();
        const email = String(this.stationFooterCoordEmail || '').trim();
        return [
            {
                nom_entreprise: String(this.entreprise?.nom || this.stationName || '--').trim() || '--',
                adresse: adresseParts.length ? adresseParts.join(', ') : undefined,
                matricule_fiscale: matricule && matricule !== '--' ? matricule : null,
                telephone: tel && tel !== '--' ? tel : null,
                email: email && email !== '--' ? email : null,
            },
        ];
    }

    /** Charge les comptes bancaires de la station pour le footer. */
    private loadBanquesForDocument(preferRib?: string | null): void {
        if (!this.stationId) {
            this.availableBanques = [];
            this.selectedBanqueId = null;
            this.applySelectedBanqueDisplay();
            return;
        }
        this.banqueService.getBanques(this.stationId).subscribe({
            next: (response) => {
                const list = Array.isArray(response?.banques) ? response.banques : [];
                this.availableBanques = list.filter(
                    (b) => b && b.statut !== false && Number((b as any).statut) !== 0
                );
                const prefer = String(preferRib || this.banque?.rib || '').trim();
                let chosen: Banque | null = null;
                if (prefer && prefer !== '--') {
                    chosen =
                        this.availableBanques.find((b) => String(b.rib || '').trim() === prefer) || null;
                }
                if (!chosen && this.selectedBanqueId != null) {
                    chosen =
                        this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) ||
                        null;
                }
                if (!chosen && this.availableBanques.length) {
                    chosen = this.availableBanques[0];
                }
                this.selectedBanqueId = chosen?.id != null ? Number(chosen.id) : null;
                this.applySelectedBanqueDisplay();
                this.cdr.markForCheck();
            },
            error: () => {
                this.availableBanques = [];
                if (!this.banque?.rib || this.banque.rib === '--') {
                    this.banque = { nom_banque: '--', rib: '--' };
                }
                this.cdr.markForCheck();
            },
        });
    }

    banqueOptionLabel(b: Banque | null | undefined): string {
        if (!b) {
            return '';
        }
        const name = String(b.nom || b.designation || 'Compte').trim();
        const rib = String(b.rib || '').trim();
        return rib ? `${name} — ${rib}` : name;
    }

    onSelectedBanqueChange(id: number | null): void {
        this.selectedBanqueId = id != null ? Number(id) : null;
        this.applySelectedBanqueDisplay();
        this.cdr.detectChanges();
    }

    private applySelectedBanqueDisplay(): void {
        const selected =
            this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) || null;
        if (selected) {
            this.banque = {
                nom_banque: String(selected.nom || selected.designation || 'Banque').trim() || 'Banque',
                rib: String(selected.rib || '').trim() || '--',
                agence: selected.agence || null,
                designation: selected.designation || null,
            };
            return;
        }
        if (!this.availableBanques.length) {
            if (!this.banque?.rib || this.banque.rib === '--') {
                this.banque = { nom_banque: '--', rib: '--' };
            }
        }
    }

    canSelectDocumentBanque(): boolean {
        return this.mode !== 'validation' && this.availableBanques.length > 1;
    }

    /** Coordonnées bancaires persistées avec le document. */
    private buildCoordonneesBancairesPayload(): Array<{
        nom: string;
        rib: string;
        banque?: string | null;
        agence?: string | null;
    }> {
        const selected =
            this.availableBanques.find((b) => Number(b.id) === Number(this.selectedBanqueId)) || null;
        if (selected) {
            return [
                {
                    nom: String(selected.designation || selected.nom || 'Compte').trim() || 'Compte',
                    rib: String(selected.rib || '').trim(),
                    banque: String(selected.nom || '').trim() || null,
                    agence: selected.agence || null,
                },
            ];
        }
        const rib = String(this.banque?.rib || '').trim();
        const nom = String(this.banque?.nom_banque || '').trim();
        if (!rib || rib === '--') {
            return [];
        }
        return [
            {
                nom: nom && nom !== '--' ? nom : 'Compte',
                rib,
                banque: nom && nom !== '--' ? nom : null,
                agence: this.banque?.agence || null,
            },
        ];
    }

    private loadParametreDocumentCachet(): void {
        if (!this.stationId) {
            this.documentCachetUrl = null;
            return;
        }
        this.parametreDocumentSettingsService.getByStation(this.stationId).subscribe({
            next: (bundle) => {
                const pd = bundle?.parametre_document;
                const raw = pd?.image_cachet ?? null;
                this.documentCachetUrl = this.resolveCachetDisplayUrl(raw);
                this.paramDocAffProduitMatriciel = isTruthyTinyInt(pd?.aff_produit_matriciel ?? 1);
                this.cdr.markForCheck();
            },
            error: () => {
                this.documentCachetUrl = null;
                this.cdr.markForCheck();
            }
        });
    }

    private resolveCachetDisplayUrl(raw: string | null | undefined): string | null {
        if (raw == null || raw === '') {
            return null;
        }
        const s = String(raw).trim();
        if (s.startsWith('data:') || s.startsWith('http://') || s.startsWith('https://')) {
            return s;
        }
        const base = this.urlImages.replace(/\/$/, '');
        const path = s.startsWith('/') ? s : `/${s}`;
        return `${base}${path}`;
    }

    onCategorieSelect(categorieLibelle: string): void {
        const categorie = this.categories.find(c => c.libelle === categorieLibelle);
        if (categorie) {
            this.selectedCategorie = categorieLibelle;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        } else {
            this.selectedCategorie = '';
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }
    }

    onCategorieSaved(newCategorie: Categorie): void {
        this.toastr.success('Catégorie ajoutée avec succès !', 'Succès');
        this.loadCategories();
        setTimeout(() => {
            this.selectedCategorie = newCategorie.libelle;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
        }, 500);
    }

    loadTvaRates(): void {
        if (!this.stationId) {
            this.isLoadingTvaRates = false;
            this.tvaRates = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingTvaRates = true;
        this.tvaService.getTvaList(this.stationId).subscribe({
            next: (response) => {
                this.zone.run(() => {
                    const liste = response?.tvaListe || [];
                    this.tvaRates = Array.isArray(liste)
                        ? liste.filter((tva: any) => tva.statut === true)
                        : [];

                    this.isLoadingTvaRates = false;
                    this.cdr.detectChanges();
                });
            },
            error: (err) => {
                this.zone.run(() => {
                    this.isLoadingTvaRates = false;
                    this.tvaRates = [];
                    this.toastr.error('Erreur lors du chargement des taux de TVA.', 'Erreur');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    getStockBadgeClass(product: Product): string {
        if (!product.informations_logistique || product.informations_logistique.length === 0 || product.informations_logistique.every(info => info.minimum <= 0)) {
            return 'badge-tous';
        }
        return 'badge-en-stok';
    }

    getStockStatus(product: Product | Item): string {
        const quantity = this.getStockQuantity(product);
        if (quantity > 0) {
            return 'En stock';
        }
        return 'En rupture';
    }
    private stockQuantitiesCache: Map<string, number> = new Map();
    private averagePurchasePriceCache: Map<number, number> = new Map();

    reloadStockQuantitiesForAllProducts(): void {
        let count = 0;
        this.items.forEach((item, index) => {
            if (item.type === 'product' && item.product_id) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
                count++;
            }
        });
    }
    private shouldFilterStockByEntrepot(): boolean {
        const documentTypesRequiringEntrepot = [
            'BON DE LIVRAISON',
            'BON RECEPTION',
            'INVENTAIRE',
            'BON TRANSFERT'
        ];
        return documentTypesRequiringEntrepot.includes(this.documentType);
    }

    /** Ng-select entrepôt (hors bon de transfert et avoir : l'avoir reprend l'entrepôt source). */
    shouldShowSingleWarehouseSelect(): boolean {
        if (!this.isEntrepotVisible || this.documentType === 'BON TRANSFERT' || this.isAvoirWarehouseLocked()) {
            return false;
        }
        return [
            'BON RECEPTION',
            'FACTURE FOURNISSEUR',
            'FACTURE',
            'BON DE LIVRAISON',
            'AVOIR',
            'INVENTAIRE'
        ].includes(this.documentType);
    }

    shouldShowLockedWarehouseDisplay(): boolean {
        return this.isEntrepotVisible && this.isAvoirWarehouseLocked();
    }

    private isAvoirWarehouseLocked(): boolean {
        // Avoir fournisseur figé si besoin métier séparé ; avoir client sélectionnable pour le stock.
        return this.documentType === 'AVOIR FOURNISSEUR';
    }

    getLockedWarehouseLabel(): string {
        if (this.lockedWarehouseName && String(this.lockedWarehouseName).trim() !== '') {
            return String(this.lockedWarehouseName).trim();
        }
        const id = Number(this.selectedWarehouseId);
        if (!Number.isFinite(id) || id <= 0) {
            return '--';
        }
        const w = (this.warehouses || []).find((x: any) => Number(x?.id) === id);
        const nom = w?.nom || w?.libelle || w?.label;
        return nom && String(nom).trim() !== '' ? String(nom).trim() : `Entrepôt ${id}`;
    }

    private applySourceWarehouseFromDoc(doc: any): void {
        if (!doc) {
            return;
        }
        const erpId = Number(doc.entrepot_id ?? doc.entrepot?.id);
        let hidden: any = doc?.hidden_fournisseur_fields;
        if (typeof hidden === 'string') {
            try {
                hidden = JSON.parse(hidden);
            } catch {
                hidden = null;
            }
        }
        const lcFromHidden = Number(hidden?.[LC_ENTREPOT_HIDDEN_KEY]);
        let entrepotId: number | null = null;
        if (Number.isFinite(lcFromHidden) && lcFromHidden > 0) {
            entrepotId = lcFromHidden;
        } else if (Number.isFinite(erpId) && erpId > 0) {
            const mapped = [...(this.warehouses || []), ...(this.allWarehouses || [])].find(
                (x: any) => Number(x?.erp_id) === erpId || Number(x?.erp_entrepot_id) === erpId
            );
            entrepotId = mapped ? Number(mapped.id) : erpId;
        }
        if (entrepotId == null) {
            return;
        }
        this.selectedWarehouseId = entrepotId;
        const nom = doc.entrepot?.nom || doc.entrepot?.libelle || doc.entrepot?.label || doc.code_entrepot;
        if (nom != null && String(nom).trim() !== '') {
            this.lockedWarehouseName = String(nom).trim();
        }
    }

    showQuantiteDisponibleColumn(): boolean {
        return (
            this.documentType === 'INVENTAIRE' ||
            this.documentType === 'BON TRANSFERT' ||
            this.documentType === 'BON DE LIVRAISON' ||
            this.documentType === 'BON RECEPTION'
        );
    }

    private getProductLogisticsInfoArray(product: any): any[] {
        if (!product || typeof product !== 'object') {
            return [];
        }
        const raw =
            product.informations_logistique ??
            product.information_logistique ??
            product.informationsLogistique ??
            product.informations_logistiques ??
            product.product?.informations_logistique ??
            product.data?.informations_logistique ??
            product.data?.information_logistique;
        return Array.isArray(raw) ? raw : [];
    }

    private unwrapProductFromApiResponse(res: any): any {
        if (res == null || typeof res !== 'object') {
            return null;
        }
        const inner =
            res.data?.data ??
            res.data?.product ??
            res.data ??
            res.product ??
            res.produit;
        if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
            return inner;
        }
        return res;
    }

    private parseLogisticMinimum(line: any): number {
        if (line == null || typeof line !== 'object') {
            return NaN;
        }
        const raw = line.minimum ?? line.min ?? line.quantite_min ?? line.stock_min ?? line.seuil_min;
        const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.'));
        return Number.isFinite(n) ? n : NaN;
    }

    private nearlyEqualQty(a: number, b: number): boolean {
        return Math.abs(a - b) < 1e-6;
    }

    private isLogisticAlertEnabledOnLine(line: any): boolean {
        if (!line || typeof line !== 'object') {
            return false;
        }
        const v = line.is_active_alert ?? line.is_active_alerte ?? line.active_alert;
        if (v === true || v === 1 || v === '1') {
            return true;
        }
        if (v === false || v === 0 || v === '0' || v === '') {
            return false;
        }
        return !!v;
    }

    private isStockRuptureAlertEnabledForItem(item: Item): boolean {
        const pid = item.product_id;
        if (pid == null) {
            return false;
        }
        const product = this.products.find((p) => Number(p.id) === Number(pid));
        if (!product) {
            return false;
        }
        const lines = this.getProductLogisticsInfoArray(product);
        if (lines.length === 0) {
            return false;
        }
        const entrepotId = this.shouldFilterStockByEntrepot() ? this.getEntrepotIdForStockQuantity() : null;
        if (entrepotId != null) {
            const line = lines.find(
                (l) => Number(l.entrepot_id ?? l.entrepotId) === Number(entrepotId)
            );
            if (line) {
                return this.isLogisticAlertEnabledOnLine(line);
            }
            return false;
        }
        return lines.some((l) => this.isLogisticAlertEnabledOnLine(l));
    }

    private queueStockRupturePopup(): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        if (this.stockRupturePopupTimer != null) {
            clearTimeout(this.stockRupturePopupTimer);
        }
        this.stockRupturePopupTimer = setTimeout(() => {
            this.stockRupturePopupTimer = null;
            this.zone.run(() => this.openStockRuptureModalIfNeeded());
        }, 400);
    }


    private getLineStockQtyForRuptureAlert(item: Item): number {
        if (item.stockResolved === true && item.availableQuantity !== undefined && item.availableQuantity !== null) {
            const n = Number(item.availableQuantity);
            return Number.isFinite(n) ? n : 0;
        }
        return this.getStockQuantityForDisplay(item);
    }

    private openStockRuptureModalIfNeeded(): void {
        if (!this.showQuantiteDisponibleColumn()) {
            return;
        }
        const lines = this.items
            .filter(
                (it) =>
                    it.type === 'product' &&
                    !!it.product_id &&
                    !!it.designation?.trim() &&
                    this.isStockRuptureAlertEnabledForItem(it as Item) &&
                    it.stockResolved === true &&
                    this.getLineStockQtyForRuptureAlert(it as Item) <= 0
            )
            .map((it) => ({
                designation: (it.designation || 'Produit').trim(),
                qty: this.getLineStockQtyForRuptureAlert(it as Item)
            }));
        if (lines.length === 0) {
            return;
        }
        this.stockRuptureModalLines = lines;
        this.cdr.detectChanges();

        const openModal = (tpl: TemplateRef<any>) => {
            if (this.stockRuptureModalRef) {
                try {
                    this.stockRuptureModalRef.dismiss();
                } catch {

                }
                this.stockRuptureModalRef = null;
            }
            const ref = this.modalService.open(tpl, {
                ariaLabelledBy: 'modal-stock-rupture-title',
                centered: true,
                size: 'md',
                windowClass: 'warning-modal-centered stock-rupture-modal-window',
                backdropClass: 'stock-rupture-backdrop',
                backdrop: 'static',
                keyboard: true
            });
            this.stockRuptureModalRef = ref;
            ref.result.then(
                () => undefined,
                () => undefined
            ).then(() => {
                if (this.stockRuptureModalRef === ref) {
                    this.stockRuptureModalRef = null;
                }
            });
        };

        const tpl = this.stockRuptureModal;
        if (tpl) {
            openModal(tpl);
            return;
        }
        setTimeout(() => {
            const t2 = this.stockRuptureModal;
            if (t2) {
                this.zone.run(() => openModal(t2));
            } else {
                const msg = lines.map((l) => `• ${l.designation} (dispo : ${l.qty})`).join('\n');
                this.toastr.warning(msg, 'Stock insuffisant', {
                    timeOut: 12000,
                    closeButton: true,
                    enableHtml: false
                });
            }
        }, 0);
    }
    /** Normalise code entrepôt pour matching ERP ↔ LC. */
    private normalizeEntrepotCode(value: unknown): string {
        return String(value ?? '').trim().toUpperCase();
    }

    /**
     * Enrichit les entrepôts LC avec erp_id (match code_entrepot puis libellé).
     * Le select garde id = ID logiciel caisse.
     */
    private enrichLcWarehousesWithErpMapping(lcRows: any[]): Observable<any[]> {
        const rows = Array.isArray(lcRows) ? lcRows : [];
        const userId = Number(this.currentUser?.id) || 0;
        const stationId = Number(this.stationId) || 0;
        const withLcMeta = (list: any[]): any[] =>
            (list || []).map((w) => {
                const lcId = Number(w?.id);
                return {
                    ...w,
                    id: lcId,
                    lc_id: lcId,
                    erp_id: w?.erp_id != null ? Number(w.erp_id) : null,
                    erp_entrepot_id:
                        w?.erp_entrepot_id != null
                            ? Number(w.erp_entrepot_id)
                            : w?.erp_id != null
                              ? Number(w.erp_id)
                              : null,
                };
            });

        if (!(userId > 0) || !(stationId > 0) || !rows.length) {
            return of(withLcMeta(rows));
        }

        return this.warehouseService.getAllWarehouses(userId, stationId).pipe(
            map((erpRows: any[]) => {
                const byCode = new Map<string, number>();
                const byName = new Map<string, number>();
                for (const e of erpRows || []) {
                    const eid = Number(e?.id);
                    if (!Number.isFinite(eid) || eid <= 0) {
                        continue;
                    }
                    const code = this.normalizeEntrepotCode(e?.code ?? e?.code_entrepot);
                    if (code) {
                        byCode.set(code, eid);
                    }
                    const nom = String(e?.nom ?? e?.libelle ?? '').trim().toLowerCase();
                    if (nom) {
                        byName.set(nom, eid);
                    }
                }
                return (rows || []).map((w) => {
                    const lcId = Number(w?.id);
                    const code = this.normalizeEntrepotCode(w?.code_entrepot ?? w?.code);
                    const nom = String(w?.nom ?? w?.libelle ?? '').trim().toLowerCase();
                    const erpId =
                        (code && byCode.get(code)) || (nom && byName.get(nom)) || null;
                    return {
                        ...w,
                        id: lcId,
                        lc_id: lcId,
                        erp_id: erpId,
                        erp_entrepot_id: erpId,
                    };
                });
            }),
            catchError(() => of(withLcMeta(rows)))
        );
    }

    /** ID ERP à partir de la sélection UI (id LC ou déjà ERP). */
    private resolveErpEntrepotIdFromSelection(selectedId: number | null | undefined): number | null {
        if (selectedId == null) {
            return null;
        }
        const n = Number(selectedId);
        if (!Number.isFinite(n) || n <= 0) {
            return null;
        }
        const pool = [...(this.warehouses || []), ...(this.allWarehouses || [])];
        const w = pool.find(
            (x: any) =>
                Number(x?.id) === n ||
                Number(x?.lc_id) === n ||
                Number(x?.erp_id) === n ||
                Number(x?.erp_entrepot_id) === n
        );
        const erp = Number(w?.erp_id ?? w?.erp_entrepot_id);
        if (Number.isFinite(erp) && erp > 0) {
            return erp;
        }
        // Repli : id hors liste LC = souvent déjà un id ERP (ancien document).
        if (!w) {
            return n;
        }
        return null;
    }

    /** ID logiciel caisse à partir de la sélection UI. */
    private resolveLcEntrepotIdFromSelection(selectedId: number | null | undefined): number | null {
        if (selectedId == null) {
            return null;
        }
        const n = Number(selectedId);
        if (!Number.isFinite(n) || n <= 0) {
            return null;
        }
        const pool = [...(this.warehouses || []), ...(this.allWarehouses || [])];
        const w = pool.find(
            (x: any) =>
                Number(x?.id) === n ||
                Number(x?.lc_id) === n ||
                Number(x?.erp_id) === n ||
                Number(x?.erp_entrepot_id) === n
        );
        const lc = Number(w?.lc_id ?? w?.id);
        if (Number.isFinite(lc) && lc > 0) {
            return lc;
        }
        return n;
    }

    private getEntrepotIdForStockQuantity(): number | null {
        // Quantités / mouvements ERP → ID entrepôt ERP (jamais l'id LC brut).
        if (this.documentType === 'BON TRANSFERT') {
            return this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseInitialId);
        }
        return this.resolveErpEntrepotIdFromSelection(this.selectedWarehouseId);
    }

    /** Entrepôt ERP pour alimenter le stock (bon réception « Reçu », etc.). */
    private resolveWarehouseIdForStockUpdate(): number | null {
        return this.getEntrepotIdForStockQuantity();
    }
    private getStockCacheKey(productId: number, entrepotId?: number | null): string {
        if (this.shouldFilterStockByEntrepot() && entrepotId) {
            return `${productId}_${entrepotId}`;
        }
        return `${productId}`;
    }

    getStockQuantity(product: Product | Item): number {
        const useCacheOnly = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
        if (!useCacheOnly && 'availableQuantity' in product && product.availableQuantity !== undefined && product.availableQuantity !== null) {
            return product.availableQuantity;
        }
        let productId: number | undefined;
        let entrepotId: number | null | undefined;
        
        if ('product_id' in product && product.product_id) {
            productId = product.product_id;
        } else if ('id' in product && product.id !== undefined && product.id !== null) {
            productId = product.id;
        }
        if (this.shouldFilterStockByEntrepot()) {
            entrepotId = this.getEntrepotIdForStockQuantity();
        }
        if (productId !== undefined) {
            const cacheKey = this.getStockCacheKey(productId, entrepotId);
            const cachedQty = this.stockQuantitiesCache.get(cacheKey);
            if (cachedQty !== undefined) {
                return cachedQty;
            }

            if (productId !== undefined && productId !== null) {
                if (this.shouldFilterStockByEntrepot() && entrepotId) {
                    this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                        next: (stockDetails: any) => {
                            let quantity = 0;
                            if (stockDetails && stockDetails.stocks_by_entrepot) {
                                const stockByEntrepot = stockDetails.stocks_by_entrepot.find((stock: any) => 
                                    stock.entrepot_id === entrepotId || stock.entrepotId === entrepotId
                                );
                                
                                if (stockByEntrepot) {
                                    quantity = Number(stockByEntrepot.quantity || stockByEntrepot.qty || 0);
                                } else {
                                    quantity = 0;
                                }
                            } else {
                                quantity = 0;
                            }
                            
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, quantity);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = quantity;
                            }
                            this.cdr.detectChanges();
                        },
                        error: (error) => {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            this.cdr.detectChanges();
                        }
                    });
                } else {
                    this.stockService.getStockDetailsByErpProductId(productId).subscribe({
                        next: (stockDetails: any) => {
                            if (!stockDetails) {
                                const cacheKey = this.getStockCacheKey(productId, entrepotId);
                                this.stockQuantitiesCache.set(cacheKey, 0);
                                this.cdr.detectChanges();
                                return;
                            }
                            
                            let quantity = 0;
                            
                            if (this.shouldFilterStockByEntrepot() && entrepotId) {
                                const stockByEntrepot = stockDetails.stocks_by_entrepot?.find((stock: any) => stock.entrepot_id === entrepotId);
                                if (stockByEntrepot) {
                                    quantity = Number(stockByEntrepot.quantity || 0);
                                } else {
                                    quantity = 0;
                                }
                            } else {
                                quantity = Number(stockDetails.total_quantity || 0);
                            }
                            
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, quantity);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = quantity;
                            }
                            this.cdr.detectChanges();
                        },
                        error: () => {
                            const cacheKey = this.getStockCacheKey(productId, entrepotId);
                            this.stockQuantitiesCache.set(cacheKey, 0);
                            const prod = this.products.find(p => p.id === productId);
                            if (prod) {
                                (prod as any).availableQuantity = 0;
                            }
                            this.cdr.detectChanges();
                        }
                    });
                }
            }
            return 0;
        }
        if ('informations_logistique' in product && product.informations_logistique && product.informations_logistique.length > 0) {
            return product.informations_logistique[0].minimum || 0;
        }
        
        return 0;
    }
    getStockQuantityForDisplay(item: Product | Item | null | undefined): number {
        if (item == null) return 0;
        const useLineOnly =
            this.documentType === 'INVENTAIRE' ||
            this.documentType === 'BON TRANSFERT' ||
            this.documentType === 'BON DE LIVRAISON' ||
            this.documentType === 'BON RECEPTION';
        if (useLineOnly && 'availableQuantity' in item && (item as Item).availableQuantity != null) {
            const n = Number((item as Item).availableQuantity);
            return Number.isFinite(n) ? n : 0;
        }
        const useCacheOnly = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT');
        const qty = useCacheOnly
            ? (this.getStockQuantity(item) ?? 0)
            : (('availableQuantity' in item && item.availableQuantity != null) ? item.availableQuantity : (this.getStockQuantity(item) ?? 0));
        const num = Number(qty);
        return Number.isFinite(num) ? num : 0;
    }

    private applyStockToLine(
        index: number,
        productId: number,
        quantity: number,
        entrepotId: number | null | undefined,
        shouldUpdateCache: boolean
    ): void {
        const row = this.items[index];
        if (!row || row.type !== 'product' || Number(row.product_id) !== Number(productId)) {
            return;
        }
        const q = !Number.isFinite(quantity) || quantity < 0 ? 0 : quantity;
        row.availableQuantity = q;
        row.stockResolved = true;
        if (shouldUpdateCache) {
            const cacheKey = this.getStockCacheKey(productId, entrepotId);
            this.stockQuantitiesCache.set(cacheKey, q);
        }
        this.afterStockLineUpdated();
    }

    private loadStockQuantity(productId: number, refInterne: string, index: number): void {
        
        const item = this.items[index];
        if (!item) {
            return;
        }
        item.stockResolved = false;
        // BON TRANSFERT / INVENTAIRE : ne pas écraser le cache global (utilisé par le select produits).
        // Le stock affiché doit rester le stock réel jusqu'à approbation du document.
        const isStockDoc = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
        const shouldUpdateCache = !isStockDoc;

        const entrepotIdErp = this.shouldFilterStockByEntrepot()
            ? this.getEntrepotIdForStockQuantity()
            : null;
        const product = this.findProductForLcStockMeta(productId, refInterne);
        const meta = this.buildLcStockMetaFromProduct(product, productId, refInterne);
        if (!meta) {
            this.applyStockToLine(index, productId, 0, entrepotIdErp, shouldUpdateCache);
            return;
        }
        this.lcStockGestion
            .getStockGlobaleByErpProducts([meta], {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .subscribe({
                next: (rec) => {
                    // Colonne « Quantité disponible » = stock_disponible_global (Gestion stock).
                    const qty = rec[productId]?.disponible ?? 0;
                    this.applyStockToLine(index, productId, qty, entrepotIdErp, shouldUpdateCache);
                },
                error: () => {
                    this.applyStockToLine(index, productId, 0, entrepotIdErp, shouldUpdateCache);
                },
            });
    }

    private afterStockLineUpdated(): void {
        this.cdr.detectChanges();
        this.queueStockRupturePopup();
    }

    private readUserIdFromLocalStorage(): number | null {
        try {
            const u = JSON.parse(localStorage.getItem('currentUser') || '{}');
            const id = u?.id ?? u?.user_id;
            if (id == null || id === '') {
                return null;
            }
            const n = Number(id);
            return Number.isFinite(n) && n > 0 ? n : null;
        } catch {
            return null;
        }
    }

    private readStationIdFromLocalStorageForBarcodeApi(): number {
        return getStationIdFromLocalStorage();
    }

    private isProductLikeObject(o: any): boolean {
        if (!o || typeof o !== 'object' || Array.isArray(o)) {
            return false;
        }
        const id = o.id;
        if (id == null || id === '') {
            return false;
        }
        const idNum = Number(id);
        if (!Number.isFinite(idNum)) {
            return false;
        }
        const labelKeys = ['nom', 'designation', 'name', 'libelle', 'label', 'title', 'intitule'];
        if (labelKeys.some((k) => o[k] != null && String(o[k]).trim() !== '')) {
            return true;
        }
        const skuKeys = ['ref_interne', 'reference', 'sku', 'code_article'];
        if (skuKeys.some((k) => o[k] != null && String(o[k]).trim() !== '')) {
            return true;
        }
        if (o.code_barre != null && String(o.code_barre).trim() !== '') {
            return true;
        }
        return false;
    }

    private collectProductLikeFromBarcodeResponse(node: any, out: any[], depth: number): void {
        if (node == null || depth > 12) {
            return;
        }
        if (Array.isArray(node)) {
            for (const el of node) {
                this.collectProductLikeFromBarcodeResponse(el, out, depth + 1);
            }
            return;
        }
        if (typeof node !== 'object') {
            return;
        }
        if (this.isProductLikeObject(node)) {
            out.push(node);
            return;
        }
        for (const k of Object.keys(node)) {
            const v = (node as any)[k];
            if (v != null && typeof v === 'object') {
                this.collectProductLikeFromBarcodeResponse(v, out, depth + 1);
            }
        }
    }

    private normalizeDocumentProductFromBarcodeApi(raw: any): any {
        if (!raw || typeof raw !== 'object') {
            return raw;
        }
        const nom =
            raw.nom ??
            raw.designation ??
            raw.name ??
            raw.libelle ??
            raw.label ??
            raw.title ??
            raw.intitule ??
            '';
        let liste_prix = raw.liste_prix;
        if (Array.isArray(liste_prix) && liste_prix.length > 0) {
            liste_prix = liste_prix[0];
        }
        const ref_interne = raw.ref_interne ?? raw.reference ?? raw.sku ?? raw.code_article ?? '';
        const ct = this.extractCouleurTailleFromProductLike(raw);
        return {
            ...raw,
            nom: String(nom || '').trim() || String(ref_interne || '').trim() || `Produit #${raw.id}`,
            ref_interne: ref_interne || raw.ref_interne,
            liste_prix,
            couleur: ct.couleur || raw.couleur || null,
            taille: ct.taille || raw.taille || null,
        };
    }

    private unwrapProductsFromBarcodeApiResponse(res: any): Product[] {
        if (res == null) {
            return [];
        }
        const collected: any[] = [];
        this.collectProductLikeFromBarcodeResponse(res, collected, 0);
        const byId = new Map<number, any>();
        for (const p of collected) {
            const id = Number(p.id);
            if (Number.isFinite(id)) {
                byId.set(id, p);
            }
        }
        let list = Array.from(byId.values());
        if (list.length === 0 && this.isProductLikeObject(res)) {
            list = [res];
        }
        return list.map((p) => this.normalizeDocumentProductFromBarcodeApi(p)) as Product[];
    }

    private mergeProductsFromBarcodeApiIntoStore(products: Product[]): void {
        if (!products?.length) {
            return;
        }
        let changed = false;
        for (const p of products) {
            const id = p?.id;
            if (id == null) {
                continue;
            }
            const n = Number(id);
            if (!Number.isFinite(n)) {
                continue;
            }
            const idx = this.products.findIndex((pr) => Number(pr.id) === n);
            if (idx < 0) {
                this.products.push(p as Product);
                changed = true;
            }
        }
        if (changed) {
            this.invalidateBarcodePickerItemsCache();
            this.rebuildProductsForDocumentSelect();
        }
    }

    private filterProductsByBarcodeClientSide(base: Product[], qNoSpace: string): Product[] {
        return base.filter((p: any) => {
            const cb = p?.code_barre;
            if (cb == null || cb === '') {
                return false;
            }
            const s = String(cb).trim();
            if (s === '' || s === '0') {
                return false;
            }
            const normalized = s.replace(/\s/g, '');
            return normalized.includes(qNoSpace);
        });
    }

    onProductLineBarcodeQueryChange(lineIndex: number, value: string | null | undefined): void {
        const qTrim = value != null ? String(value).trim() : '';
        const prevTimer = this.barcodeLineDebounceTimers[lineIndex];
        if (prevTimer != null) {
            clearTimeout(prevTimer);
            delete this.barcodeLineDebounceTimers[lineIndex];
        }
        if (!qTrim) {
            delete this.productLineBarcodeApiHits[lineIndex];
            delete this.productLineBarcodeSearchLoading[lineIndex];
            this.cdr.markForCheck();
            return;
        }
        this.barcodeLineDebounceTimers[lineIndex] = setTimeout(() => {
            delete this.barcodeLineDebounceTimers[lineIndex];
            this.fetchProductsByBarcodeFromApi(lineIndex, qTrim);
        }, 400);
    }

    private fetchProductsByBarcodeFromApi(lineIndex: number, codeBarre: string): void {
        const requested = String(codeBarre).trim();
        const requestedNoSpace = requested.replace(/\s/g, '');
        const userId = this.readUserIdFromLocalStorage();
        const stationId = this.readStationIdFromLocalStorageForBarcodeApi();
        if (!userId || !stationId) {
            this.toastr.warning(
                'Impossible d’appeler l’API code à barre : utilisateur ou station manquant dans localStorage.',
                'Code à barre'
            );
            return;
        }
        this.productLineBarcodeSearchLoading[lineIndex] = true;
        this.cdr.markForCheck();
        this.productsService
            .getProductsByCodeBarre(codeBarre, stationId, userId)
            .pipe(
                finalize(() => {
                    this.productLineBarcodeSearchLoading[lineIndex] = false;
                    this.cdr.markForCheck();
                }),
                catchError(() => {
                    delete this.productLineBarcodeApiHits[lineIndex];
                    this.toastr.error(
                        'Impossible de récupérer le produit par code à barre.',
                        'Erreur'
                    );
                    return of(null);
                })
            )
            .subscribe((res) => {
                if (res == null) {
                    return;
                }
                const list = this.unwrapProductsFromBarcodeApiResponse(res);
                this.productLineBarcodeApiHits[lineIndex] = list;
                this.mergeProductsFromBarcodeApiIntoStore(list);
                this.cdr.markForCheck();

                const currentRaw = this.productLineBarcodeQuery[lineIndex];
                const current = currentRaw != null ? String(currentRaw).trim() : '';
                const currentNoSpace = current.replace(/\s/g, '');
                const stillSameQuery =
                    current === requested ||
                    (requestedNoSpace !== '' && currentNoSpace === requestedNoSpace);

                if (list.length === 0) {
                    this.toastr.warning('Aucun produit trouvé pour ce code à barre.', 'Code à barre');
                    return;
                }
                if (list.length === 1 && stillSameQuery) {
                    this.zone.run(() => {
                        setTimeout(() => {
                            this.applyLineFromBarcodeApiResult(lineIndex, list[0]);
                        }, 0);
                    });
                }
            });
    }

    private pickProductFromBarcodeApiList(list: Product[], preferred?: any): Product {
        if (!list?.length) {
            throw new Error('pickProductFromBarcodeApiList: liste vide');
        }
        if (list.length === 1) {
            return list[0];
        }
        const prefId = preferred?.id != null ? Number(preferred.id) : NaN;
        if (Number.isFinite(prefId)) {
            const byId = list.find((p) => Number(p.id) === prefId);
            if (byId) {
                return byId;
            }
        }
        const prefCb = String(
            (preferred as any)?.code_barre ?? (preferred as any)?.code_bar ?? ''
        ).replace(/\s/g, '');
        if (prefCb) {
            const byCb = list.find((p: any) =>
                String(p?.code_barre ?? p?.code_bar ?? '')
                    .replace(/\s/g, '') === prefCb
            );
            if (byCb) {
                return byCb;
            }
        }
        return list[0];
    }

    private applyLineFromBarcodeApiResult(lineIndex: number, productToApply: Product): void {
        this.productLineBarcodeQuery[lineIndex] = '';
        delete this.productLineBarcodeApiHits[lineIndex];
        delete this.productLineBarcodeSearchLoading[lineIndex];
        this.applyProductSelectionToLine(lineIndex, productToApply, 1);
    }

    private fetchProductByBarcodeAndApplyToLine(
        lineIndex: number,
        codeBarre: string,
        preferredProduct?: any
    ): void {
        const code = String(codeBarre ?? '').trim();
        if (!code || code === '0') {
            this.toastr.warning('Code à barre invalide.', 'Code à barre');
            delete this.barcodePickerModel[lineIndex];
            this.invalidateBarcodePickerMergedLineCache(lineIndex);
            return;
        }
        const userId = this.readUserIdFromLocalStorage();
        const stationId = this.readStationIdFromLocalStorageForBarcodeApi();
        if (!userId || !stationId) {
            this.toastr.warning(
                'Impossible d’appeler l’API code à barre : utilisateur ou station manquant dans localStorage.',
                'Code à barre'
            );
            delete this.barcodePickerModel[lineIndex];
            this.invalidateBarcodePickerMergedLineCache(lineIndex);
            return;
        }
        this.productLineBarcodeSearchLoading[lineIndex] = true;
        this.cdr.markForCheck();
        this.productsService
            .getProductsByCodeBarre(code, stationId, userId)
            .pipe(
                finalize(() => {
                    this.productLineBarcodeSearchLoading[lineIndex] = false;
                    this.cdr.markForCheck();
                }),
                catchError(() => {
                    this.toastr.error(
                        'Impossible de récupérer le produit par code à barre.',
                        'Erreur'
                    );
                    delete this.barcodePickerModel[lineIndex];
                    this.invalidateBarcodePickerMergedLineCache(lineIndex);
                    return of(null);
                })
            )
            .subscribe((res) => {
                if (res == null) {
                    return;
                }
                const list = this.unwrapProductsFromBarcodeApiResponse(res);
                this.mergeProductsFromBarcodeApiIntoStore(list);
                if (list.length === 0) {
                    this.toastr.warning('Aucun produit trouvé pour ce code à barre.', 'Code à barre');
                    delete this.barcodePickerModel[lineIndex];
                    this.invalidateBarcodePickerMergedLineCache(lineIndex);
                    return;
                }
                const toApply = this.pickProductFromBarcodeApiList(list, preferredProduct);
                this.zone.run(() => {
                    this.applyLineFromBarcodeApiResult(lineIndex, toApply);
                });
            });
    }

    getProductSelectItemsForLine(lineIndex: number): Product[] {
        let base = this.productsForDocumentSelect || [];
        const row = this.items[lineIndex];
        if (row?.type === 'product' && row.product_id != null) {
            const pid = Number(row.product_id);
            if (Number.isFinite(pid) && !base.some((p) => Number(p?.id) === pid)) {
                const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
                if (fromCatalog) {
                    base = [fromCatalog as Product, ...base];
                }
            }
        }
        const raw = this.productLineBarcodeQuery[lineIndex];
        const q = raw != null ? String(raw).trim().replace(/\s/g, '') : '';
        if (!q) {
            return base;
        }
        const apiList = this.productLineBarcodeApiHits[lineIndex];
        if (apiList != null && apiList.length > 0) {
            return apiList;
        }
        return this.filterProductsByBarcodeClientSide(base, q);
    }

    getBarcodePickerItemsForLine(lineIndex: number): Product[] {
        const row = this.items[lineIndex];
        const filled = row?.type === 'product' && !!row.designation?.trim();
        const m = this.barcodePickerModel[lineIndex];
        const modelKey =
            filled && m?.id != null ? `M${Number(m.id)}` : 'N';

        const base = this.getCachedBarcodePickerBaseList();
        const apiList = this.productLineBarcodeApiHits[lineIndex];
        const apiKey = apiList?.length
            ? apiList
                  .map((p) => p.id)
                  .filter((id) => id != null)
                  .sort((a, b) => Number(a) - Number(b))
                  .join(',')
            : '';
        const mergeKey = `${this.getBarcodePickerBaseFingerprint()}_${lineIndex}_${apiKey}_${modelKey}`;
        if (
            this.barcodePickerMergedKeyByLine[lineIndex] === mergeKey &&
            this.barcodePickerMergedByLine[lineIndex]
        ) {
            return this.barcodePickerMergedByLine[lineIndex];
        }
        let list: Product[];
        if (!apiList?.length) {
            list = base;
        } else {
            const byId = new Map<number, Product>();
            for (const p of base) {
                if (p?.id != null) {
                    byId.set(Number(p.id), p);
                }
            }
            for (const p of apiList) {
                if (p?.id != null) {
                    byId.set(Number(p.id), p as Product);
                }
            }
            list = this.sortBarcodePickerProducts(Array.from(byId.values()));
        }
        if (filled && m?.id != null) {
            const mid = Number(m.id);
            const has = list.some((p) => p?.id != null && Number(p.id) === mid);
            if (!has) {
                list = [m as Product, ...list];
            }
        }
        this.barcodePickerMergedByLine[lineIndex] = list;
        this.barcodePickerMergedKeyByLine[lineIndex] = mergeKey;
        return list;
    }

    private getProductsWithRealBarcodeSortedForPicker(): Product[] {
        const list = (this.products || []).filter(
            (p: any) => !this.isBarcodeEmptyOrZeroForSelect(p)
        ) as Product[];
        return this.sortBarcodePickerProducts(list);
    }

    private sortBarcodePickerProducts(list: Product[]): Product[] {
        return [...list].sort((a: any, b: any) => {
            const ca = String(a?.code_barre ?? '').trim();
            const cb = String(b?.code_barre ?? '').trim();
            return ca.localeCompare(cb, undefined, { numeric: true });
        });
    }

    private extractCouleurTailleFromProductLike(p: any): { couleur: string; taille: string } {
        if (!p || typeof p !== 'object') {
            return { couleur: '', taille: '' };
        }
        const couleurRaw =
            p.couleur ??
            p.couleur_libelle ??
            p.libelle_couleur ??
            p.nom_couleur ??
            p.color ??
            p.couleur_nom;
        const tailleRaw =
            p.taille ??
            p.taille_libelle ??
            p.libelle_taille ??
            p.nom_taille ??
            p.size ??
            p.taille_nom;
        const couleur =
            couleurRaw != null && String(couleurRaw).trim() !== '' ? String(couleurRaw).trim() : '';
        const taille =
            tailleRaw != null && String(tailleRaw).trim() !== '' ? String(tailleRaw).trim() : '';
        return { couleur, taille };
    }

    formatBarcodeDisplayForPicker(code: any): string {
        const raw = code != null ? String(code).replace(/\s/g, '').trim() : '';
        if (!raw) {
            return '';
        }
        if (/^\d{13}$/.test(raw)) {
            return `${raw[0]} ${raw.slice(1, 7)} ${raw.slice(7)}`;
        }
        if (/^\d{12}$/.test(raw)) {
            return `${raw.slice(0, 6)} ${raw.slice(6)}`;
        }
        if (/^\d{8}$/.test(raw)) {
            return `${raw.slice(0, 4)} ${raw.slice(4)}`;
        }
        return String(code).trim();
    }

    formatBarcodePickerCouleurTaille(p: any): string {
        const { couleur: c, taille: t } = this.extractCouleurTailleFromProductLike(p);
        if (c && t) {
            return `${c} / ${t}`;
        }
        if (c) {
            return c;
        }
        if (t) {
            return t;
        }
        return '—';
    }

    onBarcodePickerSearch(lineIndex: number, event: { term: string; items: any[] }): void {
        const term = event?.term ?? '';
        this.productLineBarcodeQuery[lineIndex] = term;
        this.onProductLineBarcodeQueryChange(lineIndex, term);
    }

    enableBarcodePickerEdit(lineIndex: number): void {
        const it = this.items[lineIndex];
        if (it?.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        this.barcodePickerUnlockEdit[lineIndex] = true;
        this.invalidateBarcodePickerMergedLineCache(lineIndex);
        this.cdr.markForCheck();
    }

    private restoreBarcodePickerModelForLine(lineIndex: number): void {
        const it = this.items[lineIndex];
        if (it?.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        const pid = it.product_id != null ? Number(it.product_id) : NaN;
        if (!Number.isFinite(pid)) {
            return;
        }
        const fromCatalog = this.products.find((pr) => Number(pr.id) === pid);
        if (fromCatalog) {
            this.barcodePickerModel[lineIndex] = fromCatalog;
        } else {
            this.barcodePickerModel[lineIndex] = {
                id: pid,
                nom: it.designation || '',
                code_barre: it.code_barre || '',
                ref_interne: it.reference,
                couleur: it.couleur ?? null,
                taille: it.taille ?? null,
            } as any as Product;
        }
        this.hydrateItemVariantFieldsFromBarcodePicker(lineIndex);
        this.invalidateBarcodePickerMergedLineCache(lineIndex);
    }

    onBarcodeColumnSelect(index: number, product: any): void {
        const row = this.items[index];
        if (row?.type === 'product' && row.designation?.trim() && !this.barcodePickerUnlockEdit[index]) {
            return;
        }
        const prevTimer = this.barcodeLineDebounceTimers[index];
        if (prevTimer != null) {
            clearTimeout(prevTimer);
            delete this.barcodeLineDebounceTimers[index];
        }
        if (!product) {
            this.productLineBarcodeQuery[index] = '';
            delete this.productLineBarcodeApiHits[index];
            delete this.productLineBarcodeSearchLoading[index];
            const rowAfter = this.items[index];
            if (
                rowAfter?.type === 'product' &&
                rowAfter.designation?.trim() &&
                this.barcodePickerUnlockEdit[index]
            ) {
                delete this.barcodePickerUnlockEdit[index];
                this.restoreBarcodePickerModelForLine(index);
            } else {
                delete this.barcodePickerModel[index];
                this.invalidateBarcodePickerMergedLineCache(index);
            }
            this.cdr.markForCheck();
            return;
        }
        const rawCb = (product as any).code_barre ?? (product as any).code_bar;
        const code = rawCb != null ? String(rawCb).trim() : '';
        if (!code || code === '0') {
            this.toastr.warning(
                'Ce produit n’a pas de code à barre exploitable.',
                'Code à barre'
            );
            const rowBad = this.items[index];
            if (
                rowBad?.type === 'product' &&
                rowBad.designation?.trim() &&
                this.barcodePickerUnlockEdit[index]
            ) {
                delete this.barcodePickerUnlockEdit[index];
                this.restoreBarcodePickerModelForLine(index);
            } else {
                delete this.barcodePickerModel[index];
                this.invalidateBarcodePickerMergedLineCache(index);
            }
            return;
        }
        this.fetchProductByBarcodeAndApplyToLine(index, code, product);
    }

    isProductLineBarcodeSearchLoading(lineIndex: number): boolean {
        return !!this.productLineBarcodeSearchLoading[lineIndex];
    }

    compareDesignationProductById = (a: unknown, b: unknown): boolean => {
        const na = a != null && a !== '' ? Number(a) : NaN;
        const nb = b != null && b !== '' ? Number(b) : NaN;
        return Number.isFinite(na) && Number.isFinite(nb) && na === nb;
    };

    /** ng-select désignation : id produit, objet ou nom (legacy bindValue nom). */
    private resolveProductFromDesignationSelect(
        selected: unknown,
        lineIndex?: number
    ): Product | null {
        if (selected == null || selected === '') {
            return null;
        }
        if (typeof selected === 'number' && Number.isFinite(selected) && selected > 0) {
            return this.findCatalogProductById(selected, lineIndex);
        }
        if (typeof selected === 'string') {
            const s = selected.trim();
            if (/^\d+$/.test(s)) {
                return this.findCatalogProductById(Number(s), lineIndex);
            }
            if (s) {
                return this.findCatalogProductByNom(s, lineIndex);
            }
            return null;
        }
        if (typeof selected === 'object') {
            const o = selected as Product;
            if (o.id != null && Number.isFinite(Number(o.id))) {
                return (
                    this.findCatalogProductById(Number(o.id), lineIndex) ?? o
                );
            }
            const nomObj = String((o as any).nom ?? '').trim();
            if (nomObj) {
                return this.findCatalogProductByNom(nomObj, lineIndex);
            }
        }
        return null;
    }

    private findCatalogProductById(id: number, lineIndex?: number): Product | null {
        const target = Number(id);
        if (!Number.isFinite(target) || target <= 0) {
            return null;
        }
        const lineItems =
            lineIndex != null ? this.getProductSelectItemsForLine(lineIndex) : [];
        const pools = [
            lineItems,
            this.productsForDocumentSelect,
            this.products,
            this.variantModalFullGroup,
        ];
        for (const pool of pools) {
            const hit = (pool || []).find((p) => Number(p?.id) === target);
            if (hit) {
                return hit;
            }
        }
        return null;
    }

    private findCatalogProductByNom(nom: string, lineIndex?: number): Product | null {
        const target = nom.trim();
        if (!target) {
            return null;
        }
        const lineItems =
            lineIndex != null ? this.getProductSelectItemsForLine(lineIndex) : [];
        const pools = [
            lineItems,
            this.productsForDocumentSelect,
            this.products,
            this.variantModalFullGroup,
        ];
        for (const pool of pools) {
            const hit = (pool || []).find((p) => String(p?.nom ?? '').trim() === target);
            if (hit?.id != null) {
                return hit;
            }
        }
        return null;
    }

    /** Variantes : même ref. fabricant, sinon même nom (aligné front-achat). */
    private getVariantGroupProductsForDesignationSelect(p: Product): Product[] {
        const refGroup = this.getRefFabricantGroupProducts(p);
        if (this.resolveVariantModalProductRows(refGroup).length >= 2) {
            return refGroup;
        }
        const nomKey = String(p?.nom ?? '')
            .trim()
            .toLowerCase();
        if (nomKey) {
            const byNom = (this.products || []).filter(
                (pr) => String(pr?.nom ?? '').trim().toLowerCase() === nomKey
            );
            if (this.resolveVariantModalProductRows(byNom).length >= 2) {
                return byNom;
            }
        }
        return refGroup;
    }

    /** Lignes du popup variantes : priorité aux codes-barres valides, sinon toute la ref. fabricant. */
    private resolveVariantModalProductRows(group: Product[]): Product[] {
        const withBarcode = this.filterVariantModalProductsByBarcode(group);
        if (withBarcode.length >= 2) {
            return withBarcode;
        }
        const byId = new Map<number, Product>();
        for (const p of this.sortVariantGroupForModal(group)) {
            const id = p?.id != null ? Number(p.id) : NaN;
            if (Number.isFinite(id) && id > 0) {
                byId.set(id, p);
            }
        }
        return Array.from(byId.values());
    }

    /**
     * Même flux que front-achat : ng-select → groupe ref. fabricant → popup si ≥ 2 codes-barres.
     */
    onProductSelect(index: number, selectedProduct: any): void {
        if (this.suppressDesignationSelectChange) {
            return;
        }
        if (!selectedProduct) {
            const keepRow = this.items[index];
            if (
                keepRow?.type === 'product' &&
                keepRow.product_id != null &&
                String(keepRow.designation ?? '').trim()
            ) {
                return;
            }
            delete this.productLineBarcodeQuery[index];
            delete this.productLineBarcodeApiHits[index];
            delete this.productLineBarcodeSearchLoading[index];
            delete this.barcodePickerModel[index];
            delete this.barcodePickerUnlockEdit[index];
            this.invalidateBarcodePickerMergedLineCache(index);
            const cleared = this.items[index];
            if (cleared?.type === 'product') {
                cleared.code_barre = '';
                cleared.product_id = null as any;
                cleared.designation = '';
                cleared.couleur = undefined;
                cleared.taille = undefined;
            }
            return;
        }

        let resolved = this.resolveProductFromDesignationSelect(selectedProduct, index);
        if (!resolved?.id) {
            resolved = this.resolveProductFromDesignationSelect(
                this.items[index]?.product_id,
                index
            );
        }
        if (!resolved?.id) {
            this.toastr.warning(
                'Produit introuvable dans le catalogue. Rechargez la liste ou resélectionnez.',
                'Désignation'
            );
            return;
        }
        selectedProduct = resolved;

        const apiHits = this.productLineBarcodeApiHits[index];
        const selectedId = selectedProduct?.id != null ? Number(selectedProduct.id) : NaN;
        const isFromBarcodeApiLookup =
            Array.isArray(apiHits) &&
            apiHits.length > 0 &&
            Number.isFinite(selectedId) &&
            apiHits.some((p: any) => Number(p?.id) === selectedId);

        this.productLineBarcodeQuery[index] = '';
        delete this.productLineBarcodeApiHits[index];
        delete this.productLineBarcodeSearchLoading[index];

        if (isFromBarcodeApiLookup) {
            this.applyProductSelectionToLine(index, selectedProduct, 1);
            return;
        }

        this.tryDesignationSelectWithVariantModal(index, selectedProduct);
    }

    private tryDesignationSelectWithVariantModal(index: number, selectedProduct: Product): void {
        const tryLocal = (): { group: Product[]; withBarcode: Product[] } => {
            const group = this.getVariantGroupProductsForDesignationSelect(selectedProduct);
            const withBarcode = this.filterVariantModalProductsByBarcode(group);
            return { group, withBarcode };
        };

        let { group, withBarcode } = tryLocal();
        if (this.resolveVariantModalProductRows(group).length >= 2) {
            this.openVariantSelectionModal(index, selectedProduct, group);
            return;
        }

        if (!this.stationId) {
            this.stationId = getStationIdFromLocalStorage();
        }
        const ref = this.extractRefFabricantFromProductLike(selectedProduct);
        if (!ref || !this.stationId) {
            const toApply = withBarcode.length === 1 ? withBarcode[0] : selectedProduct;
            this.applyProductSelectionToLine(index, toApply, 1);
            return;
        }

        this.productsService.getProductsByRefFabricant(this.stationId, ref).subscribe({
            next: (list) => {
                const mapped = (list || []).map((p) => this.mapApiProductForDocumentSelect(p));
                if (mapped.length > 0) {
                    this.mergeProductsFromBarcodeApiIntoStore(mapped);
                }
                const refreshed =
                    mapped.find((p) => Number(p?.id) === Number(selectedProduct.id)) ??
                    selectedProduct;
                group = this.getVariantGroupProductsForDesignationSelect(refreshed as Product);
                if (mapped.length > 0) {
                    group = this.mergeVariantGroupProducts(group, mapped);
                }
                withBarcode = this.filterVariantModalProductsByBarcode(group);
                this.zone.run(() => {
                    if (this.resolveVariantModalProductRows(group).length >= 2) {
                        this.openVariantSelectionModal(index, refreshed as Product, group);
                    } else {
                        const toApply =
                            withBarcode.length === 1 ? withBarcode[0] : (refreshed as Product);
                        this.applyProductSelectionToLine(index, toApply, 1);
                    }
                });
            },
            error: () => {
                this.zone.run(() => {
                    const toApply = withBarcode.length === 1 ? withBarcode[0] : selectedProduct;
                    this.applyProductSelectionToLine(index, toApply, 1);
                });
            },
        });
    }

    private applyProductSelectionToLine(index: number, selectedProduct: any, quantity: number = 1): void {
        const item = this.items[index];
        const catalogProduct =
            this.findCatalogProductById(Number(selectedProduct?.id), index) ??
            selectedProduct;
        if (!item || item.type !== 'product' || !catalogProduct?.id) {
            return;
        }
        selectedProduct = catalogProduct;

        item.product_id = selectedProduct.id;
        item.designation = selectedProduct.nom;
        item.reference = selectedProduct.ref_interne || selectedProduct.reference || '-';
        const rawCb = (selectedProduct as any).code_barre ?? (selectedProduct as any).code_bar;
        const cbTrim = rawCb != null ? String(rawCb).trim() : '';
        item.code_barre =
            cbTrim !== '' && cbTrim !== '0' ? cbTrim : '';

        const isAchat = this.isAchatDocument();
        const prixUnitaireOrigine = isAchat
            ? (Number(selectedProduct.prix_unitaires) || Number(selectedProduct.prix_achat) || 0)
            : this.resolveVenteDocumentPrixHtFromProduct(selectedProduct);
        item.priceHT = prixUnitaireOrigine;
        item.prixUnitaireRef = prixUnitaireOrigine;

        if (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') {
            const valeurUnitaireProduit = selectedProduct.valeur_unitaire;
            const prixUnitairesProduit = selectedProduct.prix_unitaires;
            item.valeur_unitaire = valeurUnitaireProduit || prixUnitairesProduit || 0;
        } else if (this.documentType === 'FACTURE FOURNISSEUR') {
            item.valeur_unitaire = Number(selectedProduct.valeur_unitaire) || Number(selectedProduct.prix_unitaires) || 0;
        } else {
            item.valeur_unitaire = selectedProduct.valeur_unitaire || 0;
        }
        const q = Number(quantity);
        item.quantity = Number.isFinite(q) && q > 0 ? q : 1;

        if (this.documentType === 'FACTURE FOURNISSEUR') {
            this.calculateTotal(index);
        }
        item.availableQuantity = undefined;
        if (selectedProduct.id) {
            this.loadStockQuantity(selectedProduct.id, item.reference || '', index);
        } else {
            item.availableQuantity = undefined;
        }

        if (selectedProduct.description) {
            this.productDescriptions[index] = selectedProduct.description;
        } else {
            this.productDescriptions[index] = '';
        }
        this.showProductDescription[index] = false;

        const variantCt = this.extractCouleurTailleFromProductLike(selectedProduct);
        item.couleur = variantCt.couleur;
        item.taille = variantCt.taille;

        if (selectedProduct.unite) {
            item.unite_libelle = selectedProduct.unite.libelle || selectedProduct.unite.nom || '--';
        } else if (selectedProduct.unite_id) {
            item.unite_libelle = this.getUniteLibelle(selectedProduct.unite_id);
        } else {
            item.unite_libelle = '--';
        }
        if (selectedProduct.tva_id === null || selectedProduct.tva_id === undefined) {
            item.tva = '0';
        } else {
            const tvaFound = this.tvaRates.find(t => t.id === selectedProduct.tva_id);
            if (tvaFound) {
                item.tva = tvaFound.valeur.toString();
            } else {
                item.tva = '0';
            }
        }
        if (this.taxes && this.taxes.length > 0) {
            this.applyProductTaxes(selectedProduct, index);
        } else {
            const sub = this.taxeService.getTaxeList(this.stationId).subscribe({
                next: (res => {
                    this.loadTaxes();
                    setTimeout(() => this.applyProductTaxes(selectedProduct, index), 100);
                    sub.unsubscribe();
                }),
            });
        }

        this.calculateLine(index);
        this.calculateTotals();
        this.updateTvaSummary();
        this.barcodePickerModel[index] = selectedProduct as Product;
        delete this.barcodePickerUnlockEdit[index];
        this.invalidateBarcodePickerMergedLineCache(index);
        this.cdr.detectChanges();
        this.updateApproveButtonState();
    }

    private invalidateBarcodePickerMergedLineCache(lineIndex: number): void {
        delete this.barcodePickerMergedByLine[lineIndex];
        delete this.barcodePickerMergedKeyByLine[lineIndex];
    }

     private hydrateItemVariantFieldsFromBarcodePicker(lineIndex: number): void {
        const it = this.items[lineIndex];
        const m = this.barcodePickerModel[lineIndex] as any;
        if (it?.type !== 'product' || !m) {
            return;
        }
        const ct = this.extractCouleurTailleFromProductLike(m);
        if (!(String(it.couleur ?? '').trim()) && ct.couleur) {
            it.couleur = ct.couleur;
        }
        if (!(String(it.taille ?? '').trim()) && ct.taille) {
            it.taille = ct.taille;
        }
    }

    private syncBarcodePickerModelForProductLines(): void {
        this.items.forEach((it, idx) => {
            if (it.type !== 'product' || !it.designation?.trim()) {
                return;
            }
            this.syncBarcodePickerModelForLine(idx);
        });
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    /** Sync code-barres uniquement pour les lignes visibles (groupes repliés = tête seule). */
    private syncBarcodePickerModelForVisibleProductLines(): void {
        this.items.forEach((it, idx) => {
            if (it.type !== 'product' || !it.designation?.trim()) {
                return;
            }
            if (!this.isProductLineVisible(idx)) {
                return;
            }
            this.syncBarcodePickerModelForLine(idx);
        });
        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private syncBarcodePickerModelForLine(idx: number): void {
        const it = this.items[idx];
        if (!it || it.type !== 'product' || !it.designation?.trim()) {
            return;
        }
        const pid = it.product_id != null ? Number(it.product_id) : NaN;
        if (!Number.isFinite(pid)) {
            return;
        }
        const fromCatalog = this.products.find((pr) => Number(pr.id) === pid);
        if (fromCatalog) {
            this.barcodePickerModel[idx] = fromCatalog;
            this.hydrateItemVariantFieldsFromBarcodePicker(idx);
            return;
        }
        this.barcodePickerModel[idx] = {
            id: pid,
            nom: it.designation || '',
            code_barre: it.code_barre || '',
            ref_interne: it.reference,
            couleur: it.couleur ?? null,
            taille: it.taille ?? null,
        } as any as Product;
    }

    /** Clé de regroupement désignation / ref fabricant pour replier les codes-barres. */
    getProductLineGroupKey(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return `solo:${index}`;
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            const ref = this.extractRefFabricantFromProductLike(fromCatalog ?? item);
            if (ref) {
                return `ref:${ref}`;
            }
        }
        const des = String(item.designation || '')
            .trim()
            .toLowerCase();
        if (des) {
            return `des:${des}`;
        }
        return `solo:${index}`;
    }

    getProductLineGroupMemberIndices(groupKey: string): number[] {
        const out: number[] = [];
        (this.items || []).forEach((it, i) => {
            if (it?.type === 'product' && this.getProductLineGroupKey(i) === groupKey) {
                out.push(i);
            }
        });
        return out;
    }

    /** Couleur normalisée pour regroupement (vide → « — »). */
    getProductLineCouleurNorm(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return '—';
        }
        const fromItem = String(item.couleur ?? '').trim();
        if (fromItem) {
            return fromItem;
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            const { couleur } = this.extractCouleurTailleFromProductLike(fromCatalog);
            if (couleur) {
                return couleur;
            }
        }
        return '—';
    }

    getProductLineCouleurGroupKey(index: number): string {
        const desKey = this.getProductLineGroupKey(index);
        const couleur = this.getProductLineCouleurNorm(index);
        return `${desKey}|c:${couleur.toLowerCase()}`;
    }

    getProductLineCouleurMemberIndices(index: number): number[] {
        const desKey = this.getProductLineGroupKey(index);
        const couleurNorm = this.getProductLineCouleurNorm(index).toLowerCase();
        return this.getProductLineGroupMemberIndices(desKey).filter(
            (mi) => this.getProductLineCouleurNorm(mi).toLowerCase() === couleurNorm
        );
    }

    isProductLineGroupHead(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        return members.length > 0 && members[0] === index;
    }

    /** Première ligne du sous-groupe couleur (dans le groupe désignation). */
    isProductLineCouleurHead(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        return colorMembers.length > 0 && colorMembers[0] === index;
    }

    /** true = matrice couleur × taille ; false = lignes classiques (paramètre + override session). */
    useProductMatrixLineDisplay(): boolean {
        return resolveDocumentProductMatrixDisplay({
            stationAffProduitMatriciel: this.paramDocAffProduitMatriciel,
            sessionAfficherProduitsMatriciel: this.documentColumnSettings?.afficherProduitsMatriciel,
        });
    }

    productLineGroupCanToggle(index: number): boolean {
        if (!this.useProductMatrixLineDisplay()) {
            return false;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        return this.getProductLineGroupMemberIndices(key).length > 1;
    }

    /** Sous-groupe couleur avec plusieurs produits (taille / code-barres). */
    productLineCouleurGroupCanToggle(index: number): boolean {
        if (!this.useProductMatrixLineDisplay()) {
            return false;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return false;
        }
        return this.getProductLineCouleurMemberIndices(index).length > 1;
    }

    isProductLineBarcodeGroupExpanded(index: number): boolean {
        return this.expandedBarcodeGroups.has(this.getProductLineGroupKey(index));
    }

    isProductLineCouleurGroupExpanded(index: number): boolean {
        return this.expandedCouleurGroups.has(this.getProductLineCouleurGroupKey(index));
    }

    isProductLineBarcodeGroupLoading(index: number): boolean {
        return !!this.barcodeGroupLoading[this.getProductLineGroupKey(index)];
    }

    getProductLineGroupBarcodeCount(index: number): number {
        return this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index)).length;
    }

    /** Nombre de couleurs distinctes dans le groupe réf. fabricant. */
    getProductLineGroupCouleurCount(index: number): number {
        const members = this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index));
        const couleurs = new Set<string>();
        for (const mi of members) {
            couleurs.add(this.getProductLineCouleurNorm(mi).toLowerCase());
        }
        return couleurs.size;
    }

    /** En-tête réf. fabricant ouvert (texte simple, sans chip). */
    shouldShowProductLineRefOpenSummary(index: number): boolean {
        return (
            this.productLineGroupCanToggle(index) &&
            this.isProductLineGroupHead(index) &&
            this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    getProductLineRefOpenBannerTrailingColspan(): number {
        const refCol = this.documentColumnSettings?.reference ? 1 : 0;
        const trailing = this.getColspan() - 1 - refCol;
        return trailing > 0 ? trailing : 1;
    }

    shouldShowProductLineBarcodeColumnCouleurHint(index: number): boolean {
        return (
            this.isProductLineBarcodeGroupExpanded(index) &&
            this.isProductLineCouleurHead(index) &&
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineRefGroupCollapsedHead(index)
        );
    }

    shouldShowProductLineSplitLayout(index: number): boolean {
        return this.shouldShowProductLineFullEditor(index);
    }

    shouldShowProductLineCouleurBannerRow(index: number): boolean {
        if (!this.shouldShowProductLineSplitLayout(index)) {
            return false;
        }
        if (this.getProductLineCouleurNorm(index) === '—') {
            return false;
        }
        return this.isProductLineCouleurHead(index);
    }

    isProductLineVariantProductRow(index: number): boolean {
        return (
            this.shouldShowProductLineFullEditor(index) &&
            this.productLineGroupCanToggle(index) &&
            this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    getProductLineCouleurBarcodeCount(index: number): number {
        return this.getProductLineCouleurMemberIndices(index).length;
    }

    getProductLineRefFabricantLabel(index: number): string {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return '—';
        }
        const pid = item.product_id != null ? Number(item.product_id) : NaN;
        let ref = '';
        if (Number.isFinite(pid)) {
            const fromCatalog = (this.products || []).find((pr) => Number(pr.id) === pid);
            ref = this.normalizeRefFabricantForSelect(
                (fromCatalog as any)?.ref_fabricant ??
                    (fromCatalog as any)?.ref_fabriquant ??
                    (item as any).ref_fabricant ??
                    (item as any).ref_fabriquant
            );
        } else {
            ref = this.normalizeRefFabricantForSelect(
                (item as any).ref_fabricant ?? (item as any).ref_fabriquant
            );
        }
        if (ref) {
            return ref;
        }
        const des = String(item.designation || '').trim();
        return des || '—';
    }

    /** Niveau 1 fermé : ligne regroupée par réf. fabricant. */
    isProductLineRefGroupCollapsedHead(index: number): boolean {
        return (
            this.productLineGroupCanToggle(index) &&
            this.isProductLineGroupHead(index) &&
            !this.isProductLineBarcodeGroupExpanded(index)
        );
    }

    /** Niveau 2 fermé : ligne regroupée par couleur (sous réf. fabricant ouverte). */
    isProductLineCouleurGroupCollapsedHead(index: number): boolean {
        return (
            this.isProductLineBarcodeGroupExpanded(index) &&
            this.isProductLineCouleurHead(index) &&
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index)
        );
    }

    isProductLineInCollapsedGroup(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return false;
        }
        if (!this.expandedBarcodeGroups.has(key)) {
            return true;
        }
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        if (colorMembers.length <= 1) {
            return false;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        return !this.expandedCouleurGroups.has(couleurKey);
    }

    shouldShowProductLineFullEditor(index: number): boolean {
        if (!this.productLineGroupCanToggle(index)) {
            return true;
        }
        return !this.isProductLineInCollapsedGroup(index);
    }

    isProductLineRefGroupCollapsed(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return false;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return false;
        }
        return !this.expandedBarcodeGroups.has(key);
    }

    isStockLcDocumentType(): boolean {
        return this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
    }

    /** Saisie Prix HT : pour stock LC, recopie vers valeur_unitaire (payload ligne). */
    onProductLinePriceHtInput(index: number): void {
        const item = this.items[index];
        if (item?.type === 'product' && this.isStockLcDocumentType()) {
            const pu = Number(item.priceHT);
            item.valeur_unitaire = Number.isFinite(pu) ? pu : 0;
        }
        this.calculateTotal(index);
    }

    /** Prix HT : affiché sur toute ligne produit visible (groupe ouvert ou replié). */
    shouldShowProductLinePrixHt(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        return this.isProductLineVisible(index);
    }

    showDocumentPrixHtColumn(): boolean {
        if (this.isStockLcDocumentType()) {
            return false;
        }
        return !!this.documentColumnSettings?.prixUnitaire;
    }

    /** PU HT d'une ligne produit (aligné affichage prix / calcul montants). */
    private resolveProductLineUnitPrice(item: any): number {
        if (!item) {
            return 0;
        }
        if (this.isStockLcDocumentType()) {
            return (
                Number(item.valeur_unitaire) ||
                Number(item.priceHT) ||
                Number(item.prixUnitaireRef) ||
                0
            );
        }
        return (
            Number(item.priceHT) ||
            Number(item.valeur_unitaire) ||
            Number(item.prixUnitaireRef) ||
            0
        );
    }

    /** Prix unitaire HT affiché (ligne ou tête de groupe replié). */
    getProductLinePrixHtDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return 0;
        }
        const linePu = (): number => this.resolveProductLineUnitPrice(item);

        if (!this.productLineGroupCanToggle(index)) {
            return linePu();
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (this.isProductLineGroupHead(index)) {
                const members = this.getProductLineGroupMemberIndices(
                    this.getProductLineGroupKey(index)
                );
                for (const mi of members) {
                    const it = this.items[mi];
                    if (it?.type === 'product') {
                        const pu =
                            Number(it.priceHT) ||
                            Number(it.valeur_unitaire) ||
                            Number(it.prixUnitaireRef) ||
                            0;
                        if (pu > 0 || String(it.designation || '').trim()) {
                            return pu;
                        }
                    }
                }
            }
            return linePu();
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            for (const mi of this.getProductLineCouleurMemberIndices(index)) {
                const it = this.items[mi];
                if (it?.type === 'product') {
                    const pu =
                        Number(it.priceHT) ||
                        Number(it.valeur_unitaire) ||
                        Number(it.prixUnitaireRef) ||
                        0;
                    if (pu > 0 || String(it.designation || '').trim()) {
                        return pu;
                    }
                }
            }
        }
        return linePu();
    }

    onProductLinePrixHtChange(index: number, value: unknown): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        const parsed = Number(value);
        const pu = Number.isFinite(parsed) ? parsed : 0;
        item.priceHT = pu;
        item.prixUnitaireRef = pu;
        if (this.isStockLcDocumentType()) {
            item.valeur_unitaire = pu;
        }
        this.onProductLinePriceHtInput(index);
        this.calculateTotal(index);
        this.calculateTotals();
        this.updateTvaSummary();
        this.cdr.markForCheck();
    }

    shouldShowProductLineBarcodePicker(index: number): boolean {
        if (!this.productLineGroupCanToggle(index)) {
            return true;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return !this.isProductLineGroupHead(index);
        }
        if (!this.productLineCouleurGroupCanToggle(index)) {
            return true;
        }
        if (!this.isProductLineCouleurGroupExpanded(index)) {
            return !this.isProductLineCouleurHead(index);
        }
        return true;
    }

    isProductLineQuantityReadonly(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return false;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return false;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return true;
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return true;
        }
        return false;
    }

    getProductLineQuantityDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return Number(item.quantity) || 0;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            return this.sumProductLineQuantities(
                this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
            );
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineQuantities(this.getProductLineCouleurMemberIndices(index));
        }
        return Number(item.quantity) || 0;
    }

    private sumProductLineQuantities(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product') {
                const q = Number(it.quantity);
                if (Number.isFinite(q)) {
                    sum += q;
                }
            }
        }
        return sum;
    }

    private sumProductLineHtNet(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product' && String(it.designation || '').trim()) {
                sum += this.getLineTotalHT(it);
            }
        }
        return Number(sum.toFixed(3));
    }

    getProductLineTotalHTDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !String(item.designation || '').trim()) {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return this.getLineTotalHT(item);
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (this.isProductLineGroupHead(index)) {
                return this.sumProductLineHtNet(
                    this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
                );
            }
            return 0;
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineHtNet(this.getProductLineCouleurMemberIndices(index));
        }
        return this.getLineTotalHT(item);
    }

    /** Stock disponible affiché : somme du groupe / couleur si regroupement replié. */
    getProductLineStockDisplay(index: number): number {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id) {
            return 0;
        }
        if (!this.productLineGroupCanToggle(index)) {
            return this.getStockQuantityForDisplay(item);
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (!this.isProductLineGroupHead(index)) {
                return 0;
            }
            return this.sumProductLineStockQuantities(
                this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index))
            );
        }
        if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            return this.sumProductLineStockQuantities(this.getProductLineCouleurMemberIndices(index));
        }
        return this.getStockQuantityForDisplay(item);
    }

    isProductLineStockResolved(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id) {
            return false;
        }
        let indices: number[] = [index];
        if (!this.productLineGroupCanToggle(index)) {
            return item.stockResolved === true;
        }
        if (!this.isProductLineBarcodeGroupExpanded(index)) {
            if (!this.isProductLineGroupHead(index)) {
                return false;
            }
            indices = this.getProductLineGroupMemberIndices(this.getProductLineGroupKey(index));
        } else if (
            this.productLineCouleurGroupCanToggle(index) &&
            !this.isProductLineCouleurGroupExpanded(index) &&
            this.isProductLineCouleurHead(index)
        ) {
            indices = this.getProductLineCouleurMemberIndices(index);
        }
        return (indices || []).every((mi) => this.items[mi]?.stockResolved === true);
    }

    /** Contour rouge sur la quantité si saisie > stock disponible affiché. */
    isProductLineQuantityOverAvailableStock(index: number): boolean {
        if (!this.showQuantiteDisponibleColumn()) {
            return false;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product' || !item.product_id || !String(item.designation || '').trim()) {
            return false;
        }
        if (!this.isProductLineStockResolved(index)) {
            return false;
        }
        const qty = Number(this.getProductLineQuantityDisplay(index));
        const stock = Number(this.getProductLineStockDisplay(index));
        if (!Number.isFinite(qty) || !Number.isFinite(stock)) {
            return false;
        }
        return qty > stock;
    }

    private sumProductLineStockQuantities(indices: number[]): number {
        let sum = 0;
        for (const i of indices || []) {
            const it = this.items[i];
            if (it?.type === 'product' && it.product_id) {
                sum += this.getStockQuantityForDisplay(it);
            }
        }
        return Math.trunc(sum);
    }

    isProductLineVisible(index: number): boolean {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return true;
        }
        if (!this.useProductMatrixLineDisplay()) {
            return true;
        }
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);
        if (members.length <= 1) {
            return true;
        }
        if (!this.expandedBarcodeGroups.has(key)) {
            return members[0] === index;
        }
        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        if (colorMembers.length <= 1) {
            return true;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (!this.expandedCouleurGroups.has(couleurKey)) {
            return colorMembers[0] === index;
        }
        return true;
    }

    toggleProductLineBarcodeGroup(index: number, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.productLineGroupCanToggle(index)) {
            return;
        }
        const key = this.getProductLineGroupKey(index);
        if (this.expandedBarcodeGroups.has(key)) {
            this.expandedBarcodeGroups.delete(key);
            for (const ck of Array.from(this.expandedCouleurGroups)) {
                if (ck.startsWith(`${key}|c:`)) {
                    this.expandedCouleurGroups.delete(ck);
                }
            }
            this.cdr.detectChanges();
            setTimeout(() => this.refreshFeatherIcons(), 0);
            return;
        }
        this.expandedBarcodeGroups.add(key);
        this.ensureProductLineBarcodeGroupLoaded(index);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    toggleProductLineCouleurGroup(index: number, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.productLineCouleurGroupCanToggle(index)) {
            return;
        }
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (this.expandedCouleurGroups.has(couleurKey)) {
            this.expandedCouleurGroups.delete(couleurKey);
        } else {
            this.expandedCouleurGroups.add(couleurKey);
            for (const mi of this.getProductLineCouleurMemberIndices(index)) {
                this.syncBarcodePickerModelForLine(mi);
                const it = this.items[mi];
                if (it?.type === 'product' && it.product_id) {
                    this.loadStockQuantity(Number(it.product_id), it.reference || '', mi);
                }
            }
            this.barcodePickerMergedByLine = {};
            this.barcodePickerMergedKeyByLine = {};
        }
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    private ensureProductLineBarcodeGroupLoaded(index: number): void {
        const key = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(key);

        const finishLocal = () => {
            for (const mi of members) {
                this.syncBarcodePickerModelForLine(mi);
                const it = this.items[mi];
                if (it?.type === 'product' && it.product_id) {
                    this.loadStockQuantity(Number(it.product_id), it.reference || '', mi);
                }
            }
            this.barcodePickerMergedByLine = {};
            this.barcodePickerMergedKeyByLine = {};
            this.barcodeGroupLoaded.add(key);
            this.barcodeGroupLoading[key] = false;
            this.cdr.detectChanges();
            setTimeout(() => this.refreshFeatherIcons(), 0);
        };

        if (this.barcodeGroupLoaded.has(key)) {
            finishLocal();
            return;
        }

        this.barcodeGroupLoading[key] = true;
        this.cdr.detectChanges();

        const ref = key.startsWith('ref:') ? key.slice(4) : '';
        if (!ref || !this.stationId) {
            finishLocal();
            return;
        }

        this.productsService.getProductsByRefFabricant(this.stationId, ref).subscribe({
            next: (list) => {
                const mapped = (list || []).map((p) => this.mapApiProductForDocumentSelect(p));
                this.mergeProductsFromBarcodeApiIntoStore(mapped);
                finishLocal();
            },
            error: () => finishLocal(),
        });
    }

    private getRefFabricantGroupProducts(p: Product | any): Product[] {
        const ref = this.extractRefFabricantFromProductLike(p);
        if (!ref) {
            return p?.id != null ? [p as Product] : [];
        }
        const fromList = (this.products || []).filter((pr: any) => {
            return this.refFabricantKeysMatch(
                ref,
                this.extractRefFabricantFromProductLike(pr)
            );
        });
        const byId = new Map<number, Product>();
        for (const pr of fromList) {
            if (pr?.id != null) {
                byId.set(Number(pr.id), pr);
            }
        }
        if (p?.id != null && !byId.has(Number(p.id))) {
            byId.set(Number(p.id), p as Product);
        }
        return Array.from(byId.values());
    }

    private shiftLineMetaMapsForInsert(fromIndex: number): void {
        const shiftUp = <T>(src: Record<number, T>): Record<number, T> => {
            const out: Record<number, T> = {};
            for (const key of Object.keys(src)) {
                const i = Number(key);
                if (Number.isNaN(i)) {
                    continue;
                }
                out[i >= fromIndex ? i + 1 : i] = src[i];
            }
            return out;
        };
        this.productDescriptions = shiftUp(this.productDescriptions);
        this.showProductDescription = shiftUp(this.showProductDescription);
        this.productLineBarcodeQuery = shiftUp(this.productLineBarcodeQuery);
        this.productLineBarcodeApiHits = shiftUp(this.productLineBarcodeApiHits);
        this.productLineBarcodeSearchLoading = shiftUp(this.productLineBarcodeSearchLoading);
        this.barcodePickerModel = shiftUp(this.barcodePickerModel);
        this.barcodePickerUnlockEdit = shiftUp(this.barcodePickerUnlockEdit);

        const timers: Record<number, ReturnType<typeof setTimeout>> = {};
        for (const key of Object.keys(this.barcodeLineDebounceTimers)) {
            const i = Number(key);
            if (Number.isNaN(i)) {
                continue;
            }
            timers[i >= fromIndex ? i + 1 : i] = this.barcodeLineDebounceTimers[i];
        }
        this.barcodeLineDebounceTimers = timers;

        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    /**
     * Déplace une entrée indexée (0..lineCount-1) comme une ligne du tableau `items`.
     */
    private moveSparseIndexRecord<T>(
        src: Record<number, T>,
        fromIndex: number,
        toIndex: number,
        lineCount: number
    ): Record<number, T> {
        if (fromIndex === toIndex || lineCount <= 0 || fromIndex < 0 || fromIndex >= lineCount) {
            return { ...src };
        }
        let insertAt = toIndex;
        if (fromIndex < toIndex) {
            insertAt = toIndex - 1;
        }
        const slots: (T | undefined)[] = new Array(lineCount);
        for (const key of Object.keys(src)) {
            const i = Number(key);
            if (!Number.isNaN(i) && i >= 0 && i < lineCount) {
                slots[i] = src[i];
            }
        }
        const moved = slots[fromIndex];
        slots.splice(fromIndex, 1);
        slots.splice(insertAt, 0, moved);
        const out: Record<number, T> = {};
        for (let i = 0; i < slots.length; i++) {
            if (slots[i] !== undefined) {
                out[i] = slots[i] as T;
            }
        }
        return out;
    }

    /** Réindexe code-barres, descriptions, etc. quand l'utilisateur réordonne les lignes. */
    private reorderLineMetaMapsForMove(fromIndex: number, toIndex: number, lineCount: number): void {
        const move = <T>(src: Record<number, T>) =>
            this.moveSparseIndexRecord(src, fromIndex, toIndex, lineCount);

        this.productDescriptions = move(this.productDescriptions);
        this.showProductDescription = move(this.showProductDescription);
        this.productLineBarcodeQuery = move(this.productLineBarcodeQuery);
        this.productLineBarcodeApiHits = move(this.productLineBarcodeApiHits);
        this.productLineBarcodeSearchLoading = move(this.productLineBarcodeSearchLoading);
        this.barcodePickerModel = move(this.barcodePickerModel);
        this.barcodePickerUnlockEdit = move(this.barcodePickerUnlockEdit);

        Object.values(this.barcodeLineDebounceTimers).forEach((t) => clearTimeout(t));
        this.barcodeLineDebounceTimers = move(this.barcodeLineDebounceTimers);

        this.barcodePickerMergedByLine = {};
        this.barcodePickerMergedKeyByLine = {};
    }

    private shiftLineMetaMapsForRemove(removedIndex: number): void {
        const shiftDown = <T>(src: Record<number, T>): Record<number, T> => {
            const out: Record<number, T> = {};
            for (const key of Object.keys(src)) {
                const i = Number(key);
                if (Number.isNaN(i)) {
                    continue;
                }
                if (i < removedIndex) {
                    out[i] = src[i];
                } else if (i > removedIndex) {
                    out[i - 1] = src[i];
                }
            }
            return out;
        };

        if (this.barcodeLineDebounceTimers[removedIndex]) {
            clearTimeout(this.barcodeLineDebounceTimers[removedIndex]);
        }

        this.productDescriptions = shiftDown(this.productDescriptions);
        this.showProductDescription = shiftDown(this.showProductDescription);
        this.productLineBarcodeQuery = shiftDown(this.productLineBarcodeQuery);
        this.productLineBarcodeApiHits = shiftDown(this.productLineBarcodeApiHits);
        this.productLineBarcodeSearchLoading = shiftDown(this.productLineBarcodeSearchLoading);
        this.barcodePickerModel = shiftDown(this.barcodePickerModel);
        this.barcodePickerUnlockEdit = shiftDown(this.barcodePickerUnlockEdit);

        const timers: Record<number, ReturnType<typeof setTimeout>> = {};
        for (const key of Object.keys(this.barcodeLineDebounceTimers)) {
            const i = Number(key);
            if (Number.isNaN(i) || i === removedIndex) {
                continue;
            }
            timers[i > removedIndex ? i - 1 : i] = this.barcodeLineDebounceTimers[i];
        }
        this.barcodeLineDebounceTimers = timers;

        const merged: Record<number, Product[]> = {};
        const mergedKeys: Record<number, string> = {};
        for (const key of Object.keys(this.barcodePickerMergedByLine)) {
            const i = Number(key);
            if (Number.isNaN(i) || i === removedIndex) {
                continue;
            }
            const ni = i > removedIndex ? i - 1 : i;
            merged[ni] = this.barcodePickerMergedByLine[i];
            if (this.barcodePickerMergedKeyByLine[i] !== undefined) {
                mergedKeys[ni] = this.barcodePickerMergedKeyByLine[i];
            }
        }
        this.barcodePickerMergedByLine = merged;
        this.barcodePickerMergedKeyByLine = mergedKeys;
    }

    /** Déplace une ligne document + toutes les métadonnées indexées (code-barres, description, etc.). */
    private moveDocumentLine(fromIndex: number, toIndex: number): void {
        if (
            fromIndex === toIndex ||
            fromIndex < 0 ||
            toIndex < 0 ||
            fromIndex >= this.items.length ||
            toIndex >= this.items.length
        ) {
            return;
        }
        const lineCount = this.items.length;
        this.reorderLineMetaMapsForMove(fromIndex, toIndex, lineCount);

        let insertAt = toIndex;
        if (fromIndex < toIndex) {
            insertAt = toIndex - 1;
        }
        const [draggedItem] = this.items.splice(fromIndex, 1);
        this.items.splice(insertAt, 0, draggedItem);
    }

    private sortVariantGroupForModal(group: Product[]): Product[] {
        return [...group].sort((a, b) => {
            const ae = this.isBarcodeEmptyOrZeroForSelect(a);
            const be = this.isBarcodeEmptyOrZeroForSelect(b);
            if (ae !== be) {
                return ae ? -1 : 1;
            }
            const ca = String((a as any)?.code_barre ?? '').trim();
            const cb = String((b as any)?.code_barre ?? '').trim();
            return ca.localeCompare(cb, undefined, { numeric: true });
        });
    }

    private filterVariantModalProductsByBarcode(group: Product[]): Product[] {
        return this.sortVariantGroupForModal(group).filter((p) => !this.isBarcodeEmptyOrZeroForSelect(p));
    }

    private openVariantSelectionModal(
        lineIndex: number,
        selectedProduct: Product,
        group: Product[]
    ): void {
        const modalProducts = this.resolveVariantModalProductRows(group);
        if (modalProducts.length < 2) {
            if (modalProducts.length === 1) {
                this.applyProductSelectionToLine(lineIndex, modalProducts[0], 1);
            } else {
                this.applyProductSelectionToLine(lineIndex, selectedProduct, 1);
            }
            return;
        }

        if (!this.variantSelectionModalTpl) {
            this.cdr.detectChanges();
            setTimeout(
                () => this.openVariantSelectionModal(lineIndex, selectedProduct, group),
                50
            );
            return;
        }

        this.variantModalLineSnapshot = JSON.parse(JSON.stringify(this.items[lineIndex])) as Item;
        this.variantModalLineIndex = lineIndex;
        this.variantModalPrimary = selectedProduct;
        this.variantModalFullGroup = Array.isArray(group) ? group.slice() : [];
        this.variantModalStockByProductId.clear();
        this.variantModalStockDisponibleByProductId.clear();
        this.variantModalTableLoading = true;
        this.variantModalRows = modalProducts.map((prod) => ({
            product: prod,
            selected: true,
            quantity: 0
        }));
        this.rebuildVariantModalMatrix();
        this.variantModalBulkQuantity = 0;
        this.toggleAllVariantModalRows(true);
        this.loadVariantModalStockTotalsFromApi();
        this.variantSelectionModalRef = this.modalService.open(this.variantSelectionModalTpl, {
            centered: true,
            scrollable: true,
            backdrop: 'static',
            windowClass: 'variant-selection-modal-window'
        });
        // Toutes les variantes cochées par défaut après rendu du modal.
        setTimeout(() => {
            this.toggleAllVariantModalRows(true);
            this.cdr.detectChanges();
            this.refreshFeatherIcons();
        }, 0);
        this.variantSelectionModalRef.result.then(
            () => undefined,
            () => {
                if (this.variantModalLineSnapshot != null && this.variantModalLineIndex != null) {
                    this.items[this.variantModalLineIndex] = JSON.parse(
                        JSON.stringify(this.variantModalLineSnapshot)
                    ) as Item;
                    this.variantModalLineSnapshot = null;
                    this.variantModalLineIndex = null;
                    this.variantModalPrimary = null;
                    this.variantModalRows = [];
                    this.variantModalCouleurs = [];
                    this.variantModalTailles = [];
                    this.variantModalCellKeyToRowIndex.clear();
                    this.variantModalBulkQuantity = 0;
                    this.variantModalTableLoading = false;
                    this.variantModalFullGroup = [];
                    this.variantModalStockByProductId.clear();
                    this.variantModalStockDisponibleByProductId.clear();
                    this.rebuildProductsForDocumentSelect();
                    this.calculateTotals();
                    this.updateTvaSummary();
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();
                }
            }
        );
        setTimeout(() => this.refreshFeatherIcons(), 150);
    }

    private variantMatrixCellKey(couleur: string, taille: string): string {
        return `${String(couleur || '—').trim().toLowerCase()}||${String(taille || '—').trim().toLowerCase()}`;
    }

    private rebuildVariantModalMatrix(): void {
        const couleurs: string[] = [];
        const tailles: string[] = [];
        const couleurSeen = new Set<string>();
        const tailleSeen = new Set<string>();
        this.variantModalCellKeyToRowIndex.clear();

        this.variantModalRows.forEach((row, idx) => {
            const ct = this.extractCouleurTailleFromProductLike(row.product);
            const c = ct.couleur || '—';
            const t = ct.taille || '—';
            const ck = c.toLowerCase();
            const tk = t.toLowerCase();
            if (!couleurSeen.has(ck)) {
                couleurSeen.add(ck);
                couleurs.push(c);
            }
            if (!tailleSeen.has(tk)) {
                tailleSeen.add(tk);
                tailles.push(t);
            }
            const key = this.variantMatrixCellKey(c, t);
            if (!this.variantModalCellKeyToRowIndex.has(key)) {
                this.variantModalCellKeyToRowIndex.set(key, idx);
            }
        });

        const collator = (a: string, b: string) =>
            a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
        this.variantModalCouleurs = couleurs.sort(collator);
        this.variantModalTailles = tailles.sort((a, b) => this.compareTailleVetementOrder(a, b));
    }

    private compareTailleVetementOrder(a: string, b: string): number {
        const rankA = this.getTailleVetementRank(a);
        const rankB = this.getTailleVetementRank(b);
        if (rankA !== rankB) {
            return rankA - rankB;
        }
        return String(a || '').localeCompare(String(b || ''), undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    }

    private getTailleVetementRank(raw: string): number {
        const s = String(raw || '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace(/_/g, '');
        if (!s || s === '—' || s === '-') {
            return 10000;
        }
        const letterOrder: { [k: string]: number } = {
            xxs: 10, '2xs': 10, xs: 20, s: 30, sm: 30, small: 30, m: 40, md: 40, medium: 40,
            l: 50, lg: 50, large: 50, xl: 60, '1xl': 60, xxl: 70, '2xl': 70, xxxl: 80, '3xl': 80,
            xxxxl: 90, '4xl': 90, xxxxxl: 100, '5xl': 100, xxxxxxl: 110, '6xl': 110
        };
        if (letterOrder[s] != null) {
            return letterOrder[s];
        }
        const compact = s.replace(/-/g, '');
        if (letterOrder[compact] != null) {
            return letterOrder[compact];
        }
        const num = Number(s.replace(',', '.'));
        if (Number.isFinite(num)) {
            return 1000 + num;
        }
        if (/^x{0,6}l(arge)?$/.test(s) || /^x{1,6}-?l(arge)?$/.test(s)) {
            const xCount = (s.match(/x/g) || []).length;
            return 50 + xCount * 10;
        }
        return 5000;
    }

    hasVariantModalMatrixCell(couleur: string, taille: string): boolean {
        return this.variantModalCellKeyToRowIndex.has(this.variantMatrixCellKey(couleur, taille));
    }

    getVariantModalMatrixRow(
        couleur: string,
        taille: string
    ): { product: Product; selected: boolean; quantity: number } | null {
        const idx = this.variantModalCellKeyToRowIndex.get(this.variantMatrixCellKey(couleur, taille));
        if (idx == null) {
            return null;
        }
        return this.variantModalRows[idx] ?? null;
    }

    getVariantModalMatrixQuantity(couleur: string, taille: string): number {
        const row = this.getVariantModalMatrixRow(couleur, taille);
        return row ? this.normalizeVariantModalQuantity(row.quantity) : 0;
    }

    onVariantModalMatrixQuantityChange(
        couleur: string,
        taille: string,
        value: string | number | null | undefined
    ): void {
        const idx = this.variantModalCellKeyToRowIndex.get(this.variantMatrixCellKey(couleur, taille));
        if (idx == null) {
            return;
        }
        const q = this.normalizeVariantModalQuantity(value);
        const row = this.variantModalRows[idx];
        if (!row) {
            return;
        }
        row.quantity = q;
        row.selected = q > 0;
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    incrementVariantModalMatrixQuantity(couleur: string, taille: string): void {
        const current = this.getVariantModalMatrixQuantity(couleur, taille);
        this.onVariantModalMatrixQuantityChange(couleur, taille, current + 1);
    }

    decrementVariantModalMatrixQuantity(couleur: string, taille: string): void {
        const current = this.getVariantModalMatrixQuantity(couleur, taille);
        this.onVariantModalMatrixQuantityChange(couleur, taille, Math.max(0, current - 1));
    }

    areAllVariantModalRowsSelected(): boolean {
        return this.variantModalRows.length > 0 && this.variantModalRows.every((r) => r.selected === true);
    }

    trackVariantModalRow(index: number, row: { product: Product; selected: boolean; quantity: number }): number | string {
        const id = row?.product?.id;
        return id != null ? Number(id) : index;
    }

    clearVariantModalRowSelection(): void {
        this.variantModalRows.forEach((r) => {
            r.selected = false;
        });
    }

    setVariantModalRowSelected(rowIndex: number, checked: boolean): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        row.selected = checked === true;
        this.cdr.detectChanges();
    }

    toggleAllVariantModalRows(checked: boolean): void {
        const value = checked === true;
        this.variantModalRows.forEach((r) => (r.selected = value));
        this.cdr.detectChanges();
    }

    private normalizeVariantModalQuantity(value: string | number | null | undefined): number {
        return normalizeNonNegativeIntegerQuantity(value);
    }

    onVariantModalBulkQuantityChange(value: string | number | null | undefined): void {
        this.variantModalBulkQuantity = this.normalizeVariantModalQuantity(value);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    incrementVariantModalBulkQuantity(): void {
        this.variantModalBulkQuantity = this.normalizeVariantModalQuantity(this.variantModalBulkQuantity) + 1;
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    decrementVariantModalBulkQuantity(): void {
        this.variantModalBulkQuantity = Math.max(
            0,
            this.normalizeVariantModalQuantity(this.variantModalBulkQuantity) - 1
        );
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    applyVariantModalQuantityToAll(): void {
        const q = this.normalizeVariantModalQuantity(this.variantModalBulkQuantity);
        this.variantModalBulkQuantity = q;
        this.variantModalRows.forEach((r) => {
            r.quantity = q;
            r.selected = q > 0;
        });
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    onVariantModalRowQuantityChange(rowIndex: number, value: string | number | null | undefined): void {
        this.setVariantModalRowQuantity(rowIndex, value);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    private setVariantModalRowQuantity(rowIndex: number, newQuantity: string | number | null | undefined): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        row.quantity = this.normalizeVariantModalQuantity(newQuantity);
        row.selected = row.quantity > 0;
    }

    incrementVariantModalQuantity(rowIndex: number): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        const current = parseFloat(String(row.quantity ?? 0)) || 0;
        this.setVariantModalRowQuantity(rowIndex, current + 1);
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    decrementVariantModalQuantity(rowIndex: number): void {
        const row = this.variantModalRows[rowIndex];
        if (!row) {
            return;
        }
        const current = parseFloat(String(row.quantity ?? 0)) || 0;
        this.setVariantModalRowQuantity(rowIndex, Math.max(0, current - 1));
        this.cdr.detectChanges();
        setTimeout(() => this.refreshFeatherIcons(), 0);
    }

    displayCodeBarreVariant(p: Product | any): string {
        const c = p?.code_barre;
        if (c == null || c === '') {
            return '—';
        }
        const s = String(c).trim();
        return s === '' ? '—' : s;
    }

    displayCodeBarreVariantFormatted(p: Product | any): string {
        const base = this.displayCodeBarreVariant(p);
        if (base === '—') {
            return base;
        }
        const digits = base.replace(/\s/g, '');
        if (/^\d{13}$/.test(digits)) {
            return `${digits[0]} ${digits.slice(1, 7)} ${digits.slice(7)}`;
        }
        if (/^\d{12}$/.test(digits)) {
            return `${digits.slice(0, 6)} ${digits.slice(6)}`;
        }
        if (/^\d{8}$/.test(digits)) {
            return `${digits.slice(0, 4)} ${digits.slice(4)}`;
        }
        return base;
    }

    getVariantModalStockDisplay(p: Product | any | null | undefined): number {
        if (p == null || p.id == null) {
            return 0;
        }
        const id = Number(p.id);
        if (!Number.isFinite(id)) {
            return 0;
        }
        if (this.variantModalStockByProductId.has(id)) {
            const q = this.variantModalStockByProductId.get(id);
            return q !== undefined && Number.isFinite(q) ? q : 0;
        }
        return 0;
    }

    getVariantModalGroupTotalStock(): number {
        const seen = new Set<number>();
        let sum = 0;
        for (const p of this.variantModalFullGroup) {
            if (p?.id == null || this.isBarcodeEmptyOrZeroForSelect(p)) {
                continue;
            }
            const id = Number(p.id);
            if (!Number.isFinite(id) || seen.has(id)) {
                continue;
            }
            seen.add(id);
            sum += this.getVariantModalStockDisplay(p);
        }
        return sum;
    }

    getVariantModalStockStatus(p: Product | any): string {
        return this.getVariantModalStockDisplay(p) > 0 ? 'En stock' : 'En rupture';
    }

    private loadVariantModalStockTotalsFromApi(): void {
        const metas: Array<{
            id: number;
            code_barre?: string | null;
            ref_interne?: string | null;
            ref_fabricant?: string | null;
        }> = [];
        const seen = new Set<number>();
        for (const p of this.variantModalFullGroup) {
            if (p?.id == null) {
                continue;
            }
            const id = Number(p.id);
            if (!Number.isFinite(id) || seen.has(id)) {
                continue;
            }
            seen.add(id);
            const meta = this.buildLcStockMetaFromProduct(p, id);
            if (meta) {
                metas.push(meta);
            }
        }
        if (metas.length === 0) {
            this.variantModalTableLoading = false;
            this.cdr.detectChanges();
            return;
        }
        this.variantModalTableLoading = true;
        this.lcStockGestion
            .getStockGlobaleByErpProducts(metas, {
                entrepotIds: this.getLcEntrepotIdsForGestionGlobale(),
            })
            .pipe(
                catchError(() => {
                    const empty: Record<number, { physique: number; disponible: number }> = {};
                    for (const m of metas) {
                        empty[m.id] = { physique: 0, disponible: 0 };
                    }
                    return of(empty);
                })
            )
            .subscribe({
                next: (rec) => {
                    for (const m of metas) {
                        const pair = rec[m.id] ?? { physique: 0, disponible: 0 };
                        this.variantModalStockByProductId.set(m.id, pair.physique);
                        this.variantModalStockDisponibleByProductId.set(m.id, pair.disponible);
                    }
                    this.variantModalTableLoading = false;
                    this.toggleAllVariantModalRows(true);
                    this.cdr.detectChanges();
                    setTimeout(() => this.refreshFeatherIcons(), 0);
                },
                error: () => {
                    this.variantModalTableLoading = false;
                    this.cdr.detectChanges();
                }
            });
    }

    /** STOCK DISPONIBLE — même champ que Gestion stock (stock_disponible_global). */
    getVariantStockWebQty(p: Product | any): number {
        if (p?.id == null) {
            return 0;
        }
        const id = Number(p.id);
        if (!Number.isFinite(id)) {
            return 0;
        }
        if (this.variantModalStockDisponibleByProductId.has(id)) {
            const q = this.variantModalStockDisponibleByProductId.get(id);
            return q !== undefined && Number.isFinite(q) ? q : 0;
        }
        if (this.variantModalStockByProductId.has(id)) {
            return this.getVariantModalStockDisplay(p);
        }
        return 0;
    }

    getVariantStockWebStatus(p: Product | any): string {
        const q = this.getVariantStockWebQty(p);
        return q > 0 ? 'En stock' : 'En rupture';
    }

    formatVariantCouleurOnly(p: Product | any): string {
        const c = p?.couleur != null ? String(p.couleur).trim() : '';
        return c || '—';
    }

    formatVariantTailleOnly(p: Product | any): string {
        const t = p?.taille != null ? String(p.taille).trim() : '';
        return t || '—';
    }

    confirmVariantSelectionModal(modal: { close: (r?: any) => void }): void {
        const picked = this.variantModalRows.filter(
            (r) => this.normalizeVariantModalQuantity(r.quantity) > 0
        );
        if (picked.length === 0) {
            this.toastr.warning(
                'Saisissez une quantité supérieure à 0 pour au moins une variante (couleur × taille).',
                'Variantes'
            );
            return;
        }
        const baseIdx = this.variantModalLineIndex;
        if (baseIdx == null) {
            modal.close('ok');
            this.variantSelectionModalRef = null;
            return;
        }
        const rows = picked.map((r) => ({
            product: r.product,
            quantity: normalizeNonNegativeIntegerQuantity(r.quantity),
        }));

        this.variantModalLineSnapshot = null;
        this.variantModalLineIndex = null;
        this.variantModalPrimary = null;
        this.variantModalRows = [];
        this.variantModalCouleurs = [];
        this.variantModalTailles = [];
        this.variantModalCellKeyToRowIndex.clear();
        this.variantModalBulkQuantity = 0;
        this.variantModalTableLoading = false;
        this.variantModalFullGroup = [];
        this.variantModalStockByProductId.clear();
        this.variantModalStockDisponibleByProductId.clear();

        this.applyMultipleVariantRowsToDocumentLine(baseIdx, rows);
        modal.close('ok');
        this.variantSelectionModalRef = null;
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    private createEmptyProductLineItem(): Item {
        return {
            type: 'product',
            designation: '',
            quantity: 0,
            reference: '',
            code_barre: '',
            priceHT: 0,
            tva: '0',
            totalHT: 0
        } as Item;
    }

    private applyMultipleVariantRowsToDocumentLine(
        baseIdx: number,
        selected: { product: Product; quantity: number }[]
    ): void {
        if (selected.length === 0) {
            return;
        }
        this.mergeProductsFromBarcodeApiIntoStore(
            selected.map((s) => s.product).filter((p) => p?.id != null)
        );

        this.suppressDesignationSelectChange = true;
        try {
            let idx = baseIdx;
            for (let i = 0; i < selected.length; i++) {
                if (i > 0) {
                    this.shiftLineMetaMapsForInsert(idx);
                    this.items.splice(idx, 0, this.createEmptyProductLineItem());
                }
                this.applyProductSelectionToLine(idx, selected[i].product, selected[i].quantity);
                idx++;
            }
        } finally {
            setTimeout(() => {
                this.suppressDesignationSelectChange = false;
            }, 0);
        }

        this.rebuildProductsForDocumentSelect();
        this.calculateTotals();
        this.updateTvaSummary();
        this.updateApproveButtonState();

        if (selected[0]?.product) {
            const key = this.getProductLineGroupKey(baseIdx);
            this.expandedBarcodeGroups.delete(key);
            this.barcodeGroupLoaded.delete(key);
            delete this.barcodeGroupLoading[key];
        }

        this.syncBarcodePickerModelForVisibleProductLines();
        this.cdr.markForCheck();
    }

    openErpProductDetailFromVariantModal(productId: number | null | undefined): void {
        if (productId == null) {
            return;
        }
        this.zone.run(() => {
            this.router.navigate(['/bibliotheque-test/detail-produit', productId]);
        });
    }

    private applyProductTaxes(product: any, index: number, mergeWithExisting?: boolean): void {
        const item = this.items[index];
        let newTaxes: any[] = [];
        const activeTaxIds = new Set(
            (this.taxes || []).filter((t: any) => this.isTaxActiveForDocument(t)).map((t: any) => t.id)
        );

        if (Array.isArray(product.taxes) && product.taxes.length > 0) {
            newTaxes = product.taxes
                .filter((taxe: any) => {
                    const id = taxe.taxes_id ?? taxe.id;
                    const isActive =
                        taxe.statut === true ||
                        taxe.statut === 1 ||
                        (id != null && activeTaxIds.has(Number(id)));
                    return id != null && isActive;
                })
                .map((taxe: any) => {
                    if (taxe.taxes_id) {
                        return { ...taxe, id: taxe.taxes_id };
                    }
                    return taxe;
                });
        } else if (product.taxe_id !== null && product.taxe_id !== undefined) {
            const taxeIds = Array.isArray(product.taxe_id) ? product.taxe_id : [product.taxe_id];
            newTaxes = this.taxes.filter(
                t => taxeIds.includes(t.id) && this.isTaxActiveForDocument(t)
            );
        }

        if (mergeWithExisting && (item['taxesProduit'] || []).length > 0) {
            const existingIds = new Set((item['taxesProduit'] || []).map((t: any) => t.id ?? t.taxes_id));
            const toAdd = newTaxes.filter((t: any) => !existingIds.has(t.id));
            item['taxesProduit'] = [...(item['taxesProduit'] || []), ...toAdd];
        } else {
            item['taxesProduit'] = newTaxes;
        }

        item['fodecApplique'] = (item['taxesProduit'] || []).some((taxe: any) =>
            taxe.nom?.toLowerCase().includes('fodec') ||
            taxe.label?.toLowerCase().includes('fodec')
        );
        
        this.calculateLine(index);
        this.cdr.detectChanges();
    }

    private loadProductTaxes(productId: number, index: number): void {
        this.productsService.getDetailsProduct(productId).subscribe({
            next: (res: any) => {
                const product: Product = res.data || res;

                const item = this.items[index];
                const taxeProduit = this.taxes.find(
                    t => t.id === product.taxe_id && this.isTaxActiveForDocument(t)
                );
                item['taxesProduit'] = taxeProduit ? [taxeProduit] : [];
                item['fodecApplique'] = this.taxes.some(t =>
                    t.id === product.taxe_id &&
                    this.isTaxActiveForDocument(t) &&
                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec'))
                );

                if (taxeProduit) {
                    item.tva = taxeProduit.valeur.toString();
                } else {
                    item.tva = '0';
                }

                this.calculateLine(index);
                this.cdr.detectChanges();
            },

        });
    }

    calculateLine(index: number): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        const prixUnitaire = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') 
            ? (item.valeur_unitaire || 0) 
            : (item.priceHT || 0);
        // Accepter qnt négatives (avoirs / retours) — ne pas forcer à 1 si quantity = 0 explicite.
        const qteRaw = Number(item.quantity);
        const qte = Number.isFinite(qteRaw) ? qteRaw : 1;
        const htBrut = Number(prixUnitaire) * qte;
        const remisePourcent = Number(item.remise || 0);
        const montantRemise = htBrut * (remisePourcent / 100);
        const htApresRemise = htBrut - montantRemise;
        item.totalHTBrut = +htBrut.toFixed(3);
        item.montantRemise = +montantRemise.toFixed(3);
        item.htNet = +htApresRemise.toFixed(3);
        let totalTaxesAvantTVA = 0;
        let taxesAvantTVAInclusesTVA = 0;
        const taxesAvant: any[] = [];

        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const valeurNum = parseFloat(taxe.valeur || '0');
            if (isNaN(valeurNum)) return;
            const isFixe = taxe.valeur_fixe === true || taxe.valeur_fixe === 1;
            if (!isFixe && valeurNum === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (appliqueAvantTVA) {
                const Base_Taxe_Ligne = htApresRemise;
                const montantTaxe = isFixe ? valeurNum : Base_Taxe_Ligne * (valeurNum / 100);
                totalTaxesAvantTVA += montantTaxe;
                taxesAvant.push({
                    nom: taxe.nom || taxe.label,
                    taux: valeurNum,
                    montant: +montantTaxe.toFixed(3)
                });
                const estFODEC = taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec');
                const appliqueALaTVA = taxe.applique_tva === true ||
                                       taxe.applique_a_la_tva === true ||
                                       taxe.appliquee_a_la_tva === true ||
                                       taxe.applique_a_tva === true ||
                                       taxe.appliquee_a_tva === true ||
                                       estFODEC;

                if (appliqueALaTVA) {
                    taxesAvantTVAInclusesTVA += montantTaxe;
                }
            }
        });

        item.taxesAvantTVA = +totalTaxesAvantTVA.toFixed(3);
        item.listeTaxesAvantTVA = taxesAvant;
        const baseTVA = htApresRemise + taxesAvantTVAInclusesTVA;
        item.baseTVA = +baseTVA.toFixed(3);
        const tauxTVA = Number(item.tva || 0);
        const montantTVA = baseTVA * (tauxTVA / 100);
        item.montantTVA = +montantTVA.toFixed(3);
        let totalTaxesApresTVA = 0;
        const taxesApres: any[] = [];

        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const valeurNum = parseFloat(taxe.valeur || '0');
            if (isNaN(valeurNum)) return;
            const isFixe = taxe.valeur_fixe === true || taxe.valeur_fixe === 1;
            if (!isFixe && valeurNum === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (!appliqueAvantTVA) {
                const Base_ApresTVA_Ligne = baseTVA + montantTVA;
                const montant = isFixe ? valeurNum : Base_ApresTVA_Ligne * (valeurNum / 100);
                totalTaxesApresTVA += montant;
                taxesApres.push({
                    nom: taxe.nom || taxe.label,
                    taux: valeurNum,
                    montant: +montant.toFixed(3)
                });
            }
        });

        item.taxesApresTVA = +totalTaxesApresTVA.toFixed(3);
        item.listeTaxesApresTVA = taxesApres;
        item.totalHT = +(htApresRemise + totalTaxesAvantTVA).toFixed(3);
        item.ttcLigne = +(htApresRemise + totalTaxesAvantTVA + montantTVA + totalTaxesApresTVA).toFixed(3);
    }

    onProjectSelect(libelle: string): void {
        this.selectedProject = libelle;
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    onFournisseurSaved(apiResponse: any): void {

        let newFournisseur;
        if (apiResponse?.fournisseur) {
            newFournisseur = apiResponse.fournisseur;
        } else if (apiResponse?.fornisseur) {
            newFournisseur = apiResponse.fornisseur;
        } else if (apiResponse?.data) {
            newFournisseur = apiResponse.data;
        } else if (apiResponse?.id) {
            newFournisseur = apiResponse;
        }

        if (!newFournisseur || !newFournisseur.id) {
            this.toastr.error('Erreur: Fournisseur invalide dans la réponse');
            return;
        }

        this.toastr.success(apiResponse.message || 'Fournisseur ajouté avec succès !', 'Succès');

        this.loadFournisseurs(newFournisseur.id);
    }

    onClientSaved(apiResponse: any): void {
        if (!apiResponse || !apiResponse.client) {
            this.toastr.error('Réponse invalide de l\'API');
            return;
        }

        const newClient = apiResponse.client;

        this.toastr.success(apiResponse.message || 'Client ajouté avec succès !', 'Succès');

        const clientIdToSelect = newClient.id;

        this.loadClients(clientIdToSelect);
    }

    /** Le document affiche uniquement les clients provenant de l'API ERP. */
    private fetchCaisseClientsForDocument(): Observable<CaisseClient[]> {
        return of([] as CaisseClient[]);
    }

    private mapCaisseClientToDocumentClient(c: CaisseClient): Client {
        const nomPrenom =
            [c.prenom, c.nom].filter(Boolean).join(' ').trim() || `Client caisse #${c.id}`;
        return {
            // ID négatif pour éviter collision avec un client ERP de même id numérique
            id: -Math.abs(Number(c.id)),
            type: 'Individuel',
            civilite: '',
            nom_prenom: nomPrenom,
            station_id: Number(c.station_id) || this.stationId || 0,
            user_id: Number(c.user_id) || 0,
            identifiant_unique: `LC-${c.id}`,
            emails: c.email ? [{ email: String(c.email) }] : [],
            telephones: c.telephone
                ? [{ type: 'Principal', num_tel: String(c.telephone), code_pays: '' }]
                : [],
            adresses: [],
            is_archive: false,
            source: 'caisse',
            created_at: c.created_at ?? undefined,
            updated_at: c.updated_at ?? undefined
        };
    }

    private clientDedupeKeyForDocument(client: Pick<Client, 'nom_prenom' | 'emails' | 'telephones' | 'id' | 'identifiant_unique'>): string {
        const email = String(client.emails?.[0]?.email || '')
            .trim()
            .toLowerCase();
        const tel = String(client.telephones?.[0]?.num_tel || '')
            .replace(/\s+/g, '')
            .trim();
        // Identité forte : email ou téléphone — évite d’exclure toute la caisse sur un nom vague.
        if (email || tel) {
            return `${email}|${tel}`;
        }
        const name = String(client.nom_prenom || '')
            .trim()
            .toLowerCase();
        if (name) {
            return `name:${name}`;
        }
        const uid = String(client.identifiant_unique || client.id || '').trim();
        return uid ? `id:${uid}` : '';
    }

    private mergeErpClientsWithCaisse(erpClients: Client[], caisse: CaisseClient[]): Client[] {
        const merged: Client[] = [...(erpClients || [])].map((c) => ({
            ...c,
            source: c.source ?? 'erp'
        }));
        const existing = new Set(
            merged.map((c) => this.clientDedupeKeyForDocument(c)).filter((k) => !!k)
        );
        for (const raw of caisse || []) {
            const mapped = this.mapCaisseClientToDocumentClient(raw);
            const key = this.clientDedupeKeyForDocument(mapped);
            if (key && existing.has(key)) {
                continue;
            }
            if (key) {
                existing.add(key);
            }
            merged.push(mapped);
        }
        return merged;
    }

    isCaisseClient(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        return client.source === 'caisse' || String(client.identifiant_unique || '').startsWith('LC-');
    }

    /** Libellé ng-select : nom_entreprise pour Professionnel / Négoce. */
    getClientSelectLabel(client: Client | null | undefined): string {
        if (!client) {
            return '';
        }
        const type = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const isEntrepriseType = type === 'professionnel' || type === 'negoce' || type === 'patente';
        const entreprise = String(client.nom_entreprise || client.raison_social || '').trim();
        const personne = String(client.nom_prenom || '').trim();

        if (isEntrepriseType) {
            if (entreprise && personne && entreprise.toLowerCase() !== personne.toLowerCase()) {
                return `${entreprise} - ${personne}`;
            }
            return entreprise || personne || `Client #${client.id ?? ''}`;
        }
        return personne || entreprise || `Client #${client.id ?? ''}`;
    }

    /** Client professionnel = type Professionnel uniquement (ENUM ERP) — hors Négoce. */
    isClientPatente(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        return t === 'professionnel' || t === 'patente' || t === 'entreprise';
    }

    /** Client type Négoce (vente négoce uniquement). */
    isClientNegoce(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        return t === 'negoce';
    }

    isClientParticulier(client: Client | null | undefined): boolean {
        if (!client) {
            return false;
        }
        const t = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        if (t === 'individuel' || t === 'particulier') {
            return true;
        }
        // Type inconnu / vide → traité comme particulier (pas pro / négoce)
        return !this.isClientPatente(client) && !this.isClientNegoce(client);
    }

    /** Recalcule la liste ng-select selon Professionnel / Particulier / Négoce. */
    private refreshClientsForSelect(): void {
        const all = this.clients || [];
        if (this.isVenteNegoceContext || this.clientSearchMode === 'negoce') {
            this.clientsForSelect = all.filter((c) => this.isClientNegoce(c));
            return;
        }
        this.clientsForSelect =
            this.clientSearchMode === 'patente'
                ? all.filter((c) => this.isClientPatente(c))
                : all.filter((c) => this.isClientParticulier(c));
    }

    get clientSearchPlaceholder(): string {
        if (this.isVenteNegoceContext || this.clientSearchMode === 'negoce') {
            return 'Rechercher un client négoce…';
        }
        return this.clientSearchMode === 'patente'
            ? 'Rechercher par entreprise…'
            : 'Rechercher par nom…';
    }

    setClientSearchMode(mode: 'patente' | 'particulier' | 'negoce'): void {
        if (this.isVenteNegoceContext) {
            mode = 'negoce';
        }
        if (this.clientSearchMode === mode) {
            return;
        }
        this.clientSearchMode = mode;
        this.selectedClient = null;
        this.selectedClientId = null;
        this.clientId = null;
        this.refreshClientsForSelect();
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    /**
     * Recherche : professionnel → nom d'entreprise (pas email) ;
     * particulier → nom / prénom (pas email).
     */
    searchClients = (term: string, item: Client): boolean => {
        const t = String(term || '')
            .trim()
            .toLowerCase();
        if (!t) {
            return true;
        }
        let hayParts: Array<string | null | undefined>;
        if (this.clientSearchMode === 'patente' || this.clientSearchMode === 'negoce') {
            hayParts = [
                item?.nom_entreprise,
                item?.raison_social,
                item?.code_client,
                item?.identifiant_unique,
                item?.numero_identification_fiscale
            ];
        } else {
            hayParts = [
                item?.nom_prenom,
                item?.code_client,
                item?.identifiant_unique
            ];
        }
        const hay = hayParts
            .filter(Boolean)
            .join(' ')
            .toLowerCase()
            .replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, ' ');
        return hay.includes(t);
    };

    /** FK ERP : null pour un client uniquement présent en caisse. */
    resolveDocumentClientId(client: Client | null | undefined): number | null {
        if (!client?.id || this.isCaisseClient(client)) {
            return null;
        }
        return client.id;
    }

    /** Libellé client persisté / affiché : entreprise si pro, sinon nom+prénom. */
    resolveDocumentClientDisplayName(client: Client | null | undefined): string {
        if (!client) {
            return 'Client inconnu';
        }
        const type = String(client.type || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const isPro =
            type === 'professionnel' || type === 'negoce' || type === 'patente' || type === 'entreprise';
        const entreprise = String(
            (client as any).nom_entreprise || (client as any).raison_social || ''
        ).trim();
        const nomPrenom = String(client.nom_prenom || '').trim();
        if (isPro) {
            return entreprise || nomPrenom || 'Client inconnu';
        }
        return nomPrenom || entreprise || 'Client inconnu';
    }

    loadClients(clientIdToSelect?: number): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingClients = false;
            this.clients = [];
            this.clientsForSelect = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingClients = true;
        forkJoin({
            erp: this.clientService.getActiveClient(this.stationId, 1, 100).pipe(
                catchError(() => of({ data: [] as Client[] }))
            ),
            caisse: this.fetchCaisseClientsForDocument()
        }).subscribe({
            next: ({ erp, caisse }) => {
                this.zone.run(() => {
                    const erpList = (erp?.data || []) as Client[];
                    this.clients = this.mergeErpClientsWithCaisse(erpList, caisse);
                    this.refreshClientsForSelect();
                    this.isLoadingClients = false;

                    const idToSelect = clientIdToSelect ?? this.pendingClientId;

                    if (idToSelect !== undefined) {
                        const clientToSelect = this.clients.find(c => c.id === idToSelect);
                        if (clientToSelect) {
                            if (this.isVenteNegoceContext) {
                                this.clientSearchMode = 'negoce';
                            } else {
                                this.clientSearchMode = this.isClientPatente(clientToSelect)
                                    ? 'patente'
                                    : this.isClientNegoce(clientToSelect)
                                      ? 'patente'
                                      : 'particulier';
                                // En vente classique, un client négoce n’est pas sélectionnable
                                if (this.isClientNegoce(clientToSelect)) {
                                    this.selectedClient = null;
                                    this.selectedClientId = null;
                                    this.clientId = null;
                                    this.refreshClientsForSelect();
                                    this.pendingClientId = undefined;
                                    this.isLoadingClients = false;
                                    this.cdr.detectChanges();
                                    this.toastr.warning(
                                        'Ce client est de type Négoce : utilisez le menu Vente négoce.',
                                        'Client non disponible'
                                    );
                                    return;
                                }
                            }
                            this.refreshClientsForSelect();
                            this.selectedClient = clientToSelect;
                            this.selectedClientId = idToSelect;
                            this.clientId = idToSelect;

                            this.editMode = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };

                            if (this.mode === 'add' || !this.documentId) {
                                this.modifiedClientFields = {
                                    nomClient: false,
                                    identifiant: false,
                                    numeroIdentification: false,
                                    adresse: false,
                                    email: false
                                };
                                this.modifiedFournisseurFields = {
                                    nomEntreprise: false,
                                    numeroIdentification: false,
                                    responsable: false,
                                    telephone: false,
                                    adresse: false
                                };
                            } else {
                                this.loadModifiedFields();
                            }

                            this.cdr.detectChanges();

                            setTimeout(() => {
                                this.initializeFeatherIcons();
                            }, 200);

                            this.updateApproveButtonState();
                            this.cdr.detectChanges();

                            setTimeout(() => {
                                this.initializeFeatherIcons();
                            }, 200);

                            this.toastr.info(`Client "${clientToSelect.nom_prenom}" chargé.`);
                        } else {
                            this.selectedClient = null;
                        }
                        this.pendingClientId = undefined;
                    }

                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.zone.run(() => {
                    this.isLoadingClients = false;
                    this.clients = [];
                    this.clientsForSelect = [];
                    this.toastr.error('Erreur lors du chargement des clients.', 'Erreur');
                    this.cdr.detectChanges();
                });
            }
        });
    }

    private applySelectedClientFromList(client: Client, clientId: number): void {
        this.selectedClient = client;
        this.selectedClientId = clientId;
        this.clientId = clientId;
        this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };

        if (this.mode === 'add' || !this.documentId) {
            this.modifiedClientFields = {
                nomClient: false,
                identifiant: false,
                numeroIdentification: false,
                adresse: false,
                email: false
            };
            this.modifiedFournisseurFields = {
                nomEntreprise: false,
                numeroIdentification: false,
                responsable: false,
                telephone: false,
                adresse: false
            };
        } else {
            this.loadModifiedFields();
        }
        this.loadWarehouses();
        this.updateApproveButtonState();
        this.cdr.detectChanges();
        setTimeout(() => {
            this.initializeFeatherIcons();
        }, 150);
    }

    onClientSelect(value: any): void {
        let clientId: number | null = null;

        if (value === null || value === undefined) {
            // ng-select peut émettre null pendant le refresh de la liste — ignorer si sélection en cours
            if (this.clientSelectLoading || this.selectedClient) {
                return;
            }
            this.selectedClient = null;
            this.selectedClientId = null;
            this.clientId = null;
            this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
            this.cdr.detectChanges();
            return;
        }

        if (typeof value === 'object' && value.id !== undefined) {
            clientId = typeof value.id === 'number' ? value.id : parseInt(value.id, 10);
        } else if (typeof value === 'number') {
            clientId = value;
        } else if (typeof value === 'string') {
            clientId = parseInt(value, 10);
        }

        if (clientId == null || isNaN(clientId)) {
            this.toastr.error('ID de client invalide');
            return;
        }

        this.clientSelectLoading = true;
        const fromList = this.clients.find((c) => Number(c.id) === Number(clientId));
        // Appliquer immédiatement pour fermer le select et éviter le reset ng-select
        if (fromList) {
            this.applySelectedClientFromList(fromList, clientId);
        }

        if (fromList && this.isCaisseClient(fromList)) {
            this.clientSelectLoading = false;
            return;
        }

        this.clientService.getClientById(clientId).subscribe({
            next: (clientComplet) => {
                if (!clientComplet || !clientComplet.id) {
                    this.clientSelectLoading = false;
                    if (!fromList) {
                        this.toastr.error('Les données du client sont invalides.');
                    }
                    return;
                }
                if (!Array.isArray(clientComplet.adresses)) {
                    clientComplet.adresses = clientComplet.adresses ? [clientComplet.adresses] : [];
                }
                if (!Array.isArray(clientComplet.telephones)) {
                    clientComplet.telephones = clientComplet.telephones ? [clientComplet.telephones] : [];
                }
                if (!Array.isArray(clientComplet.emails)) {
                    clientComplet.emails = clientComplet.emails ? [clientComplet.emails] : [];
                }
                const existingIndex = this.clients.findIndex(
                    (c) => Number(c.id) === Number(clientComplet.id)
                );
                if (existingIndex >= 0) {
                    this.clients[existingIndex] = clientComplet;
                } else {
                    this.clients = [clientComplet, ...this.clients];
                }
                this.refreshClientsForSelect();

                this.selectedClient = clientComplet;
                this.selectedClientId = clientComplet.id;
                this.clientId = clientComplet.id;
                this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };

                if (this.mode === 'add' || !this.documentId) {
                    this.modifiedClientFields = {
                        nomClient: false,
                        identifiant: false,
                        adresse: false,
                        email: false
                    };
                    this.modifiedFournisseurFields = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };
                } else {
                    this.loadModifiedFields();
                }
                this.loadWarehouses();
                this.updateApproveButtonState();
                this.clientSelectLoading = false;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.initializeFeatherIcons();
                }, 150);
            },
            error: (err) => {
                this.clientSelectLoading = false;
                const client = this.clients.find((c) => Number(c.id) === Number(clientId));
                if (client) {
                    this.applySelectedClientFromList(client, clientId);
                } else {
                    this.selectedClientId = null;
                    this.selectedClient = null;
                    this.clientId = null;
                    this.pendingClientId = clientId;
                    const errorMessage =
                        err?.error?.message || err?.error?.error || err?.message || 'Erreur inconnue';
                    this.toastr.error(
                        `Impossible de charger les données du client: ${errorMessage}`,
                        'Erreur'
                    );
                }
            }
        });
    }

    onFournisseurSelect(fournisseurId: number | any): void {
        let id: number | null = null;
        
        if (fournisseurId === null || fournisseurId === undefined) {
            this.selectedFournisseur = null;
            this.selectedFournisseurId = null;
            this.clientId = null;
            this.updateApproveButtonState();
            this.cdr.detectChanges();
            return;
        }

        if (typeof fournisseurId === 'object' && fournisseurId.id !== undefined) {
            id = typeof fournisseurId.id === 'number' ? fournisseurId.id : parseInt(fournisseurId.id, 10);
        } 
        else if (typeof fournisseurId === 'number') {
            id = fournisseurId;
        }
        else if (typeof fournisseurId === 'string') {
            id = parseInt(fournisseurId, 10);
        }
        
        if (!id || isNaN(id)) {
            this.toastr.error('ID de fournisseur invalide');
            return;
        }

        
        this.fournisseurService.getFournisseurById(id).subscribe({
            next: (fournisseurComplet) => {
                
                if (!fournisseurComplet || !fournisseurComplet.id) {
                    this.toastr.error('Les données du fournisseur sont invalides.');
                    return;
                }

                if (!Array.isArray(fournisseurComplet.adresses)) {
                    fournisseurComplet.adresses = fournisseurComplet.adresses ? [fournisseurComplet.adresses] : [];
                }
                if (!Array.isArray(fournisseurComplet.telephones)) {
                    fournisseurComplet.telephones = fournisseurComplet.telephones ? [fournisseurComplet.telephones] : [];
                }
                if (!Array.isArray(fournisseurComplet.emails)) {
                    fournisseurComplet.emails = fournisseurComplet.emails ? [fournisseurComplet.emails] : [];
                }

                const responsable = (fournisseurComplet as any).responsable || 
                                  (fournisseurComplet as any).contact || 
                                  (fournisseurComplet as any).nom_contact ||
                                  '';
                
                const fournisseurWithExtras = {
                    ...fournisseurComplet,
                    responsable: responsable,
                    phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                } as any;

                const existingIndex = this.fournisseurs.findIndex(f => f.id === fournisseurComplet.id);
                if (existingIndex >= 0) {
                    this.fournisseurs[existingIndex] = fournisseurWithExtras as Fournisseur;
                } else {
                    this.fournisseurs = [fournisseurWithExtras as Fournisseur, ...this.fournisseurs];
                }
                
                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                this.selectedFournisseurId = fournisseurComplet.id;
                this.clientId = fournisseurComplet.id;

                this.editModeFournisseur = {
                    nomEntreprise: false,
                    numeroIdentification: false,
                    responsable: false,
                    telephone: false,
                    adresse: false
                };

                if (this.mode === 'add' || !this.documentId) {
                    this.modifiedClientFields = {
                        nomClient: false,
                        identifiant: false,
                        adresse: false,
                        email: false
                    };
                    this.modifiedFournisseurFields = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };
                } else {
                    this.loadModifiedFields();
                }
                this.loadWarehouses();
                
                this.loadProjects();
                this.updateApproveButtonState();
                this.cdr.detectChanges();

                setTimeout(() => {
                    this.initializeFeatherIcons();
                }, 150);
            },
            error: (err) => {
                const fournisseur = this.fournisseurs.find(f => f.id === id);
                if (fournisseur) {

                    if (!Array.isArray(fournisseur.adresses)) {
                        fournisseur.adresses = fournisseur.adresses ? [fournisseur.adresses] : [];
                    }
                    if (!Array.isArray(fournisseur.telephones)) {
                        fournisseur.telephones = fournisseur.telephones ? [fournisseur.telephones] : [];
                    }
                    if (!Array.isArray(fournisseur.emails)) {
                        fournisseur.emails = fournisseur.emails ? [fournisseur.emails] : [];
                    }
                    
                    this.selectedFournisseur = fournisseur;
                    this.selectedFournisseurId = id;
                    this.clientId = id;

                    this.editModeFournisseur = {
                        nomEntreprise: false,
                        numeroIdentification: false,
                        responsable: false,
                        telephone: false,
                        adresse: false
                    };

                    if (this.mode === 'add' || !this.documentId) {
                        this.modifiedClientFields = {
                            nomClient: false,
                            identifiant: false,
                            adresse: false,
                            email: false
                        };
                        this.modifiedFournisseurFields = {
                            nomEntreprise: false,
                            numeroIdentification: false,
                            responsable: false,
                            telephone: false,
                            adresse: false
                        };
                    } else {
                        this.loadModifiedFields();
                    }
                    this.loadWarehouses();
                    
                    this.loadProjects();
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();

                    setTimeout(() => {
                        this.initializeFeatherIcons();
                    }, 150);
                } else {
                    this.selectedFournisseurId = null;
                    this.selectedFournisseur = null;
                    this.clientId = null;
                    const errorMessage = err?.error?.message || err?.error?.error || err?.message || 'Erreur inconnue';
                    this.toastr.error(`Impossible de charger les données du fournisseur: ${errorMessage}`, 'Erreur');
                    this.updateApproveButtonState();
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onProjectSaved(): void {
        this.toastr.success('Projet ajouté avec succès !', 'Succès');
        this.loadProjects();
    }

    openAjoutFournisseurModal() {
        this.ajoutFournisseurComponent.openModal();
    }

    openAjoutClientModal() {
        this.ajoutClientComponent.openModal();
    }

    private normalizeTypeDocumentTitre(s: string | null | undefined): string {
        return (s || '')
            .trim()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    private extractTypePrefixFromTypeRow(type: any): string {
        if (!type || typeof type !== 'object') {
            return '';
        }
        const flat = this.extractTypePrefixFromFlatObject(type);
        if (flat) {
            return flat;
        }
        const nested = type.type_document ?? type.typeDocument ?? type.document_type;
        if (nested && typeof nested === 'object') {
            return this.extractTypePrefixFromFlatObject(nested);
        }
        return '';
    }

    private extractTypePrefixFromFlatObject(o: any): string {
        if (!o || typeof o !== 'object') {
            return '';
        }
        const candidates = [
            o.prefix,
            o.preffix,
            o.preffixe,
            o.ref_prefix,
            o.reference_prefix,
            o.prefix_reference,
            o.prefixe,
            o.code_prefix,
            o.code,
            o.libelle_prefix,
            o.prefix_ref
        ];
        for (const c of candidates) {
            if (c != null && String(c).trim() !== '') {
                const s = String(c).trim();
                if (/^[\d.]+$/.test(s)) {
                    continue;
                }
                return s;
            }
        }
        return '';
    }

    private extractRefCounterFromTypeRow(type: any): number | null {
        if (!type || typeof type !== 'object') {
            return null;
        }
        const v = type.ref_counter ?? type.refCounter ?? type.compteur_ref ?? type.counter;
        if (v == null || v === '') {
            return null;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }

    /** Réponse GET /api/documents/ref-counter/:type_document_id */
    private extractRefCounterFromApiResponse(res: any): number | null {
        const raw = res?.data ?? res;
        const v =
            raw?.ref_counter ??
            raw?.refCounter ??
            raw?.compteur_ref ??
            res?.ref_counter ??
            res?.data?.ref_counter;
        if (v == null || v === '') {
            return null;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }

    /** Alimente typeDocumentsMeta.refCounter pour buildInitialRefFromTypeMeta (prochaine ref = counter + 1). */
    private ensureTypeMetaRefCounter(counter: number | null): void {
        const dt = this.documentType;
        if (!dt) {
            return;
        }
        const tid = this.typeDocumentIdMap[dt];
        const prev = this.typeDocumentsMeta[dt];
        this.typeDocumentsMeta[dt] = {
            id: prev?.id ?? (tid != null ? Number(tid) : 0),
            prefix: prev?.prefix ?? this.documentTypeToRefPrefix[dt] ?? 'DOC',
            refCounter: counter != null && Number.isFinite(counter) ? Number(counter) : prev?.refCounter ?? null
        };
    }

    private isProvisionalDraftRef(ref: string | null | undefined): boolean {
        return String(ref || '').trim().toUpperCase().includes('BROUILLON');
    }

    private documentRefPayloadSpread(): { ref_externe?: string; ref_interne?: string } {
        // Uniquement le 1er document (popup) : seed. Les suivants : le backend alloue N+1 sans trou.
        // Document déjà persisté : ne jamais renvoyer la ref (immuable, même en brouillon).
        if (!this.referenceSeedFromPopup || this.documentId) {
            return {};
        }
        const r = (this.documentReference || this.refExterne || '').trim();
        if (!r || /^0+$/.test(r) || this.isProvisionalDraftRef(r)) {
            return {};
        }
        return { ref_externe: r, ref_interne: r };
    }

    /** Après POST /api/documents réussi : synchronise le compteur serveur. */
    private incrementRefCounterAfterDocumentCreate(typeDocumentId: number | null | undefined): void {
        // No-op : l'incrément est atomique dans createDocument (évite les numéros sautés).
    }

    private incrementRefCountersAfterDocumentCreates(pairedBonLivraisonId?: number | null): void {
        // No-op : voir incrementRefCounterAfterDocumentCreate.
    }

    private finishDocumentReferenceHeaderPrefetch(): void {
        this.documentReferenceHeaderPending = false;
        this.cdr.markForCheck();
    }

    private applyNextReferenceFromRefCounterApi(onDone?: () => void): void {
        // Document déjà créé : la référence est immuable (ne pas régénérer l’affichage).
        if (this.documentId || this.mode === 'edit' || this.mode === 'validation') {
            this.documentReferenceHeaderPending = false;
            onDone?.();
            return;
        }
        const typeId = this.typeDocumentIdMap[this.documentType];
        const prefix = this.getReferencePrefix();
        const uid = Number(this.currentUser?.id);
        const prefetchGen = ++this.documentReferencePrefetchGen;
        this.documentReferenceHeaderPending = true;
        this.cdr.markForCheck();
        if (!this.stationId || typeId == null || !Number.isFinite(uid) || uid <= 0) {
            this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
            this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
            this.finishDocumentReferenceHeaderPrefetch();
            onDone?.();
            return;
        }
        this.documentService.getRefCounter(typeId, this.stationId, uid).subscribe({
            next: (res: any) => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                const c = this.extractRefCounterFromApiResponse(res);
                this.ensureTypeMetaRefCounter(c);
                this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            },
            error: () => {
                if (prefetchGen !== this.documentReferencePrefetchGen) {
                    return;
                }
                this.documentReference = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.finishDocumentReferenceHeaderPrefetch();
                onDone?.();
            }
        });
    }

    private applyTypeDocumentsFromApi(response: any): void {
        let typesData: any[] = [];
        if (Array.isArray(response)) {
            typesData = response;
        } else if (response?.data?.types && Array.isArray(response.data.types)) {
            typesData = response.data.types;
        } else if (Array.isArray(response?.data)) {
            typesData = response.data;
        } else if (response?.types && Array.isArray(response.types)) {
            typesData = response.types;
        }

        if (!Array.isArray(typesData)) {
            return;
        }

        typesData.forEach((type: any) => {
            const titreNorm = this.normalizeTypeDocumentTitre(type.titre || type.nom || '');
            const id = Number(type.id);
            if (!id || Number.isNaN(id)) {
                return;
            }
            let docTypeKey: string | null = null;
            if (titreNorm === 'AVOIR FOURNISSEUR' || (titreNorm.includes('AVOIR') && titreNorm.includes('FOURNISSEUR'))) {
                docTypeKey = 'AVOIR FOURNISSEUR';
            } else if (titreNorm === 'AVOIR') {
                docTypeKey = 'AVOIR';
            }
            if (!docTypeKey) {
                return;
            }

            const prefix = this.extractTypePrefixFromTypeRow(type);
            const refCounter = this.extractRefCounterFromTypeRow(type);

            this.typeDocumentIdMap[docTypeKey] = id;
            if (prefix && !this.isFacPrefixMisappliedForDocType(docTypeKey, prefix)) {
                this.documentTypeToRefPrefix[docTypeKey] = prefix;
            }
            this.typeDocumentsMeta[docTypeKey] = {
                id,
                prefix: (prefix && !this.isFacPrefixMisappliedForDocType(docTypeKey, prefix)
                    ? prefix
                    : this.documentTypeToRefPrefix[docTypeKey]) || 'DOC',
                refCounter
            };
            this.typeIdToDocumentTypeFromApi[id] = docTypeKey;
        });
    }

    private loadTypeDocumentsMetadata(): void {
        this.documentService.getTypeDocuments().subscribe({
            next: (res) => {
                this.applyTypeDocumentsFromApi(res);
                this.loadCurrentTypeDocumentPrefixFromApi();
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            },
            error: () => {
            }
        });
    }

    private loadReferenceModelFromParametreDocument(): void {
        if (!this.stationId) {
            return;
        }
        const typeDocumentId =
            this.typeDocumentIdMap[this.documentType] ??
            (this.documentType ? undefined : this.typeDocumentIdMap['FACTURE']);
        this.parametreDocumentSettingsService.getByStation(this.stationId).pipe(
            tap((bundle) => {
                const pd = bundle?.parametre_document as Record<string, unknown> | undefined;
                if (pd != null) {
                    this.paramDocMajPrixAchatProduit = isTruthyTinyInt(pd['maj_prix_achat_produit']);
                    this.paramDocBaseCalculPrixAchat = normalizeBaseCalculPrixAchat(pd['base_calcul_prix_achat']);
                }
            }),
            switchMap((bundle) => {
                const pd = bundle?.parametre_document;
                const raw = resolveModeleReferenceForType(
                    pd?.modeles_reference,
                    typeDocumentId,
                    pd?.modele_reference ?? null
                );
                if (raw == null) {
                    return of(null);
                }
                const idOrType = Number(raw);
                if (Number.isNaN(idOrType)) {
                    return of(null);
                }
                return this.documentService.getReferenceModelById(idOrType).pipe(
                    catchError(() =>
                        this.documentService.getReferenceModelsAll().pipe(
                            map((res: any) => {
                                const list: any[] = Array.isArray(res?.data) ? res.data : [];
                                let m = list.find((x) => Number(x.id) === idOrType);
                                if (!m) {
                                    m = list.find((x) => Number(x.model_type) === idOrType);
                                }
                                // Prefer model matching current document type when ambiguous
                                if (!m && typeDocumentId != null) {
                                    m = list.find(
                                        (x) =>
                                            Number(x.type_document_id) === Number(typeDocumentId) &&
                                            Number(x.model_type) === idOrType
                                    );
                                }
                                return m ?? null;
                            })
                        )
                    )
                );
            }),
            catchError(() => of(null))
        ).subscribe((model) => {
            this.applyReferenceModelFromParametre(model, typeDocumentId);
        });
    }

    private applyReferenceModelFromParametre(
        model: ReferenceModel | any | null,
        typeDocumentId?: number
    ): void {
        if (!model || typeof model !== 'object') {
            this.referenceModelDetail = null;
            if (!this.documentId) {
                this.referenceModelType = this.documentService.getDefaultReferenceModelType(
                    this.stationId,
                    typeDocumentId
                );
            }
            this.maybePrefetchNextDocumentReference(true);
            this.cdr.markForCheck();
            return;
        }
        const id = Number(model.id);
        const mt = Number(model.model_type ?? model.modelType);
        this.referenceModelDetail = {
            id: Number.isNaN(id) ? 0 : id,
            model_type: Number.isNaN(mt) ? 0 : mt,
            current_counter: Number(model.current_counter ?? 0),
            prefix: model.prefix != null ? String(model.prefix).trim() : null,
            description: model.description != null ? String(model.description) : ''
        };
        if (!Number.isNaN(mt) && mt > 0) {
            this.documentService.setDefaultReferenceModelType(this.stationId, mt, typeDocumentId);
            if (!this.documentId) {
                this.referenceModelType = mt;
            }
        }
        this.maybePrefetchNextDocumentReference(true);
        this.cdr.markForCheck();
    }

    private buildInitialRefFromTypeMeta(docType: string, fallbackPrefix: string): string {
        const meta = this.typeDocumentsMeta[docType];
        const rawP = (meta?.prefix || fallbackPrefix || 'DOC').trim() || 'DOC';
        const p = this.substituteReferenceYearInPrefix(rawP) || rawP;
        const fmt = this.getModelReferenceFormatMeta();
        const year = new Date().getFullYear();

        if (fmt?.kind === 'year_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'year_concat_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${year}${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${year}${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. 00000X-2026 (séquence puis année avec tiret)
        if (fmt?.kind === 'seq_year') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${nextNum.toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${nextNum.toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
        }

        if (fmt?.kind === 'prefix_year_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. DEV-00000X (sans année dans la chaîne)
        if (fmt?.kind === 'prefix_seq') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return `${p}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return `${p}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        // Ex. 0000001 (numéro seul)
        if (fmt?.kind === 'seq_only') {
            if (meta?.refCounter != null && meta.refCounter >= 0) {
                const nextNum = meta.refCounter + 1;
                return nextNum.toString().padStart(fmt.sequencePad, '0');
            }
            const cc = Number(this.referenceModelDetail?.current_counter);
            if (!Number.isNaN(cc) && cc > 0) {
                const nextNum = cc + 1;
                return nextNum.toString().padStart(fmt.sequencePad, '0');
            }
            return (1).toString().padStart(fmt.sequencePad, '0');
        }

        if (meta?.refCounter != null && meta.refCounter >= 0) {
            const nextNum = meta.refCounter + 1;
            return `${p}-${nextNum.toString().padStart(4, '0')}`;
        }
        return `${p}-0001`;
    }


    private needsTypeDocumentsApiForRef(): boolean {
        if (this.documentType !== 'AVOIR' && this.documentType !== 'AVOIR FOURNISSEUR') {
            return false;
        }
        const id = this.typeDocumentIdMap[this.documentType];
        return id == null || Number.isNaN(Number(id));
    }

    private checkRoute(): void {
        const currentUrl = this.router.url;

        if (currentUrl.includes('/vente-negoce/devis/add-devis') || currentUrl.includes('/vente/devis/add-devis')) {
            this.documentType = 'DEVIS';
        } else if (currentUrl.includes('/vente-negoce/commande-client/add-commande-client') || currentUrl.includes('/vente/commande-client/add-commande-client')) {
            this.documentType = 'COMMANDE CLIENT';
        } else if (currentUrl.includes('/vente-negoce/bon-sortie/add-bon-sortie') || currentUrl.includes('/vente/bon-sortie/add-bon-sortie')) {
            this.documentType = 'BON DE SORTIE';
        } else if (currentUrl.includes('/vente-negoce/bon-livraison/add-bon-livraison') || currentUrl.includes('/vente/bon-livraison/add-bon-livraison')) {
            this.documentType = 'BON DE LIVRAISON';
        } else if (currentUrl.includes('/vente-negoce/avoir/add-facture') || currentUrl.includes('/vente-negoce/avoir/edit-facture')
            || currentUrl.includes('/vente/avoir/add-facture') || currentUrl.includes('/vente/avoir/edit-facture')) {
            this.documentType = 'AVOIR';
        } else if (currentUrl.includes('/achat/avoir-fournisseur/add-avoir-fournisseur') || currentUrl.includes('/achat/avoir-fournisseur/edit-avoir-fournisseur')) {
            this.documentType = 'AVOIR FOURNISSEUR';
        } else if (currentUrl.includes('/vente/facture/add-facture') || currentUrl.includes('/vente/facture/edit-facture')
            || currentUrl.includes('/vente-negoce/facture/add-facture') || currentUrl.includes('/vente-negoce/facture/edit-facture')) {
            this.documentType = 'FACTURE';
        } else if (currentUrl.includes('/achat/commande-fournisseur/add-commande-fournisseur')) {
            this.documentType = 'COMMANDE FOURNISSEUR';
        } else if (currentUrl.includes('/achat/facture-fournisseur/add-facture-fournisseur')) {
            this.documentType = 'FACTURE FOURNISSEUR';
        } else if (currentUrl.includes('/achat/bon-reception/add-bon-reception')) {
            this.documentType = 'BON RECEPTION';
        } else if (currentUrl.includes('/stock/inventaire/add-inventaire') 
                   || currentUrl.includes('/inventaire/add-inventaire')
                   || currentUrl.includes('/inventaire/ajout-inventaire')) {
            this.documentType = 'INVENTAIRE';
        } else if (currentUrl.includes('/stock/bon-transfert/add-bon-transfert') 
                   || currentUrl.includes('/bon-transfert/add-bon-transfert')
                   || currentUrl.includes('/bon-transfert/ajout-bonTransfert')) {
            this.documentType = 'BON TRANSFERT';
        } else {
            this.documentType = 'DEVIS';
        }

        this.loadCurrentTypeDocumentPrefixFromApi();
        this.cdr.detectChanges();
    }

    private substituteReferenceYearInPrefix(raw: string | null | undefined): string {
        let s = (raw ?? '').trim();
        if (!s) {
            return '';
        }
        const y = new Date().getFullYear();
        s = s.replace(/\{YYYY\}/gi, String(y)).replace(/\{YEAR\}/gi, String(y));
        s = s.replace(/(?<![0-9])(20\d{2})(?![0-9])/g, String(y));
        return s.replace(/-+$/, '').trim();
    }

    private resolveTypeDocumentIdForPrefixLoad(typeDocumentIdOverride?: number | null): number | null {
        if (
            typeDocumentIdOverride != null &&
            !Number.isNaN(Number(typeDocumentIdOverride)) &&
            Number(typeDocumentIdOverride) > 0
        ) {
            return Number(typeDocumentIdOverride);
        }
        const fromMap = this.typeDocumentIdMap[this.documentType];
        if (fromMap != null && !Number.isNaN(Number(fromMap))) {
            return Number(fromMap);
        }
        if (this.currentTypeDocumentId != null && !Number.isNaN(Number(this.currentTypeDocumentId))) {
            return Number(this.currentTypeDocumentId);
        }
        return null;
    }

    private refreshReferencePrefixFromTypeDocument$(typeDocumentIdOverride?: number | null): Observable<void> {
        const resolved = this.resolveTypeDocumentIdForPrefixLoad(typeDocumentIdOverride);
        if (resolved == null || Number.isNaN(resolved)) {
            this.typeDocumentPrefixRawFromApi = null;
            return of(undefined);
        }
        return this.documentService.getTypeDocumentById(resolved).pipe(
            tap((row: any) => {
                const rawPrefix = this.extractTypePrefixFromTypeRow(row);
                const trimmedPrefix = rawPrefix && String(rawPrefix).trim() !== '' ? String(rawPrefix).trim() : null;
                this.typeDocumentPrefixRawFromApi =
                    trimmedPrefix && !this.isGenericFacPrefixMisappliedForCurrentType(trimmedPrefix)
                        ? trimmedPrefix
                        : null;
                const rc = this.extractRefCounterFromTypeRow(row);
                if (this.documentType) {
                    const basePrefix =
                        this.typeDocumentPrefixRawFromApi ||
                        this.documentTypeToRefPrefix[this.documentType] ||
                        'DOC';
                    this.typeDocumentsMeta[this.documentType] = {
                        id: resolved,
                        prefix: basePrefix,
                        refCounter: rc
                    };
                }
            }),
            map(() => undefined),
            catchError(() => {
                this.typeDocumentPrefixRawFromApi = null;
                return of(undefined);
            }),
            tap(() => {
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            })
        );
    }

    private loadCurrentTypeDocumentPrefixFromApi(typeDocumentIdOverride?: number | null): void {
        this.refreshReferencePrefixFromTypeDocument$(typeDocumentIdOverride).subscribe();
    }

    private refreshConversionLockForSourceDocument(onDone?: () => void): void {
        const id = Number(this.documentId);
        if (!Number.isFinite(id) || id <= 0) {
            this.sourceLockedByActiveConversion = false;
            onDone?.();
            return;
        }
        this.documentService
            .getDocumentsByOriginalId(id)
            .pipe(catchError(() => of(null)))
            .subscribe((res) => {
                const children = res ? parseConvertedChildrenFromApiResponse(res) : [];
                this.sourceLockedByActiveConversion = isSourceDocumentLockedByConversion(
                    children,
                    this.statutIdMap
                );
                onDone?.();
                this.cdr.markForCheck();
            });
    }

    private updateHeaderConfig(): void {
        const currentUrl = this.router.url;
        if (currentUrl.includes('/action/apercu') || currentUrl.includes('/action/validation')) {
            return;
        }

        let buttons: any[] = [];

        if (this.mode === 'validation') {
            buttons = this.getButtonsForValidationMode(this.documentType);

        } else if (this.mode === 'edit' || this.isEditing) {
            const statut = this.currentStatutId;
            buttons = this.getButtonsForDocumentType(this.documentType, statut);

        } else {
            buttons = [
                { label: 'Retour', action: () => this.onHeaderRetour(), type: 'primary' },
                { label: 'Annuler', action: () => this.onHeaderAnnuler(), type: 'secondary' },
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                { label: 'Approuver', action: () => this.openReferenceModal(), type: 'primary', disabled: this.isApproveButtonDisabled || this.isSubmitting }
            ];
        }

        buttons = filterHeaderButtonsWhenConversionLocked(buttons, this.sourceLockedByActiveConversion);

        this.headerService.setConfig({
            title: `${this.documentType} - ${this.mode.toUpperCase()}`,
            buttons: buttons
        });
    }

    /** Au moins un champ utile rempli (sinon Retour/Annuler ne font rien).
     *  La référence auto-générée / entrepôt par défaut ne comptent pas. */
    private hasMeaningfulDocumentContent(): boolean {
        const hasProduct = this.items.some(
            (i) => i.type === 'product' && !!(i.designation && String(i.designation).trim())
        );
        const hasParty = !!(this.selectedClient || this.selectedFournisseur);
        const hasNote = !!(this.note && String(this.note).trim());
        const hasProject = !!(this.selectedProject && String(this.selectedProject).trim());
        // Ref saisie via popup uniquement (pas la preview auto)
        const hasUserRef = !!this.referenceSeedFromPopup;
        return hasProduct || hasParty || hasNote || hasProject || hasUserRef;
    }

    /** Retour : si vide → aucune action ; sinon crée/sauve brouillon puis liste. */
    private onHeaderRetour(): void {
        if (!this.hasMeaningfulDocumentContent()) {
            return;
        }
        this.saveAsDraft();
    }

    /** Annuler : si vide → aucune action ; sinon retour liste sans créer de document. */
    private onHeaderAnnuler(): void {
        if (!this.hasMeaningfulDocumentContent()) {
            return;
        }
        this.documentPreviewService.clear();
        this.router.navigate([this.getBasePath()]);
    }

    /** Brouillon déjà enregistré : Annuler = quitter vers la liste (sans passer en Annulé ici). */
    private onHeaderAnnulerExistingBrouillon(): void {
        this.documentPreviewService.clear();
        this.router.navigate([this.getBasePath()]);
    }

    private getButtonsForValidationMode(documentType: string): any[] {
        const baseButtons = [
            { label: 'Retour', action: () => this.retour(), type: 'primary' },
            { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
        ];
        return [...baseButtons, ...this.buildPostCreateActionButtons(documentType, (statutId) =>
            this.changeStatutAndSave(statutId)
        )];
    }

    /**
     * Actions post-création (statut Crée) — aligné approve-vente / projet vente.
     * Ex. DEVIS : Accepter + Négocier.
     */
    private buildPostCreateActionButtons(
        documentType: string,
        onStatut: (statutId: number) => void
    ): any[] {
        const buttons: any[] = [];
        switch (documentType) {
            case 'DEVIS':
                buttons.push({
                    label: 'Accepter',
                    action: () => onStatut(this.statutIdMap['Accepté']),
                    type: 'primary'
                });
                buttons.push({
                    label: 'Négocier',
                    action: () => onStatut(this.statutIdMap['Négociation']),
                    type: 'primary'
                });
                break;
            case 'COMMANDE CLIENT':
            case 'COMMANDE FOURNISSEUR':
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'BON DE LIVRAISON':
                buttons.push({
                    label: 'Livrer',
                    action: () => onStatut(this.statutIdMap['Livré']),
                    type: 'primary'
                });
                break;
            case 'BON RECEPTION':
                buttons.push({
                    label: 'Reçu',
                    action: () => onStatut(this.statutIdMap['Reçu']),
                    type: 'primary'
                });
                break;
            case 'BON DE SORTIE':
                buttons.push({
                    label: 'Fermer',
                    action: () => onStatut(this.statutIdMap['Fermé']),
                    type: 'primary'
                });
                break;
            case 'INVENTAIRE':
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Inventorié'] ?? this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'BON TRANSFERT':
                buttons.push({
                    label: 'Transférer',
                    action: () => onStatut(this.statutIdMap['Transféré'] ?? this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
            case 'FACTURE':
            case 'FACTURE FOURNISSEUR':
            case 'AVOIR':
            case 'AVOIR FOURNISSEUR':
            case 'RETOUR FOURNISSEUR':
                // Pas d’action métier supplémentaire (facture déjà Non payé / avoir déjà créé)
                break;
            default:
                buttons.push({
                    label: 'Valider',
                    action: () => onStatut(this.statutIdMap['Valide']),
                    type: 'primary'
                });
                break;
        }
        return buttons;
    }

    private getButtonsForDocumentType(documentType: string, statut: number | null): any[] {
        const baseButtons = [
            { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
            { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
        ];
        if (statut === this.statutIdMap['Non utilisé'] || statut === this.statutIdMap['Partiellement utilisé'] || statut === this.statutIdMap['Utilisé']) {
            return baseButtons;
        }
        // Bon de réception reçu : Retour + Annuler
        if (documentType === 'BON RECEPTION' && statut === this.statutIdMap['Reçu']) {
            return [
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' },
                { label: 'Annuler', action: () => this.changeStatutAndSave(this.statutIdMap['Annulé']), type: 'secondary' }
            ];
        }
        // Statuts finalisés (projet vente) : Retour + Annuler
        if (
            statut === this.statutIdMap['Payé'] ||
            statut === this.statutIdMap['Partiellement payé'] ||
            statut === this.statutIdMap['Reçu'] ||
            statut === this.statutIdMap['Fermé'] ||
            statut === this.statutIdMap['Transféré'] ||
            statut === this.statutIdMap['Livré'] ||
            statut === this.statutIdMap['Valide'] ||
            statut === this.statutIdMap['Accepté'] ||
            statut === this.statutIdMap['Non payé']
        ) {
            return baseButtons;
        }
        // Statut Crée : mêmes actions que la page validation (ex. DEVIS → Accepter / Négocier)
        if (statut === this.statutIdMap['Crée'] || statut === this.statutIdMap['Créé']) {
            return [
                ...baseButtons,
                ...this.buildPostCreateActionButtons(documentType, (statutId) =>
                    this.changeStatutAndSave(statutId)
                )
            ];
        }
        else if (statut === this.statutIdMap['Négociation']) {
            if (documentType === 'DEVIS') {
                return [
                    ...baseButtons,
                    { label: 'Accepter', action: () => this.changeStatutAndSave(this.statutIdMap['Accepté']), type: 'primary' }
                ];
            } else {
                return this.getButtonsForDocumentType(documentType, this.statutIdMap['Crée']);
            }
        }
        else if (statut === this.statutIdMap['Annulé']) {
            if (documentType === 'BON RECEPTION') {
                return [
                    { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' }
                ];
            }
            return [
                {
                    label: 'Remettre en brouillon',
                    action: () => this.remettreEnBrouillonFromAnnule(),
                    type: 'primary'
                },
                { label: 'Retour', action: () => this.saveAndExecute(() => this.retour()), type: 'primary' }
            ];
        }
        else if (statut === this.statutIdMap['Brouillon']) {
            return [
                { label: 'Retour', action: () => this.onHeaderRetour(), type: 'secondary' },
                { label: 'Annuler', action: () => this.onHeaderAnnulerExistingBrouillon(), type: 'primary' },
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                { label: 'Approuver', action: () => this.openReferenceModal(), type: 'primary', disabled: this.isApproveButtonDisabled || this.isSubmitting }
            ];
        }
        else {
            return [
                ...baseButtons,
                { label: 'Apercevoir', action: () => this.goToApercu(), type: 'primary' },
                { label: 'Approuver', action: () => this.openReferenceModal(), type: 'primary', disabled: this.isApproveButtonDisabled || this.isSubmitting }
            ];
        }
    }

    saveAsDraft(): void {
        if (this.isSavingDraft) {
            return;
        }

        if (!this.hasMeaningfulDocumentContent()) {
            // Document vide : aucune création, aucune navigation
            return;
        }

        if (this.mode === 'edit' && this.documentId) {
            this.isSavingDraft = true;
            this.toastr.info('Mise à jour du brouillon en cours...', 'Brouillon');

            this.recalculateAll();
            this.updateDocument(this.statutIdMap['Brouillon']).subscribe({
                next: (res) => {
                    this.applyAllocatedReferenceFromCreateResponse(res);
                    this.currentStatutId = this.statutIdMap['Brouillon'];
                    this.updateHeaderConfig();
                    this.toastr.success('Brouillon mis à jour !');
                    this.documentPreviewService.clear();
                    this.router.navigate([this.getBasePath()]);
                },
                error: (err) => {
                    this.toastr.error('Échec mise à jour brouillon', 'Erreur');
                    this.documentPreviewService.clear();
                    this.router.navigate([this.getBasePath()]);
                },
                complete: () => this.isSavingDraft = false
            });
            return;
        }
        this.isSavingDraft = true;
        this.toastr.info('Sauvegarde en brouillon en cours...', 'Brouillon');

        this.calculateTotals();
        const payload = this.buildPerfectDraftPayload();

        this.documentService.create(payload).subscribe({
            next: (res) => {
                const newId = res?.data?.id || res?.data?.document?.id;
                if (newId) {
                    this.documentId = newId;
                    this.mode = 'edit';
                    this.isEditing = true;
                    this.currentStatutId = 1; // Brouillon
                    this.applyAllocatedReferenceFromCreateResponse(res);
                    this.saveModifiedFields();
                    this.updateHeaderConfig();
                }

                this.toastr.success('Document sauvegardé en brouillon !');
                this.documentPreviewService.clear();
                this.router.navigate([this.getBasePath()]);
            },
            error: (err) => {
                this.toastr.error('Échec sauvegarde brouillon, retour quand même', 'Erreur');
                this.documentPreviewService.clear();
                this.router.navigate([this.getBasePath()]);
            },
            complete: () => this.isSavingDraft = false
        });
    }

    private buildPerfectDraftPayload(): any {
        const isAchat = this.isAchatDocument();

        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (p) {
                projetPivot = {
                    id_projet: String(p.id),
                    titre: p.libelle || 'Projet sans titre'
                };
            }
        }

        const f = (n: number): string => Number(n || 0).toFixed(3);

        const payload: any = {
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,
            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),
            user_id: this.currentUser.id,
            station_id: this.stationId,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 1, // Brouillon
            entrepot_id: this.documentType === 'BON TRANSFERT' 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.documentType === 'BON TRANSFERT' && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            client_data: !isAchat && this.selectedClient ? {
                client_id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || null,
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                fournisseur_id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : null,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            lignes_document: this.prepareLignesDocumentForSave(),
            parametrage_doc: this.buildParametrageDoc(),
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            }
        };

        const cleaned = this.cleanPayload(payload as DocumentPayload);
        return cleaned;
    }

    private buildDraftPayload(): DocumentPayload {
        const isAchat = ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(this.documentType);

        const projetPivot = this.selectedProject && this.projects.length > 0
            ? this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject))
            : null;

        const payload: DocumentPayload = {
            ...this.documentRefPayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || '',

            total_ht: this.totals.totalHT.toFixed(3),
            total_tva: this.totals.totalTVA.toFixed(3),
            total_ttc: this.totals.totalTTC.toFixed(3),
            timbre_fiscal: this.getTimbreFiscalEffective().toFixed(3),
            net_payer: this.totals.netAPayer.toFixed(3),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 1, // Brouillon
            ...this.referenceModelTypePayloadSpread(),
            entrepot_id: this.documentType === 'BON TRANSFERT' 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.documentType === 'BON TRANSFERT' && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            client_id: !isAchat ? this.resolveDocumentClientId(this.selectedClient) : null,
            fournisseur_id: isAchat ? this.selectedFournisseur?.id ?? null : null,

            client_data: !isAchat && this.selectedClient ? {
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : undefined,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '',
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : undefined,

            projets: projetPivot ? [{
                id_projet: String(projetPivot.id),
                titre: projetPivot.libelle
            }] : [],
            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),

            date_echeance: '', // À calculer si nécessaire
            nbr_date: 0, // À définir si nécessaire
            color: '#134AD3', // Couleur par défaut

            lignes_document: this.prepareLignesDocumentForSave(),
            parametrage_doc: this.buildParametrageDoc()
        };

        return this.cleanPayload(payload);
    }

    private updateDocumentStatut(statutId: number, withRetour: boolean = false): void {
        if (!this.documentId || !this.stationId) {
            this.toastr.error('ID du document ou station manquant.');
            return;
        }

        const payload = {
            statut_id: statutId,
            station_id: this.stationId
        };
        this.documentService.updateStatut(this.documentId, payload).subscribe({
            next: (response) => {
                this.toastr.success(`Statut mis à jour avec succès (ID: ${statutId}).`);
                if (withRetour) {
                    this.retour();
                }
            },
            error: (err) => {
                this.toastr.error(`Échec de la mise à jour du statut: ${err?.error?.message || 'Erreur serveur'}`);
            }
        });

    }

    private getApproveStatutId(): number {
        if (this.isAvoirDocument()) {
            return this.statutIdMap['Non utilisé'];
        }
        if (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR') {
            return this.statutIdMap['Non payé'];
        }
        // Bon de livraison : Approuver → Crée ; sortie stock au « Livrer » (page validation)
        if (this.documentType === 'BON DE LIVRAISON') {
            return this.statutIdMap['Crée'];
        }
        // Bon de réception : Approuver → Crée, puis Reçu / Annuler / Retour sur approve-vente
        return this.statutIdMap['Crée'];
    }

    customFields: { label: string; value: string }[] = [];

    addField(): void {
        this.customFields.push({label: '', value: ''});
        this.cdr.detectChanges();
    }

    removeField(index: number): void {
        this.customFields.splice(index, 1);
        this.cdr.detectChanges();
    }

    addClient(): void {
        const basePath = this.documentType === 'COMMANDE FOURNISSEUR' || this.documentType === 'FACTURE FOURNISSEUR' || this.documentType === 'BON RECEPTION'
            ? '/tiers/fournisseurs/add-fournisseur'
            : '/tiers/clients/add-client';
        this.router.navigate([basePath]);
    }

    refreshFeatherIcons(): void {
        this.zone.run(() => {
        setTimeout(() => {
                this.cleanAndReplaceFeatherIcons();
        }, 0);
        });
    }

    private cleanAndReplaceFeatherIcons(): void {
        this.refreshEyeIconsOnly();
    }

    private isRefreshingIcons = false;
    private isInitializingIcons = false;
    private iconInitializationTimeout: any = null;

    ngOnDestroy(): void {
        for (const k of Object.keys(this.barcodeLineDebounceTimers)) {
            const t = this.barcodeLineDebounceTimers[Number(k)];
            if (t != null) {
                clearTimeout(t);
            }
        }
        this.barcodeLineDebounceTimers = {};
        if (this.stockRupturePopupTimer != null) {
            clearTimeout(this.stockRupturePopupTimer);
            this.stockRupturePopupTimer = null;
        }
        const currentUrl = this.router.url;
        if (!currentUrl.includes('/action/apercu') && !currentUrl.includes('/edit-')) {
            this.documentPreviewService.clear();
        }
    }

    retour(): void {
        this.documentPreviewService.clear();
        const basePath = this.getBasePath();
        this.router.navigate([basePath]);
    }


    openReferenceModal(): void {
        if (!this.validateClientAndProject()) {
            return;
        }
        if (
            this.documentType === 'INVENTAIRE' ||
            this.documentType === 'BON DE LIVRAISON' ||
            this.documentType === 'BON RECEPTION' ||
            this.documentType === 'AVOIR'
        ) {
            const hasProduct = this.items.some(i => i.type === 'product' && i.designation?.trim());
            const hasEntrepot = this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined;
            if (!hasProduct || !hasEntrepot) {
                this.modalRef = this.modalService.open(this.depotWarningModal, {
                    ariaLabelledBy: 'modal-depot-warning-title',
                    centered: true,
                    size: 'sm',
                    windowClass: 'warning-modal-centered'
                });
                return;
            }
        }
        const isNewDocument = this.mode === 'add' || !this.documentId;
        // Mode édition : jamais de popup référence (Approuver continue directement)
        if (!isNewDocument) {
            this.confirmReference();
            return;
        }
        const refTrimmed = (this.documentReference || '').trim();
        const refEmptyOrPlaceholder = refTrimmed === '' || /^0+$/.test(refTrimmed);

        const assignProvisionalRefIfNeeded = () => {
            if (isNewDocument && refEmptyOrPlaceholder) {
                this.documentReference = this.getReferenceConcreteValueForModal();
                this.numericReference = this.getNumericReferenceFromRefString(this.documentReference);
                this.cdr.detectChanges();
            }
        };

        /**
         * 1er document du type (création) → popup pour saisir la référence de départ.
         * Mode edit → pas de popup.
         * Documents suivants → auto-incrément, pas de popup.
         */
        const finishOpenReference = () => {
            const typeId = this.typeDocumentIdMap[this.documentType];
            const proceed = (forceFirst?: boolean) => {
                assignProvisionalRefIfNeeded();
                const isFirst =
                    forceFirst === true ||
                    (forceFirst !== false && this.isFirstDocumentReferenceForType());
                if (isFirst) {
                    this.openReferenceModalInternal();
                    return;
                }
                this.confirmReference();
            };

            const decideFirstOfType = () => {
                const uid = Number(this.currentUser?.id);
                if (!this.stationId || typeId == null) {
                    proceed(true);
                    return;
                }

                const afterCounter = (counter: number | null) => {
                    this.ensureTypeMetaRefCounter(counter);
                    // 1ère fois du type = aucune séquence réelle encore utilisée
                    if (counter == null || !Number.isFinite(Number(counter)) || Number(counter) <= 0) {
                        proceed(true);
                        return;
                    }
                    proceed(false);
                };

                if (!Number.isFinite(uid) || uid <= 0) {
                    this.documentService.countByStatut(this.stationId, Number(typeId)).pipe(
                        catchError(() => of(null))
                    ).subscribe((res: any) => {
                        const total = Number(
                            res?.data?.total_documents ??
                            res?.total_documents ??
                            res?.data?.total ??
                            NaN
                        );
                        if (Number.isFinite(total) && total <= 0) {
                            afterCounter(0);
                            return;
                        }
                        afterCounter(total > 0 ? 1 : null);
                    });
                    return;
                }

                this.documentService.getRefCounter(Number(typeId), this.stationId, uid).pipe(
                    catchError(() => of(null))
                ).subscribe((res: any) => {
                    const c = this.extractRefCounterFromApiResponse(res);
                    if (c != null) {
                        afterCounter(c);
                        return;
                    }
                    // Fallback : nombre de documents du type
                    this.documentService.countByStatut(this.stationId, Number(typeId)).pipe(
                        catchError(() => of(null))
                    ).subscribe((countRes: any) => {
                        const total = Number(
                            countRes?.data?.total_documents ??
                            countRes?.total_documents ??
                            countRes?.data?.total ??
                            NaN
                        );
                        if (Number.isFinite(total) && total <= 0) {
                            afterCounter(0);
                        } else if (Number.isFinite(total) && total > 0) {
                            afterCounter(1);
                        } else {
                            afterCounter(null);
                        }
                    });
                });
            };

            decideFirstOfType();
        };

        const afterPrefixFromApi$ = this.needsTypeDocumentsApiForRef()
            ? this.documentService.getTypeDocuments().pipe(
                  tap((res) => this.applyTypeDocumentsFromApi(res)),
                  catchError(() => of(null)),
                  switchMap(() => this.refreshReferencePrefixFromTypeDocument$())
              )
            : this.refreshReferencePrefixFromTypeDocument$();

        afterPrefixFromApi$.subscribe({
            next: () => finishOpenReference(),
            error: () => finishOpenReference()
        });
    }

    /**
     * True s’il n’existe encore aucune séquence réelle pour ce type (compteur ≤ 0).
     * Ne pas utiliser referenceModelDetail.current_counter : il est partagé entre types.
     */
    private isFirstDocumentReferenceForType(): boolean {
        const metaRc = this.typeDocumentsMeta[this.documentType]?.refCounter;
        if (metaRc != null && Number.isFinite(Number(metaRc)) && Number(metaRc) > 0) {
            return false;
        }
        return true;
    }

    private getReferencePrefix(): string {
        const staticP = this.documentTypeToRefPrefix[this.documentType] || 'DOC';
        const staticResolved = this.substituteReferenceYearInPrefix(staticP) || staticP;

        const fromType = this.substituteReferenceYearInPrefix(this.typeDocumentPrefixRawFromApi);
        if (fromType && !this.isGenericFacPrefixMisappliedForCurrentType(fromType)) {
            return fromType;
        }
        const fromModel = this.referenceModelDetail?.prefix;
        if (fromModel != null && String(fromModel).trim() !== '') {
            const m = this.substituteReferenceYearInPrefix(String(fromModel).replace(/-+$/, '').trim());
            if (m && !this.isGenericFacPrefixMisappliedForCurrentType(m)) {
                return m;
            }
        }
        return staticResolved;
    }

    private isFacPrefixMisappliedForDocType(docTypeKey: string, prefix: string): boolean {
        const p = String(prefix || '').trim().toUpperCase();
        const isFacLike = p === 'FAC' || p.startsWith('FAC-');
        if (!isFacLike) {
            return false;
        }
        return docTypeKey !== 'FACTURE' && docTypeKey !== 'FACTURE FOURNISSEUR';
    }

    private isGenericFacPrefixMisappliedForCurrentType(modelPrefixNormalized: string): boolean {
        const p = modelPrefixNormalized.toUpperCase();
        const isFacLike = p === 'FAC' || p.startsWith('FAC-');
        if (!isFacLike) {
            return false;
        }
        return (
            this.documentType !== 'FACTURE' &&
            this.documentType !== 'FACTURE FOURNISSEUR'
        );
    }

    private getReferenceModelTypeForPayload(): number | null {
        const d = this.referenceModelDetail;
        if (d != null && d.model_type != null) {
            const mt = Number(d.model_type);
            if (!Number.isNaN(mt) && mt > 0) {
                return mt;
            }
        }
        return this.referenceModelType;
    }

    private referenceModelTypePayloadSpread(): { reference_model_type: number } | Record<string, never> {
        const t = this.getReferenceModelTypeForPayload();
        return t != null ? { reference_model_type: t } : {};
    }

    private escapeRegExp(s: string): string {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    private getNumericReferenceFromRefString(ref: string | null | undefined): number {
        const r = (ref || '').trim();
        const mYc = r.match(/^(\d{4})(\d+)$/);
        if (mYc) {
            const y0 = parseInt(mYc[1], 10);
            if (y0 >= 2000 && y0 <= 2099) {
                const n = parseInt(mYc[2], 10);
                return isNaN(n) ? 1 : n;
            }
        }
        const mSeqYear = r.match(/^(\d+)-(\d{4})$/);
        if (mSeqYear) {
            const n = parseInt(mSeqYear[1], 10);
            return isNaN(n) ? 1 : n;
        }
        const mDash = r.match(/-(\d+)$/);
        if (mDash) {
            const n = parseInt(mDash[1], 10);
            return isNaN(n) ? 1 : n;
        }
        if (/^\d+$/.test(r)) {
            const n = parseInt(r, 10);
            return isNaN(n) ? 1 : n;
        }
        return 1;
    }

    private extractSequenceFromLastReference(lastRef: string | null | undefined, prefix: string): number | null {
        const ref = (lastRef || '').trim();
        if (!ref) {
            return null;
        }
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind === 'seq_only' && /^\d+$/.test(ref)) {
            const n = parseInt(ref, 10);
            return isNaN(n) ? null : n;
        }
        if (fmt?.kind === 'year_concat_seq') {
            const mCat = ref.match(/^(\d{4})(\d+)$/);
            if (mCat) {
                const y0 = parseInt(mCat[1], 10);
                if (y0 >= 2000 && y0 <= 2099) {
                    return parseInt(mCat[2], 10);
                }
            }
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                return parseInt(mYs[2], 10);
            }
            if (/^\d+$/.test(ref)) {
                const n = parseInt(ref, 10);
                return isNaN(n) ? null : n;
            }
        }
        if (fmt?.kind === 'seq_year') {
            const mSy = ref.match(/^(\d+)-(\d{4})$/i);
            if (mSy) {
                return parseInt(mSy[1], 10);
            }
            // Ancienne ref modèle 3 (AAAA-séquence) : réutiliser le compteur
            const mYsLegacy = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYsLegacy) {
                return parseInt(mYsLegacy[2], 10);
            }
        }
        if (fmt?.kind === 'year_seq') {
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                return parseInt(mYs[2], 10);
            }
        }
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        if (!new RegExp(`^${this.escapeRegExp(p)}`, 'i').test(ref)) {
            return null;
        }
        const stripped = ref.replace(new RegExp(`^${this.escapeRegExp(p)}`, 'i'), '').replace(/^-+/, '');
        if (!stripped) {
            return null;
        }
        const parts = stripped.split('-').filter((s) => s.length > 0);
        for (let i = parts.length - 1; i >= 0; i--) {
            const seg = parts[i];
            if (/^\d{4}$/.test(seg)) {
                const y = parseInt(seg, 10);
                if (y >= 2000 && y <= 2099) {
                    continue;
                }
            }
            const digits = seg.replace(/\D/g, '');
            if (!digits.length) {
                continue;
            }
            const n = parseInt(digits, 10);
            if (!isNaN(n)) {
                return n;
            }
        }
        return null;
    }

    private getModelReferenceFormatMeta():
        | { kind: 'year_seq'; sequencePad: number }
        | { kind: 'year_concat_seq'; sequencePad: number }
        | { kind: 'seq_year'; sequencePad: number }
        | { kind: 'prefix_year_seq'; sequencePad: number }
        | { kind: 'prefix_seq'; sequencePad: number }
        | { kind: 'seq_only'; sequencePad: number }
        | null {
        const desc = this.referenceModelDetail?.description?.trim();
        if (!desc) {
            return null;
        }
        const idx = desc.indexOf(':');
        const part = idx >= 0 ? desc.slice(idx + 1).trim() : desc;
        if (!part) {
            return null;
        }
        const sub = this.substituteReferenceYearInPrefix(part) || part;
        const withPrefix = this.applyEffectivePrefixToFormatExampleString(sub).trim();
        if (!withPrefix) {
            return null;
        }
        const hyphenCount = (withPrefix.match(/-/g) || []).length;

        // Aucun tiret : soit 202600000X (modèle 4), soit 000000X (seq_only)
        if (hyphenCount === 0) {
            const raw = withPrefix.trim();
            if (raw && /^[\dX]+$/i.test(raw)) {
                const mCat = raw.match(/^((?:20\d{2}|\d{4}))([\dX]+)$/i);
                if (mCat) {
                    const y0 = parseInt(mCat[1], 10);
                    const tail = mCat[2];
                    if (
                        y0 >= 2000 &&
                        y0 <= 2099 &&
                        tail.length >= 1 &&
                        (/X/i.test(raw) || tail.length >= 2)
                    ) {
                        let sequencePad: number;
                        if (/X/i.test(tail)) {
                            const beforeX = tail.split(/X/i)[0] || '';
                            const digitsBefore = beforeX.replace(/\D/g, '');
                            sequencePad = Math.max(digitsBefore.length || 5, 4);
                        } else {
                            const digits = tail.replace(/\D/g, '');
                            sequencePad = Math.max(digits.length || 4, 4);
                        }
                        return { kind: 'year_concat_seq', sequencePad };
                    }
                }
            }
            if (raw && /\d/.test(raw) && /^[\dX]+$/i.test(raw)) {
                let sequencePad: number;
                if (/X/i.test(raw)) {
                    const beforeX = raw.split(/X/i)[0] || '';
                    const digitsBefore = beforeX.replace(/\D/g, '');
                    sequencePad = Math.max(digitsBefore.length || 5, 4);
                } else {
                    const digits = raw.replace(/\D/g, '');
                    sequencePad = Math.max(digits.length || 4, 4);
                }
                return { kind: 'seq_only', sequencePad };
            }
        }

        // AAAA-séquence ou PRÉFIXE-séquence : exactement un tiret
        if (hyphenCount === 1) {
            const mY = withPrefix.match(/^((?:20\d{2}|\d{4}))-(.+)$/);
            if (mY) {
                const y = parseInt(mY[1], 10);
                if (y >= 2000 && y <= 2099) {
                    const tailRaw = mY[2].trim();
                    let sequencePad: number;
                    if (/X/i.test(tailRaw)) {
                        const beforeX = tailRaw.split(/X/i)[0] || '';
                        const digitsBefore = beforeX.replace(/\D/g, '');
                        sequencePad = Math.max(digitsBefore.length || 5, 4);
                    } else {
                        const digits = tailRaw.replace(/\D/g, '');
                        sequencePad = Math.max(digits.length || 4, 4);
                    }
                    return { kind: 'year_seq', sequencePad };
                }
            }
            const mP = withPrefix.match(/^([^-]+)-(.+)$/);
            if (mP) {
                const leftRaw = mP[1].trim();
                const rightRaw = mP[2].trim();
                const ry = parseInt(rightRaw, 10);
                // Modèle 4 : 00000X-2026 (chiffres / X à gauche, année 2000–2099 à droite)
                if (
                    /^\d{4}$/.test(rightRaw) &&
                    !isNaN(ry) &&
                    ry >= 2000 &&
                    ry <= 2099 &&
                    /^[\dX]+$/i.test(leftRaw)
                ) {
                    let sequencePad: number;
                    if (/X/i.test(leftRaw)) {
                        const beforeX = leftRaw.split(/X/i)[0] || '';
                        const digitsBefore = beforeX.replace(/\D/g, '');
                        sequencePad = Math.max(digitsBefore.length || 5, 4);
                    } else {
                        const digits = leftRaw.replace(/\D/g, '');
                        sequencePad = Math.max(digits.length || 4, 4);
                    }
                    return { kind: 'seq_year', sequencePad };
                }
                const tailRaw = rightRaw;
                let sequencePad: number;
                if (/X/i.test(tailRaw)) {
                    const beforeX = tailRaw.split(/X/i)[0] || '';
                    const digitsBefore = beforeX.replace(/\D/g, '');
                    sequencePad = Math.max(digitsBefore.length || 5, 4);
                } else {
                    const digits = tailRaw.replace(/\D/g, '');
                    sequencePad = Math.max(digits.length || 4, 4);
                }
                return { kind: 'prefix_seq', sequencePad };
            }
        }

        const tailMatch = withPrefix.match(/^(.+)-(\d{4})-(.+)$/);
        if (tailMatch) {
            const firstSeg = tailMatch[1].trim();
            const looksLikeYearOnly =
                /^(?:20\d{2}|\d{4})$/.test(firstSeg) &&
                (() => {
                    const n = parseInt(firstSeg, 10);
                    return n >= 2000 && n <= 2099;
                })() &&
                !/[A-Za-z]/.test(firstSeg);
            if (looksLikeYearOnly) {
                return null;
            }
            const tailRaw = tailMatch[3].trim();
            let sequencePad: number;
            if (/X/i.test(tailRaw)) {
                const beforeX = tailRaw.split(/X/i)[0] || '';
                const digitsBefore = beforeX.replace(/\D/g, '');
                sequencePad = Math.max(digitsBefore.length || 5, 4);
            } else {
                const digits = tailRaw.replace(/\D/g, '');
                sequencePad = Math.max(digits.length || 4, 4);
            }
            return { kind: 'prefix_year_seq', sequencePad };
        }
        return null;
    }


    private getModelReferenceTemplateInfo(): { threeSegments: true; sequencePad: number } | null {
        const m = this.getModelReferenceFormatMeta();
        return m?.kind === 'prefix_year_seq' ? { threeSegments: true, sequencePad: m.sequencePad } : null;
    }

    getReferenceConcreteValueForModal(): string {
        return this.buildInitialRefFromTypeMeta(this.documentType, this.getReferencePrefix());
    }

    getReferencePlaceholder(): string {
        return this.getReferenceConcreteValueForModal();
    }

    getReferenceInputPlaceholder(): string {
        return this.getReferenceConcreteValueForModal();
    }

    getReferenceModalHelpLine(): string {
        const desc = this.referenceModelDetail?.description?.trim();
        if (desc) {
            const idx = desc.indexOf(':');
            const line = idx >= 0 ? desc.slice(0, idx).trim() : desc;
            if (line) {
                return line;
            }
        }
        return this.getDefaultReferenceModalHelpLine();
    }

    private getDefaultReferenceModalHelpLine(): string {
        const t = this.documentType;
        if (t === 'DEVIS') {
            return 'Indiquez la référence du devis.';
        }
        if (t === 'FACTURE' || t === 'FACTURE FOURNISSEUR') {
            return 'Indiquez la référence de la facture.';
        }
        if (t === 'COMMANDE CLIENT' || t === 'COMMANDE FOURNISSEUR') {
            return 'Indiquez la référence de la commande.';
        }
        if (t === 'BON DE LIVRAISON' || t === 'BON RECEPTION' || t === 'BON DE SORTIE' || t === 'BON TRANSFERT') {
            return 'Indiquez la référence du bon.';
        }
        if (t === 'INVENTAIRE') {
            return 'Indiquez la référence de l’inventaire.';
        }
        if (t === 'AVOIR' || t === 'AVOIR FOURNISSEUR') {
            return 'Indiquez la référence de l’avoir.';
        }
        return 'Indiquez la référence du document.';
    }

    private applyEffectivePrefixToFormatExampleString(fmt: string): string {
        const prefix = this.getReferencePrefix();
        if (!fmt?.trim() || !prefix) {
            return fmt;
        }
        let out = fmt.trim();
        out = out.replace(
            /(^|[\s;,:()\/])([A-Za-z0-9]{1,20})-((?:20\d{2}|\d{4}))-([^\s]+)/g,
            (_m, lead: string, _oldPref: string, year: string, tail: string) =>
                `${lead}${prefix}-${year}-${tail}`
        );
        out = out.replace(
            /^([A-Za-z0-9]{1,20})-((?:20\d{2}|\d{4}))-(.+)$/,
            (_m, _oldPref: string, year: string, tail: string) => `${prefix}-${year}-${tail}`
        );
        return out;
    }

    getReferenceFormatExample(): string {
        const prefix = this.getReferencePrefix();
        const desc = this.referenceModelDetail?.description?.trim();
        if (desc) {
            const idx = desc.indexOf(':');
            const part = idx >= 0 ? desc.slice(idx + 1).trim() : desc;
            if (part) {
                const sub = this.substituteReferenceYearInPrefix(part) || part;
                return this.applyEffectivePrefixToFormatExampleString(sub);
            }
        }
        const fmt = this.getModelReferenceFormatMeta();
        const y = new Date().getFullYear();
        if (fmt?.kind === 'year_seq') {
            return `${y}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'year_concat_seq') {
            return `${y}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'seq_year') {
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${y}`;
        }
        if (fmt?.kind === 'prefix_year_seq') {
            return `${prefix}-${y}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'prefix_seq') {
            return `${prefix}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }
        if (fmt?.kind === 'seq_only') {
            return (1).toString().padStart(fmt.sequencePad, '0');
        }
        return `${prefix}-0001`;
    }

    getReferenceValidationMessage(): string {
        const ex = this.getReferenceFormatExample();
        const placeholder = this.getReferencePlaceholder();
        if (this.referenceModelDetail?.description?.trim()) {
            return `Référence invalide. Format attendu : ${ex} (ex. ${placeholder}).`;
        }
        return `Référence invalide. Utilisez le préfixe « ${this.getReferencePrefix()} » suivi d’un numéro (ex. ${placeholder}) ou uniquement des chiffres.`;
    }

    private parseReferenceThreeSegmentParts(ref: string): { prefix: string; year: number; seq: number; pad: number } | null {
        const tmpl = this.getModelReferenceTemplateInfo();
        if (!tmpl?.threeSegments) {
            return null;
        }
        const p = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
        const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d{4})-(\\d+)$`, 'i');
        const m = ref.trim().match(re);
        if (!m) {
            return null;
        }
        return {
            prefix: p,
            year: parseInt(m[1], 10),
            seq: parseInt(m[2], 10),
            pad: tmpl.sequencePad
        };
    }

    private parseReferenceYearSequenceParts(ref: string): { year: number; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'year_seq') {
            return null;
        }
        const m = ref.trim().match(/^(\d{4})-(\d+)$/i);
        if (!m) {
            return null;
        }
        return {
            year: parseInt(m[1], 10),
            seq: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceYearConcatParts(ref: string): { year: number; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'year_concat_seq') {
            return null;
        }
        const m = ref.trim().match(/^(\d{4})(\d+)$/);
        if (!m) {
            return null;
        }
        const y0 = parseInt(m[1], 10);
        if (y0 < 2000 || y0 > 2099) {
            return null;
        }
        return {
            year: y0,
            seq: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceSeqYearParts(ref: string): { seq: number; year: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'seq_year') {
            return null;
        }
        const m = ref.trim().match(/^(\d+)-(\d{4})$/i);
        if (!m) {
            return null;
        }
        return {
            seq: parseInt(m[1], 10),
            year: parseInt(m[2], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferencePrefixSequenceParts(ref: string): { prefix: string; seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'prefix_seq') {
            return null;
        }
        const p = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
        const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d+)$`, 'i');
        const m = ref.trim().match(re);
        if (!m) {
            return null;
        }
        return {
            prefix: p,
            seq: parseInt(m[1], 10),
            pad: fmt.sequencePad
        };
    }

    private parseReferenceSeqOnlyParts(ref: string): { seq: number; pad: number } | null {
        const fmt = this.getModelReferenceFormatMeta();
        if (fmt?.kind !== 'seq_only') {
            return null;
        }
        const r = ref.trim();
        if (!/^\d+$/.test(r)) {
            return null;
        }
        const seq = parseInt(r, 10);
        return { seq: isNaN(seq) ? 1 : seq, pad: fmt.sequencePad };
    }

    private parseReferenceCounterAndPadding(): { num: number; pad: number } {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            return { num: three.seq, pad: three.pad };
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            return { num: ys.seq, pad: ys.pad };
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            return { num: yc.seq, pad: yc.pad };
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            return { num: sy.seq, pad: sy.pad };
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            return { num: ps.seq, pad: ps.pad };
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            return { num: so.seq, pad: so.pad };
        }
        const prefix = this.getReferencePrefix();
        const re = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`);
        const m = ref.match(re);
        if (m) {
            const n = parseInt(m[1], 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(m[1].length, 4) };
        }
        if (/^\d+$/.test(ref)) {
            const n = parseInt(ref, 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(ref.length, 4) };
        }
        const loose = ref.match(/^(.+)-(\d+)$/);
        if (loose) {
            const n = parseInt(loose[2], 10);
            return { num: isNaN(n) ? 1 : n, pad: Math.max(loose[2].length, 4) };
        }
        return { num: 1, pad: 4 };
    }

    private incrementRefExterneTwoSegment(lastRef: string | null | undefined, prefix: string): string {
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        const ref = (lastRef || '').trim();
        if (!ref) {
            return `${p}-0001`;
        }
        const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const same = new RegExp(`^${escape(p)}-(\\d+)$`, 'i');
        const m = ref.match(same);
        if (m) {
            const num = parseInt(m[1], 10);
            const nextNum = isNaN(num) ? 1 : num + 1;
            const pad = Math.max(m[1].length, 4);
            return `${p}-${nextNum.toString().padStart(pad, '0')}`;
        }
        const carried = this.extractSequenceFromLastReference(ref, p);
        if (carried != null) {
            const nextNum = carried + 1;
            const pad = Math.max(String(nextNum).length, 4);
            return `${p}-${nextNum.toString().padStart(pad, '0')}`;
        }
        return `${p}-0001`;
    }

    private incrementRefExterneForCurrentModel(lastRef: string | null | undefined, prefix: string): string {
        const fmt = this.getModelReferenceFormatMeta();
        const p = (prefix || 'DOC').replace(/-+$/, '').trim() || 'DOC';
        const year = new Date().getFullYear();

        if (fmt?.kind === 'year_seq') {
            const ref = (lastRef || '').trim();
            const mYs = ref.match(/^(\d{4})-(\d+)$/i);
            if (mYs) {
                const refYear = parseInt(mYs[1], 10);
                const num = parseInt(mYs[2], 10);
                if (refYear === year) {
                    return `${year}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    return `${year}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                return `${refYear}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${year}-${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'year_concat_seq') {
            const ref = (lastRef || '').trim();
            const mCat = ref.match(/^(\d{4})(\d+)$/);
            if (mCat) {
                const refYear = parseInt(mCat[1], 10);
                const num = parseInt(mCat[2], 10);
                if (refYear === year) {
                    return `${year}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    return `${year}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
                }
                return `${refYear}${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${year}${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${year}${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'seq_year') {
            const ref = (lastRef || '').trim();
            const mSy = ref.match(/^(\d+)-(\d{4})$/i);
            if (mSy) {
                const num = parseInt(mSy[1], 10);
                const refYear = parseInt(mSy[2], 10);
                if (refYear === year) {
                    return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
                }
                if (refYear < year) {
                    return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
                }
                return `${(num + 1).toString().padStart(fmt.sequencePad, '0')}-${refYear}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${(carried + 1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
            }
            return `${(1).toString().padStart(fmt.sequencePad, '0')}-${year}`;
        }

        if (fmt?.kind === 'prefix_year_seq') {
            const ref = (lastRef || '').trim();
            const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d{4})-(\\d+)$`, 'i');
            const m = ref.match(re);
            if (m) {
                const refYear = parseInt(m[1], 10);
                const num = parseInt(m[2], 10);
                if (refYear === year) {
                    const nextNum = (isNaN(num) ? 0 : num) + 1;
                    return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
                }
                if (refYear < year) {
                    const nextNum = (isNaN(num) ? 0 : num) + 1;
                    return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
                }
                const nextNum = (isNaN(num) ? 0 : num) + 1;
                return `${p}-${refYear}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                const nextNum = carried + 1;
                return `${p}-${year}-${nextNum.toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${year}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'prefix_seq') {
            const ref = (lastRef || '').trim();
            const re = new RegExp(`^${this.escapeRegExp(p)}-(\\d+)$`, 'i');
            const m = ref.match(re);
            if (m) {
                const num = parseInt(m[1], 10);
                return `${p}-${(num + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return `${p}-${(carried + 1).toString().padStart(fmt.sequencePad, '0')}`;
            }
            return `${p}-${(1).toString().padStart(fmt.sequencePad, '0')}`;
        }

        if (fmt?.kind === 'seq_only') {
            const ref = (lastRef || '').trim();
            if (/^\d+$/.test(ref)) {
                const num = parseInt(ref, 10);
                return (num + 1).toString().padStart(fmt.sequencePad, '0');
            }
            const carried = this.extractSequenceFromLastReference(ref, p);
            if (carried != null) {
                return (carried + 1).toString().padStart(fmt.sequencePad, '0');
            }
            return (1).toString().padStart(fmt.sequencePad, '0');
        }

        return this.incrementRefExterneTwoSegment(lastRef, prefix);
    }
    private loadNextReferenceInBackground(): void {
        this.applyNextReferenceFromRefCounterApi();
    }

    /** Précharge la prochaine référence auto-incrémentée (nouveau document uniquement). */
    private maybePrefetchNextDocumentReference(force = false): void {
        if (this.documentId || this.mode === 'edit' || this.mode === 'validation') {
            return;
        }
        if (!force) {
            const r = (this.documentReference || this.refExterne || '').trim();
            if (r && !/^0+$/.test(r)) {
                return;
            }
        }
        this.loadNextReferenceInBackground();
    }

    isHeaderDocumentReferenceLoading(): boolean {
        return (
            this.documentReferenceHeaderPending &&
            !this.documentId &&
            this.mode === 'add'
        );
    }

    /** Référence affichée à côté du type de document (sans placeholder 0001 / 001). */
    getHeaderDocumentReference(): string {
        if (this.isHeaderDocumentReferenceLoading()) {
            return '';
        }
        const r = (this.documentReference || this.refExterne || '').trim();
        if (r && !/^0+$/.test(r)) {
            return r;
        }
        return '';
    }

    private assignProvisionalRefExterneForType(): void {
        this.applyNextReferenceFromRefCounterApi();
    }

    private openReferenceModalInternal(): void {
        if (!this.referenceModal) {
            this.cdr.detectChanges();
            setTimeout(() => this.openReferenceModalInternal(), 50);
            return;
        }
        this.referenceSeedFromPopup = true;
        this.modalRef = this.modalService.open(this.referenceModal, {
            ariaLabelledBy: 'modal-reference-title',
            centered: true,
            size: 'sm',
            windowClass: 'warning-modal-centered'
        });
    }

    openmargeModal(index: number): void {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            this.margeModalDesignation = '—';
            this.margeModalPercentDisplay = null;
            this.margeModalMontantDisplay = null;
            this.margeModalHint =
                'La marge est calculée sur les lignes produit. Pour un sous-total ou une autre ligne, ajoutez ou sélectionnez une ligne produit.';
        } else {
            const r = this.computeProductLineMargin(index);
            this.margeModalDesignation = r.designation;
            this.margeModalPercentDisplay = r.pct;
            this.margeModalMontantDisplay = r.montant;
            this.margeModalHint = r.hint;
        }
        this.cdr.detectChanges();
        this.modalRef = this.modalService.open(this.margeModal, {
            ariaLabelledBy: 'modal-marge-title',
            centered: true,
            size: 'sm',
            windowClass: 'warning-modal-centered'
        });
    }

    private getProductCostUnitaire(product: Product | undefined): number {
        if (!product) {
            return 0;
        }
        const pa = Number(product.prix_unitaires);
        if (Number.isFinite(pa) && pa > 0) {
            return pa;
        }
        const vu = Number(product.valeur_unitaire);
        if (Number.isFinite(vu) && vu > 0) {
            return vu;
        }
        return 0;
    }

    private computeProductLineMargin(index: number): {
        designation: string;
        pct: number | null;
        montant: number | null;
        hint: string;
    } {
        const item = this.items[index];
        const designation = (item.designation || 'Produit').trim();
        const product = item.product_id ? this.products.find(p => p.id === item.product_id) : undefined;
        const qRaw = Number(item.quantity);
        const q = Number.isFinite(qRaw) ? qRaw : 0;
        const remise = Number(item.remise || 0) / 100;

        const hintVente =
            'Prix de vente HT unitaire (après remise) comparé au coût d’achat (fiche produit : prix d’achat ou valeur unitaire).';
        const hintAchat =
            'Écart entre la valorisation stock (CMUP / valeur unitaire article) et le prix d’achat unitaire sur la ligne.';
        const hintStockDoc =
            'Valeur unitaire saisie sur la ligne comparée au coût d’achat (fiche produit).';
        const hintPasCout =
            'Coût ou valorisation produit introuvable : vérifiez la fiche article ou sélectionnez à nouveau le produit.';
        const hintPrixQty =
            'Indiquez un prix unitaire HT et une quantité pour calculer la marge.';

        if (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') {
            const valUnit = Number(item.valeur_unitaire || 0) * (1 - remise);
            const pa = this.getProductCostUnitaire(product);
            if (!product || pa <= 0) {
                return { designation, pct: null, montant: null, hint: hintPasCout };
            }
            const margeUnit = valUnit - pa;
            const montant = margeUnit * q;
            const pct = Math.abs(valUnit) > 1e-9 ? (margeUnit / valUnit) * 100 : null;
            return { designation, pct, montant, hint: hintStockDoc };
        }

        if (this.isAchatDocument()) {
            const prixAchatUnit = Number(item.priceHT || 0) * (1 - remise);
            let cmup = 0;
            const vuLigneFf = Number((item as any).valeur_unitaire);
            if (
                this.documentType === 'FACTURE FOURNISSEUR' &&
                Number.isFinite(vuLigneFf) &&
                vuLigneFf > 0
            ) {
                cmup = vuLigneFf;
            } else if (product) {
                const vu = Number(product.valeur_unitaire);
                const pap = Number(product.prix_unitaires);
                if (Number.isFinite(vu) && vu > 0) {
                    cmup = vu;
                } else if (Number.isFinite(pap) && pap > 0) {
                    cmup = pap;
                }
            }
            if (cmup <= 0) {
                return { designation, pct: null, montant: null, hint: hintPasCout };
            }
            const ecartUnit = cmup - prixAchatUnit;
            const montant = ecartUnit * q;
            const pct = Math.abs(cmup) > 1e-9 ? (ecartUnit / cmup) * 100 : null;
            return { designation, pct, montant, hint: hintAchat };
        }

        const pvUnit = Number(item.priceHT || 0) * (1 - remise);
        const pa = this.getProductCostUnitaire(product);
        if (!product || pa <= 0) {
            return { designation, pct: null, montant: null, hint: hintPasCout };
        }
        if (Math.abs(pvUnit) < 1e-9 && Math.abs(q) < 1e-9) {
            return { designation, pct: null, montant: null, hint: hintPrixQty };
        }
        const margeUnit = pvUnit - pa;
        const montant = margeUnit * q;
        const pct = Math.abs(pvUnit) > 1e-9 ? (margeUnit / pvUnit) * 100 : null;
        return { designation, pct, montant, hint: hintVente };
    }
    removeAjoutLigne(itemIndex: number, ajoutLigneIndex: number): void {
        const item = this.items[itemIndex];
        if (item && item.ajout_ligne && item.ajout_ligne.length > ajoutLigneIndex) {
            item.ajout_ligne.splice(ajoutLigneIndex, 1);
            item.ajout_ligne.forEach((ligne, idx) => {
                ligne.order = idx + 1;
            });
            if (item.ajout_ligne.length === 0) {
                item.ajout_ligne = undefined;
            }
            this.cdr.detectChanges();
        }
    }

    getColspanForAjoutLigne(): number {
        let colspan = 1; // DÉSIGNATION (toujours présent)
        if (this.documentColumnSettings.reference) colspan++;
        if (this.documentColumnSettings.taille) colspan++;
        if (this.showQuantiteDisponibleColumn()) colspan++;
        if (this.documentColumnSettings.quantite) colspan++;
        if (this.documentColumnSettings.unite) colspan++;
        if (this.documentColumnSettings.prixUnitaire) colspan++;
        if (this.documentColumnSettings.remise) colspan++;
        if (this.documentColumnSettings.tva) colspan++;
        if (this.documentColumnSettings.afficherMontantsTTC) colspan++;
        colspan++;
        colspan++;
        return colspan;
    }

    confirmReference(): void {
        this.modalRef?.close();
        if (this.isSubmitting) return;

        // Appliquer la référence modifiée dans le popup avant création
        const refFromModal = (this.documentReference || '').trim();
        const isNewDocument = this.mode === 'add' || !this.documentId;
        if (refFromModal && !/^0+$/.test(refFromModal) && !this.isProvisionalDraftRef(refFromModal)) {
            this.documentReference = refFromModal;
            this.refExterne = refFromModal;
            this.numericReference = this.getNumericReferenceFromRefString(refFromModal) ?? this.numericReference;
            // Seed compteur UNIQUEMENT à la 1re création (pas à l’approbation d’un brouillon existant)
            if (isNewDocument) {
                this.referenceSeedFromPopup = true;
                const seq = this.getNumericReferenceFromRefString(refFromModal);
                if (seq != null && Number.isFinite(seq) && seq > 0) {
                    this.ensureTypeMetaRefCounter(0);
                }
            } else {
                this.referenceSeedFromPopup = false;
            }
        } else if (!isNewDocument) {
            this.referenceSeedFromPopup = false;
        }

        if (this.documentType === 'BON TRANSFERT') {
            const hasInitialEntrepot = this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined;
            const hasDestinationEntrepot = this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined;
            
            if (!hasInitialEntrepot || !hasDestinationEntrepot) {
                this.modalRef = this.modalService.open(this.depotWarningModal, {
                    ariaLabelledBy: 'modal-depot-warning-title',
                    centered: true,
                    size: 'sm',
                    windowClass: 'warning-modal-centered'
                });
                return;
            }
        }
        this.recalculateAll();
        if (this.mode === 'add' || !this.documentId) {
            this.isSubmitting = true;
            this.toastr.info('Création du document en cours...', '', { timeOut: 5000 });

            const createAndThenNavigateForAdd = (
                res: any,
                pairedBonLivraisonId?: number | null,
                opts?: { skipRefCounterIncrement?: boolean }
            ) => {
                const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                if (!newId) {
                    this.toastr.error('Erreur : ID non reçu après création');
                    this.isSubmitting = false;
                    this.updateHeaderConfig();
                    return;
                }
                this.applyAllocatedReferenceFromCreateResponse(res);
                // opts.skipRefCounterIncrement conservé pour compat ; incrément géré côté API create.
                this.documentId = newId;
                this.currentStatutId = this.getApproveStatutId();
                this.saveModifiedFields();

                const navigateAfterCreate = () => {
                    this.toastr.success(
                        pairedBonLivraisonId
                            ? 'Facture et bon de livraison créés et approuvés.'
                            : 'Document créé et approuvé !'
                    );
                    if (this.documentType === 'INVENTAIRE') {
                        this.router.navigate(['/inventaire/action/validation'], { queryParams: { id: newId } });
                    } else if (this.documentType === 'BON TRANSFERT') {
                        this.router.navigate(['/bon-transfert/action/validation'], { queryParams: { id: newId } });
                    } else {
                        // Facture / FF (Non payé) et autres → page validation (Retour / Annuler)
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], { queryParams: { id: newId } });
                    }
                };

                if (this.documentType === 'BON TRANSFERT') {
                    this.schedulePostDocumentStockAlerts();
                    this.postStockTransfertsApiForBonTransfert()
                        .pipe(
                            catchError((err) => {
                                const msg =
                                    err?.error?.message ||
                                    err?.message ||
                                    'Impossible d’enregistrer le transfert (/api/stock-transferts).';
                                this.toastr.warning(msg, 'Bon de transfert', { timeOut: 8000 });
                                return of(null);
                            }),
                            finalize(() => {
                                navigateAfterCreate();
                                this.isSubmitting = false;
                                this.updateHeaderConfig();
                                this.cdr.detectChanges();
                            })
                        )
                        .subscribe();
                    return;
                }

                if (this.requiresStockUpdate()) {
                    this.updateStockForDocument(newId, () => this.schedulePostDocumentStockAlerts());
                } else {
                    this.schedulePostDocumentStockAlerts();
                }
                if (this.documentType === 'FACTURE FOURNISSEUR') {
                    this.updateProductsValeurUnitaireForFactureFournisseur();
                }

                const approveStatutId = this.getApproveStatutId();
                const stationIdForStatut =
                    Number(res?.data?.document?.station_id ?? res?.data?.station_id ?? this.stationId) || this.stationId;

                const finishCreate = () => {
                    this.currentStatutId = approveStatutId;
                    this.linkTicketsToErpFactureIfNeeded$(newId, res).subscribe({
                        next: () => {
                            this.isSubmitting = false;
                            this.updateHeaderConfig();
                            this.cdr.detectChanges();
                            navigateAfterCreate();
                        },
                        error: () => {
                            this.isSubmitting = false;
                            this.updateHeaderConfig();
                            this.cdr.detectChanges();
                            navigateAfterCreate();
                        }
                    });
                };

                // Garantir le statut d'approbation (Non payé pour facture) après création
                if (approveStatutId != null && stationIdForStatut) {
                    this.documentService.updateStatut(newId, {
                        statut_id: approveStatutId,
                        station_id: stationIdForStatut
                    }).subscribe({
                        next: () => finishCreate(),
                        error: (err) => {
                            this.toastr.warning(
                                err?.error?.message ||
                                    'Facture créée, mais le statut Non payé n\'a pas pu être appliqué. Vérifiez dans la liste.',
                                'Statut'
                            );
                            finishCreate();
                        }
                    });
                } else {
                    finishCreate();
                }
            };
            if (this.conversionFromRef) {
                const cf = this.conversionFromRef;
                // Toujours lier le document créé à la source (contrainte anti-reconversion)
                const documentOriginalIdForConvert = cf.sourceId;
                const convertCall = cf.isAvoir && cf.totalsAvoir
                    ? this.documentService.convertDocumentType(cf.sourceId, cf.typeDocumentId, cf.statutId, documentOriginalIdForConvert, cf.totalsAvoir)
                    : this.documentService.convertDocumentType(cf.sourceId, cf.typeDocumentId, cf.statutId, documentOriginalIdForConvert);

                convertCall.pipe(
                    switchMap((res: any) => {
                        const stationIdFromRes = res?.data?.document?.station_id ?? res?.data?.station_id ?? this.stationId;
                        const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                        if (!newId) {
                            return throwError(() => new Error('ID du document converti non reçu'));
                        }
                        this.documentId = newId;
                        this.documentOriginalId = cf.sourceId;
                        this.recalculateAll();
                        this.currentTypeDocumentId = cf.typeDocumentId;
                        return this.documentService.getDocumentById(newId).pipe(
                            switchMap((docRes: any) => {
                                const doc = docRes?.data?.document ?? docRes?.data ?? docRes;
                                if (doc) {
                                    if (doc.statut_id != null) {
                                        this.currentStatutId = doc.statut_id;
                                    }
                                    if (doc.type_document_id != null) {
                                        this.currentTypeDocumentId = doc.type_document_id;
                                    }
                                    if (doc.user_id != null) {
                                        this.currentDocumentUserId = Number(doc.user_id);
                                    }
                                }
                                this.mode = 'edit';
                                this.isEditing = true;
                                return this.performUpdateDocument(this.currentStatutId ?? undefined);
                            }),
                            catchError(() => {
                                this.mode = 'edit';
                                this.isEditing = true;
                                return this.performUpdateDocument(undefined);
                            }),
                            map(() => ({ res, stationIdFromRes }))
                        );
                    }),
                    switchMap(({ res, stationIdFromRes }: { res: any; stationIdFromRes: number }) => {
                        const newId = res?.data?.id || res?.data?.document?.id || res?.id;
                        const stationId = stationIdFromRes ?? this.stationId;
                        const updateStatutCall = stationId
                            ? this.documentService.updateStatut(newId, { statut_id: cf.statutId, station_id: stationId })
                            : this.documentService.updateStatus(newId, cf.statutId);
                        return updateStatutCall.pipe(
                            map(() => res),
                            catchError(() => of(res))
                        );
                    })
                ).subscribe({
                    next: (res) => {
                        this.conversionFromRef = null;
                        createAndThenNavigateForAdd(res, undefined, { skipRefCounterIncrement: true });
                    },
                    error: (err) => {
                        this.isSubmitting = false;
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || err?.message || 'Erreur lors de la conversion');
                    }
                });
                return;
            }

            const payload = this.buildCreatePayload();

            if (this.documentType === 'BON TRANSFERT') {
                if (this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined) {
                    payload.entrepot_id = this.selectedWarehouseInitialId;
                }
                if (this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined) {
                    payload.entrepot_dest_id = this.selectedWarehouseDestinationId;
                }
            } else if (this.selectedWarehouseId !== null && this.selectedWarehouseId !== undefined) {
                payload.entrepot_id = this.selectedWarehouseId;
            }

            this.applyLogicielCaisseEntrepotToPayload(payload);

            if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
                payload.parametrage_doc = this.buildParametrageDoc();
            }

            if (this.documentType === 'BON TRANSFERT') {
                this.documentService.create(payload).subscribe({
                    next: (res) => createAndThenNavigateForAdd(res),
                    error: (err) => {
                        this.isSubmitting = false;
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || err?.message || 'Erreur lors de la création', 'Erreur');
                    }
                });
            } else if (this.documentType === 'FACTURE') {
                this.createFactureWithOptionalBonLivraison$().subscribe({
                    next: ({ res, pairedBlId }) => createAndThenNavigateForAdd(res, pairedBlId),
                    error: (err) => {
                        this.isSubmitting = false;
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || 'Erreur lors de la création');
                    }
                });
            } else {
                this.documentService.create(payload).subscribe({
                    next: (res) => createAndThenNavigateForAdd(res),
                    error: (err) => {
                        this.isSubmitting = false;
                        this.updateHeaderConfig();
                        this.cdr.detectChanges();
                        this.toastr.error(err?.error?.message || 'Erreur lors de la création');
                    }
                });
            }

        } else {
            this.isSubmitting = true;
            this.toastr.info('Approbation en cours...', '', { timeOut: 5000 });

            const statutApprouve = this.getApproveStatutId();
            this.updateDocument(statutApprouve)
                .pipe(
                    switchMap(() =>
                        this.documentType === 'BON TRANSFERT'
                            ? this.postStockTransfertsApiForBonTransfert().pipe(
                                  catchError((err) => {
                                      const msg =
                                          err?.error?.message ||
                                          err?.message ||
                                          'Impossible d’enregistrer le transfert (/api/stock-transferts).';
                                      this.toastr.warning(msg, 'Bon de transfert', { timeOut: 8000 });
                                      return of(null);
                                  })
                              )
                            : of(null)
                    ),
                    finalize(() => {
                        this.isSubmitting = false;
                    })
                )
                .subscribe({
                    next: () => {
                        this.toastr.success('Document approuvé avec succès !');
                        this.currentStatutId = statutApprouve;
                        this.updateHeaderConfig();

                        if (this.documentType === 'FACTURE FOURNISSEUR') {
                            this.updateProductsValeurUnitaireForFactureFournisseur();
                        }

                        const afterApproveNavigate = () => {
                            if (this.documentType === 'INVENTAIRE') {
                                this.router.navigate(['/inventaire/action/validation'], {
                                    queryParams: { id: this.documentId }
                                });
                            } else if (this.documentType === 'BON TRANSFERT') {
                                this.router.navigate(['/bon-transfert/action/validation'], {
                                    queryParams: { id: this.documentId }
                                });
                            } else {
                                // Facture / FF (Non payé) → validation (Retour / Annuler)
                                this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                                    queryParams: { id: this.documentId }
                                });
                            }
                        };

                        const afterStockOrSkip = () => {
                            this.linkTicketsToErpFactureIfNeeded$(this.documentId, {
                                data: {
                                    document: {
                                        id: this.documentId,
                                        ref_externe: this.documentReference || this.refExterne
                                    }
                                }
                            }).subscribe({
                                next: () => afterApproveNavigate(),
                                error: () => afterApproveNavigate()
                            });
                        };

                        // Avoir / BR « Reçu » : stock à l'approbation ; BL → stock uniquement au « Livrer »
                        if (this.requiresStockUpdate() && this.documentId != null) {
                            this.updateStockForDocument(this.documentId, () => {
                                this.schedulePostDocumentStockAlerts();
                                afterStockOrSkip();
                            });
                        } else {
                            afterStockOrSkip();
                        }
                    },
                    error: () => {
                        this.toastr.error('Erreur lors de l\'approbation');
                    }
                });
        }
    }

    private extractNewDocumentIdFromCreateResponse(res: any): number | null {
        const raw = res?.data?.id ?? res?.data?.document?.id ?? res?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) ? n : null;
    }

    /** Applique la référence réellement allouée par le backend (source de vérité). */
    private applyAllocatedReferenceFromCreateResponse(res: any): void {
        const allocated = String(
            res?.data?.document?.ref_externe ??
                res?.data?.ref_externe ??
                res?.data?.document?.ref_interne ??
                res?.ref_externe ??
                ''
        ).trim();
        if (allocated) {
            this.documentReference = allocated;
            this.refExterne = allocated;
            this.numericReference = this.getNumericReferenceFromRefString(allocated);
        }
        const seq = this.numericReference;
        if (seq != null && Number.isFinite(Number(seq)) && Number(seq) > 0) {
            this.ensureTypeMetaRefCounter(Number(seq));
        } else {
            const prev = this.typeDocumentsMeta[this.documentType]?.refCounter;
            const next = prev != null && Number.isFinite(Number(prev)) ? Number(prev) + 1 : 1;
            this.ensureTypeMetaRefCounter(next);
        }
        this.cdr.markForCheck();
    }

    private buildCreatePayloadForDocumentType(
        docType: string,
        options?: { document_original_id?: number | null }
    ): any {
        const prevType = this.documentType;
        this.documentType = docType;
        try {
            const payload = this.buildCreatePayload();
            // Ne jamais réutiliser la ref du document principal (ex. facture → BL) :
            // le backend alloue la prochaine séquence du type cible.
            delete payload.ref_externe;
            delete payload.ref_interne;
            if (options?.document_original_id != null && options.document_original_id !== undefined) {
                payload.document_original_id = options.document_original_id;
            }
            return payload;
        } finally {
            this.documentType = prevType;
        }
    }

    private createFactureWithOptionalBonLivraison$(): Observable<{ res: any; pairedBlId: number | null }> {
        return this.parametreDocumentSettingsService.getByStation(this.stationId).pipe(
            catchError(() => of(null)),
            switchMap((bundle) => {
                const activeBonLiv =
                    bundle != null && isTruthyTinyInt(bundle.parametre_document?.active_bon_liv);
                let payload = this.buildCreatePayload();
                if (this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined) {
                    payload.entrepot_id = this.selectedWarehouseId;
                }
                this.applyLogicielCaisseEntrepotToPayload(payload);
                if (!payload.parametrage_doc) {
                    payload.parametrage_doc = this.buildParametrageDoc();
                }
                return this.documentService.create(payload).pipe(
                    switchMap((res) => {
                        const factureId = this.extractNewDocumentIdFromCreateResponse(res);
                        if (!activeBonLiv || factureId == null) {
                            return of({ res, pairedBlId: null as number | null });
                        }
                        const blPayload = this.buildCreatePayloadForDocumentType('BON DE LIVRAISON', {
                            document_original_id: factureId
                        });
                        if (this.selectedWarehouseId != null && this.selectedWarehouseId !== undefined) {
                            blPayload.entrepot_id = this.selectedWarehouseId;
                        }
                        this.applyLogicielCaisseEntrepotToPayload(blPayload);
                        if (!blPayload.parametrage_doc) {
                            blPayload.parametrage_doc = this.buildParametrageDoc();
                        }
                        return this.documentService.create(blPayload).pipe(
                            map((blRes) => ({
                                res,
                                pairedBlId: this.extractNewDocumentIdFromCreateResponse(blRes)
                            })),
                            catchError((err) => {
                                this.toastr.warning(
                                    'La facture a été créée, mais la génération automatique du bon de livraison a échoué. Vous pouvez le créer manuellement.',
                                    'Bon de livraison',
                                    { timeOut: 10000 }
                                );
                                return of({ res, pairedBlId: null });
                            })
                        );
                    })
                );
            })
        );
    }

    private buildCreatePayload(): any {
        const isAchat = this.isAchatDocument();

        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (p) {
                projetPivot = {
                    id_projet: String(p.id),
                    titre: p.libelle || 'Projet sans titre'
                };
            }
        }

        const f = (n: number) => Number(n || 0).toFixed(3);

        const payload = {
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,
            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            entrepot_id: this.documentType === 'BON TRANSFERT' 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.documentType === 'BON TRANSFERT' && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),

            statut_id: this.getApproveStatutId(),

            client_data: !isAchat && this.selectedClient ? {
                client_id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || null,
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fornisseur_data: isAchat && this.selectedFournisseur ? {
                fournisseur_id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            } : null,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],

            parametrage_doc: this.buildParametrageDoc(),
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },
            lignes_document: this.prepareLignesDocumentForSave()
        };
        return payload;
    }

    cancelReference(): void {
        this.referenceSeedFromPopup = false;
        this.modalRef?.dismiss('Cancel');
    }

    increment(): void {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            const next = three.seq + 1;
            this.documentReference = `${three.prefix}-${three.year}-${next.toString().padStart(three.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            const next = ys.seq + 1;
            this.documentReference = `${ys.year}-${next.toString().padStart(ys.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            const next = yc.seq + 1;
            const calY = new Date().getFullYear();
            const refY = yc.year < calY ? calY : yc.year;
            this.documentReference = `${refY}${next.toString().padStart(yc.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            const next = sy.seq + 1;
            const calY = new Date().getFullYear();
            const refY = sy.year < calY ? calY : sy.year;
            this.documentReference = `${next.toString().padStart(sy.pad, '0')}-${refY}`;
            this.numericReference = next;
            return;
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            const next = ps.seq + 1;
            this.documentReference = `${ps.prefix}-${next.toString().padStart(ps.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            const next = so.seq + 1;
            this.documentReference = next.toString().padStart(so.pad, '0');
            this.numericReference = next;
            return;
        }
        const fmtYs = this.getModelReferenceFormatMeta();
        if (fmtYs?.kind === 'year_seq') {
            const prefix = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
            const reLegacy = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`, 'i');
            const mLeg = ref.match(reLegacy);
            if (mLeg) {
                const num = parseInt(mLeg[1], 10);
                const year = new Date().getFullYear();
                const next = num + 1;
                this.documentReference = `${year}-${next.toString().padStart(fmtYs.sequencePad, '0')}`;
                this.numericReference = next;
                return;
            }
        }
        const prefix = this.getReferencePrefix();
        const { num, pad } = this.parseReferenceCounterAndPadding();
        const next = num + 1;
        this.documentReference = `${prefix}-${next.toString().padStart(pad, '0')}`;
        this.numericReference = next;
    }

    decrement(): void {
        const ref = (this.documentReference || '').trim();
        const three = this.parseReferenceThreeSegmentParts(ref);
        if (three) {
            if (three.seq <= 1) {
                return;
            }
            const next = three.seq - 1;
            this.documentReference = `${three.prefix}-${three.year}-${next.toString().padStart(three.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const ys = this.parseReferenceYearSequenceParts(ref);
        if (ys) {
            if (ys.seq <= 1) {
                return;
            }
            const next = ys.seq - 1;
            this.documentReference = `${ys.year}-${next.toString().padStart(ys.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const yc = this.parseReferenceYearConcatParts(ref);
        if (yc) {
            if (yc.seq <= 1) {
                return;
            }
            const next = yc.seq - 1;
            this.documentReference = `${yc.year}${next.toString().padStart(yc.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const sy = this.parseReferenceSeqYearParts(ref);
        if (sy) {
            if (sy.seq <= 1) {
                return;
            }
            const next = sy.seq - 1;
            this.documentReference = `${next.toString().padStart(sy.pad, '0')}-${sy.year}`;
            this.numericReference = next;
            return;
        }
        const ps = this.parseReferencePrefixSequenceParts(ref);
        if (ps) {
            if (ps.seq <= 1) {
                return;
            }
            const next = ps.seq - 1;
            this.documentReference = `${ps.prefix}-${next.toString().padStart(ps.pad, '0')}`;
            this.numericReference = next;
            return;
        }
        const so = this.parseReferenceSeqOnlyParts(ref);
        if (so) {
            if (so.seq <= 1) {
                return;
            }
            const next = so.seq - 1;
            this.documentReference = next.toString().padStart(so.pad, '0');
            this.numericReference = next;
            return;
        }
        const fmtYs = this.getModelReferenceFormatMeta();
        if (fmtYs?.kind === 'year_seq') {
            const prefix = this.getReferencePrefix().replace(/-+$/, '').trim() || 'DOC';
            const reLegacy = new RegExp(`^${this.escapeRegExp(prefix)}-(\\d+)$`, 'i');
            const mLeg = ref.match(reLegacy);
            if (mLeg) {
                const num = parseInt(mLeg[1], 10);
                if (num <= 1) {
                    return;
                }
                const year = new Date().getFullYear();
                const next = num - 1;
                this.documentReference = `${year}-${next.toString().padStart(fmtYs.sequencePad, '0')}`;
                this.numericReference = next;
                return;
            }
        }
        const prefix = this.getReferencePrefix();
        const { num, pad } = this.parseReferenceCounterAndPadding();
        if (num <= 1) {
            return;
        }
        const next = num - 1;
        this.documentReference = `${prefix}-${next.toString().padStart(pad, '0')}`;
        this.numericReference = next;
    }
    incrementQuantity(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            const currentQty = parseFloat(item.quantity?.toString() || '0');
            item.quantity = currentQty + 1;
            this.calculateTotal(index);
            if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
            }
        }
    }
    decrementQuantity(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            const currentQty = parseFloat(item.quantity?.toString() || '0');
            item.quantity = currentQty - 1;
            this.calculateTotal(index);
            if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                this.loadStockQuantity(item.product_id, item.reference || '', index);
            }
        }
    }
    incrementPrice(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            if (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') {
                const currentPrice = parseFloat(item.valeur_unitaire?.toString() || '0');
                item.valeur_unitaire = currentPrice + 1;
            } else {
                const currentPrice = parseFloat(item.priceHT?.toString() || '0');
                item.priceHT = currentPrice + 1;
            }
            this.calculateTotal(index);
        }
    }
    decrementPrice(index: number): void {
        const item = this.items[index];
        if (item && item.type === 'product') {
            if (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') {
                const currentPrice = parseFloat(item.valeur_unitaire?.toString() || '0');
                if (currentPrice > 0) {
                    item.valeur_unitaire = Math.max(0, currentPrice - 1);
                }
            } else {
                const currentPrice = parseFloat(item.priceHT?.toString() || '0');
                if (currentPrice > 0) {
                    item.priceHT = Math.max(0, currentPrice - 1);
                }
            }
            this.calculateTotal(index);
        }
    }

    isValidNumber(value: string): boolean {
        const v = (value || '').trim();
        if (v === '') {
            return false;
        }
        if (/^\d+$/.test(v)) {
            return true;
        }
        const prefix = this.getReferencePrefix();
        const pNorm = prefix.replace(/-+$/, '').trim() || 'DOC';

        const fmtMeta = this.getModelReferenceFormatMeta();
        if (fmtMeta?.kind === 'year_seq') {
            if (/^\d{4}-\d+$/.test(v)) {
                return true;
            }
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d+$`, 'i').test(v);
        }
        if (fmtMeta?.kind === 'year_concat_seq') {
            if (!/^\d{4}\d+$/.test(v)) {
                return false;
            }
            const y0 = parseInt(v.slice(0, 4), 10);
            return y0 >= 2000 && y0 <= 2099;
        }
        if (fmtMeta?.kind === 'seq_year') {
            return /^\d+-\d{4}$/.test(v);
        }
        if (fmtMeta?.kind === 'seq_only') {
            return /^\d+$/.test(v);
        }
        if (fmtMeta?.kind === 'prefix_seq') {
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d+$`, 'i').test(v);
        }

        if (this.getModelReferenceTemplateInfo()?.threeSegments) {
            return new RegExp(`^${this.escapeRegExp(pNorm)}-\\d{4}-\\d+$`, 'i').test(v);
        }

        const strict = new RegExp(`^${this.escapeRegExp(prefix)}-\\d+$`);
        if (strict.test(v)) {
            return true;
        }
        const match = v.match(/^(.+)-(\d+)$/);
        return match != null && !isNaN(parseInt(match[2], 10));
    }

    validateInput(input: any): void {
        this.cdr.markForCheck();
    }

    goToApercu(): void {
        this.saveModifiedFields();

        const buildAndNavigate = (previewPayload: any) => {
            const previewData = {
                isDraft: true,
                previewData: previewPayload,
                mode: this.mode,
                documentType: this.documentType
            };
            this.documentPreviewService.setPreviewData(previewData);

            const urlWithoutQuery = this.router.url.split('?')[0];
            const segments = urlWithoutQuery.split('/').filter(Boolean);
            const baseSegments = segments.slice(0, -1);
            const apercuPath: string[] = baseSegments.length > 0
                ? [...baseSegments, 'action', 'apercu']
                : (this.getBasePath().replace(/^\//, '') + '/action/apercu').split('/').filter(Boolean);

            this.router.navigate(apercuPath, {
                queryParams: { id: this.documentId || undefined },
                queryParamsHandling: 'merge'
            }).then(success => {
                if (!success) {
                    this.documentPreviewService.clear();
                }
            });
        };

        const runRefThenNavigate = () => {
            const data = this.buildPreviewDataForApercu();
            const refTrimmed = (this.documentReference || this.refExterne || '').trim();
            const refEmptyOrPlaceholder = refTrimmed === '' || /^0+$/.test(refTrimmed);
            const prefix = this.getReferencePrefix();
            const typeId = this.typeDocumentIdMap[this.documentType];

            if (refEmptyOrPlaceholder && this.stationId && typeId != null) {
                const uid = Number(this.currentUser?.id);
                if (Number.isFinite(uid) && uid > 0) {
                    this.documentService.getRefCounter(typeId, this.stationId, uid).subscribe({
                        next: (res: any) => {
                            const c = this.extractRefCounterFromApiResponse(res);
                            this.ensureTypeMetaRefCounter(c);
                            const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                            data.reference = ref;
                            data.ref_externe = ref;
                            data.ref_interne = ref;
                            buildAndNavigate(data);
                        },
                        error: () => {
                            const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                            data.reference = ref;
                            data.ref_externe = ref;
                            data.ref_interne = ref;
                            buildAndNavigate(data);
                        }
                    });
                } else {
                    const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                    data.reference = ref;
                    data.ref_externe = ref;
                    data.ref_interne = ref;
                    buildAndNavigate(data);
                }
            } else if (refEmptyOrPlaceholder) {
                const ref = this.buildInitialRefFromTypeMeta(this.documentType, prefix);
                data.reference = ref;
                data.ref_externe = ref;
                data.ref_interne = ref;
                buildAndNavigate(data);
            } else {
                buildAndNavigate(data);
            }
        };

        if (this.needsTypeDocumentsApiForRef()) {
            this.documentService.getTypeDocuments().subscribe({
                next: (res) => {
                    this.applyTypeDocumentsFromApi(res);
                    runRefThenNavigate();
                },
                error: () => runRefThenNavigate()
            });
        } else {
            runRefThenNavigate();
        }
    }

    private collectAjoutLignesBetweenProductsForApercu(productIndex: number, nextProductIndex: number): any[] {
        const result: any[] = [];
        let order = 1;
        for (let i = productIndex + 1; i < nextProductIndex; i++) {
            const item = this.items[i];
            if (!item) {
                continue;
            }
            if (item.type === 'text' || item.type === 'heading' ||
                item.type === 'separator' || item.type === 'subtotal') {
                const newLigne: any = {
                    contenu_text: '',
                    rubrique: '',
                    separateur: false,
                    sous_total: 0,
                    order
                };
                if (item.type === 'text') {
                    const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                    newLigne.contenu_text = content;
                } else if (item.type === 'heading') {
                    const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                    newLigne.rubrique = content;
                } else if (item.type === 'separator') {
                    newLigne.separateur = true;
                } else if (item.type === 'subtotal') {
                    const subTotal = (item.subTotal !== undefined && item.subTotal !== null) ? Number(item.subTotal) : 0;
                    newLigne.sous_total = subTotal;
                }
                result.push(newLigne);
                order++;
            }
        }
        return result;
    }

    private getWarehouseSnapshotForPreview(id: number | null | undefined): { id: number; nom: string } | null {
        if (id == null || id === undefined) {
            return null;
        }
        const w = this.warehouses.find((wh: any) => wh.id === id);
        return w ? { id: w.id, nom: w.nom || '--' } : null;
    }

    private buildPreviewWarehouseFields(): Record<string, any> {
        const isBonTransfert = this.documentType === 'BON TRANSFERT';
        const entrepotId = isBonTransfert ? this.selectedWarehouseInitialId : this.selectedWarehouseId;
        const entrepotSnap = this.getWarehouseSnapshotForPreview(entrepotId);
        if (!isBonTransfert) {
            return {
                entrepot_id: entrepotId ?? null,
                entrepot: entrepotSnap
            };
        }
        const destId = this.selectedWarehouseDestinationId;
        return {
            entrepot_id: entrepotId ?? null,
            entrepot_dest_id: destId ?? null,
            entrepot: entrepotSnap,
            entrepot_destination: this.getWarehouseSnapshotForPreview(destId)
        };
    }

    private buildPreviewCategoriesForApercu(): Array<{ nom: string; titre: string; libelle?: string }> {
        if (this.documentType !== 'FACTURE FOURNISSEUR') {
            return [];
        }
        const lib = (this.selectedCategorie || '').trim();
        if (!lib) {
            return [];
        }
        return [{ nom: lib, titre: lib, libelle: lib }];
    }

    private buildPreviewDataForApercu(): any {
        const isAchat = this.isAchatDocument();
        const productsWithIndex: { item: Item; index: number }[] = [];
        this.items.forEach((item, index) => {
            if (item.type === 'product' && item.designation?.trim()) {
                productsWithIndex.push({ item, index });
            }
        });

        const previewRef = this.refExterne || this.documentReference;
        const previewData = {
            id: this.documentId || null,
            client_id: !isAchat ? this.resolveDocumentClientId(this.selectedClient) : null,
            fournisseur_id: isAchat && this.selectedFournisseur ? this.selectedFournisseur.id : null,
            typeDocument: {titre: this.documentType},
            ...this.buildPreviewWarehouseFields(),
            reference: this.documentReference,
            ref_externe: previewRef,
            ref_interne: previewRef,
            date: this.documentDate,
            date_document: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || '',
            client_data: !isAchat && this.selectedClient ? {
                id: this.resolveDocumentClientId(this.selectedClient),
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                nom_prenom: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '--',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || '--',
                email: this.getEmailString(this.selectedClient.emails),
                adresse: this.getAdresseString(this.selectedClient.adresses),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            } : null,

            fournisseur_data: isAchat && this.selectedFournisseur ? {
                id: this.selectedFournisseur.id,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '--',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '--',
                email: this.getEmailString(this.selectedFournisseur.emails),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                telephone: this.getTelephoneString(this.selectedFournisseur.telephones)
            } : null,

            projets: this.selectedProject ? [{
                id_projet: this.getProjetCode(),
                titre: this.selectedProject
            }] : [],

            lignesDocument: productsWithIndex.map(({ item: i, index: productIndex }, productIdx) => {
                const nextProductIndex = productIdx < productsWithIndex.length - 1
                    ? productsWithIndex[productIdx + 1].index
                    : this.items.length;
                const ajoutFromItems = this.collectAjoutLignesBetweenProductsForApercu(productIndex, nextProductIndex);
                const ajoutFallback = (i.ajout_ligne && i.ajout_ligne.length > 0)
                    ? i.ajout_ligne.map((ligne: any) => ({
                        contenu_text: ligne.contenu_text || '',
                        rubrique: ligne.rubrique || '',
                        separateur: ligne.separateur === true || ligne.separateur === 1 || ligne.separateur === 'true',
                        sous_total: Number(ligne.sous_total) || 0,
                        order: Number(ligne.order) || 0
                    }))
                    : [];
                const rawAjout = ajoutFromItems.length > 0 ? ajoutFromItems : ajoutFallback;
                const filteredAjout = rawAjout.filter((al: any) =>
                    al.separateur ||
                    (Number(al.sous_total) > 0) ||
                    (al.contenu_text && String(al.contenu_text).trim().length > 0) ||
                    (al.rubrique && String(al.rubrique).trim().length > 0)
                );
                const prixUnitaire = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
                    ? (Number(i.valeur_unitaire) || 0)
                    : (Number(i.priceHT) || 0);
                const qnt = i.quantity !== null && i.quantity !== undefined ? i.quantity : 0;
                return {
                    libelle: i.designation,
                    qnt: qnt,
                    prix_ht: prixUnitaire,
                    valeur_unitaire: (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') ? prixUnitaire : undefined,
                    tva: Number(i.tva) || 0,
                    total_ht: qnt * prixUnitaire,
                    product_id: i.product_id || null,
                    ajout_ligne: filteredAjout.length > 0
                        ? filteredAjout.map((al: any, idx: number) => ({
                            contenu_text: al.contenu_text || '',
                            rubrique: al.rubrique || '',
                            separateur: !!al.separateur,
                            sous_total: Number(al.sous_total) || 0,
                            order: idx + 1
                        }))
                        : undefined
                };
            }),

            total_ht: this.totals.totalHT,
            total_tva: this.totals.totalTVA,
            total_ttc: this.totals.totalTTC,
            timbre_fiscal: this.getTimbreFiscalEffective(),
            net_payer: this.totals.netAPayer,

            categories: this.buildPreviewCategoriesForApercu(),

            categorie_libelle:
                this.documentType === 'FACTURE FOURNISSEUR' && (this.selectedCategorie || '').trim()
                    ? (this.selectedCategorie as string).trim()
                    : null,

            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            }
        };
        return previewData;
    }

    private isAchatDocument(): boolean {
        return ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR', 'AVOIR FOURNISSEUR'].includes(
            this.documentType
        );
    }

    /** Prix HT affiché sur les documents de vente : champ catalogue `prix_unitaires` (front-vente). */
    private resolveVenteDocumentPrixHtFromProduct(product: any): number {
        const pu = Number(product?.prix_unitaires);
        if (Number.isFinite(pu) && pu > 0) {
            return pu;
        }
        const resultHt = Number(product?.result_ht);
        if (Number.isFinite(resultHt) && resultHt > 0) {
            return resultHt;
        }
        const lp = product?.liste_prix;
        const liste = Array.isArray(lp) ? lp[0] : lp;
        const fromListe = Number(liste?.result_ht);
        if (Number.isFinite(fromListe) && fromListe > 0) {
            return fromListe;
        }
        return Number.isFinite(pu) ? pu : 0;
    }

    private resolveVenteDocumentPrixHtFromLigne(ligne: any): number {
        const pu = parseFloat(ligne?.prix_unitaires);
        if (!isNaN(pu) && pu > 0) {
            return pu;
        }
        const pv = parseFloat(ligne?.prix_vente);
        if (!isNaN(pv)) {
            return pv;
        }
        const resultHt = parseFloat(ligne?.result_ht);
        if (!isNaN(resultHt) && resultHt > 0) {
            return resultHt;
        }
        const prixHt = parseFloat(ligne?.prix_ht);
        return !isNaN(prixHt) ? prixHt : 0;
    }

    public shouldShowClient(): boolean {
        const docType = this.documentType;
        if (docType === 'INVENTAIRE' || docType === 'BON TRANSFERT') {
            return false;
        }
        if (docType === 'COMMANDE FOURNISSEUR'
            || docType === 'FACTURE FOURNISSEUR'
            || docType === 'AVOIR FOURNISSEUR'
            || docType === 'BON RECEPTION') {
            return false;
        }
        return true;
    }

    public shouldShowFournisseur(): boolean {
        const docType = this.documentType;
        if (docType === 'INVENTAIRE' || docType === 'BON TRANSFERT') {
            return false;
        }
        return docType === 'COMMANDE FOURNISSEUR'
            || docType === 'FACTURE FOURNISSEUR'
            || docType === 'AVOIR FOURNISSEUR'
            || docType === 'BON RECEPTION';
    }
    public shouldAlignDetailsRight(): boolean {
        return !this.shouldShowClient() && !this.shouldShowFournisseur();
    }

    private requiresStockUpdate(): boolean {
        const t = this.documentType;
        if (t === 'BON RECEPTION') {
            return this.currentStatutId === this.statutIdMap['Reçu'];
        }
        if (t === 'BON DE LIVRAISON') {
            return this.currentStatutId === this.statutIdMap['Livré'];
        }
        if (t === 'INVENTAIRE') {
            return false;
        }
        if (t === 'BON TRANSFERT') {
            return false;
        }
        return t === 'AVOIR' || t === 'AVOIR FOURNISSEUR';
    }

    private getMouvementStockDateAndRef(documentId: number | null): { formattedDate: string; referenceDoc: string | null } {
        let formattedDate = this.documentDate || new Date().toISOString().split('T')[0];
        if (!formattedDate.includes('T')) {
            formattedDate = `${formattedDate}T12:00:00Z`;
        }
        const referenceDoc = this.documentReference?.trim() || this.refExterne?.trim() || null;
        return { formattedDate, referenceDoc };
    }

    private extractValeurUnitaireProduitDepuisApi(product: any): number {
        const vu = parseFloat(String(product?.valeur_unitaire ?? '').replace(',', '.'));
        if (Number.isFinite(vu) && vu >= 0) {
            return vu;
        }
        const pa = parseFloat(String(product?.prix_unitaires ?? '').replace(',', '.'));
        if (Number.isFinite(pa) && pa >= 0) {
            return pa;
        }
        return 0;
    }

    private resolveQuantiteStockPourCmup(item: any, product?: any): number {
        const pid = item?.product_id;
        if (!pid) {
            return 0;
        }
        const entrepotId = this.shouldFilterStockByEntrepot() ? this.getEntrepotIdForStockQuantity() : null;
        const cacheKey = this.getStockCacheKey(pid, entrepotId);
        const cached = this.stockQuantitiesCache.get(cacheKey);
        if (cached !== undefined && Number.isFinite(Number(cached))) {
            return Math.max(0, Number(cached));
        }
        if (item?.availableQuantity != null) {
            const q = Number(item.availableQuantity);
            if (Number.isFinite(q)) {
                return Math.max(0, q);
            }
        }
        const p = product ?? {};
        const candidates = [
            p.quantity,
            p.quantite,
            p.stock_quantity,
            p.total_quantity,
            p?.data?.quantity
        ];
        for (const c of candidates) {
            if (c != null && c !== '') {
                const n = Number(c);
                if (Number.isFinite(n)) {
                    return Math.max(0, n);
                }
            }
        }
        return 0;
    }

    private getPrixUnitaireEntreeFactureFournisseurPourCmup(item: any, product?: any): number {
        if (this.paramDocBaseCalculPrixAchat === 'produit' && product != null) {
            const p = product?.data ?? product;
            const fromCard =
                Number(p?.prix_unitaires ?? p?.prix_achat ?? p?.valeur_unitaire ?? 0) || 0;
            if (fromCard > 0) {
                return fromCard;
            }
        }
        const pu = Number(item?.priceHT) || Number((item as any)?.prix_achat) || 0;
        const remisePct = Number(item?.remise || 0);
        if (!Number.isFinite(remisePct) || remisePct <= 0) {
            return pu;
        }
        return pu * (1 - remisePct / 100);
    }

    private logCmupValeurUnitaireDetail(
        source: 'sauvegarde-approbation' | 'saisie-ligne',
        item: any,
        parts: {
            valeur_unitaire_produit: number;
            quantite_stock: number;
            prix_ht_brut: number;
            remise_pct: number;
            prix_entree_unitaire_net: number;
            quantite_entree: number;
            resultat: number | null;
        }
    ): void {
        const pid = item?.product_id;
        const libelle = (item?.designation && String(item.designation).trim()) || `produit #${pid}`;
        const n =
            parts.valeur_unitaire_produit * parts.quantite_stock +
            parts.prix_entree_unitaire_net * parts.quantite_entree;
        const d = parts.quantite_stock + parts.quantite_entree;

    }

    private computeCmupValeurUnitaireFactureFournisseur(product: any, item: any): number | null {
        const prixEntreeUnitaire = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
        const quantiteEntree =
            item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        const prixHtBrut = Number(item.priceHT) || 0;
        const remisePct = Number(item.remise || 0);
        if (quantiteEntree <= 0) {
            return null;
        }
        const valeur_unitaire_precedent = this.extractValeurUnitaireProduitDepuisApi(product);
        const quantite_stock = this.resolveQuantiteStockPourCmup(item, product);
        const denom = quantite_stock + quantiteEntree;
        const valeur_unitaire_nouveau =
            denom > 0
                ? (valeur_unitaire_precedent * quantite_stock + prixEntreeUnitaire * quantiteEntree) / denom
                : prixEntreeUnitaire;
        const rounded = Number(Number(valeur_unitaire_nouveau).toFixed(3));
        if (isNaN(rounded) || rounded < 0) {
            this.logCmupValeurUnitaireDetail('sauvegarde-approbation', item, {
                valeur_unitaire_produit: valeur_unitaire_precedent,
                quantite_stock,
                prix_ht_brut: prixHtBrut,
                remise_pct: remisePct,
                prix_entree_unitaire_net: prixEntreeUnitaire,
                quantite_entree: quantiteEntree,
                resultat: null
            });
            return null;
        }
        this.logCmupValeurUnitaireDetail('sauvegarde-approbation', item, {
            valeur_unitaire_produit: valeur_unitaire_precedent,
            quantite_stock,
            prix_ht_brut: prixHtBrut,
            remise_pct: remisePct,
            prix_entree_unitaire_net: prixEntreeUnitaire,
            quantite_entree: quantiteEntree,
            resultat: rounded
        });
        return rounded;
    }

    private getProductPutMandatoryIds(): { station_id: number; client_id: number } {
        const station_id = Number(this.stationId) || 0;
        const client_id = this.isAchatDocument()
            ? Number(this.selectedFournisseurId) || 0
            : Number(this.selectedClientId ?? this.selectedClient?.id) || 0;
        return { station_id, client_id };
    }

    private updateProductsValeurUnitaireForFactureFournisseur(): void {
        if (this.documentType !== 'FACTURE FOURNISSEUR') {
            return;
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.product_id && i.designation?.trim());
        if (productItems.length === 0) {
            return;
        }
        const putIds = this.getProductPutMandatoryIds();
        const updates: Observable<any>[] = productItems.map((item) =>
            this.productsService.getDetailsProduct(item.product_id!).pipe(
                catchError(() => of({ data: {} } as any)),
                switchMap((res: any) => {
                    const product = res?.data ?? res;
                    const valueToSend = this.computeCmupValeurUnitaireFactureFournisseur(product, item);
                    if (valueToSend === null) {
                        return of(null);
                    }
                    if (!this.paramDocMajPrixAchatProduit) {
                        return this.productsService.updateProductValeurUnitaire(item.product_id!, valueToSend, putIds).pipe(
                            catchError(() => {
                                return this.productsService.getDetailsProduct(item.product_id!).pipe(
                                    switchMap((productRes: any) => {
                                        const productData = productRes?.data ?? productRes;
                                        return this.productsService.updateProduct(
                                            item.product_id!,
                                            {
                                                ...productData,
                                                valeur_unitaire: valueToSend
                                            },
                                            putIds
                                        );
                                    }),
                                    catchError(() => {
                                        this.toastr.warning(
                                            `Mise à jour valeur_unitaire impossible pour un produit (vérifier le backend).`,
                                            '',
                                            { timeOut: 5000 }
                                        );
                                        return of(null);
                                    })
                                );
                            })
                        );
                    }
                    const lignePu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
                    return this.productsService
                        .updateProduct(
                            item.product_id!,
                            {
                                ...product,
                                valeur_unitaire: valueToSend,
                                prix_unitaires: lignePu
                            },
                            putIds
                        )
                        .pipe(
                            catchError(() => {
                                return this.productsService.getDetailsProduct(item.product_id!).pipe(
                                    switchMap((productRes: any) => {
                                        const productData = productRes?.data ?? productRes;
                                        const lu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productData);
                                        return this.productsService.updateProduct(
                                            item.product_id!,
                                            {
                                                ...productData,
                                                valeur_unitaire: valueToSend,
                                                prix_unitaires: lu
                                            },
                                            putIds
                                        );
                                    }),
                                    catchError(() => {
                                        this.toastr.warning(
                                            `Mise à jour valeur_unitaire impossible pour un produit (vérifier le backend).`,
                                            '',
                                            { timeOut: 5000 }
                                        );
                                        return of(null);
                                    })
                                );
                            })
                        );
                })
            )
        );
        forkJoin(updates).subscribe({

            error: () => {
                this.toastr.warning('Erreur lors de la mise à jour de la valeur_unitaire des produits.', '', { timeOut: 5000 });
            }
        });
    }

    /** Sortie LC (−stock_physique, −stock_disponible) au « Livrer » bon de livraison. */
    private updateLcStockForBonLivraisonAfterLivre(documentId: number, onComplete?: () => void): void {
        const lcEntrepotId = this.resolveLcEntrepotIdFromSelection(this.selectedWarehouseId);
        if (!lcEntrepotId) {
            this.toastr.warning(
                'Entrepôt logiciel caisse manquant : le stock physique/disponible n\'a pas été mis à jour.',
                'Stock',
                { timeOut: 7000 }
            );
            onComplete?.();
            return;
        }

        const productLignes = (this.items || []).filter(
            (it) =>
                it?.type === 'product' &&
                !!String(it.designation ?? '').trim() &&
                it.product_id != null &&
                (Number(it.quantity) || 0) > 0
        );

        if (!productLignes.length) {
            this.toastr.warning('Aucune ligne produit : stock non mis à jour.', 'Stock');
            onComplete?.();
            return;
        }

        const refDoc =
            String(this.documentReference || this.refExterne || '').trim() ||
            `BON DE LIVRAISON #${documentId}`;

        forkJoin(
            productLignes.map((item) => {
                const qnt = Number(item.quantity) || 0;
                const lineCb = String(item.code_barre ?? '')
                    .replace(/\s/g, '')
                    .trim();
                const lineRef = String(item.reference ?? '').trim();
                const libelle = String(item.designation ?? '').trim() || null;

                if (lineCb && lineCb !== '0' && lineCb !== '-') {
                    return of({
                        code_barre: lineCb,
                        ref_interne: lineRef && lineRef !== '-' ? lineRef : null,
                        qnt,
                        libelle,
                    });
                }

                const productId = Number(item.product_id);
                if (!Number.isFinite(productId) || productId <= 0) {
                    return of({
                        code_barre: null,
                        ref_interne: lineRef && lineRef !== '-' ? lineRef : null,
                        qnt,
                        libelle,
                    });
                }

                return this.productsService.getDetailsProduct(productId).pipe(
                    map((product: any) => {
                        const p = product?.data || product || {};
                        const cb = String(p.code_barre ?? p.code_bar ?? '')
                            .replace(/\s/g, '')
                            .trim();
                        const ref = String(p.ref_interne || p.reference || lineRef || '').trim();
                        return {
                            code_barre: cb && cb !== '0' && cb !== '-' ? cb : null,
                            ref_interne: ref && ref !== '-' ? ref : null,
                            qnt,
                            libelle: libelle || String(p.nom || '').trim() || null,
                        };
                    }),
                    catchError(() =>
                        of({
                            code_barre: null,
                            ref_interne: lineRef && lineRef !== '-' ? lineRef : null,
                            qnt,
                            libelle,
                        })
                    )
                );
            })
        )
            .pipe(
                switchMap((rows: Array<LcBonReceptionEntreeLigne | null>) => {
                    const lignes: LcBonReceptionEntreeLigne[] = (rows || []).filter(
                        (r): r is LcBonReceptionEntreeLigne =>
                            !!r &&
                            Number(r.qnt) > 0 &&
                            !!(r.code_barre || r.ref_interne)
                    );
                    if (!lignes.length) {
                        return throwError(
                            () =>
                                new Error(
                                    'Aucun code-barres / référence sur les lignes. Renseignez le code-barres produit.'
                                )
                        );
                    }
                    return this.lcStockReception.sortieBonLivraisonByBarcode({
                        entrepot_id: lcEntrepotId,
                        reference_document: refDoc,
                        lignes,
                    });
                }),
                finalize(() => onComplete?.())
            )
            .subscribe({
                next: (res) => {
                    if (res?.already_applied) {
                        this.toastr.info(
                            'Stock déjà mis à jour pour ce bon de livraison (pas de double sortie).',
                            'Stock'
                        );
                    } else {
                        this.toastr.success(
                            `Stock diminué pour ${res?.updated ?? 0} produit(s) (physique + disponible)`,
                            'Succès'
                        );
                    }
                    this.invalidateDocumentStockDisplayCache();
                    this.cdr.markForCheck();
                },
                error: (err) => {
                    const msg =
                        typeof err === 'string'
                            ? err
                            : err?.message || err?.error?.message || '';
                    this.toastr.error(
                        msg || 'Échec de la sortie stock à la livraison',
                        'Erreur',
                        { timeOut: 12000 }
                    );
                },
            });
    }

    private updateStockForDocument(
        documentId: number,
        onComplete?: () => void,
        stockDocumentTypeOverride?: string
    ): void {
        const docTypeForStock = stockDocumentTypeOverride ?? this.documentType;
        const stockTypeRequiresUpdate = (): boolean => {
            const t = docTypeForStock;
            return (
                t === 'BON DE LIVRAISON' ||
                t === 'BON RECEPTION' ||
                t === 'INVENTAIRE' ||
                t === 'AVOIR' ||
                t === 'AVOIR FOURNISSEUR'
            );
        };
        if (!stockTypeRequiresUpdate()) {
            return;
        }
        if (docTypeForStock === 'BON TRANSFERT') {
            return;
        }
        if (
            docTypeForStock === 'BON RECEPTION' &&
            this.currentStatutId !== this.statutIdMap['Reçu']
        ) {
            onComplete?.();
            return;
        }
        // BL : sortie stock uniquement si statut Livré (bouton Livrer).
        if (docTypeForStock === 'BON DE LIVRAISON') {
            if (this.currentStatutId !== this.statutIdMap['Livré']) {
                onComplete?.();
                return;
            }
        }
        if (docTypeForStock === 'INVENTAIRE') {
            onComplete?.();
            return;
        }

        const erpWarehouseId = this.resolveWarehouseIdForStockUpdate();
        if (!erpWarehouseId) {
            if (
                docTypeForStock === 'AVOIR' ||
                docTypeForStock === 'AVOIR FOURNISSEUR' ||
                docTypeForStock === 'BON RECEPTION' ||
                docTypeForStock === 'BON DE LIVRAISON'
            ) {
                this.toastr.warning(
                    'Entrepôt manquant : sélectionnez un entrepôt pour mettre à jour le stock.',
                    'Stock',
                    { timeOut: 7000 }
                );
            }
            onComplete?.();
            return;
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);

        if (productItems.length === 0) {
            onComplete?.();
            return;
        }


        const mouvementType = docTypeForStock;
        const stockUpdates: Observable<any>[] = [];

        productItems.forEach((item, index) => {
            const qteRaw = item.quantity ?? item.qnt;
            if (!item.product_id || (qteRaw === null || qteRaw === undefined)) {
                return;
            }

            const quantite = Number(qteRaw) || 0;
            if (docTypeForStock !== 'INVENTAIRE' && quantite === 0) {
                return;
            }

            const productId = item.product_id;
            // Avoir : lignes souvent en négatif (conversion) — prix module stock en valeur absolue
            const prixVenteFromItem = Math.abs(Number(item.priceHT || 0));
            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    let prixVente = prixVenteFromItem;
                    
                    if (prixVente <= 0) {
                        if (productData.result_ht) {
                            prixVente = parseFloat(productData.result_ht);
                        } else if (productData.liste_prix) {
                            const listePrix = Array.isArray(productData.liste_prix) 
                                ? productData.liste_prix[0] 
                                : productData.liste_prix;
                            
                            if (listePrix?.result_ht) {
                                prixVente = parseFloat(listePrix.result_ht);
                            } else if (listePrix?.montant) {
                                prixVente = parseFloat(listePrix.montant);
                            }
                        }
                        if (prixVente <= 0 && productData.prix_unitaires) {
                            prixVente = parseFloat(productData.prix_unitaires);
                        }
                    }

                    if (
                        (docTypeForStock === 'BON RECEPTION' ||
                            docTypeForStock === 'AVOIR FOURNISSEUR' ||
                            docTypeForStock === 'AVOIR') &&
                        prixVente <= 0 &&
                        prixAchat > 0
                    ) {
                        prixVente = prixAchat;
                    }

                    if (
                        prixVente <= 0 &&
                        docTypeForStock !== 'BON RECEPTION' &&
                        docTypeForStock !== 'INVENTAIRE' &&
                        docTypeForStock !== 'AVOIR FOURNISSEUR' &&
                        docTypeForStock !== 'AVOIR'
                    ) {
                        return of(null);
                    }
                    
                    const refInterne =
                        String(
                            productData.ref_interne ||
                                productData.reference ||
                                item.reference ||
                                ''
                        ).trim() || `ERP-${productId}`;
                    const legacyFindProductObservable = this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((existingProduct: any) => {
                            if (existingProduct && existingProduct.id) {
                                const stockProductId = existingProduct.id;
                                return this.stockService.updateProductPrices(stockProductId, prixAchat, prixVente, productId).pipe(
                                    switchMap((updateResponse: any) => {
                                        const updatedStockProductId = updateResponse?.stockProductId || updateResponse?.data?.id || updateResponse?.id || updateResponse?.product?.id || stockProductId;
                                        return of(updatedStockProductId);
                                    }),
                                    catchError((updateError) => {
                                        return of(stockProductId);
                                    })
                                );
                            } else {
                                return this.stockService.createProduct({
                                    id: productId,
                                    ref_interne: refInterne,
                                    nom: productData.nom || item.designation || '',
                                    prix_achat: prixAchat,
                                    prix_vente: prixVente > 0 ? prixVente : Math.max(prixAchat, 0.001)
                                }).pipe(
                                    switchMap((createResponse: any) => {
                                        let stockProductId = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                        
                                        if (!stockProductId) {
                                            return throwError(() => new Error('ID du produit module stock non trouvé dans la réponse de création'));
                                        }
                                        
                                        return of(stockProductId);
                                    }),
                                    catchError((createError) => {
                                        if (createError.status === 400 && createError.error?.existing_product_id) {
                                            const existingStockProductId = createError.error.existing_product_id;
                                            return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                                switchMap((updateResponse: any) => {
                                                    const updatedStockProductId = updateResponse?.stockProductId || updateResponse?.data?.id || updateResponse?.id || updateResponse?.product?.id || existingStockProductId;
                                                    return of(updatedStockProductId);
                                                }),
                                                catchError((updateError) => {
                                                    return of(existingStockProductId);
                                                })
                                            );
                                        }

                                        return throwError(() => createError);
                                    })
                                );
                            }
                        }),
                        catchError((error) => {
                            return throwError(() => error);
                        })
                    );

                    const findProductObservable =
                        docTypeForStock === 'BON RECEPTION'
                            ? this.stockService
                                  .resolveStockTableProductIdFromErpId(productId, {
                                      entrepotIdForZeroStock: erpWarehouseId
                                  })
                                  .pipe(
                                      switchMap((resolvedId) => {
                                          if (resolvedId != null && Number(resolvedId) > 0) {
                                              return of(Number(resolvedId));
                                          }
                                          return legacyFindProductObservable;
                                      }),
                                      catchError(() => legacyFindProductObservable)
                                  )
                            : legacyFindProductObservable;
                    
                    const updatePriceObservable = findProductObservable;

                    return updatePriceObservable.pipe(
                        switchMap((stockProductId: number | null) => {

                            if (!stockProductId) {
                                return of({ success: false, productId: productId, error: 'ID du produit module stock manquant', step: 'stock_product_id_missing' });
                            }
                            
                            const finalStockProductId = stockProductId;
                            if (docTypeForStock === 'INVENTAIRE') {

                                return this.stockService.getStockByProductAndEntrepot(finalStockProductId, erpWarehouseId).pipe(
                                    catchError(() => of({ quantity: 0 })),
                                    switchMap((currentStock: any) => {
                                        const quantityStock = Number(currentStock?.quantity ?? currentStock?.qty ?? 0);
                                        const quantiteSaisie = quantite;
                                        const delta = quantiteSaisie - quantityStock;
                                        if (delta === 0) {
                                            return of({
                                                success: true,
                                                productId: productId,
                                                productLocalId: finalStockProductId,
                                                response: null,
                                                skippedNoDelta: true
                                            });
                                        }
                                        const stockApres = quantityStock + delta;
                                        const { formattedDate, referenceDoc } = this.getMouvementStockDateAndRef(documentId);
                                        return this.stockService.createMouvementStock({
                                            product_id: finalStockProductId,
                                            entrepot_id: erpWarehouseId,
                                            type: 'INVENTAIRE',
                                            quantite: delta,
                                            date: formattedDate,
                                            reference_document: referenceDoc,
                                            document_id: documentId || null,
                                            stock_avant: quantityStock,
                                            stock_apres: stockApres
                                        }).pipe(
                                            map((response: any) => ({
                                                success: true,
                                                productId: productId,
                                                productLocalId: finalStockProductId,
                                                response
                                            })),
                                            catchError((error) => {
                                                return of({
                                                    success: false,
                                                    productId: productId,
                                                    productLocalId: finalStockProductId,
                                                    error
                                                });
                                            })
                                        );
                                    })
                                );
                            }
                            const isBonLivraison = docTypeForStock === 'BON DE LIVRAISON';
                            const isAvoirType =
                                docTypeForStock === 'AVOIR' || docTypeForStock === 'AVOIR FOURNISSEUR';
                            const isAvoirFournisseur = docTypeForStock === 'AVOIR FOURNISSEUR';

                            const quantiteSortieStock = quantite < 0 ? quantite : -quantite;
                            const quantiteMouvement = isAvoirType
                                ? (isAvoirFournisseur ? quantite : -quantite)
                                : isBonLivraison
                                    ? quantiteSortieStock
                                    : quantite;

                            const { formattedDate, referenceDoc } = this.getMouvementStockDateAndRef(documentId);

                            return this.stockService.getStockByProductAndEntrepot(finalStockProductId, erpWarehouseId).pipe(
                                catchError(() => of({ quantity: 0 })),
                                switchMap((currentStock: any) => {
                                    const stockAvant = Number(currentStock?.quantity || 0);
                                    const stockApres = stockAvant + quantiteMouvement;
                                    return this.stockService.createMouvementStock({
                                        product_id: finalStockProductId,
                                        entrepot_id: erpWarehouseId,
                                        type: mouvementType,
                                        quantite: quantiteMouvement,
                                        date: formattedDate,
                                        reference_document: referenceDoc,
                                        document_id: documentId || null,
                                        stock_avant: stockAvant,
                                        stock_apres: stockApres
                                    }).pipe(
                                        catchError((error) => {
                                            throw error;
                                        })
                                    );
                                })
                            );
                        }),
                        catchError((error) => {
                            return of({ success: false, productId: productId, error: error?.error || error?.message || 'Erreur inconnue', step: 'stock_update' });
                        })
                    );
                }),
                catchError((error) => {
                    return of({ success: false, productId: productId, error: error?.error || error?.message || 'Erreur lors de la récupération du produit', step: 'product_fetch' });
                })
            );

            stockUpdates.push(productObservable);
        });
        if (stockUpdates.length > 0) {
            forkJoin(stockUpdates).pipe(
                finalize(() => {
                    if (docTypeForStock === 'BON RECEPTION') {
                        this.invalidateDocumentStockDisplayCache();
                    }
                    onComplete?.();
                })
            ).subscribe({
                next: (results) => {
                    const successResults = results.filter(r => {
                        if (r && typeof r === 'object' && 'success' in r) {
                            return r.success === true;
                        }
                        return r !== null && r !== undefined;
                    });
                    const errorResults = results.filter(r => {
                        if (r && typeof r === 'object' && 'success' in r) {
                            return r.success === false;
                        }
                        return r === null || r === undefined;
                    });

                    const successCount = successResults.length;
                    const errorCount = errorResults.length;

                    if (successCount === productItems.length) {
                        this.toastr.success(`Stock mis à jour pour ${successCount} produit(s)`, 'Succès');
                    } else if (successCount > 0) {
                        this.toastr.warning(`Stock partiellement mis à jour (${successCount}/${productItems.length})`, 'Attention');
                    } else {
                        this.toastr.error(`Aucune mise à jour de stock effectuée (${errorCount} erreur(s))`, 'Erreur');
                    }
                },
                error: (error) => {
                    const errorMessage = error?.error?.message || error?.message || 'Erreur inconnue';
                    this.toastr.error(`Erreur lors de la mise à jour du stock: ${errorMessage}`, 'Erreur');
                }
            });
        } else {
            onComplete?.();
        }
    }

    /** Vide le cache UI stock (document) et recharge après un BR « Reçu ». */
    private invalidateDocumentStockDisplayCache(): void {
        this.stockQuantitiesCache.clear();
        this.selectOptionStockByCacheKey.clear();
        this.selectOptionStockLoadingKeys.clear();
        this.items.forEach((item) => {
            if (item && 'availableQuantity' in item) {
                (item as Item).availableQuantity = undefined;
            }
        });
        this.products.forEach((p) => {
            (p as any).availableQuantity = undefined;
        });
        this.reloadStockQuantitiesForAllProducts();
        if (this.products.length > 0) {
            this.preloadStockQuantitiesForAllProducts();
        }
        this.preloadSelectStockTotalsForDocumentOptions();
        this.cdr.detectChanges();
    }

    private schedulePostDocumentStockAlerts(): void {
        const ids = [
            ...new Set(
                this.items
                    .filter((i) => i.type === 'product' && i.product_id)
                    .map((i) => Number(i.product_id))
            )
        ].filter((id) => !isNaN(id) && id > 0);
        if (ids.length === 0) {
            return;
        }
        const tasks = ids.map((pid) =>
            this.checkLogisticStockAlertForProduct$(pid).pipe(catchError(() => of(undefined)))
        );
        forkJoin(tasks).subscribe();
    }

    private checkLogisticStockAlertForProduct$(erpProductId: number): Observable<void> {
        return forkJoin({
            productRes: this.productsService.getDetailsProduct(erpProductId).pipe(
                catchError(() => of(null))
            ),
            snapshot: this.stockService.getStockAlertSnapshotByErpProductId(erpProductId).pipe(
                catchError(() => of(null))
            )
        }).pipe(
            switchMap(({ productRes, snapshot }) => {
                const product = this.unwrapProductFromApiResponse(productRes);
                if (!product || typeof product !== 'object') {
                    return of(undefined);
                }
                if (!snapshot) {
                    return of(undefined);
                }
                const lines = this.getProductLogisticsInfoArray(product);
                const nom = (product.nom || product.designation || `Produit #${erpProductId}`).toString().trim();
                const stocks = snapshot.stocksByEntrepot ?? [];
                const totalQty = Number(snapshot.totalQuantity ?? 0);
                const hasPerEntrepot = stocks.length > 0;

                for (const line of lines) {
                    const lineEidRaw = line.entrepot_id ?? line.entrepotId ?? line.warehouse_id;
                    const lineEid = Number(lineEidRaw);
                    if (isNaN(lineEid)) {
                        continue;
                    }
                    if (!this.isLogisticAlertEnabledOnLine(line)) {
                        continue;
                    }
                    const minVal = this.parseLogisticMinimum(line);
                    if (!Number.isFinite(minVal)) {
                        continue;
                    }
                    let qty: number;
                    if (hasPerEntrepot) {
                        const stockRow = stocks.find((s) => Number(s.entrepotId) === lineEid);
                        qty = stockRow != null ? Number(stockRow.quantity) : 0;
                    } else {
                        qty = totalQty;
                    }
                    if (!Number.isFinite(qty)) {
                        continue;
                    }
                    const seuilExactAtteint = this.nearlyEqualQty(qty, minVal);
                    const ruptureOuSousSeuil =
                        this.nearlyEqualQty(qty, 0) || (minVal > 0 && qty < minVal);
                    if (!seuilExactAtteint && !ruptureOuSousSeuil) {
                        continue;
                    }
                    const scope = hasPerEntrepot ? `entrepôt ${lineEid}` : 'total (tous entrepôts)';
                    const body = `« ${nom || 'Produit'} » — ${scope} : quantité ${qty}, minimum produit ${minVal}.`;
                    const userId = Number(this.currentUser?.id);
                    const stationId = Number(this.stationId);
                    const clientId = Number(
                        (this.currentUser as any)?.client_id ??
                            (this.currentUser as any)?.clientId ??
                            userId
                    );
                    if (userId && stationId) {
                        this.zone.run(() => {
                            this.appNotifications
                                .create({
                                    client_id: clientId || userId,
                                    station_id: stationId,
                                    user_id: userId,
                                    titre: 'Alerte stock',
                                    message: body,
                                    type: 'stock_minimum',
                                    erp_product_id: erpProductId,
                                    stock_product_id: snapshot.stockProductId ?? null,
                                    stock_id: snapshot.stockTableProductId ?? null,
                                    entrepot_id: lineEid
                                })
                                .subscribe();
                        });
                    }
                }
                return of(undefined);
            }),
            catchError(() => of(undefined))
        );
    }

    private createMouvementsStockForBonTransfert$(documentId: number): Observable<void> {
        if (this.documentType !== 'BON TRANSFERT' || !documentId) {
            return of(undefined);
        }
        if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
            return of(undefined);
        }
        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);
        if (productItems.length === 0) {
            return of(undefined);
        }
        const { referenceDoc } = this.getMouvementStockDateAndRef(documentId);
        const perProduct: Observable<any>[] = [];

        productItems.forEach((item) => {
            if (!item.product_id || item.quantity === null || item.quantity === undefined || item.quantity === 0) {
                return;
            }
            const productId = item.product_id;
            const quantite = Number(item.quantity);
            const prixVente = Number(item.priceHT || 0);

            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const refInterne = productData.ref_interne || productData.reference || item.reference || '';
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    const prixVenteStock = prixVente > 0 ? prixVente : (prixAchat > 0 ? prixAchat : 0.01);
                    if (!refInterne) {
                        return of(null);
                    }
                    return this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((stockProduct: any) => {
                            if (stockProduct?.id) {
                                return this.stockService.updateProductPrices(stockProduct.id, prixAchat, prixVenteStock, productId).pipe(
                                    switchMap(() => of(stockProduct.id)),
                                    catchError(() => of(stockProduct.id))
                                );
                            }
                            return this.stockService.createProduct({
                                id: productId,
                                ref_interne: refInterne,
                                nom: productData.nom || item.designation || '',
                                prix_achat: prixAchat,
                                prix_vente: prixVenteStock
                            }).pipe(
                                switchMap((createResponse: any) => {
                                    const id = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                    return id != null ? of(id) : of(null);
                                }),
                                catchError((createError: any) => {
                                    if (createError?.status === 400 && createError?.error?.existing_product_id) {
                                        const existingId = createError.error.existing_product_id;
                                        return this.stockService.updateProductPrices(existingId, prixAchat, prixVenteStock, productId).pipe(
                                            switchMap(() => of(existingId)),
                                            catchError(() => of(existingId))
                                        );
                                    }
                                    return of(null);
                                })
                            );
                        }),
                        switchMap((stockProductId: number | null) => {
                            if (!stockProductId) {
                                return of(null);
                            }
                            const entrepotInitialId = this.selectedWarehouseInitialId!;
                            const entrepotDestinationId = this.selectedWarehouseDestinationId!;
                            return this.stockService.transferStock({
                                entrepot_initial_id: entrepotInitialId,
                                entrepot_dest_id: entrepotDestinationId,
                                product_id: stockProductId,
                                quantity: quantite,
                                document_id: documentId,
                                reference_document: referenceDoc
                            }).pipe(
                                catchError((err) => {
                                    const msg = err?.error?.message || err?.message || 'Erreur transfert de stock';
                                    this.toastr.error(msg, 'Stock — transfert', { timeOut: 8000 });
                                    return of(null);
                                })
                            );
                        }),
                        catchError(() => of(null))
                    );
                }),
                catchError(() => of(null))
            );
            perProduct.push(productObservable);
        });

        if (perProduct.length === 0) {
            return of(undefined);
        }
        return from(perProduct).pipe(
            concatMap((obs) => obs),
            toArray(),
            map((results) => {
                const okCount = results.filter(r => r !== null && r !== undefined).length;
                if (okCount === perProduct.length) {
                    this.toastr.success('Transfert de stock enregistré pour le bon.', 'Stock', { timeOut: 3000 });
                } else if (okCount > 0) {
                    this.toastr.warning(
                        'Bon de transfert : certains mouvements de stock n’ont pas pu être enregistrés (réf. produit, prix, module stock).',
                        'Attention',
                        { timeOut: 6000 }
                    );
                } else {
                    this.toastr.warning(
                        'Bon de transfert : aucun mouvement de stock enregistré (vérifiez les lignes produit et les prix).',
                        'Attention',
                        { timeOut: 6000 }
                    );
                }
                return undefined;
            }),
            catchError((err) => {
                console.error('[Bon transfert] Flux mouvements-stock:', err);
                this.toastr.warning(
                    'Erreur lors de l’enregistrement des mouvements de stock.',
                    'Attention',
                    { timeOut: 5000 }
                );
                return of(undefined);
            })
        );
    }

    private transferStockForDocument(documentId: number): void {
        if (this.documentType !== 'BON TRANSFERT') {
            return;
        }

        if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
            return;
        }

        const productItems = this.items.filter(i => i.type === 'product' && i.designation?.trim() && i.product_id);
        productItems.forEach((item, idx) => {
            console.log(`🔄 [transferStockForDocument] Produit ${idx + 1}: product_id=${item.product_id}, quantity=${item.quantity}, designation=${item.designation}`);
        });
        
        if (productItems.length === 0) {
            return;
        }

        const stockTransfers: Observable<any>[] = [];

        productItems.forEach((item, index) => {
            if (!item.product_id || item.quantity === null || item.quantity === undefined || item.quantity === 0) {
                return;
            }

            const productId = item.product_id;
            const quantite = Number(item.quantity);
            const prixVente = Number(item.priceHT || 0);

            const productObservable = this.productsService.getDetailsProduct(productId).pipe(
                switchMap((product: any) => {
                    const productData = product.data || product;
                    const refInterne = productData.ref_interne || productData.reference || item.reference || '';
                    const prixAchat = parseFloat(productData.prix_unitaires || productData.prix_achat || 0);
                    
                    if (!refInterne) {

                        return of(null);
                    }
                    
                    if (prixVente <= 0) {
                        return of(null);
                    }

                    return this.stockService.getProductByRefInterne(refInterne).pipe(
                        switchMap((stockProduct: any) => {
                            let stockProductId: number | null = null;
                            
                            if (stockProduct && stockProduct.id) {
                                const existingStockProductId = stockProduct.id;

                                return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                    switchMap(() => of(existingStockProductId)),
                                    catchError(() => of(existingStockProductId))
                                );
                            } else {

                                return this.stockService.createProduct({
                                    id: productId,
                                    ref_interne: refInterne,
                                    nom: productData.nom || item.designation || '',
                                    prix_achat: prixAchat,
                                    prix_vente: prixVente
                                }).pipe(
                                    switchMap((createResponse: any) => {
                                        const createdStockProductId = createResponse?.stockProductId || createResponse?.data?.id || createResponse?.id || createResponse?.product?.id;
                                        
                                        if (!createdStockProductId) {
                                            return of(null);
                                        }
                                        
                                        return of(createdStockProductId);
                                    }),
                                    catchError((createError) => {
                                        if (createError.status === 400 && createError.error?.existing_product_id) {
                                            const existingStockProductId = createError.error.existing_product_id;
                                            return this.stockService.updateProductPrices(existingStockProductId, prixAchat, prixVente, productId).pipe(
                                                switchMap(() => of(existingStockProductId)),
                                                catchError(() => of(existingStockProductId))
                                            );
                                        }

                                        return of(null);
                                    })
                                );
                            }
                        }),
                        switchMap((stockProductId: number | null) => {
                            if (!stockProductId) {
                                return of(null);
                            }

                            if (!this.selectedWarehouseInitialId || !this.selectedWarehouseDestinationId) {
                                return of(null);
                            }

                            return this.stockService.transferStock({
                                entrepot_initial_id: this.selectedWarehouseInitialId,
                                entrepot_dest_id: this.selectedWarehouseDestinationId,
                                product_id: stockProductId,
                                quantity: quantite
                            }).pipe(
                                catchError((transferError) => {
                                    return of(null);
                                })
                            );
                        }),
                        catchError((error) => {
                            return of(null);
                        })
                    );
                }),
                catchError((error) => {
                    return of(null);
                })
            );

            stockTransfers.push(productObservable);
        });

        if (stockTransfers.length > 0) {
            forkJoin(stockTransfers).subscribe({
                next: (results) => {
                    const successCount = results.filter(r => r !== null && r !== undefined).length;
                    if (successCount === productItems.length) {
                        this.toastr.success(`Stock transféré pour ${successCount} produit(s)`, 'Succès');
                    } else if (successCount > 0) {
                        this.toastr.warning(`Transfert partiel (${successCount}/${productItems.length})`, 'Attention');
                    } else {
                        this.toastr.error('Aucun transfert de stock effectué', 'Erreur');
                    }
                },
                error: (error) => {
                    const errorMessage = error?.error?.message || error?.message || 'Erreur inconnue';
                    this.toastr.error(`Erreur lors du transfert de stock: ${errorMessage}`, 'Erreur');
                }
            });
        } else {
            console.warn('⚠️ [transferStockForDocument] Aucun transfert de stock à effectuer');
        }
    }

    private getProjetCode(): string {
        const p = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
        return p?.id?.toString() || '';
    }

    addItem(type: 'code_bar' | 'product' | 'text' | 'heading' | 'separator' | 'subtotal'): void {

        const hasClient = (this.selectedClientId !== null && this.selectedClientId !== undefined) || 
                         (this.selectedClient !== null && this.selectedClient !== undefined);
        const hasFournisseur = (this.selectedFournisseurId !== null && this.selectedFournisseurId !== undefined) || 
                               (this.selectedFournisseur !== null && this.selectedFournisseur !== undefined);

        const isStockDocument = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';

        if (type === 'product' && !hasClient && !hasFournisseur && !isStockDocument) {
            this.modalRef = this.modalService.open(this.warningModal, {
                ariaLabelledBy: 'modal-warning-title',
                centered: true,
                size: 'sm',
                windowClass: 'warning-modal-centered'
            });
            return;
        }

        switch (type) {
            case 'product':
                this.items.push({
                    type: 'product',
                    designation: '',
                    quantity: 0,
                    reference: '',
                    code_barre: '',
                    priceHT: 0,
                    tva: '0',
                    totalHT: 0
                });
                break;
            case 'text':
                this.items.push({ type: 'text', content: '' });
                break;
            case 'heading':
                this.items.push({ type: 'heading', content: '' });
                break;
            case 'separator':
                this.items.push({ type: 'separator' });
                break;
            case 'subtotal':
                const subTotal = this.calculateSubTotal();
                this.items.push({ type: 'subtotal', subTotal });
                break;
        }

        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
    }

    removeItem(index: number): void {
        if (index < 0 || index >= this.items.length) {
            return;
        }
        const indices = this.resolveProductLineIndicesToRemove(index)
            .filter((i) => i >= 0 && i < this.items.length)
            .sort((a, b) => b - a);
        if (indices.length === 0) {
            return;
        }

        const desKeysToClear = new Set<string>();
        const couleurKeysToClear = new Set<string>();
        for (const i of indices) {
            const it = this.items[i];
            if (it?.type !== 'product') {
                continue;
            }
            desKeysToClear.add(this.getProductLineGroupKey(i));
            couleurKeysToClear.add(this.getProductLineCouleurGroupKey(i));
        }

        for (const i of indices) {
            this.shiftLineMetaMapsForRemove(i);
            this.items.splice(i, 1);
        }

        for (const key of desKeysToClear) {
            this.expandedBarcodeGroups.delete(key);
            this.barcodeGroupLoaded.delete(key);
            delete this.barcodeGroupLoading[key];
            for (const ck of Array.from(this.expandedCouleurGroups)) {
                if (ck.startsWith(`${key}|c:`)) {
                    this.expandedCouleurGroups.delete(ck);
                }
            }
        }
        for (const ck of couleurKeysToClear) {
            this.expandedCouleurGroups.delete(ck);
        }

        this.rebuildProductsForDocumentSelect();
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    private resolveProductLineIndicesToRemove(index: number): number[] {
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return [index];
        }

        const desKey = this.getProductLineGroupKey(index);
        const members = this.getProductLineGroupMemberIndices(desKey);
        if (members.length <= 1) {
            return [index];
        }

        if (!this.expandedBarcodeGroups.has(desKey)) {
            return members.slice();
        }

        const colorMembers = this.getProductLineCouleurMemberIndices(index);
        const couleurKey = this.getProductLineCouleurGroupKey(index);
        if (
            colorMembers.length > 1 &&
            !this.expandedCouleurGroups.has(couleurKey) &&
            this.isProductLineCouleurHead(index)
        ) {
            return colorMembers.slice();
        }

        return [index];
    }

    getRemoveItemTitle(index: number): string {
        const indices = this.resolveProductLineIndicesToRemove(index);
        if (indices.length > 1) {
            const item = this.items[index];
            if (item?.type === 'product' && !this.isProductLineBarcodeGroupExpanded(index)) {
                return `Supprimer le groupement (${indices.length} produits)`;
            }
            if (
                item?.type === 'product' &&
                this.isProductLineBarcodeGroupExpanded(index) &&
                !this.isProductLineCouleurGroupExpanded(index)
            ) {
                return `Supprimer la couleur ${this.getProductLineCouleurNorm(index)} (${indices.length} produits)`;
            }
            return `Supprimer ${indices.length} lignes`;
        }
        return 'Supprimer';
    }

    private buildLigneDocumentAttributsProduit(row: any, barcodePickerProduct?: any | null): {
        code_bar: string | null;
        ref_interne: string | null;
        couleur: string | null;
        taille: string | null;
    } {
        const rawCb = row?.code_barre ?? row?.code_bar;
        const cbTrim = rawCb != null ? String(rawCb).trim() : '';
        const code_bar = cbTrim === '' || cbTrim === '0' ? null : cbTrim;

        const rawRef = row?.reference;
        const refTrim = rawRef != null ? String(rawRef).trim() : '';
        const ref_interne = refTrim === '' || refTrim === '-' ? null : refTrim;

        const rowCt = this.extractCouleurTailleFromProductLike(row);
        const pickCt = barcodePickerProduct
            ? this.extractCouleurTailleFromProductLike(barcodePickerProduct)
            : { couleur: '', taille: '' };
        const couleurStr = rowCt.couleur || pickCt.couleur;
        const tailleStr = rowCt.taille || pickCt.taille;
        const couleur = couleurStr !== '' ? couleurStr : null;
        const taille = tailleStr !== '' ? tailleStr : null;

        return { code_bar, ref_interne, couleur, taille };
    }

    private prepareLignesDocumentForSave(): any[] {
        try {
            this.items.forEach((_, idx) => this.hydrateItemVariantFieldsFromBarcodePicker(idx));
            const itemsCopy = JSON.parse(JSON.stringify(this.items));
            const productsWithIndex: Array<{product: any, index: number}> = [];
            itemsCopy.forEach((item: any, index: number) => {
                if (item.type === 'product' && item.designation?.trim()) {
                    productsWithIndex.push({ product: item, index });
                    item.ajout_ligne = [];
                }
            });

            
            if (productsWithIndex.length === 0) {
                return [];
            }
            productsWithIndex.forEach(({product, index: productIndex}, productIdx: number) => {
                const nextProductIndex = productIdx < productsWithIndex.length - 1 
                    ? productsWithIndex[productIdx + 1].index 
                    : itemsCopy.length;


                let order = 1;
                for (let i = productIndex + 1; i < nextProductIndex; i++) {
                    const item = itemsCopy[i];
                    
                    if (!item) {
                        continue;
                    }
                    if (item.type === 'text' || item.type === 'heading' || 
                        item.type === 'separator' || item.type === 'subtotal') {
                        const newLigne: any = {
                            contenu_text: '',
                            rubrique: '',
                            separateur: false,
                            sous_total: 0,
                            order: order
                        };

                        if (item.type === 'text') {
                            const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                            newLigne.contenu_text = content;
                        } else if (item.type === 'heading') {
                            const content = (item.content !== undefined && item.content !== null) ? String(item.content).trim() : '';
                            newLigne.rubrique = content;
                        } else if (item.type === 'separator') {
                            newLigne.separateur = true;
                        } else if (item.type === 'subtotal') {
                            const subTotal = (item.subTotal !== undefined && item.subTotal !== null) ? Number(item.subTotal) : 0;
                            newLigne.sous_total = subTotal;
                        }

                        product.ajout_ligne.push(newLigne);
                        order++;
                    }
                }
            });
            const result = productsWithIndex.map(({product: i, index: productIndex}) => {
                const sourceItem = this.items[productIndex];
                const prixUnitaire = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
                    ? Number(i.valeur_unitaire || 0)
                    : Number(i.priceHT || 0);
                const remiseValue = i.remise !== undefined && i.remise !== null ? Number(i.remise) : 0;
                const qnt = i.quantity !== null && i.quantity !== undefined ? Number(i.quantity) : 0;
                const htBrut = qnt * prixUnitaire;
                const montantRemise = remiseValue > 0 ? htBrut * (remiseValue / 100) : 0;
                const htNet = sourceItem?.htNet != null ? Number(sourceItem.htNet) : (htBrut - montantRemise);

                const montantTVA = sourceItem?.montantTVA != null ? Number(sourceItem.montantTVA) : 0;
                const ttcLigne = sourceItem?.ttcLigne != null ? Number(sourceItem.ttcLigne) : 0;
                const prixHT = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
                    ? prixUnitaire
                    : (Number((i as any).prixUnitaireRef) || prixUnitaire);
                const description = this.productDescriptions[productIndex] || '';
                const taxesProduit = (sourceItem && (sourceItem as any)['taxesProduit']) ? (sourceItem as any)['taxesProduit'] : (i['taxesProduit'] || []);
                const taxeIds = taxesProduit
                    .map((taxe: any) => this.getTaxIdForPayload(taxe))
                    .filter((id: number | null): id is number => id !== null && id !== undefined);
                const taxeArray = taxesProduit
                    .map((taxe: any) => this.getTaxObjectForPayload(taxe))
                    .filter((t: any): t is { id: number; taxes_id: number; nom: string; label: string } => t != null);
                let ajoutLignes: any[] | undefined = undefined;
                if (i.ajout_ligne && Array.isArray(i.ajout_ligne) && i.ajout_ligne.length > 0) {


                    ajoutLignes = i.ajout_ligne
                        .map((ligne: any, idx: number) => {
                            const ajoutLigne: any = {
                                contenu_text: (ligne.contenu_text !== undefined && ligne.contenu_text !== null) ? String(ligne.contenu_text) : '',
                                rubrique: (ligne.rubrique !== undefined && ligne.rubrique !== null) ? String(ligne.rubrique) : '',
                                separateur: ligne.separateur === true || ligne.separateur === 1 || ligne.separateur === 'true',
                                sous_total: (ligne.sous_total !== undefined && ligne.sous_total !== null) ? Number(ligne.sous_total) : 0,
                                order: (ligne.order !== undefined && ligne.order !== null) ? Number(ligne.order) : (idx + 1)
                            };
                            return ajoutLigne;
                        })
                        .filter((al: any) => {
                            const hasContent = al.separateur || 
                                al.sous_total > 0 || 
                                (al.contenu_text && al.contenu_text.trim().length > 0) || 
                                (al.rubrique && al.rubrique.trim().length > 0);

                            return hasContent;
                        });
                    if (ajoutLignes.length > 0) {
                        ajoutLignes.forEach((al: any, idx: number) => {
                            al.order = idx + 1;
                        });
                    } else {
                        ajoutLignes = undefined;

                    }
                } else {
                    console.log(`ℹ️ [prepareLignesDocumentForSave] Aucune ajout_ligne pour "${i.designation}"`);
                }

                const rowForMeta = sourceItem || i;
                const attrsLigne = this.buildLigneDocumentAttributsProduit(
                    rowForMeta,
                    this.barcodePickerModel[productIndex]
                );
                const ligneDoc: any = {
                    libelle: i.designation.trim(),
                    qnt: qnt,
                    prix_ht: prixHT.toFixed(3),
                    tva: Number(i.tva) || 0,
                    product_id: i.product_id || null,
                    taxe_id: taxeIds.length > 0 ? (taxeIds.length === 1 ? taxeIds[0] : taxeIds) : null,
                    taxe_ids: taxeIds,
                    taxe: taxeArray,
                    remise: remiseValue,
                    reference: i.reference || null,
                    code_bar: attrsLigne.code_bar,
                    ref_interne: attrsLigne.ref_interne,
                    couleur: attrsLigne.couleur,
                    taille: attrsLigne.taille,
                    total_ht: Number(htNet).toFixed(3),
                    montant_tva: Number(montantTVA).toFixed(3),
                    ttc_ligne: Number(ttcLigne).toFixed(3)
                };
                if (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') {
                    ligneDoc.valeur_unitaire = prixUnitaire.toFixed(3);
                } else if (this.documentType === 'FACTURE FOURNISSEUR') {
                    ligneDoc.prix_achat = prixUnitaire.toFixed(3);
                } else {
                    if (this.isAchatDocument()) {
                        ligneDoc.prix_achat = prixUnitaire.toFixed(3);
                    } else {
                        ligneDoc.prix_vente = prixUnitaire.toFixed(3);
                    }
                }
                if (ajoutLignes !== undefined && ajoutLignes !== null && ajoutLignes.length > 0) {
                    ligneDoc.ajout_ligne = ajoutLignes;
                } else {
                    ligneDoc.ajout_ligne = [];

                }
                if (description && description.trim()) {
                    ligneDoc.description = description.trim();
                }

                return ligneDoc;
            });

            return result;
        } catch (error) {
            this.items.forEach((_, idx) => this.hydrateItemVariantFieldsFromBarcodePicker(idx));
            return this.items
                .map((i, idx) => ({ i, idx }))
                .filter(({ i }) => i.type === 'product' && i.designation?.trim())
                .map(({ i, idx }) => {
                    const taxesProduit = i['taxesProduit'] || [];
                    const taxeIds = taxesProduit
                        .map((taxe: any) => this.getTaxIdForPayload(taxe))
                        .filter((id: number | null): id is number => id !== null && id !== undefined);
                    const taxeArray = taxesProduit
                        .map((taxe: any) => this.getTaxObjectForPayload(taxe))
                        .filter((t: any): t is { id: number; taxes_id: number; nom: string; label: string } => t != null);
                    const qnt = i.quantity !== null && i.quantity !== undefined ? Number(i.quantity) : 0;
                    const prixUnitaireFallback = Number(i.priceHT || 0);
                    const prixUnitaireRefFallback = Number((i as any).prixUnitaireRef);
                    const remiseFallback = Number(i.remise || 0);
                    const htBrutFallback = qnt * prixUnitaireFallback;
                    const montantRemiseFallback = remiseFallback > 0 ? htBrutFallback * (remiseFallback / 100) : 0;
                    const htNet = i.htNet != null ? Number(i.htNet) : (htBrutFallback - montantRemiseFallback);
                    const montantTVA = i.montantTVA != null ? Number(i.montantTVA) : 0;
                    const ttcLigne = i.ttcLigne != null ? Number(i.ttcLigne) : 0;
                    const prixHtFallback = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
                        ? prixUnitaireFallback
                        : (prixUnitaireRefFallback || prixUnitaireFallback);
                    const attrsFb = this.buildLigneDocumentAttributsProduit(i, this.barcodePickerModel[idx]);
                    const out: any = {
                        libelle: i.designation!.trim(),
                        qnt: qnt,
                        prix_ht: prixHtFallback.toFixed(3),
                        tva: Number(i.tva) || 0,
                        product_id: i.product_id || null,
                        taxe_id: taxeIds.length > 0 ? (taxeIds.length === 1 ? taxeIds[0] : taxeIds) : null,
                        taxe_ids: taxeIds,
                        taxe: taxeArray,
                        remise: i.remise || 0,
                        reference: i.reference || null,
                        code_bar: attrsFb.code_bar,
                        ref_interne: attrsFb.ref_interne,
                        couleur: attrsFb.couleur,
                        taille: attrsFb.taille,
                        total_ht: Number(htNet).toFixed(3),
                        montant_tva: Number(montantTVA).toFixed(3),
                        ttc_ligne: Number(ttcLigne).toFixed(3),
                        ajout_ligne: i.ajout_ligne && i.ajout_ligne.length > 0 ? i.ajout_ligne.map((ligne: any) => ({
                            contenu_text: ligne.contenu_text || '',
                            rubrique: ligne.rubrique || '',
                            separateur: ligne.separateur || false,
                            sous_total: Number(ligne.sous_total) || 0,
                            order: Number(ligne.order) || 0
                        })) : undefined
                    };
                    if (this.documentType !== 'INVENTAIRE' && this.documentType !== 'BON TRANSFERT') {
                        if (this.isAchatDocument()) {
                            out.prix_achat = prixUnitaireFallback.toFixed(3);
                        } else {
                            out.prix_vente = prixUnitaireFallback.toFixed(3);
                        }
                    }
                    return out;
                });
        }
    }

    moveItemToFirst(index: number): void {
        if (index <= 0 || index >= this.items.length) {
            return;
        }
        this.moveDocumentLine(index, 0);
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.markForCheck();
    }
    draggedIndex: number | null = null;

    onDragStart(event: DragEvent, index: number): void {
        this.draggedIndex = index;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/html', index.toString());
        }
        if (event.target) {
            (event.target as HTMLElement).style.opacity = '0.5';
        }
    }

    onDragEnd(event: DragEvent): void {
        if (event.target) {
            (event.target as HTMLElement).style.opacity = '1';
        }
        this.draggedIndex = null;
    }

    onDragOver(event: DragEvent, index: number): void {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
        }
    }

    onDrop(event: DragEvent, dropIndex: number): void {
        event.preventDefault();
        if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
            return;
        }

        this.moveDocumentLine(this.draggedIndex, dropIndex);

        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.markForCheck();
        this.draggedIndex = null;
    }

    onDragEnter(event: DragEvent): void {
        event.preventDefault();
    }

    calculateSubTotal(): number {
        const subTotal = this.items
            .filter(item => item.type === 'product' && item.designation)
            .reduce((sum, item) => sum + (item.htNet ?? item.totalHT ?? 0), 0);
        return subTotal;
    }

    calculateTotal(index: number): void {
        const item = this.items[index];
        if (item.type === 'product' && item.designation) {
            if ((this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT') && item.product_id && item.quantity) {
                this.calculateAveragePurchasePrice(index, item);
                this.updateApproveButtonState();
                this.refreshFeatherIcons();

                if (this.documentType === 'INVENTAIRE' && item.product_id && this.selectedWarehouseId) {
                    const q = parseFloat(String(item.quantity ?? 0)) || 0;
                    const cacheKey = this.getStockCacheKey(item.product_id, this.selectedWarehouseId);
                    this.stockQuantitiesCache.set(cacheKey, q);
                }
                return;
            }
            if (this.documentType === 'FACTURE FOURNISSEUR' && item.product_id && item.quantity != null && item.quantity !== undefined) {
                this.calculateValeurUnitaireFactureFournisseur(index, item);
                return;
            }
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
        }
    }

    private calculateValeurUnitaireFactureFournisseur(index: number, item: any): void {
        if (!item.product_id || !this.stationId) {
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
            return;
        }
        const productHintListe = this.products.find((p) => p.id === item.product_id);
        const prixEntreeInitial = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productHintListe);
        const quantiteEntree = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        if (quantiteEntree <= 0) {
            this.calculateLine(index);
            this.calculateTotals();
            this.updateApproveButtonState();
            this.refreshFeatherIcons();
            return;
        }
        const valeurUnitaireBase = (item as any).valeurUnitaireBase;
        const hasBase = valeurUnitaireBase != null;
        const doApplyAndPatch = (
            valeur_unitaire_nouveau: number,
            _valeur_unitaire_precedent: number,
            _quantite_stock: number,
            productSnapshot?: any
        ) => {
            const valueToSend = Number(Number(valeur_unitaire_nouveau).toFixed(3));
            const putIds = this.getProductPutMandatoryIds();
            const applyLocal = () => this.applyValeurUnitaireAndRefresh(index, item, valeur_unitaire_nouveau);

            const doFullProductPut = (pd: any) => {
                const productData = pd?.data ?? pd;
                const lignePu = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productData);
                return this.productsService.updateProduct(
                    item.product_id!,
                    {
                        ...productData,
                        valeur_unitaire: valueToSend,
                        prix_unitaires: lignePu
                    },
                    putIds
                );
            };

            if (!this.paramDocMajPrixAchatProduit) {
                this.productsService
                    .updateProductValeurUnitaire(item.product_id!, valueToSend, putIds)
                    .pipe(
                        catchError(() =>
                            this.productsService.getDetailsProduct(item.product_id!).pipe(
                                switchMap((productRes: any) => {
                                    const productData = productRes?.data ?? productRes;
                                    return this.productsService.updateProduct(
                                        item.product_id!,
                                        {
                                            ...productData,
                                            valeur_unitaire: valueToSend
                                        },
                                        putIds
                                    );
                                }),
                                catchError(() => {
                                    this.toastr.warning(
                                        'Erreur lors de la mise à jour de la valeur_unitaire du produit.',
                                        '',
                                        { timeOut: 5000 }
                                    );
                                    return of(null);
                                })
                            )
                        )
                    )
                    .subscribe({ next: () => applyLocal() });
                return;
            }

            const src$ =
                productSnapshot != null
                    ? doFullProductPut(productSnapshot)
                    : this.productsService.getDetailsProduct(item.product_id!).pipe(switchMap((res) => doFullProductPut(res)));
            src$
                .pipe(
                    catchError(() =>
                        this.productsService.getDetailsProduct(item.product_id!).pipe(
                            switchMap((productRes: any) => doFullProductPut(productRes)),
                            catchError(() => {
                                this.toastr.warning(
                                    'Erreur lors de la mise à jour de la valeur_unitaire du produit.',
                                    '',
                                    { timeOut: 5000 }
                                );
                                return of(null);
                            })
                        )
                    )
                )
                .subscribe({ next: () => applyLocal() });
        };
        if (hasBase) {
            const valeur_unitaire_precedent = Number(valeurUnitaireBase) || 0;
            const quantite_stock = this.resolveQuantiteStockPourCmup(item);
            const prixEntree = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, productHintListe);
            const denom = quantite_stock + quantiteEntree;
            const valeur_unitaire_nouveau =
                denom > 0
                    ? (valeur_unitaire_precedent * quantite_stock + prixEntree * quantiteEntree) / denom
                    : prixEntree;
            const roundedVu = Number(valeur_unitaire_nouveau.toFixed(3));
            this.logCmupValeurUnitaireDetail('saisie-ligne', item, {
                valeur_unitaire_produit: valeur_unitaire_precedent,
                quantite_stock,
                prix_ht_brut: Number(item.priceHT) || 0,
                remise_pct: Number(item.remise || 0),
                prix_entree_unitaire_net: prixEntree,
                quantite_entree: quantiteEntree,
                resultat: roundedVu
            });
            doApplyAndPatch(roundedVu, valeur_unitaire_precedent, quantite_stock, productHintListe);
            return;
        }
        this.productsService
            .getDetailsProduct(item.product_id)
            .pipe(
                catchError(() => of({ valeur_unitaire: 0, quantity: 0 } as any)),
                map((res: any) => {
                    const product = res?.data ?? res;
                    const prixEntree = this.getPrixUnitaireEntreeFactureFournisseurPourCmup(item, product);
                    const valeur_unitaire_precedent = this.extractValeurUnitaireProduitDepuisApi(product);
                    const quantite_stock = this.resolveQuantiteStockPourCmup(item, product);
                    (item as any).valeurUnitaireBase = valeur_unitaire_precedent;
                    (item as any).quantiteStockBase = quantite_stock;
                    const denom = quantite_stock + quantiteEntree;
                    const valeur_unitaire_nouveau =
                        denom > 0
                            ? (valeur_unitaire_precedent * quantite_stock + prixEntree * quantiteEntree) / denom
                            : prixEntree;
                    const roundedVu = Number(valeur_unitaire_nouveau.toFixed(3));
                    return {
                        valeur_unitaire_nouveau: roundedVu,
                        valeur_unitaire_precedent,
                        quantite_stock,
                        productSnapshot: product,
                        prixEntree
                    };
                })
            )
            .subscribe({
                next: ({ valeur_unitaire_nouveau, valeur_unitaire_precedent, quantite_stock, productSnapshot, prixEntree }) => {
                    this.logCmupValeurUnitaireDetail('saisie-ligne', item, {
                        valeur_unitaire_produit: valeur_unitaire_precedent,
                        quantite_stock,
                        prix_ht_brut: Number(item.priceHT) || 0,
                        remise_pct: Number(item.remise || 0),
                        prix_entree_unitaire_net: prixEntree,
                        quantite_entree: quantiteEntree,
                        resultat: valeur_unitaire_nouveau
                    });
                    doApplyAndPatch(valeur_unitaire_nouveau, valeur_unitaire_precedent, quantite_stock, productSnapshot);
                },
                error: () => {
                    const valeur_unitaire_nouveau = prixEntreeInitial;

                    if (index >= 0 && index < this.items.length && this.items[index]) {
                        this.items[index].valeur_unitaire = valeur_unitaire_nouveau;
                        (this.items[index] as any).valeurUnitaireIsMoyennePonderee = false;
                    }
                    item.valeur_unitaire = valeur_unitaire_nouveau;
                    (item as any).valeurUnitaireIsMoyennePonderee = false;
                    this.calculateLine(index);
                    this.calculateTotals();
                    this.updateApproveButtonState();
                    this.refreshFeatherIcons();
                    this.cdr.detectChanges();
                }
            });
    }

    private applyValeurUnitaireAndRefresh(index: number, item: any, valeur_unitaire_nouveau: number): void {
        if (index >= 0 && index < this.items.length && this.items[index]) {
            this.items[index].valeur_unitaire = valeur_unitaire_nouveau;
            (this.items[index] as any).valeurUnitaireIsMoyennePonderee = true;
        }
        item.valeur_unitaire = valeur_unitaire_nouveau;
        (item as any).valeurUnitaireIsMoyennePonderee = true;
        this.calculateLine(index);
        this.calculateTotals();
        this.updateApproveButtonState();
        this.refreshFeatherIcons();
        this.cdr.detectChanges();
    }

    private calculateAveragePurchasePrice(index: number, item: any): void {
        if (!item.product_id || !this.stationId) {
            return;
        }
        const product = this.products.find(p => p.id === item.product_id);
        if (!product) {
            return;
        }

        const valeurModifieeUtilisateur = item.valeur_unitaire;
        const valeurUnitaireProduit = product.valeur_unitaire;
        const prixUnitairesProduit = product.prix_unitaires;
        const valeurProduitBackend = valeurUnitaireProduit || prixUnitairesProduit || 0;

        const valeurInitiale = (valeurModifieeUtilisateur && valeurModifieeUtilisateur > 0) 
            ? valeurModifieeUtilisateur 
            : valeurProduitBackend;
        const quantiteEntree = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        if (quantiteEntree === 0) {
            this.updateValeurUnitaire(index, item, valeurInitiale);
            return;
        }

        this.documentService.calculateValeurUnitaire(
            item.product_id,
            quantiteEntree,
            this.selectedWarehouseId || undefined,
            this.stationId,
            valeurInitiale
        ).pipe(
            catchError((error) => {
                this.stockService.getProductByProductId(item.product_id).pipe(
                    switchMap((stockProduct: any) => {
                        
                        if (!stockProduct || !stockProduct.id) {
                            return of({ quantiteEnStock: 0, valeurPrecedente: valeurInitiale });
                        }
                        
                        const stockProductId = stockProduct.id;
                        const entrepotId = this.selectedWarehouseId;

                        if (entrepotId) {
                            return this.stockService.getStockByProductAndEntrepot(stockProductId, entrepotId).pipe(
                                map((stock: any) => {
                                    const quantiteEnStock = Number(stock?.quantity || 0);
                                    const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                    const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                    const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                    return { quantiteEnStock, valeurPrecedente };
                                }),
                                catchError((error) => {
                                    return this.stockService.getTotalStockByProduct(stockProductId).pipe(
                                        map((totalQuantity: number) => {
                                            const quantiteEnStock = totalQuantity || 0;
                                            const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                            const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                            const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                            return { quantiteEnStock, valeurPrecedente };
                                        })
                                    );
                                })
                            );
                        } else {
                            return this.stockService.getTotalStockByProduct(stockProductId).pipe(
                                map((totalQuantity: number) => {
                                    const quantiteEnStock = totalQuantity || 0;
                                    const prixAchatStock = parseFloat(stockProduct.prix_achat);
                                    const valeurUnitaireStock = parseFloat(stockProduct.valeur_unitaire);
                                    const valeurPrecedente = prixAchatStock || valeurUnitaireStock || valeurInitiale;

                                    return { quantiteEnStock, valeurPrecedente };
                                })
                            );
                        }
                    }),
                    catchError(() => {
                        return of({ quantiteEnStock: 0, valeurPrecedente: valeurInitiale });
                    })
                ).subscribe({
                    next: (result: { quantiteEnStock: number, valeurPrecedente: number }) => {
                        const { quantiteEnStock, valeurPrecedente } = result;
                        const quantiteGlobale = quantiteEnStock + quantiteEntree;

                        let valeurCalculee: number;
                        if (quantiteGlobale <= 0) {
                            valeurCalculee = valeurInitiale;
                        } else {
                            const produit1 = valeurPrecedente * quantiteEnStock;
                            const produit2 = valeurInitiale * quantiteEntree;
                            const somme = produit1 + produit2;
                            const valeurMoyenne = somme / quantiteGlobale;
                            valeurCalculee = Number(valeurMoyenne.toFixed(3));

                        }
                        this.updateValeurUnitaire(index, item, valeurCalculee);
                    }
                });
                
                return of(null);
            })
        ).subscribe({
            next: (response: any) => {
                if (!response) {
                    return;
                }

                const valeurCalculeeBackend = response?.data?.valeur_unitaire || response?.valeur_unitaire || response?.data || response;
                const valeurCalculee = typeof valeurCalculeeBackend === 'number' ? valeurCalculeeBackend : parseFloat(valeurCalculeeBackend) || valeurInitiale;

                this.updateValeurUnitaire(index, item, valeurCalculee);
            },
            error: (error) => {
                this.updateValeurUnitaire(index, item, valeurInitiale);
            }
        });
    }

    private updateValeurUnitaire(index: number, item: any, nouvelleValeur: number): void {

        
        this.zone.run(() => {
            if (index >= 0 && index < this.items.length && this.items[index]) {
                const ancienneValeur = this.items[index].valeur_unitaire;
                this.items[index].valeur_unitaire = nouvelleValeur;
                const prixUnitaire = this.items[index].valeur_unitaire || 0;
                const quantity = this.items[index].quantity !== null && this.items[index].quantity !== undefined ? this.items[index].quantity : 0;
                this.items[index].totalHT = quantity * prixUnitaire;
                Object.assign(item, this.items[index]);

            } else {
                const ancienneValeur = item.valeur_unitaire;
                item.valeur_unitaire = nouvelleValeur;
                const prixUnitaire = item.valeur_unitaire || 0;
                item.totalHT = (item.quantity || 0) * prixUnitaire;

            }
            
            this.calculateTotals();
            this.updateApproveButtonState();

            this.cdr.markForCheck();
            this.cdr.detectChanges();
        });
        setTimeout(() => {
            this.zone.run(() => {
                if (index >= 0 && index < this.items.length && this.items[index]) {
                    const valeurActuelle = this.items[index].valeur_unitaire;
                    if (valeurActuelle !== nouvelleValeur) {
                        this.items[index].valeur_unitaire = nouvelleValeur;
                        Object.assign(item, this.items[index]);
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }
                }
            });
        }, 100);
    }
    
    calculateTotals(): void {
        this.items.forEach((item, index) => {
            if (item?.type === 'product') {
                this.calculateLine(index);
            }
        });

        const lignes = this.items.filter(i => i.type === 'product' && i.designation?.trim());

        this.totals.totalRemise = lignes.reduce((s, i) => s + (i.montantRemise || 0), 0);
        this.totals.totalHT = lignes.reduce((s, i) => s + (i.htNet || 0), 0);
        this.totals.totalTaxesAvantTVA = lignes.reduce((s, i) => s + (i.taxesAvantTVA || 0), 0);
        this.totals.totalBaseTVA = lignes.reduce((s, i) => s + (i.baseTVA || 0), 0);
        this.totals.totalTVA = lignes.reduce((s, i) => s + (i.montantTVA || 0), 0);
        this.totals.totalTaxesApresTVA = lignes.reduce((s, i) => s + (i.taxesApresTVA || 0), 0);
        this.totals.totalTTC = lignes.reduce((s, i) => s + (i.ttcLigne || 0), 0);
        const Total_TTC = this.totals.totalTTC;
        const Total_HT = this.totals.totalHT;
        this.totals.Base_RS = Total_TTC;
        const tauxRSDecimal = parseFloat(this.totals.Taux_RS || '0') / 100;
        this.totals.RS = this.totals.Base_RS * tauxRSDecimal;
        this.totals.retenueSource = this.totals.RS;
        this.totals.Net_à_payer = Total_TTC - this.totals.RS;

        const Total_TVA = this.totals.totalTVA;

        this.totals.documentLevelTaxLines = [];
        this.totals.taxesAfterHT = [];
        this.totals.taxesAfterTTC = [];
        this.totals.taxesAfterTimbre = [];
        this.totals.documentLevelTaxesTotal = 0;

        const allTaxes = (this.taxes || []).filter((t: any) => this.isTaxActiveForDocument(t));

        const taxIdsUsedOnLines = new Set<number>();
        (this.items || []).forEach((it: any) => {
            if (it.type !== 'product' || !it['taxesProduit']) return;
            (it['taxesProduit'] || []).forEach((t: any) => {
                const id = t.taxes_id ?? t.id;
                if (id != null) taxIdsUsedOnLines.add(Number(id));
            });
        });

        for (const tax of allTaxes) {
            const appliqueAvantTva = tax.applique_avant_tva === true || tax.applique_avant_tva === 1;
            const appliqueApresTva = tax.applique_apres_tva === true || tax.applique_apres_tva === 1;
            const appliqueTva = tax.applique_tva === true || tax.applique_tva === 1 || tax.applique_a_la_tva === true || tax.applique_a_la_tva === 1;
            const taxeSurProduits = tax.taxe_applique_sur_produits === true || tax.taxe_applique_sur_produits === 1;
            const valeurNum = Number(tax.valeur) || 0;
            const valeurPourcentage = tax.valeur_pourcentage === true || tax.valeur_pourcentage === 1;
            const isFixe = tax.valeur_fixe === true || tax.valeur_fixe === 1;
            const label = tax.label || tax.nom || 'Taxe';
            const taxId = tax.id != null ? Number(tax.id) : null;

            if (appliqueTva) {
                if (!this.isAvoirDocument()) {
                    const amount = isFixe ? valeurNum : (valeurPourcentage ? Total_TVA * (valeurNum / 100) : valeurNum);
                    this.totals.taxesAfterTimbre.push({ label, amount: Number(amount.toFixed(3)) });
                    this.totals.documentLevelTaxesTotal += amount;
                }
            } else if (appliqueAvantTva || taxeSurProduits) {
                if (taxeSurProduits && taxId != null && !taxIdsUsedOnLines.has(taxId)) {
                    continue;
                }
                let amount = 0;
                if (taxeSurProduits && taxId != null) {
                    (this.items || []).forEach((it: any) => {
                        if (it.type !== 'product' || !it['taxesProduit']) return;
                        const hasThisTax = (it['taxesProduit'] || []).some((t: any) => Number(t.taxes_id ?? t.id) === taxId);
                        if (!hasThisTax) return;
                        const listAvant = it.listeTaxesAvantTVA || [];
                        const listApres = it.listeTaxesApresTVA || [];
                        const labelNorm = (label || '').trim();
                        const matchAvant = listAvant.find((x: any) => Math.abs(Number(x.taux) - valeurNum) < 0.01 && ((x.nom || '').trim() === labelNorm || (x.nom || '') === (tax.nom || '')));
                        const matchApres = listApres.find((x: any) => Math.abs(Number(x.taux) - valeurNum) < 0.01 && ((x.nom || '').trim() === labelNorm || (x.nom || '') === (tax.nom || '')));
                        amount += (matchAvant?.montant || 0) + (matchApres?.montant || 0);
                    });
                } else if (isFixe) {
                    amount = valeurNum;
                } else if (valeurPourcentage) {
                    amount = Total_HT * (valeurNum / 100);
                } else {
                    amount = valeurNum;
                }
                this.totals.taxesAfterHT.push({ label, amount: Number(amount.toFixed(3)) });
                if (!taxeSurProduits) {
                    this.totals.documentLevelTaxesTotal += amount;
                }
            } else if (appliqueApresTva && !taxeSurProduits) {
                const amount = isFixe ? valeurNum : (valeurPourcentage ? Total_TTC * (valeurNum / 100) : valeurNum);
                this.totals.taxesAfterTTC.push({ label, amount: Number(amount.toFixed(3)) });
                this.totals.documentLevelTaxesTotal += amount;
            }
        }

        const sumTaxesAfterHT = this.totals.taxesAfterHT.reduce((s, t) => s + (t.amount || 0), 0);
        this.totals.totalTTC = Number((Total_HT + sumTaxesAfterHT + Total_TVA).toFixed(3));
        this.totals.Base_RS = this.totals.totalTTC;
        this.totals.RS = this.totals.Base_RS * tauxRSDecimal;
        this.totals.retenueSource = this.totals.RS;
        this.totals.Net_à_payer = Number((this.totals.totalTTC - this.totals.RS).toFixed(3));

        this.totals.documentLevelTaxLines = [
            ...this.totals.taxesAfterHT,
            ...this.totals.taxesAfterTTC,
            ...this.totals.taxesAfterTimbre
        ];
        this.totals.documentLevelTaxesTotal = Number(this.totals.documentLevelTaxesTotal.toFixed(3));
        const sumTimbreDynamique = this.totals.taxesAfterTimbre.reduce((s, t) => s + (t.amount || 0), 0);
        this.totals.timbreFiscal = this.isAvoirDocument() ? 0 : Number(sumTimbreDynamique.toFixed(3));
        this.totals.netAPayer = this.totals.Net_à_payer + this.totals.documentLevelTaxesTotal;

        this.updateTvaSummary();
        this.cdr.detectChanges();
    }

    updateApproveButtonState(): void {
        const hasClient = this.selectedClient !== null;
        const hasFournisseur = this.selectedFournisseur !== null;
        const hasProduct = this.items.some(i => i.type === 'product' && i.designation?.trim());
        const isStockDocument = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
        if (isStockDocument) {
            this.isApproveButtonDisabled = !hasProduct;
        } else {
            this.isApproveButtonDisabled = !(hasClient || hasFournisseur) || !hasProduct;
        }
        this.headerService.updateButtonState('Approuver', this.isApproveButtonDisabled);
    }

    public getBasePath(): string {
        const url = this.router.url || '';
        const ventePrefix = url.includes('/vente-negoce/') ? '/vente-negoce' : '/vente';
        if (url.includes(`${ventePrefix}/avoir/`)) {
            return `${ventePrefix}/avoir`;
        }
        if (url.includes('/achat/avoir-fournisseur/')) {
            return '/achat/avoir-fournisseur';
        }
        switch (this.documentType) {
            case 'DEVIS':
                return `${ventePrefix}/devis`;
            case 'COMMANDE CLIENT':
                return `${ventePrefix}/commande-client`;
            case 'BON DE SORTIE':
                return `${ventePrefix}/bon-sortie`;
            case 'BON DE LIVRAISON':
                return `${ventePrefix}/bon-livraison`;
            case 'FACTURE':
                return `${ventePrefix}/facture`;
            case 'AVOIR':
                return `${ventePrefix}/avoir`;
            case 'AVOIR FOURNISSEUR':
                return '/achat/avoir-fournisseur';
            case 'COMMANDE FOURNISSEUR':
                return '/achat/commande-fournisseur';
            case 'BON RECEPTION':
                return '/achat/bon-reception';
            case 'FACTURE FOURNISSEUR':
                return '/achat/facture-fournisseur';
            case 'INVENTAIRE':
                return '/inventaire';
            case 'BON TRANSFERT':
                return '/bon-transfert';
            default:
                return '/vente/devis';
        }
    }

    public getDocumentType(): string {
        const route = this.router.url;
        if (route.includes('/devis/')) {
            return 'Devis';
        }
        if (route.includes('/facture/')) {
            return 'Facture';
        }
        if (route.includes('/bon-livraison/')) {
            return 'Bon de livraison';
        }
        if (route.includes('/bon-sortie/')) {
            return 'Bon de sortie';
        }
        if (route.includes('/bon-reception/')) {
            return 'Bon de réception';
        }
        if (route.includes('/commande-client/')) {
            return 'Commande client';
        }
        if (route.includes('/commande-fournisseur/')) {
            return 'Commande fournisseur';
        }
        if (route.includes('/avoir/')) {
            return 'Avoir';
        }
        return 'Document';
    }
    private getTimbreFiscalEffective(): number {
        if (this.isAvoirDocument()) {
            return 0;
        }
        return Number(this.totals.timbreFiscal ?? 0);
    }
    toggleReadonly(field: string) {
        if (field === 'date') {
            this.isDateReadonly = !this.isDateReadonly;
        } else if (field === 'entrepot') {
            this.isEntrepotReadonly = !this.isEntrepotReadonly;
        } else if (field === 'entrepotInitial') {
            this.isEntrepotInitialReadonly = !this.isEntrepotInitialReadonly;
        } else if (field === 'entrepotDestination') {
            this.isEntrepotDestinationReadonly = !this.isEntrepotDestinationReadonly;
        } else if (field === 'dateLiv') {
            this.isDateLivReadonly = !this.isDateLivReadonly;
        } else if (field === 'refExterne') {
            // Règle générale : la référence ne se modifie jamais.
            this.isReferenceReadonly = true;
        } else if (field === 'project') {
            this.isProjectReadonly = !this.isProjectReadonly;
        } else if (field === 'categorie') {
            this.isCategorieReadonly = !this.isCategorieReadonly;
        } else if (field === 'note') {
            this.isNoteReadonly = !this.isNoteReadonly;
        }
        else if (field === 'nomClient') {
            this.isNameClientReadonly = !this.isNameClientReadonly;
        }
        else if (field === 'identifiant') {
            this.isIdentifiantReadonly = !this.isIdentifiantReadonly;
        }
        else if (field === 'adresse') {
            this.isAdressReadonly = !this.isAdressReadonly;
        }
        else if (field === 'telephone') {
            this.isTelephoneReadonly = !this.isTelephoneReadonly;
        }
        else if (field === 'email') {
            this.isEmailReadonly = !this.isEmailReadonly;
        }

        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
        if (field === 'date' || field === 'dateLiv') {
            this.syncFlatpickrReadonlyOnInstances();
        }
    }

    toggleTitleVisibility(): void {
        this.isTitleVisible = !this.isTitleVisible;
        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
    }
    private getDocumentTypeFromConversionLabel(label: string): string {
        const map: { [key: string]: string } = {
            'Commande': 'COMMANDE CLIENT',
            'Bon de livraison': 'BON DE LIVRAISON',
            'Facture': 'FACTURE',
            'Bon de réception': 'BON RECEPTION',
            'Facture fournisseur': 'FACTURE FOURNISSEUR',
            'Avoir': 'FACTURE'
        };
        return map[label] || this.getTypeFromId(0) || 'DEVIS';
    }

    private resolveAvoirDocumentTypeFromConversion(conversionFrom: any): 'AVOIR' | 'AVOIR FOURNISSEUR' {
        const url = String(this.router.url || '').toLowerCase();
        if (url.includes('avoir-fournisseur') || url.includes('/achat/facture-fournisseur')) {
            return 'AVOIR FOURNISSEUR';
        }
        const src = conversionFrom?.sourceDocument;
        const titre = String(
            src?.typeDocument?.titre || src?.type_document?.titre || conversionFrom?.newType || ''
        )
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        if (titre.includes('FOURNISSEUR')) {
            return 'AVOIR FOURNISSEUR';
        }
        return 'AVOIR';
    }

    private loadFormFromConversion(conversionFrom: any): void {
        this.conversionFromRef = {
            sourceId: conversionFrom.sourceId,
            newType: conversionFrom.newType,
            typeDocumentId: conversionFrom.typeDocumentId,
            statutId: conversionFrom.statutId,
            isAvoir: conversionFrom.isAvoir,
            totalsAvoir: conversionFrom.totalsAvoir
        };
        // Lien source → cible pour payload create / update et contrainte de reconversion
        this.documentOriginalId = conversionFrom.sourceId ?? null;

        const documentTypeOverride = conversionFrom.isAvoir
            ? this.resolveAvoirDocumentTypeFromConversion(conversionFrom)
            : this.getDocumentTypeFromConversionLabel(conversionFrom.newType);
        this.loadDocumentForDuplicate(conversionFrom.sourceId, {
            doc: conversionFrom.sourceDocument,
            documentType: documentTypeOverride,
            isAvoir: conversionFrom.isAvoir,
            totalsAvoir: conversionFrom.totalsAvoir
        });
        if (conversionFrom.isAvoir) {
            this.applySourceWarehouseFromDoc(conversionFrom.sourceDocument);
        }
    }

    /** Facture vente ERP préremplie depuis tickets caisse (ligne financière ou lignes produits). */
    private loadFormFromTicketFacture(payload: any): void {
        this.isLoadingEdit = true;
        this.isEditing = false;
        this.documentType = 'FACTURE';
        this.stationId = getStationIdFromLocalStorage() || this.stationId;
        const preferEtabId =
            Number(payload?.etablissementId) > 0 ? Number(payload.etablissementId) : null;
        if (payload?.etablissementLibelle) {
            this.stationName = String(payload.etablissementLibelle).trim();
        }
        this.refreshAvailableEtablissements(preferEtabId);
        this.loadStationData();
        this.loadCurrentTypeDocumentPrefixFromApi(this.typeDocumentIdMap['FACTURE']);

        // Mémorise la liaison tickets → facture à enregistrer après sauvegarde (les deux modes).
        // Par défaut markConsolide = true (transfert tické → consolidé).
        this.ticketFactureLink = Array.isArray(payload.ticketIds) && payload.ticketIds.length
            ? {
                  ticketIds: payload.ticketIds.map((x: any) => Number(x)).filter((n: number) => n > 0),
                  ticketCodes: Array.isArray(payload.ticketCodes) ? payload.ticketCodes : [],
                  markConsolide: payload.markConsolide !== false,
              }
            : null;

        const recette = payload.recetteProduct || {};
        const totalHt = Number(payload.total_ht) || 0;
        const tvaRate = Number(payload.tva_rate) || 19;
        const recetteLigne = {
            libelle: recette.nom || 'Recette',
            ref_interne: recette.ref_interne || 'LC_RECETTE',
            product_id: recette.id || null,
            qnt: 1,
            prix_ht: totalHt,
            prix_vente: totalHt,
            result_ht: totalHt,
            total_ht: totalHt,
            tva: tvaRate,
            tva_id: payload.tva19Id ?? recette.tva_id ?? null,
            remise: 0,
        };
        // Mode « lignes produits » : reprend le détail des tickets ; sinon ligne financière unique.
        const lignesToApply =
            payload.mode === 'product_lines' &&
            Array.isArray(payload.lignesProduits) &&
            payload.lignesProduits.length
                ? payload.lignesProduits
                : [recetteLigne];

        // Entrepôt des tickets (distinct de l'établissement POS).
        const ticketEntrepotId =
            payload?.entrepotId != null && Number(payload.entrepotId) > 0
                ? Number(payload.entrepotId)
                : null;
        this.loadWarehouses(ticketEntrepotId);

        // Uniquement les APIs nécessaires à la facture ticket (évite catégories/taxes/types redondants).
        forkJoin({
            clients: this.clientService.getActiveClient(this.stationId, 1, 100).pipe(
                catchError(() => of({ data: [] as Client[] }))
            ),
            caisse: this.fetchCaisseClientsForDocument(),
            products: this.fetchAllActiveProductsByStation(this.stationId),
            projects: this.projetService.getProjectsByIdStation(this.stationId),
            tva: this.tvaService.getTvaList(this.stationId),
        }).subscribe({
            next: ({ clients, caisse, products, projects, tva }: any) => {
                this.zone.run(() => {
                    this.clients = this.mergeErpClientsWithCaisse(clients?.data || [], caisse || []);
                    this.refreshClientsForSelect();
                    this.isLoadingClients = false;
                    const productsList = (Array.isArray(products) ? products : products?.data || []).map((p: any) =>
                        this.mapApiProductForDocumentSelect(p)
                    );
                    const recetteId = recette.id;
                    if (recetteId && !productsList.some((p: any) => Number(p.id) === Number(recetteId))) {
                        productsList.unshift({
                            ...recette,
                            prix_unitaires: totalHt,
                            valeur_unitaire: totalHt,
                        });
                    }
                    this.products = productsList;
                    this.isLoadingProducts = false;
                    this.projects = Array.isArray(projects) ? projects : projects?.projectsListe || [];
                    this.isLoadingProjects = false;
                    this.fournisseurs = [];
                    this.isLoadingFournisseurs = false;
                    this.tvaRates = tva?.tvaListe || [];
                    this.categories = [];
                    this.isLoadingCategories = false;
                    this.taxes = [];
                    this.documentReference = '';
                    // Note laissée vide : ne pas afficher le contenu repris du ticket.
                    this.note = '';
                    if (ticketEntrepotId != null) {
                        this.selectedWarehouseId = ticketEntrepotId;
                    }
                    this.applyItemsData(lignesToApply);
                    this.calculateTotals();
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                });
            },
            error: () => {
                this.toastr.error('Impossible de préparer la facture depuis les tickets.', 'Erreur');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
            },
        });
    }

    /**
     * Enregistre la liaison tickets caisse → facture ERP après création (référence + consolidé).
     * S'exécute uniquement si la facture provient d'un transfert de tickets (les deux modes).
     */
    private linkTicketsToErpFactureIfNeeded(erpFactureId: any, res: any): void {
        this.linkTicketsToErpFactureIfNeeded$(erpFactureId, res).subscribe();
    }

    private linkTicketsToErpFactureIfNeeded$(erpFactureId: any, res: any): Observable<unknown> {
        const link = this.ticketFactureLink;
        this.ticketFactureLink = null;
        if (!link || !link.ticketIds.length) {
            return of(null);
        }
        const erpCode =
            (this.documentReference || '').trim() ||
            (this.refExterne || '').trim() ||
            res?.data?.document?.ref_externe ||
            res?.data?.ref_externe ||
            res?.data?.code_document ||
            res?.data?.document?.code_document ||
            res?.data?.code ||
            res?.data?.document?.code ||
            res?.data?.reference ||
            res?.data?.document?.reference ||
            null;
        return this.lcTicketService
            .linkTicketsToErpFacture(link.ticketIds, {
                erpFactureId: Number(erpFactureId) || null,
                erpFactureCode: erpCode,
                markConsolide: link.markConsolide !== false,
            })
            .pipe(
                tap(() => {
                    this.toastr.success('Tickets caisse consolidés et liés à la facture.', 'Consolidation');
                }),
                catchError(() => {
                    this.toastr.warning(
                        'Facture créée, mais la liaison avec les tickets caisse n\'a pas pu être enregistrée.',
                        'Tickets caisse'
                    );
                    return of(null);
                })
            );
    }

    private loadDocumentForDuplicate(id: number, options?: { doc?: any; documentType?: string; isAvoir?: boolean; totalsAvoir?: any }): void {
        this.isLoadingEdit = true;
        this.isEditing = false;
        this.isLoadingFournisseurs = true;
        this.isLoadingClients = true;
        this.isLoadingProducts = true;
        this.isLoadingProjects = true;
        this.isLoadingCategories = true;
        this.isLoadingWarehouses = true;

        const applyDoc = (doc: any) => {
            if (!doc) {
                this.toastr.error('Document introuvable pour la duplication');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
                return;
            }

            let docToApply = doc;
            if (options?.isAvoir && options?.doc) {
                const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                const negatedLignes = lignes.map((l: any) => ({
                    ...l,
                    qnt: -(Number(l.qnt) || 0),
                    prix_ht: -(Number(l.prix_ht) || Number(l.result_ht) || 0),
                    result_ht: -(Number(l.result_ht) || Number(l.prix_ht) || 0),
                    valeur_unitaire: -(Number(l.valeur_unitaire) || Number(l.result_ht) || Number(l.prix_ht) || 0)
                }));
                docToApply = {
                    ...doc,
                    lignesDocument: negatedLignes,
                    total_ht: -(Number(doc.total_ht) || 0),
                    total_tva: -(Number(doc.total_tva) || 0),
                    total_ttc: -(Number(doc.total_ttc) || 0),
                    net_payer: -(Number(doc.net_payer) || Number(doc.total_ttc) || 0)
                };
            }

            forkJoin([
                    this.clientService.getActiveClient(this.stationId, 1, 100).pipe(
                        catchError(() => of({ data: [] as Client[] }))
                    ),
                    this.fetchAllActiveProductsByStation(this.stationId),
                    this.projetService.getProjectsByIdStation(this.stationId),
                    this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100),
                    this.tvaService.getTvaList(this.stationId),
                    this.categorieService.getCategoriePerStation(this.stationId),
                    this.taxeService.getTaxeList(this.stationId),
                    this.documentService.getTypeDocuments().pipe(catchError(() => of(null))),
                    this.fetchCaisseClientsForDocument()
                ]).subscribe({
                    next: ([clientsRes, productsRes, projectsRes, fournisseursRes, tvaRes, categoriesRes, taxesRes, typesRes, caisseClients]: any[]) => {
                        this.zone.run(() => {
                            if (typesRes) {
                                this.applyTypeDocumentsFromApi(typesRes);
                            }
                            const doc = docToApply;
                            this.clients = this.mergeErpClientsWithCaisse(clientsRes?.data || [], caisseClients || []);
                            this.refreshClientsForSelect();
                            this.isLoadingClients = false;
                            this.products = (Array.isArray(productsRes) ? productsRes : productsRes?.data || []).map((p: any) =>
                                this.mapApiProductForDocumentSelect(p)
                            );
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                            this.isLoadingProducts = false;
                            this.preloadStockQuantitiesForAllProducts();
                            this.projects = Array.isArray(projectsRes) ? projectsRes : projectsRes?.projectsListe || [];
                            this.isLoadingProjects = false;
                            this.fournisseurs = fournisseursRes?.data || [];
                            this.isLoadingFournisseurs = false;
                            this.tvaRates = tvaRes?.tvaListe || [];
                            this.categories = categoriesRes || [];
                            this.isLoadingCategories = false;
                            const taxList = taxesRes?.taxes || taxesRes?.data || taxesRes?.tvaListe || [];
                            if (Array.isArray(taxList)) {
                                this.taxes = taxList;
                                const fodecTax = this.taxes.find((t: any) =>
                                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                    this.isTaxActiveForDocument(t)
                                );
                                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                            } else {
                                this.taxes = [];
                                this.fodecRate = 0;
                            }
                            this.documentType = options?.documentType || this.getTypeFromId(docToApply.type_document_id);
                            this.loadCurrentTypeDocumentPrefixFromApi(
                                options?.documentType
                                    ? this.typeDocumentIdMap[this.documentType]
                                    : docToApply.type_document_id
                            );
                            this.documentReference = '';
                            this.documentDate = this.getTodayLocal();
                            this.dateLivraison = this.getTodayLocal();
                            this.note = docToApply.note || '';
                            if (options?.isAvoir && this.conversionFromRef) {
                                const tidAvoir = this.typeDocumentIdMap[this.documentType];
                                if (tidAvoir != null && !Number.isNaN(Number(tidAvoir))) {
                                    this.conversionFromRef = {
                                        ...this.conversionFromRef,
                                        typeDocumentId: Number(tidAvoir)
                                    };
                                }
                            }
                            const isAchat = [
                                'COMMANDE FOURNISSEUR',
                                'BON RECEPTION',
                                'FACTURE FOURNISSEUR',
                                'AVOIR FOURNISSEUR'
                            ].includes(this.documentType);
                            if (options?.isAvoir) {
                                this.assignProvisionalRefExterneForType();
                                this.applySourceWarehouseFromDoc(docToApply);
                            }
                            const clientOrFournisseurId = isAchat 
                                ? (docToApply.fournisseur_id || docToApply.fournisseur_data?.fournisseur_id || docToApply.fournisseurs?.[0]?.fournisseur_id || docToApply.fornisseurs?.[0]?.fournisseur_id || docToApply.fournisseur?.fournisseur_id || docToApply.fournisseurs?.[0]?.id || docToApply.fornisseurs?.[0]?.id || docToApply.fournisseur_data?.id)
                                : (docToApply.clients?.[0]?.id || docToApply.client_data?.id || docToApply.client_data?.client_id);

                            if (clientOrFournisseurId) {
                                this.clientId = clientOrFournisseurId;
                            }
                            this.loadWarehouses();
                            setTimeout(() => {
                                    if (this.documentType === 'BON TRANSFERT') {
                                        const entrepotInitialId = doc.entrepot_id || doc.entrepot?.id;
                                        const entrepotDestinationId = doc.entrepot_dest_id || doc.entrepot_destination?.id || doc.entrepot_destination_id;
                                        
                                        if (entrepotInitialId) {
                                            this.selectedWarehouseInitialId = entrepotInitialId;
                                            if (!doc.entrepot && entrepotInitialId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotInitialId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },

                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseInitialId = null;
                                        }
                                        
                                        if (entrepotDestinationId) {
                                            this.selectedWarehouseDestinationId = entrepotDestinationId;
                                            if (!doc.entrepot_destination && entrepotDestinationId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotDestinationId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },
                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseDestinationId = null;
                                        }
                                    } else {
                                        const entrepotId = doc.entrepot_id || doc.entrepot?.id;
                                        
                                        if (entrepotId) {
                                            this.selectedWarehouseId = entrepotId;
                                            if (!doc.entrepot && entrepotId && this.currentUser?.id) {
                                                this.warehouseService.detailEntrepot(entrepotId, this.currentUser.id, this.stationId).subscribe({
                                                    next: (entrepotResponse: any) => {
                                                        const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                        if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                            this.warehouses = [...this.warehouses, entrepotData];
                                                            this.cdr.detectChanges();
                                                        }
                                                    },

                                                });
                                            }
                                        } else {
                                            this.selectedWarehouseId = null;
                                        }
                                    }
                                }, 500);
                            if (isAchat) {
                                const apiFournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur || doc.fournisseur_data;
                                const fournisseurId = doc.fournisseur_id ?? apiFournisseur?.fournisseur_id ?? apiFournisseur?.id;
                                if (fournisseurId) {
                                    this.clientId = fournisseurId;
                                    this.fournisseurService.getFournisseurById(fournisseurId).subscribe({
                                        next: (fournisseurComplet) => {
                                            const fournisseurWithExtras = {
                                                ...fournisseurComplet,
                                                responsable: (fournisseurComplet as any).responsable || (fournisseurComplet as any).contact || '',
                                                phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                                            };
                                            const found = this.fournisseurs.find(f => f.id === fournisseurComplet.id);
                                            if (found) {
                                                this.selectedFournisseur = {...found, ...fournisseurWithExtras} as Fournisseur;
                                            } else {
                                                this.fournisseurs = [...this.fournisseurs, fournisseurWithExtras as Fournisseur];
                                                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurComplet.id;
                                            this.clientId = fournisseurComplet.id;
                                            this.updateApproveButtonState();
                                            this.cdr.detectChanges();
                                        },
                                        error: (err) => {
                                            const found = this.fournisseurs.find(f => f.id === fournisseurId);
                                            if (found) {
                                                this.selectedFournisseur = found;
                                                this.selectedFournisseurId = fournisseurId;
                                                this.clientId = fournisseurId;
                                                this.updateApproveButtonState();
                                                this.cdr.detectChanges();
                                            }
                                        }
                                    });
                                }
                            } else {
                                const apiClient = doc.clients?.[0] || doc.client_data;
                                if (apiClient && (apiClient.id || apiClient.client_id)) {
                                    const clientId = apiClient.client_id || apiClient.id;
                                    const clientFromDocument: Partial<Client> = {
                                        id: clientId,
                                        nom_prenom: apiClient.nom_client || apiClient.nom_prenom || '',
                                        identifiant_unique: apiClient.identifiant_unique || '',
                                        adresses: apiClient.adresse && apiClient.adresse !== 'Adresse non renseignée' 
                                            ? [{
                                                adresse: apiClient.adresse,
                                                code_postal: '',
                                                region: '',
                                                pays: ''
                                            } as Address]
                                            : [],
                                        emails: apiClient.email 
                                            ? [{
                                                email: apiClient.email,
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Email]
                                            : [],
                                        telephones: apiClient.telephone 
                                            ? [{
                                                num_tel: apiClient.telephone.replace(/^\+216/, '') || apiClient.telephone,
                                                code_pays: apiClient.telephone.startsWith('+216') ? '+216' : '+216',
                                                type: 'mobile',
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Telephone]
                                            : []
                                    };
                                    
                                    const found = this.clients.find(c => c.id === clientId);
                                    if (found) {
                                        this.selectedClient = {
                                            ...found,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        };
                                    } else {
                                        this.clients = [clientFromDocument as Client, ...this.clients];
                                        this.refreshClientsForSelect();
                                        this.selectedClient = {
                                            ...clientFromDocument,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        } as Client;
                                    }
                                    
                                    this.selectedClientId = clientId;
                                    this.clientId = clientId;
                                    this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
                                    this.modifiedClientFields = {
                                        nomClient: false,
                                        identifiant: false,
                                        adresse: false,
                                        email: false
                                    };
                                    this.modifiedFournisseurFields = {
                                        nomEntreprise: false,
                                        numeroIdentification: false,
                                        responsable: false,
                                        telephone: false,
                                        adresse: false
                                    };
                                    
                                    setTimeout(() => {
                                        this.initializeFeatherIcons();
                                    }, 250);
                                }
                            }
                            const apiProjet = doc.projets?.[0];
                            if (apiProjet) {
                                const found = this.projects.find(p => p.id === (apiProjet.id || apiProjet.projet_id));
                                this.selectedProject = found?.libelle || apiProjet.titre || apiProjet.libelle || '';
                            } else {
                                this.selectedProject = '';
                            }
                            const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                            this.applyItemsData(lignes);
                            this.updateApproveButtonState();
                            setTimeout(() => {
                                this.reloadStockQuantitiesForAllProducts();
                            }, 1000);
                            if (this.taxes && this.taxes.length > 0) {
                                this.items.forEach((item, i) => {
                                    if (item.product_id && item.type === 'product') {
                                        const descriptionFromLine = this.productDescriptions[i] || '';
                                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                                            next: (p: any) => {
                                                const productData = p.data || p;
                                                this.applyProductTaxes(productData, i, true);
                                                
                                                if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                    this.productDescriptions[i] = productData.description || '';
                                                } else {
                                                    this.productDescriptions[i] = descriptionFromLine;
                                                }
                                                this.cdr.detectChanges();
                                            },
                                            error: (err) => {
                                                if (this.productDescriptions[i] === undefined) {
                                                    this.productDescriptions[i] = descriptionFromLine || '';
                                                }
                                            }
                                        });
                                    }
                                });
                            }

                            const parametrageDoc = doc.parametrage_doc || {};
                            this.applyTaxStatutDocumentFromParametrage(parametrageDoc.taxe_statut_document);
                            const fodecAfterParametrage = this.taxes.find((t: any) =>
                                (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                this.isTaxActiveForDocument(t)
                            );
                            this.fodecRate = fodecAfterParametrage ? parseFloat(fodecAfterParametrage.valeur) : 0;
                            if (parametrageDoc.aff_montant_ttc !== undefined || doc.aff_montant_ttc !== undefined) {
                                const value = parametrageDoc.aff_montant_ttc ?? doc.aff_montant_ttc;
                                this.documentColumnSettings.aff_montant_ttc = value;
                                this.documentColumnSettings.afficherMontantsTTC = value;
                            }
                            if (parametrageDoc.aff_code_bar !== undefined || doc.aff_code_bar !== undefined) {
                                const value = parametrageDoc.aff_code_bar ?? doc.aff_code_bar;
                                this.documentColumnSettings.aff_code_bar = value;
                                this.documentColumnSettings.afficherCodeBarres = value;
                            }
                            if (parametrageDoc.aff_date_echeance !== undefined || parametrageDoc.aff_date_échéance !== undefined || doc.aff_date_echeance !== undefined || doc.aff_date_échéance !== undefined) {
                                const value = parametrageDoc.aff_date_echeance ?? parametrageDoc.aff_date_échéance ?? doc.aff_date_echeance ?? doc.aff_date_échéance;
                                this.documentColumnSettings.aff_date_echeance = value;
                                this.documentColumnSettings.afficherDateEcheance = value;
                            }
                            if (parametrageDoc.aff_date_liv !== undefined || doc.aff_date_liv !== undefined) {
                                const value = parametrageDoc.aff_date_liv ?? doc.aff_date_liv;
                                this.documentColumnSettings.aff_date_liv = value;
                                this.documentColumnSettings.afficherDateLivraison = value;
                            }
                            if (parametrageDoc.aff_montant_total !== undefined || doc.aff_montant_total !== undefined) {
                                const value = parametrageDoc.aff_montant_total ?? doc.aff_montant_total;
                                this.documentColumnSettings.aff_montant_total = value;
                                this.documentColumnSettings.afficherMontantTotal = value;
                            }
                            if (parametrageDoc.aff_coordonnees !== undefined || parametrageDoc.aff_coordonnées !== undefined || doc.aff_coordonnees !== undefined || doc.aff_coordonnées !== undefined) {
                                const value = parametrageDoc.aff_coordonnees ?? parametrageDoc.aff_coordonnées ?? doc.aff_coordonnees ?? doc.aff_coordonnées;
                                this.documentColumnSettings.aff_coordonnees = value;
                                this.documentColumnSettings.afficherCoordonneesClients = value;
                            }
                            if (parametrageDoc.reference !== undefined || parametrageDoc.référence !== undefined || doc.reference !== undefined || doc.référence !== undefined) {
                                const value = parametrageDoc.reference ?? parametrageDoc.référence ?? doc.reference ?? doc.référence;
                                this.documentColumnSettings.reference = value;
                            }
                            if (parametrageDoc.quantite !== undefined || parametrageDoc.quantité !== undefined || doc.quantite !== undefined || doc.quantité !== undefined) {
                                const value = parametrageDoc.quantite ?? parametrageDoc.quantité ?? doc.quantite ?? doc.quantité;
                                this.documentColumnSettings.quantite = value;
                            }
                            if (parametrageDoc.unite !== undefined || parametrageDoc.unité !== undefined || doc.unite !== undefined || doc.unité !== undefined) {
                                const value = parametrageDoc.unite ?? parametrageDoc.unité ?? doc.unite ?? doc.unité;
                                this.documentColumnSettings.unite = value;
                            }
                            if (parametrageDoc.taille !== undefined || doc.taille !== undefined) {
                                this.documentColumnSettings.taille = parametrageDoc.taille ?? doc.taille ?? false;
                            }
                            if (parametrageDoc.prix_unitaire !== undefined || doc.prix_unitaire !== undefined) {
                                const value = parametrageDoc.prix_unitaire ?? doc.prix_unitaire;
                                this.documentColumnSettings.prix_unitaire = value;
                                this.documentColumnSettings.prixUnitaire = value;
                            }
                            if (parametrageDoc.tva !== undefined || doc.tva !== undefined) {
                                this.documentColumnSettings.tva = parametrageDoc.tva ?? doc.tva;
                            }
                            if (parametrageDoc.remise !== undefined || doc.remise !== undefined) {
                                this.documentColumnSettings.remise = parametrageDoc.remise ?? doc.remise;
                            }
                            const defaultClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            
                            const defaultFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                            
                            let parsedClientFields: any = null;
                            if (doc.hidden_client_fields) {
                                if (typeof doc.hidden_client_fields === 'string') {
                                    try {
                                        parsedClientFields = JSON.parse(doc.hidden_client_fields);
                                    } catch (e) {
                                        parsedClientFields = null;
                                    }
                                } else if (typeof doc.hidden_client_fields === 'object') {
                                    parsedClientFields = doc.hidden_client_fields;
                                }
                            }
                            
                            if (parsedClientFields && typeof parsedClientFields === 'object') {
                                this.modifiedClientFields = { ...defaultClientFields, ...parsedClientFields };
                            } else {
                                this.modifiedClientFields = { ...defaultClientFields };
                            }
                            
                            let parsedFournisseurFields: any = null;
                            if (doc.hidden_fournisseur_fields) {
                                if (typeof doc.hidden_fournisseur_fields === 'string') {
                                    try {
                                        parsedFournisseurFields = JSON.parse(doc.hidden_fournisseur_fields);
                                    } catch (e) {
                                        parsedFournisseurFields = null;
                                    }
                                } else if (typeof doc.hidden_fournisseur_fields === 'object') {
                                    parsedFournisseurFields = doc.hidden_fournisseur_fields;
                                }
                            }
                            
                            if (parsedFournisseurFields && typeof parsedFournisseurFields === 'object') {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...parsedFournisseurFields };
                            } else {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields };
                            }
                            this.loadStationData();
                            this.calculateTotals();
                            this.updateApproveButtonState();
                            localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
                            this.documentColumnSettings = {...this.documentColumnSettings};

                            this.refreshConversionLockForSourceDocument(() => this.updateHeaderConfig());
                            this.loadVenteAchatParamForCurrentDocumentType();

                            setTimeout(() => {
                                this.cdr.detectChanges();
                                this.isLoadingEdit = false;
                                this.isLoadingClients = false;
                                this.isLoadingFournisseurs = false;
                                this.isLoadingProducts = false;
                                this.isLoadingProjects = false;
                                this.isLoadingCategories = false;
                                this.isLoadingWarehouses = false;
                                
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }, 200);
                        });
                    },
                    error: (err) => {
                        this.toastr.error('Erreur lors du chargement des données pour la duplication');
                        this.isLoadingEdit = false;
                        this.cdr.detectChanges();
                    }
                });
        };
        if (options?.doc) {
            applyDoc(options.doc);
        } else {
            this.documentService.getDocumentById(id).subscribe({
                next: (response) => {
                    const doc = response?.data?.document ?? response?.data ?? response;
                    applyDoc(doc);
                },
                error: () => {
                    this.toastr.error('Document introuvable pour la duplication');
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                }
            });
        }
    }

    private loadDocumentForEdit(id: number): void {
        this.isLoadingEdit = true;
        this.isEditing = true;
        this.isLoadingFournisseurs = true;
        this.isLoadingClients = true;
        this.isLoadingProducts = true;
        this.isLoadingProjects = true;
        this.isLoadingCategories = true;
        this.isLoadingWarehouses = true;

        this.documentService.getDocumentById(id).subscribe({
            next: (response) => {
                const doc = response?.data?.document;
                if (!doc) {
                    this.toastr.error('Document introuvable');
                    this.isLoadingEdit = false;
                    this.cdr.detectChanges();
                    return;
                }
                this.currentStatutId = doc.statut_id || 1;
                this.currentDocumentUserId = doc.user_id != null ? Number(doc.user_id) : null;
                this.currentTypeDocumentId = doc.type_document_id != null ? Number(doc.type_document_id) : null;
                // Facture / FF : Non payé / Annulé / Crée → approve-vente
                // CC / BR : Annulé / Crée → approve-vente (pas l’éditeur document)
                if (
                    this.documentType === 'FACTURE' ||
                    this.documentType === 'FACTURE FOURNISSEUR' ||
                    this.documentType === 'COMMANDE CLIENT' ||
                    this.documentType === 'BON RECEPTION'
                ) {
                    const sid = Number(doc.statut_id);
                    const isNonPaye = sid === this.statutIdMap['Non payé'];
                    const isAnnule = sid === this.statutIdMap['Annulé'];
                    const isCree =
                        sid === this.statutIdMap['Crée'] || sid === this.statutIdMap['Créé'];
                    const shouldGoApprove =
                        isAnnule ||
                        isCree ||
                        ((this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR') &&
                            isNonPaye);
                    if (shouldGoApprove) {
                        this.isLoadingEdit = false;
                        if (
                            isCree &&
                            (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR')
                        ) {
                            this.documentService.updateStatus(id, this.statutIdMap['Non payé']).subscribe({
                                error: () => { }
                            });
                        }
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                            queryParams: { id }
                        });
                        return;
                    }
                }
                forkJoin([
                    this.clientService.getActiveClient(this.stationId, 1, 100).pipe(
                        catchError(() => of({ data: [] as Client[] }))
                    ),
                    this.fetchAllActiveProductsByStation(this.stationId),
                    this.projetService.getProjectsByIdStation(this.stationId),
                    this.fournisseurService.getActiveFournisseur(this.stationId, 1, 100),
                    this.tvaService.getTvaList(this.stationId),
                    this.categorieService.getCategoriePerStation(this.stationId),
                    this.taxeService.getTaxeList(this.stationId),
                    this.documentService.getTypeDocuments().pipe(catchError(() => of(null))),
                    this.fetchCaisseClientsForDocument()
                ]).subscribe({
                    next: ([clientsRes, productsRes, projectsRes, fournisseursRes, tvaRes, categoriesRes, taxesRes, typesRes, caisseClients]: any[]) => {
                        this.zone.run(() => {
                            if (typesRes) {
                                this.applyTypeDocumentsFromApi(typesRes);
                            }
                            this.clients = this.mergeErpClientsWithCaisse(clientsRes?.data || [], caisseClients || []);
                            this.refreshClientsForSelect();
                            this.isLoadingClients = false;
                            this.products = (Array.isArray(productsRes) ? productsRes : productsRes?.data || []).map((p: any) =>
                                this.mapApiProductForDocumentSelect(p)
                            );
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                            if (this.pendingClientId !== undefined) {
                                const finalClient = this.clients.find(c => c.id === this.pendingClientId);
                                if (finalClient) {
                                    this.selectedClient = finalClient;
                                    this.selectedClientId = this.pendingClientId;
                                    this.clientId = this.pendingClientId;
                                    this.cdr.detectChanges();
                                    setTimeout(() => {
                                        this.initializeFeatherIcons();
                                    }, 200);
                                } else {
                                    if (this.selectedClient && this.selectedClient.id) {
                                        this.selectedClientId = this.selectedClient.id;
                                        this.clientId = this.selectedClient.id;
                                        setTimeout(() => {
                                            this.initializeFeatherIcons();
                                        }, 200);
                                    }
                                }
                                this.pendingClientId = undefined;
                            } else if (this.selectedClient && this.selectedClient.id && !this.selectedClientId) {
                                this.selectedClientId = this.selectedClient.id;
                                this.clientId = this.selectedClient.id;
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }
                            this.isLoadingProducts = false;

                            this.preloadStockQuantitiesForAllProducts();
                            this.projects = Array.isArray(projectsRes) ? projectsRes : projectsRes?.projectsListe || [];
                            this.isLoadingProjects = false;
                            this.fournisseurs = fournisseursRes?.data || [];
                            this.isLoadingFournisseurs = false;
                            this.tvaRates = tvaRes?.tvaListe || [];
                            this.categories = categoriesRes || [];
                            this.isLoadingCategories = false;
                            const taxList = taxesRes?.taxes || taxesRes?.data || taxesRes?.tvaListe || [];
                            if (Array.isArray(taxList)) {
                                this.taxes = taxList;
                                const fodecTax = this.taxes.find((t: any) =>
                                    (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                    this.isTaxActiveForDocument(t)
                                );
                                this.fodecRate = fodecTax ? parseFloat(fodecTax.valeur) : 0;
                            } else {
                                this.taxes = [];
                                this.fodecRate = 0;
                            }
                            this.documentType = this.getTypeFromId(doc.type_document_id);
                            this.loadCurrentTypeDocumentPrefixFromApi(doc.type_document_id);
                            if (this.isAvoirWarehouseLocked()) {
                                this.applySourceWarehouseFromDoc(doc);
                            }
                            this.documentReference = doc.ref_externe || '';
                            this.refExterne = doc.ref_externe || this.refExterne || '';
                            this.documentReferenceHeaderPending = false;
                            this.isReferenceReadonly = true;
                            this.referenceModelType = (doc as any).reference_model_type ?? null;
                            this.documentOriginalId = doc.document_original_id ?? (doc as any).document_original_id ?? null;
                            this.loadWarehouses();
                            setTimeout(() => {
                                if (this.documentType === 'BON TRANSFERT') {
                                    const entrepotInitialId = doc.entrepot_id || doc.entrepot?.id;
                                    const entrepotDestinationId = doc.entrepot_dest_id || doc.entrepot_destination?.id;
                                    
                                    if (entrepotInitialId) {
                                        this.selectedWarehouseInitialId = entrepotInitialId;
                                        if (!doc.entrepot && entrepotInitialId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotInitialId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseInitialId = null;
                                    }
                                    
                                    if (entrepotDestinationId) {
                                        this.selectedWarehouseDestinationId = entrepotDestinationId;
                                        if (!doc.entrepot_destination && entrepotDestinationId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotDestinationId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseDestinationId = null;
                                    }
                                } else {
                                    const entrepotId = doc.entrepot_id || doc.entrepot?.id;
                                    
                                    if (entrepotId) {
                                        this.selectedWarehouseId = entrepotId;
                                        if (!doc.entrepot && entrepotId && this.currentUser?.id) {
                                            this.warehouseService.detailEntrepot(entrepotId, this.currentUser.id, this.stationId).subscribe({
                                                next: (entrepotResponse: any) => {
                                                    const entrepotData = entrepotResponse?.entrepot || entrepotResponse;
                                                    if (entrepotData && !this.warehouses.find(w => w.id === entrepotData.id)) {
                                                        this.warehouses = [...this.warehouses, entrepotData];
                                                        this.cdr.detectChanges();
                                                    }
                                                },
                                            });
                                        }
                                    } else {
                                        this.selectedWarehouseId = null;
                                    }
                                }
                            }, 500);
                            this.loadStationData();
                            this.refreshAvailableEtablissements();
                            const entrepriseApi = doc.entreprises?.[0];
                            if (entrepriseApi && (!this.entreprise.nom || this.entreprise.nom === '--')) {
                                this.entreprise = {
                                    nom: entrepriseApi.nom_entreprise || 'Shopi',
                                    adresse: entrepriseApi.adresse || 'Adresse non définie',
                                    ville: entrepriseApi.ville || '',
                                    pays: entrepriseApi.pays || '',
                                    matricule_fiscal: entrepriseApi.matricule_fiscale || '--'
                                };
                            } else if (!this.entreprise.nom || this.entreprise.nom === '--') {
                                this.entreprise = {
                                    nom: 'Shopi',
                                    adresse: 'Adresse non définie',
                                    ville: '',
                                    pays: '',
                                    matricule_fiscal: '--'
                                };
                            }

                            const banqueApi = doc.coordonneesBancaires?.[0];
                            if (banqueApi) {
                                this.banque = {
                                    nom_banque: banqueApi.banque || banqueApi.nom || 'Banque non définie',
                                    rib: banqueApi.rib || '--',
                                    agence: banqueApi.agence || null,
                                };
                            } else {
                                this.banque = {nom_banque: 'Banque non définie', rib: '--'};
                            }
                            this.loadBanquesForDocument(banqueApi?.rib || null);

                            const isAchat = ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(this.documentType);
                            if (isAchat) {
                                const apiFournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur || doc.fournisseur_data;
                                const fournisseurId = doc.fournisseur_id ?? apiFournisseur?.fournisseur_id ?? apiFournisseur?.id;
                                if (fournisseurId) {
                                    this.clientId = fournisseurId;
                                    this.fournisseurService.getFournisseurById(fournisseurId).subscribe({
                                        next: (fournisseurComplet) => {
                                            const fournisseurWithExtras = {
                                                ...fournisseurComplet,
                                                responsable: (fournisseurComplet as any).responsable || (fournisseurComplet as any).contact || '',
                                                phone: this.getTelephoneString(fournisseurComplet.telephones) || ''
                                            };
                                            const found = this.fournisseurs.find(f => f.id === fournisseurComplet.id);
                                            if (found) {
                                                this.selectedFournisseur = {...found, ...fournisseurWithExtras} as Fournisseur;
                                            } else {
                                                this.fournisseurs = [...this.fournisseurs, fournisseurWithExtras as Fournisseur];
                                                this.selectedFournisseur = fournisseurWithExtras as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurComplet.id;
                                            this.clientId = fournisseurComplet.id;
                                            this.cdr.detectChanges();
                                            setTimeout(() => {
                                                this.cdr.detectChanges();
                                                this.initializeFeatherIcons();
                                            }, 250);
                                        },
                                        error: (err) => {
                                            const found = this.fournisseurs.find(f => f.id === fournisseurId);
                                            if (found) {
                                                this.selectedFournisseur = found;
                                            } else if (apiFournisseur) {
                                                const temp: Partial<Fournisseur> = {
                                                    id: fournisseurId,
                                                    nom_entreprise: apiFournisseur.nom_entreprise || '--',
                                                    numero_identification_fiscale: apiFournisseur.numero_identification_fiscale || '',
                                                    telephones: apiFournisseur.telephones || [],
                                                    adresses: apiFournisseur.adresses || [],
                                                    emails: apiFournisseur.emails || [],
                                                    responsable: (apiFournisseur as any).responsable || (apiFournisseur as any).contact || '',
                                                    phone: this.getTelephoneString(apiFournisseur.telephones) || ''
                                                } as any;
                                                this.fournisseurs = [...this.fournisseurs, temp as Fournisseur];
                                                this.selectedFournisseur = temp as Fournisseur;
                                            }
                                            this.selectedFournisseurId = fournisseurId;
                                            this.clientId = fournisseurId;
                                            this.cdr.detectChanges();
                                            setTimeout(() => {
                                                this.cdr.detectChanges();
                                                this.initializeFeatherIcons();
                                            }, 250);
                                        }
                                    });
                                }
                            } else {
                                const apiClient = doc.clients?.[0] || doc.client_data;
                                if (apiClient && (apiClient.id || apiClient.client_id)) {
                                    const clientId = apiClient.client_id || apiClient.id;
                                    const clientFromDocument: Partial<Client> = {
                                            id: clientId,
                                        nom_prenom: apiClient.nom_client || apiClient.nom_prenom || '',
                                            identifiant_unique: apiClient.identifiant_unique || '',
                                        adresses: apiClient.adresse && apiClient.adresse !== 'Adresse non renseignée' 
                                            ? [{
                                                adresse: apiClient.adresse,
                                                code_postal: '',
                                                region: '',
                                                pays: ''
                                            } as Address]
                                            : [],
                                        emails: apiClient.email 
                                            ? [{
                                                email: apiClient.email,
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Email]
                                            : [],
                                        telephones: apiClient.telephone 
                                            ? [{
                                                num_tel: apiClient.telephone.replace(/^\+216/, '') || apiClient.telephone,
                                                code_pays: apiClient.telephone.startsWith('+216') ? '+216' : '+216',
                                                type: 'mobile',
                                                client_id: clientId,
                                                station_id: this.stationId,
                                                user_id: this.currentUser?.id
                                            } as Telephone]
                                            : []
                                    };
                                    const found = this.clients.find(c => c.id === clientId);
                                    if (found) {
                                        found.nom_prenom = clientFromDocument.nom_prenom || found.nom_prenom;
                                        found.identifiant_unique = clientFromDocument.identifiant_unique || found.identifiant_unique;
                                        if (clientFromDocument.adresses && clientFromDocument.adresses.length > 0) {
                                            found.adresses = clientFromDocument.adresses;
                                        }
                                        if (clientFromDocument.emails && clientFromDocument.emails.length > 0) {
                                            found.emails = clientFromDocument.emails;
                                        }
                                        if (clientFromDocument.telephones && clientFromDocument.telephones.length > 0) {
                                            found.telephones = clientFromDocument.telephones;
                                        }
                                        this.selectedClient = {
                                            ...found,
                                            adresses: [...(found.adresses || [])],
                                            telephones: [...(found.telephones || [])],
                                            emails: [...(found.emails || [])]
                                        };
                                    } else {
                                        this.clients = [clientFromDocument as Client, ...this.clients];
                                        this.refreshClientsForSelect();
                                        this.selectedClient = {
                                            ...clientFromDocument,
                                            adresses: [...(clientFromDocument.adresses || [])],
                                            telephones: [...(clientFromDocument.telephones || [])],
                                            emails: [...(clientFromDocument.emails || [])]
                                        } as Client;
                                    }
                                    
                                    this.selectedClientId = clientId;
                                    this.clientId = clientId;
                                    this.editMode = { nomClient: false, identifiant: false, numeroIdentification: false, adresse: false, email: false };
                                    this.cdr.markForCheck();
                                    this.cdr.detectChanges();
                                    setTimeout(() => {
                                        this.cdr.detectChanges();
                                        this.initializeFeatherIcons();
                                    }, 250);
                                }
                            }

                            const apiProjet = doc.projets?.[0];
                            if (apiProjet) {
                                this.originalProjectId = apiProjet.id ?? apiProjet.projet_id ?? null;
                                const found = this.projects.find(p => p.id === this.originalProjectId);
                                this.selectedProject = found?.libelle || apiProjet.titre || apiProjet.libelle || '';
                            } else {
                                this.originalProjectId = null;
                                this.selectedProject = '';
                            }

                            this.documentDate = this.formatDateToLocalString(doc.date || null);
                            this.dateLivraison = this.formatDateToLocalString(doc.date_livraison || doc.date || null);
                            this.syncFlatpickrDateConfigs();
                            this.syncFlatpickrReadonlyOnInstances();
                            this.note = doc.note || '';
                            this.documentId = doc.id;

                            const lignes = Array.isArray(doc.lignesDocument) ? doc.lignesDocument : [];
                            this.applyItemsData(lignes);
                            if (this.documentOriginalId != null && (this.documentType === 'FACTURE' || this.documentType === 'FACTURE FOURNISSEUR')) {
                                this.ensureAvoirLinesNegated();
                            }
                            setTimeout(() => {
                                this.reloadStockQuantitiesForAllProducts();
                            }, 500);

                            if (this.taxes && this.taxes.length > 0) {
                                this.items.forEach((item, i) => {
                                    if (item.product_id && item.type === 'product') {
                                        const descriptionFromLine = this.productDescriptions[i] || '';
                                        this.productsService.getDetailsProduct(item.product_id).subscribe({
                                            next: (p: any) => {
                                                const productData = p.data || p;
                                                this.applyProductTaxes(productData, i, true);
                                                if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                    this.productDescriptions[i] = productData.description || '';
                                                } else {
                                                    this.productDescriptions[i] = descriptionFromLine;
                                                }
                                                this.cdr.detectChanges();
                                            },
                                            error: (err) => {
                                                if (this.productDescriptions[i] === undefined) {
                                                    this.productDescriptions[i] = descriptionFromLine || '';
                                                }
                                            }
                                        });
                                    }
                                });
                            } else {
                                this.loadTaxes();
                                setTimeout(() => {
                                    this.items.forEach((item, i) => {
                                        if (item.product_id && item.type === 'product') {
                                            const descriptionFromLine = this.productDescriptions[i] || '';
                                            this.productsService.getDetailsProduct(item.product_id).subscribe({
                                                next: (p: any) => {
                                                    const productData = p.data || p;
                                                    this.applyProductTaxes(productData, i, true);
                                                    if (!descriptionFromLine || descriptionFromLine.trim() === '') {
                                                        this.productDescriptions[i] = productData.description || '';
                                                    } else {
                                                        this.productDescriptions[i] = descriptionFromLine;
                                                    }
                                                    this.cdr.detectChanges();
                                                },
                                                error: (err) => {
                                                    if (this.productDescriptions[i] === undefined) {
                                                        this.productDescriptions[i] = descriptionFromLine || '';
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }, 500);
                            }

                            const Total_TTC = parseFloat(doc.total_ttc) || 0;
                            const Base_RS = Total_TTC;
                            const Taux_RS = doc.Taux_RS || '0';
                            const tauxRSDecimal = parseFloat(Taux_RS) / 100;
                            const RS = Base_RS * tauxRSDecimal;
                            const Net_à_payer = Total_TTC - RS;
                            const timbreFiscal = this.isAvoirDocument()
                                ? 0
                                : (doc.timbre_fiscal != null && doc.timbre_fiscal !== ''
                                    ? parseFloat(doc.timbre_fiscal)
                                    : 0);
                            
                            this.totals = {
                                totalHT: parseFloat(doc.total_ht) || 0,
                                totalTVA: parseFloat(doc.total_tva) || 0,
                                totalTTC: Total_TTC,
                                totalRemise: parseFloat(doc.total_remise) || 0,
                                totalTaxesAvantTVA: 0,
                                totalBaseTVA: parseFloat(doc.total_ht) || 0,
                                totalTaxesApresTVA: 0,
                                retenueSource: RS,
                                netAPayer: Net_à_payer + timbreFiscal,
                                timbreFiscal: timbreFiscal,
                                Base_RS: Base_RS,
                                Taux_RS: Taux_RS,
                                RS: RS,
                                Net_à_payer: Net_à_payer,
                                documentLevelTaxLines: [],
                                documentLevelTaxesTotal: 0,
                                taxesAfterHT: [],
                                taxesAfterTTC: [],
                                taxesAfterTimbre: []
                            };

                            const parametrageDoc = doc.parametrage_doc || {};
                            this.applyTaxStatutDocumentFromParametrage(parametrageDoc.taxe_statut_document);
                            const fodecAfterParametrageEdit = this.taxes.find((t: any) =>
                                (t.nom?.toLowerCase().includes('fodec') || t.label?.toLowerCase().includes('fodec')) &&
                                this.isTaxActiveForDocument(t)
                            );
                            this.fodecRate = fodecAfterParametrageEdit ? parseFloat(fodecAfterParametrageEdit.valeur) : 0;

                            if (parametrageDoc.aff_montant_ttc !== undefined || doc.aff_montant_ttc !== undefined) {
                                const value = parametrageDoc.aff_montant_ttc ?? doc.aff_montant_ttc;
                                this.documentColumnSettings.aff_montant_ttc = value;
                                this.documentColumnSettings.afficherMontantsTTC = value;
                            }
                            if (parametrageDoc.aff_code_bar !== undefined || doc.aff_code_bar !== undefined) {
                                const value = parametrageDoc.aff_code_bar ?? doc.aff_code_bar;
                                this.documentColumnSettings.aff_code_bar = value;
                                this.documentColumnSettings.afficherCodeBarres = value;
                            }
                            if (parametrageDoc.aff_date_echeance !== undefined || parametrageDoc.aff_date_échéance !== undefined || doc.aff_date_echeance !== undefined || doc.aff_date_échéance !== undefined) {
                                const value = parametrageDoc.aff_date_echeance ?? parametrageDoc.aff_date_échéance ?? doc.aff_date_echeance ?? doc.aff_date_échéance;
                                this.documentColumnSettings.aff_date_echeance = value;
                                this.documentColumnSettings.afficherDateEcheance = value;
                            }
                            if (parametrageDoc.aff_date_liv !== undefined || doc.aff_date_liv !== undefined) {
                                const value = parametrageDoc.aff_date_liv ?? doc.aff_date_liv;
                                this.documentColumnSettings.aff_date_liv = value;
                                this.documentColumnSettings.afficherDateLivraison = value;
                            }
                            if (parametrageDoc.aff_montant_total !== undefined || doc.aff_montant_total !== undefined) {
                                const value = parametrageDoc.aff_montant_total ?? doc.aff_montant_total;
                                this.documentColumnSettings.aff_montant_total = value;
                                this.documentColumnSettings.afficherMontantTotal = value;
                            }
                            if (parametrageDoc.aff_coordonnees !== undefined || parametrageDoc.aff_coordonnées !== undefined || doc.aff_coordonnees !== undefined || doc.aff_coordonnées !== undefined) {
                                const value = parametrageDoc.aff_coordonnees ?? parametrageDoc.aff_coordonnées ?? doc.aff_coordonnees ?? doc.aff_coordonnées;
                                this.documentColumnSettings.aff_coordonnees = value;
                                this.documentColumnSettings.afficherCoordonneesClients = value;
                            }
                            if (parametrageDoc.reference !== undefined || parametrageDoc.référence !== undefined || doc.reference !== undefined || doc.référence !== undefined) {
                                const value = parametrageDoc.reference ?? parametrageDoc.référence ?? doc.reference ?? doc.référence;
                                this.documentColumnSettings.reference = value;
                            }
                            if (parametrageDoc.quantite !== undefined || parametrageDoc.quantité !== undefined || doc.quantite !== undefined || doc.quantité !== undefined) {
                                const value = parametrageDoc.quantite ?? parametrageDoc.quantité ?? doc.quantite ?? doc.quantité;
                                this.documentColumnSettings.quantite = value;
                            }
                            if (parametrageDoc.unite !== undefined || parametrageDoc.unité !== undefined || doc.unite !== undefined || doc.unité !== undefined) {
                                const value = parametrageDoc.unite ?? parametrageDoc.unité ?? doc.unite ?? doc.unité;
                                this.documentColumnSettings.unite = value;
                            }
                            if (parametrageDoc.taille !== undefined || doc.taille !== undefined) {
                                this.documentColumnSettings.taille = parametrageDoc.taille ?? doc.taille ?? false;
                            }
                            if (parametrageDoc.prix_unitaire !== undefined || doc.prix_unitaire !== undefined) {
                                const value = parametrageDoc.prix_unitaire ?? doc.prix_unitaire;
                                this.documentColumnSettings.prix_unitaire = value;
                                this.documentColumnSettings.prixUnitaire = value;
                            }
                            if (parametrageDoc.tva !== undefined || doc.tva !== undefined) {
                                this.documentColumnSettings.tva = parametrageDoc.tva ?? doc.tva;
                            }
                            if (parametrageDoc.remise !== undefined || doc.remise !== undefined) {
                                this.documentColumnSettings.remise = parametrageDoc.remise ?? doc.remise;
                            }
                            const defaultClientFields = {
                                nomClient: false,
                                identifiant: false,
                                numeroIdentification: false,
                                adresse: false,
                                email: false
                            };
                            
                            const defaultFournisseurFields = {
                                nomEntreprise: false,
                                numeroIdentification: false,
                                responsable: false,
                                telephone: false,
                                adresse: false
                            };
                            let parsedClientFields: any = null;
                            if (doc.hidden_client_fields) {
                                if (typeof doc.hidden_client_fields === 'string') {
                                    try {
                                        parsedClientFields = JSON.parse(doc.hidden_client_fields);
                                    } catch (e) {
                                        parsedClientFields = null;
                                    }
                                } else if (typeof doc.hidden_client_fields === 'object') {
                                    parsedClientFields = doc.hidden_client_fields;
                                }
                            }
                            
                            if (parsedClientFields && typeof parsedClientFields === 'object') {
                                this.modifiedClientFields = { ...defaultClientFields, ...parsedClientFields };

                            } else {
                                this.modifiedClientFields = { ...defaultClientFields };
                            }
                            let parsedFournisseurFields: any = null;
                            if (doc.hidden_fournisseur_fields) {
                                if (typeof doc.hidden_fournisseur_fields === 'string') {
                                    try {
                                        parsedFournisseurFields = JSON.parse(doc.hidden_fournisseur_fields);
                                    } catch (e) {
                                        parsedFournisseurFields = null;
                                    }
                                } else if (typeof doc.hidden_fournisseur_fields === 'object') {
                                    parsedFournisseurFields = doc.hidden_fournisseur_fields;
                                }
                            }
                            
                            if (parsedFournisseurFields && typeof parsedFournisseurFields === 'object') {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...parsedFournisseurFields };
                            } else {
                                this.modifiedFournisseurFields = { ...defaultFournisseurFields };
                            }
                            this.saveModifiedFields();
                            this.cdr.markForCheck();
                            this.cdr.detectChanges();
                            localStorage.setItem('documentColumnSettings', JSON.stringify(this.documentColumnSettings));
                            this.documentColumnSettings = {...this.documentColumnSettings};

                            this.refreshConversionLockForSourceDocument(() => this.updateHeaderConfig());
                            this.calculateTotals();
                            this.updateApproveButtonState();
                            this.loadVenteAchatParamForCurrentDocumentType();

                            setTimeout(() => {
                                this.cdr.detectChanges();
                                this.isLoadingEdit = false;
                                this.isLoadingClients = false;
                                this.isLoadingFournisseurs = false;
                                this.isLoadingProducts = false;
                                this.isLoadingProjects = false;
                                this.isLoadingCategories = false;
                                this.isLoadingWarehouses = false;

                                this.cdr.markForCheck();
                                this.cdr.detectChanges();
                                setTimeout(() => {
                                    this.initializeFeatherIcons();
                                }, 200);
                            }, 200);
                        });

                    },

                    error: (err) => {
                        this.toastr.error('Erreur lors du chargement des données');
                        this.isLoadingEdit = false;
                        this.cdr.detectChanges();
                    }
                });
            },
            error: (err) => {
                this.toastr.error('Impossible de contacter le serveur');
                this.isLoadingEdit = false;
                this.cdr.detectChanges();
            }
        });
    }

    private getTypeFromId(id: number): string {
        const fromApi = this.typeIdToDocumentTypeFromApi[id];
        if (fromApi) {
            return fromApi;
        }
        const map: { [key: number]: string } = {
            7: 'DEVIS',
            8: 'COMMANDE CLIENT',
            9: 'BON DE SORTIE',
            10: 'BON DE LIVRAISON',
            11: 'FACTURE',
            12: 'COMMANDE FOURNISSEUR',
            13: 'BON RECEPTION',
            14: 'FACTURE FOURNISSEUR',
            15: 'INVENTAIRE',
            16: 'BON TRANSFERT'
        };
        return map[id] || 'DEVIS';
    }
    private isAvoirDocument(): boolean {
        const url = this.router.url.toLowerCase();
        if (this.documentType === 'AVOIR' || this.documentType === 'AVOIR FOURNISSEUR') {
            return true;
        }
        if (url.includes('/vente/avoir/') || url.includes('/achat/avoir-fournisseur/')) {
            return true;
        }
        // Ne pas traiter une FACTURE liée (document_original_id) comme un avoir :
        // sinon Approuver envoie statut « Non utilisé » au lieu de « Non payé ».
        return false;
    }

    private validateClientAndProject(): boolean {
        if (!this.shouldShowClient()) {
            return true;
        }
        if (!this.selectedClient) {
            this.toastr.warning('Veuillez sélectionner un client.', 'Client requis');
            return false;
        }
        return true;
    }

    getAdresseString(adresses?: Address[] | any[]): string {
        if (!adresses || adresses.length === 0) {
            return 'Adresse non renseignée';
        }
        
        const a = adresses[0];
        if (!a) {
            return 'Adresse non renseignée';
        }
        const parts: string[] = [];
        
        if (a.adresse) {
            parts.push(a.adresse);
        }
        
        if (a.code_postal) {
            parts.push(a.code_postal);
        }
        
        if (a.ville) {
            parts.push(a.ville);
        }
        
        if (a.region) {
            parts.push(a.region);
        }
        
        if (a.pays) {
            parts.push(a.pays);
        }
        const adresseFormatee = parts.join(', ').trim();
        
        return adresseFormatee || 'Adresse non renseignée';
    }

    getEmailString(emails?: Email[]): string {
        return emails?.[0]?.email || 'email@exemple.com';
    }

    getTelephoneString(telephones?: Telephone[]): string {
        if (!telephones || telephones.length === 0) {
            return '--';
        }
        const t = telephones[0];
        return `${t.code_pays || '+216'}${t.num_tel || '00000000'}`;
    }

    getResponsableFournisseur(fournisseur: Fournisseur | null): string {
        if (!fournisseur) {
            return 'Non renseigné';
        }
        return (fournisseur as any).responsable || 
               (fournisseur as any).contact || 
               (fournisseur as any).nom_contact ||
               'Non renseigné';
    }

    private normalizeString(str: string | null | undefined): string {
        if (!str) {
            return '';
        }
        return str.trim().toLowerCase();
    }

    getClientIdentifiant(): string {
        if (!this.selectedClient) {
            return '--';
        }

        const found = this.clients.find(c =>
            this.normalizeString(c.nom_prenom) === this.normalizeString(this.selectedClient?.nom_prenom || '')
        );

        return found?.identifiant_unique ||
            (found as any)?.identifiant_client ||
            found?.id?.toString() ||
            '--';
    }

    private buildPreviewData(): any {
        const clientData = this.selectedClient ? {
            id: this.resolveDocumentClientId(this.selectedClient),
            client_id: this.resolveDocumentClientId(this.selectedClient),
            nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
            identifiant_unique: this.getClientIdentifiant(),
            email: this.getEmailString(this.selectedClient.emails),
            adresse: this.getAdresseString(this.selectedClient.adresses),
            telephone: this.getTelephoneString(this.selectedClient.telephones)
        } : null;

        return {
            user_id: this.currentUser.id,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: 9,
            typeDocument: {titre: this.documentType},
            reference: this.documentReference,
            date_document: this.documentDate,
            client_data: clientData,
            projets: this.selectedProject ? [{libelle: this.selectedProject}] : [],
            note: this.note || '--',
            lignes_document: this.items
                .map((i, idx) => ({ i, idx }))
                .filter(({ i }) => i.type === 'product' && i.designation)
                .map(({ i, idx }) => {
                    const a = this.buildLigneDocumentAttributsProduit(i, this.barcodePickerModel[idx]);
                    return {
                    libelle: i.designation,
                    qnt: i.quantity,
                    prix_ht: i.priceHT,
                    tva: i.tva || 19,
                    total_ht: i.totalHT,
                    product_id: i.product_id || null,
                    code_bar: a.code_bar,
                    ref_interne: a.ref_interne,
                    couleur: a.couleur,
                    taille: a.taille,
                    ajout_ligne: i.ajout_ligne && i.ajout_ligne.length > 0 ? i.ajout_ligne.map((ligne: any) => ({
                        contenu_text: ligne.contenu_text || '',
                        rubrique: ligne.rubrique || '',
                        separateur: ligne.separateur || false,
                        sous_total: Number(ligne.sous_total) || 0,
                        order: Number(ligne.order) || 0
                    })) : undefined
                    };
                })
        };
    }

    private buildPreviewDataFromApi(doc: any): any {
        const client = doc.clients?.[0] || doc.client_data;
        const fournisseur = doc.fournisseurs?.[0] || doc.fornisseurs?.[0] || doc.fournisseur_data;
        const projet = doc.projets?.[0];

        return {
            id: doc.id,
            typeDocument: {titre: this.getTypeFromId(doc.type_document_id)},
            reference: doc.ref_externe,
            date_document: doc.date,

            client_data: client ? {
                nom_client: client.nom_prenom || client.nom_client || '--',
                identifiant_unique: client.identifiant_unique || '--',
                numero_identification_fiscale: client.numero_identification_fiscale || '--',
                email: client.email || '--',
                adresse: this.formatAdresse(client.adresses?.[0]) || '--',
                telephone: this.getTelephoneString(client.telephones)
            } : null,

            fournisseur_data: fournisseur ? {
                nom_entreprise: fournisseur.nom_entreprise || '--',
                numero_identification_fiscale: fournisseur.numero_identification_fiscale || '--',
                responsable: fournisseur.responsable || (fournisseur as any).contact || '--',
                phone: this.getTelephoneString(fournisseur.telephones) || '--',
                adresse: this.formatAdresse(fournisseur.adresses?.[0]) || '--',
                email: this.getEmailString(fournisseur.emails) || '--',
                telephone: this.getTelephoneString(fournisseur.telephones) || '--'
            } : null,

            projets: projet ? [{libelle: projet.titre || projet.libelle || '--'}] : [],
            note: doc.note || '--',

            lignes_document: (doc.lignesDocument || doc.lignes_document || []).map((l: any) => {
                const prixHT = parseFloat(l.result_ht) || parseFloat(l.prix_ht) || 0;
                return {
                    libelle: l.libelle,
                    qnt: parseFloat(l.qnt),
                    prix_ht: prixHT,
                    tva: parseFloat(l.tva) || 19,
                    total_ht: prixHT * parseFloat(l.qnt),
                    product_id: l.product_id || null,
                    code_bar: l.code_bar ?? l.code_barre ?? null,
                    ref_interne: l.ref_interne ?? l.reference ?? null,
                    couleur: l.couleur ?? null,
                    taille: l.taille ?? null,
                    ajout_ligne: l.ajout_ligne && Array.isArray(l.ajout_ligne) ? l.ajout_ligne.map((al: any) => ({
                        contenu_text: al.contenu_text || '',
                        rubrique: al.rubrique || '',
                        separateur: al.separateur || false,
                        sous_total: Number(al.sous_total) || 0,
                        order: Number(al.order) || 0
                    })) : undefined
                };
            })
        };
    }

    private formatAdresse(addr: any): string {
        if (!addr) {
            return 'Adresse non renseignée';
        }
        return `${addr.adresse || ''}, ${addr.code_postal || ''} ${addr.region || ''}, ${addr.pays || ''}`.trim();
    }

    updateDocument(customStatutId?: number): Observable<any> {
        if (!this.documentId) {
            this.toastr.error('ID du document manquant.');
            return of(null);
        }
        if (!this.currentUser?.id || !this.stationId) {
            this.toastr.error('Utilisateur ou station non chargé.');
            return of(null);
        }
        if (this.mode === 'edit' && !this.currentStatutId && !customStatutId) {
            return this.documentService.getDocumentById(this.documentId).pipe(
                catchError((error) => {
                    return throwError(() => error);
                }),
                switchMap((response: any) => {
                    const doc = response?.data?.document || response?.data || response;
                    if (doc && doc.statut_id) {
                        this.currentStatutId = doc.statut_id;
                    }
                    return this.performUpdateDocument(customStatutId);
                })
            );
        } else {
            return this.performUpdateDocument(customStatutId);
        }
    }

    private performUpdateDocument(customStatutId?: number): Observable<any> {

        const isAchat = ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(this.documentType);
        let clientDataPayload: any = undefined;
        let fournisseurDataPayload: any = undefined;
        let projetPivot: ProjetPivot | null = null;
        const projetIdToSend = this.getProjetId();
        if (projetIdToSend) {
            const found = this.projects.find(p => p.id === projetIdToSend);
            if (found) {
                projetPivot = {
                    id_projet: String(found.id),
                    titre: found.libelle || 'Projet sans nom'
                };
            }
        } else if (this.originalProjectId) {
            const found = this.projects.find(p => p.id === this.originalProjectId);
            if (found) {
                projetPivot = {
                    id_projet: String(found.id),
                    titre: found.libelle || 'Projet sans nom'
                };
            }
        }
        if (!isAchat && this.selectedClient) {
            const clientActif = this.clients.find(c => c.id === this.selectedClient!.id);
            clientDataPayload = {
                client_id: clientActif ? this.resolveDocumentClientId(this.selectedClient) : null,
                nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
                identifiant_unique: this.selectedClient.identifiant_unique || '',
                numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
                adresse: this.getAdresseString(this.selectedClient.adresses),
                email: this.getEmailString(this.selectedClient.emails),
                telephone: this.getTelephoneString(this.selectedClient.telephones)
            };
            if (!clientActif) {
                this.toastr.warning('Client inactif : envoi avec client_id = null');
            }
        }
        if (isAchat && this.selectedFournisseur) {
            const fournisseurActif = this.fournisseurs.find(f => f.id === this.selectedFournisseur!.id);
            fournisseurDataPayload = {
                fournisseur_id: fournisseurActif ? this.selectedFournisseur.id : null,
                nom_entreprise: this.selectedFournisseur.nom_entreprise || '',
                numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || '',
                phone: this.getTelephoneString(this.selectedFournisseur.telephones),
                adresse: this.getAdresseString(this.selectedFournisseur.adresses),
                email: this.getEmailString(this.selectedFournisseur.emails)
            };
        }
        let statutIdToUse: number;
        if (customStatutId !== undefined) {
            statutIdToUse = customStatutId;
        } else if (this.currentStatutId) {
            statutIdToUse = this.currentStatutId;
        } else if (this.mode === 'edit' && this.documentId) {
            statutIdToUse = 1;
        } else {
            statutIdToUse = this.getApproveStatutId();
        }
        const userId = this.mode === 'edit' && this.currentDocumentUserId != null
            ? this.currentDocumentUserId
            : (this.currentUser?.id ?? 0);
        const typeDocumentId = this.mode === 'edit' && this.currentTypeDocumentId != null
            ? this.currentTypeDocumentId
            : (this.typeDocumentIdMap[this.documentType] ?? 0);

        const payload: DocumentPayload = {
            user_id: userId,
            station_id: this.stationId,
            type_document_id: typeDocumentId,
            statut_id: statutIdToUse,
            ...this.documentRefPayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note,
            total_ht: this.totals.totalHT.toFixed(3),
            total_tva: this.totals.totalTVA.toFixed(3),
            total_ttc: this.totals.totalTTC.toFixed(3),
            timbre_fiscal: this.getTimbreFiscalEffective().toFixed(3),
            net_payer: this.totals.netAPayer.toFixed(3),
            entrepot_id: this.documentType === 'BON TRANSFERT' 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.documentType === 'BON TRANSFERT' && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),
            ...(this.documentOriginalId != null && { document_original_id: this.documentOriginalId }),
            ...this.referenceModelTypePayloadSpread(),
            client_data: clientDataPayload,
            fornisseur_data: fournisseurDataPayload,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            parametrage_doc: (() => {
                const parametrageDoc = this.buildParametrageDoc();
                return parametrageDoc;
            })(),

            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },

            date_echeance: '',
            nbr_date: 0,
            color: '#134AD3',

            lignes_document: this.prepareLignesDocumentForSave()
        };

        const cleanedPayload = this.cleanPayload(payload);
        if (!this.documentId) {
            return throwError(() => new Error('ID du document manquant'));
        }
        
        return this.documentService.update(this.documentId, cleanedPayload).pipe(
            catchError((error) => {
                throw error;
            })
        );
    }

    saveDocument(): void {
        if (!this.validateClientAndProject()) {
            return;
        }
        if (this.isApproveButtonDisabled) {
            return;
        }
        if (this.isSubmitting) return;
        this.syncSessionFromStorage();
        const sessionUserId = Number(this.currentUser?.id) || 0;
        const sessionStationId = this.stationId;
        if (!sessionUserId || !sessionStationId || sessionStationId <= 0) {
            this.toastr.error(
                'Les champs station_id et user_id sont obligatoires (session invalide). Reconnectez-vous.',
                'Erreur'
            );
            return;
        }
        if (this.mode === 'edit' && this.documentId) {
            this.isSubmitting = true;
            this.toastr.info('Mise à jour du document en cours...', '', { timeOut: 5000 });
            
            this.recalculateAll();
            this.updateDocument().subscribe({
                next: () => {
                    this.toastr.success('Document mis à jour avec succès !');
                    this.isSubmitting = false;
                    if (this.documentType === 'INVENTAIRE') {
                        this.router.navigate(['/inventaire/action/validation'], {queryParams: {id: this.documentId}});
                    } else if (this.documentType === 'BON TRANSFERT') {
                        this.router.navigate(['/bon-transfert/action/validation'], {queryParams: {id: this.documentId}});
                    } else {
                        this.router.navigate([this.getBasePath(), 'action', 'validation'], {queryParams: {id: this.documentId}});
                    }
                },
                error: (err) => {
                    this.isSubmitting = false;
                    this.toastr.error(err?.error?.message || 'Erreur lors de la mise à jour');
                }
            });
            return;
        }
        this.isSubmitting = true;
        this.updateHeaderConfig();
        this.cdr.detectChanges();
        this.calculateTotals();
        const isAchat = ['COMMANDE FOURNISSEUR', 'BON RECEPTION', 'FACTURE FOURNISSEUR'].includes(this.documentType);
        let projetPivot: ProjetPivot | null = null;
        if (this.selectedProject) {
            const projet = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
            if (projet) {
                projetPivot = {
                    id_projet: String(projet.id),
                    titre: projet.libelle || 'Projet sans titre'
                };
            }
        }

        // --- CLIENT / FOURNISSEUR ---
        const clientDataPayload = !isAchat && this.selectedClient ? {
            client_id: this.resolveDocumentClientId(this.selectedClient),
            nom_client: this.resolveDocumentClientDisplayName(this.selectedClient),
            identifiant_unique: this.selectedClient.identifiant_unique || null,
            numero_identification_fiscale: this.selectedClient.numero_identification_fiscale || null,
            adresse: this.getAdresseString(this.selectedClient.adresses),
            email: this.getEmailString(this.selectedClient.emails),
            telephone: this.getTelephoneString(this.selectedClient.telephones)
        } : null;

        const fournisseurDataPayload = isAchat && this.selectedFournisseur ? {
            fournisseur_id: this.selectedFournisseur.id,
            nom_entreprise: this.selectedFournisseur.nom_entreprise || 'Fournisseur inconnu',
            numero_identification_fiscale: this.selectedFournisseur.numero_identification_fiscale || null,
            phone: this.getTelephoneString(this.selectedFournisseur.telephones),
            adresse: this.getAdresseString(this.selectedFournisseur.adresses),
            email: this.getEmailString(this.selectedFournisseur.emails)
        } : null;

        const f = (n: number) => n.toFixed(3);
        const parametrageDoc = this.buildParametrageDoc();
        const payload: any = {
            ...this.documentRefPayloadSpread(),
            ...this.referenceModelTypePayloadSpread(),
            date: this.documentDate,
            date_livraison: this.dateLivraison || this.documentDate,
            note: this.note || null,

            total_ht: f(this.totals.totalHT),
            total_tva: f(this.totals.totalTVA),
            total_ttc: f(this.totals.totalTTC),
            timbre_fiscal: Number(this.getTimbreFiscalEffective()).toFixed(3),
            net_payer: f(this.totals.netAPayer),

            user_id: this.currentUser.id,
            station_id: this.stationId,
            type_document_id: this.typeDocumentIdMap[this.documentType],
            statut_id: this.getApproveStatutId(),
            entrepot_id: this.documentType === 'BON TRANSFERT' 
                ? (this.selectedWarehouseInitialId ?? null)
                : (this.selectedWarehouseId ?? null),
            ...(this.documentType === 'BON TRANSFERT' && { entrepot_dest_id: this.selectedWarehouseDestinationId ?? null }),
            ...(this.documentOriginalId != null && { document_original_id: this.documentOriginalId }),

            client_data: clientDataPayload,
            fornisseur_data: fournisseurDataPayload,

            entreprises: this.buildEntreprisesPayload(),
            coordonnees_bancaires: this.buildCoordonneesBancairesPayload(),
            projets: projetPivot ? [projetPivot] : [],
            parametrage_doc: parametrageDoc,
            hidden_client_fields: {
                nomClient: this.modifiedClientFields.nomClient || false,
                identifiant: this.modifiedClientFields.identifiant || false,
                numeroIdentification: this.modifiedClientFields.numeroIdentification || false,
                adresse: this.modifiedClientFields.adresse || false,
                email: this.modifiedClientFields.email || false
            },
            hidden_fournisseur_fields: {
                nomEntreprise: this.modifiedFournisseurFields.nomEntreprise || false,
                numeroIdentification: this.modifiedFournisseurFields.numeroIdentification || false,
                responsable: this.modifiedFournisseurFields.responsable || false,
                telephone: this.modifiedFournisseurFields.telephone || false,
                adresse: this.modifiedFournisseurFields.adresse || false
            },

            lignes_document: this.prepareLignesDocumentForSave()
        };

        const entrepotIdValue = this.documentType === 'BON TRANSFERT'
            ? (this.selectedWarehouseInitialId !== null && this.selectedWarehouseInitialId !== undefined 
                ? this.selectedWarehouseInitialId 
                : payload.entrepot_id)
            : (this.selectedWarehouseId !== null && this.selectedWarehouseId !== undefined 
                ? this.selectedWarehouseId 
                : payload.entrepot_id);
        
        const entrepotDestIdValue = this.documentType === 'BON TRANSFERT'
            ? (this.selectedWarehouseDestinationId !== null && this.selectedWarehouseDestinationId !== undefined 
                ? this.selectedWarehouseDestinationId 
                : payload.entrepot_dest_id)
            : null;
        payload.user_id = sessionUserId;
        payload.station_id = sessionStationId;

        Object.keys(payload).forEach(key => {
            if (key === 'user_id' || key === 'station_id') {
                return;
            }
            if (key !== 'entrepot_id' && key !== 'entrepot_dest_id' && key !== 'hidden_client_fields' && key !== 'hidden_fournisseur_fields' && key !== 'parametrage_doc') {
            if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
                delete payload[key];
                }
            }
        });

        if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }

        if (entrepotIdValue !== null && entrepotIdValue !== undefined && entrepotIdValue !== '') {
            payload.entrepot_id = entrepotIdValue;
        } else {
            delete payload.entrepot_id;
        }

        if (this.documentType === 'BON TRANSFERT' && entrepotDestIdValue !== null && entrepotDestIdValue !== undefined && entrepotDestIdValue !== '') {
            payload.entrepot_dest_id = entrepotDestIdValue;
        } else if (this.documentType === 'BON TRANSFERT') {
            delete payload.entrepot_dest_id;
        }

        this.applyLogicielCaisseEntrepotToPayload(payload);

        if (payload.lignes_document && Array.isArray(payload.lignes_document)) {
            payload.lignes_document.forEach((ligne: any, idx: number) => {
                if (ligne.ajout_ligne && Array.isArray(ligne.ajout_ligne)) {
                }
            });
        }
        if (!payload.parametrage_doc || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }
        if (!payload.hasOwnProperty('parametrage_doc') || payload.parametrage_doc === null || payload.parametrage_doc === undefined) {
            payload.parametrage_doc = this.buildParametrageDoc();
        }

        const onCreateSuccess = (res: any, pairedBonLivraisonId?: number | null) => {
            const id = res?.data?.id || res?.data?.document?.id || res?.id;
            if (id) {
                this.applyAllocatedReferenceFromCreateResponse(res);
            }
            this.currentStatutId = this.getApproveStatutId();
            const afterCreateCommon = () => {
                if (this.requiresStockUpdate()) {
                    this.updateStockForDocument(id, () => this.schedulePostDocumentStockAlerts());
                } else {
                    this.schedulePostDocumentStockAlerts();
                }
                if (this.documentType === 'FACTURE FOURNISSEUR') {
                    this.updateProductsValeurUnitaireForFactureFournisseur();
                }
                this.toastr.success(
                    pairedBonLivraisonId
                        ? 'Facture et bon de livraison créés avec succès !'
                        : 'Document créé avec succès !'
                );
                const goAfterLink = () => {
                    this.isSubmitting = false;
                    this.updateHeaderConfig();
                    this.router.navigate([this.getBasePath(), 'action', 'validation'], {queryParams: {id}});
                };
                this.linkTicketsToErpFactureIfNeeded$(id, res).subscribe({
                    next: () => goAfterLink(),
                    error: () => goAfterLink()
                });
            };

            afterCreateCommon();
        };
        const onCreateError = (err: any) => {
            this.isSubmitting = false;
            this.updateHeaderConfig();
            this.cdr.detectChanges();
            const errorMessage = err?.error?.message || err?.message || 'Erreur lors de la création';
            this.toastr.error(errorMessage, 'Erreur de sauvegarde');
        };

        if (this.documentType === 'BON TRANSFERT') {
            this.documentService.create(payload).subscribe({
                next: onCreateSuccess,
                error: (err) => {
                    this.isSubmitting = false;
                    this.updateHeaderConfig();
                    this.cdr.detectChanges();
                    this.toastr.error(err?.error?.message || err?.message || 'Erreur lors de la création', 'Erreur de sauvegarde');
                }
            });
        } else if (this.documentType === 'FACTURE') {
            this.createFactureWithOptionalBonLivraison$().subscribe({
                next: ({ res, pairedBlId }) => onCreateSuccess(res, pairedBlId),
                error: onCreateError
            });
        } else {
            this.documentService.create(payload).subscribe({
                next: (res) => onCreateSuccess(res),
                error: onCreateError
            });
        }
    }
    private buildParametrageDoc(): any {
        const parametrageDoc = {
            aff_montant_ttc: this.documentColumnSettings.aff_montant_ttc !== undefined 
                ? this.documentColumnSettings.aff_montant_ttc 
                : (this.documentColumnSettings.afficherMontantsTTC !== undefined ? this.documentColumnSettings.afficherMontantsTTC : false),
            aff_code_bar: this.documentColumnSettings.aff_code_bar !== undefined 
                ? this.documentColumnSettings.aff_code_bar 
                : (this.documentColumnSettings.afficherCodeBarres !== undefined ? this.documentColumnSettings.afficherCodeBarres : true),
            aff_date_echeance: this.documentColumnSettings.aff_date_echeance !== undefined 
                ? this.documentColumnSettings.aff_date_echeance 
                : (this.documentColumnSettings.afficherDateEcheance !== undefined ? this.documentColumnSettings.afficherDateEcheance : false),
            aff_date_liv: this.documentColumnSettings.aff_date_liv !== undefined 
                ? this.documentColumnSettings.aff_date_liv 
                : (this.documentColumnSettings.afficherDateLivraison !== undefined ? this.documentColumnSettings.afficherDateLivraison : true),
            aff_montant_total: this.documentColumnSettings.aff_montant_total !== undefined 
                ? this.documentColumnSettings.aff_montant_total 
                : (this.documentColumnSettings.afficherMontantTotal !== undefined ? this.documentColumnSettings.afficherMontantTotal : true),
            aff_coordonnees: this.documentColumnSettings.aff_coordonnees !== undefined 
                ? this.documentColumnSettings.aff_coordonnees 
                : (this.documentColumnSettings.afficherCoordonneesClients !== undefined ? this.documentColumnSettings.afficherCoordonneesClients : true),
            reference: this.documentColumnSettings.reference !== undefined 
                ? this.documentColumnSettings.reference 
                : false,
            quantite: this.documentColumnSettings.quantite !== undefined
                ? this.documentColumnSettings.quantite
                : (this.documentColumnSettings.quantité !== undefined ? this.documentColumnSettings.quantité : true),
            unité: this.documentColumnSettings.unité !== undefined 
                ? this.documentColumnSettings.unité 
                : (this.documentColumnSettings.unite !== undefined ? this.documentColumnSettings.unite : false),
            taille: this.documentColumnSettings.taille !== undefined ? this.documentColumnSettings.taille : false,
            prix_unitaire: this.documentColumnSettings.prix_unitaire !== undefined 
                ? this.documentColumnSettings.prix_unitaire 
                : (this.documentColumnSettings.prixUnitaire !== undefined ? this.documentColumnSettings.prixUnitaire : true),
            tva: this.documentColumnSettings.tva !== undefined ? this.documentColumnSettings.tva : true,
            remise: this.documentColumnSettings.remise !== undefined ? this.documentColumnSettings.remise : false,
            color: this.primaryColor || '#134AD3',
            label: this.documentLabel || '',
            date_echeance: this.dateFrequency || 'jours',
            nbr_date: this.nbrDate || 1,
            ...(Object.keys(this.documentTaxStatutOverrides).length > 0
                ? { taxe_statut_document: { ...this.documentTaxStatutOverrides } }
                : {})
        };
        return parametrageDoc;
    }

    private cleanPayload(payload: DocumentPayload): DocumentPayload {
        const cleaned: any = {...payload};
        const required = ['user_id', 'type_document_id', 'statut_id', 'station_id'];
        const parametrageDocAttribute = ['parametrage_doc'];
        const hiddenFieldsAttributes = [
            'hidden_client_fields', 'hidden_fournisseur_fields'
        ];
        const entrepotIdValue = cleaned.entrepot_id;
        const entrepotDestIdValue = cleaned.entrepot_dest_id;

        Object.keys(cleaned).forEach(key => {
            if (required.includes(key) || parametrageDocAttribute.includes(key) || hiddenFieldsAttributes.includes(key)) {
                return;
            }
            if (key === 'lignes_document') {
                return;
            }
            if (key === 'entrepot_id') {
                return;
            }
            if (key === 'entrepot_dest_id') {
                return;
            }
            if (key === 'parametrage_doc') {
                return;
            }
            const value = cleaned[key];
            if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
                delete cleaned[key];
            }
        });
        if (entrepotIdValue !== null && entrepotIdValue !== undefined && entrepotIdValue !== '') {
            cleaned.entrepot_id = entrepotIdValue;
        } else {
            delete cleaned.entrepot_id;
        }
        if (entrepotDestIdValue !== null && entrepotDestIdValue !== undefined && entrepotDestIdValue !== '') {
            cleaned.entrepot_dest_id = entrepotDestIdValue;
        } else {
            delete cleaned.entrepot_dest_id;
        }
        if (!cleaned.lignes_document) {
            cleaned.lignes_document = [];
        }
        if (cleaned.lignes_document && Array.isArray(cleaned.lignes_document)) {
            cleaned.lignes_document.forEach((ligne: any, idx: number) => {
                if (!ligne.hasOwnProperty('ajout_ligne')) {
                    ligne.ajout_ligne = [];
                } else if (ligne.ajout_ligne === undefined || ligne.ajout_ligne === null) {
                    ligne.ajout_ligne = [];
                }

            });
        }
        if (!cleaned.parametrage_doc || cleaned.parametrage_doc === null || cleaned.parametrage_doc === undefined) {
            cleaned.parametrage_doc = this.buildParametrageDoc();
        }
        
        return cleaned as DocumentPayload;
    }

    private getProjetId(): number | null {
        const projet = this.projects.find(p => this.normalizeString(p.libelle) === this.normalizeString(this.selectedProject));
        return projet?.id || null;
    }

    onDocumentSettingsChange(settings: any) {
        if (settings.reference !== undefined) {
            this.documentColumnSettings.reference = settings.reference;
            this.documentColumnSettings.référence = settings.reference;
        }
        if (settings.quantite !== undefined) {
            this.documentColumnSettings.quantite = settings.quantite;
            this.documentColumnSettings.quantité = settings.quantite;
        }
        if (settings.unite !== undefined) {
            this.documentColumnSettings.unite = settings.unite;
            this.documentColumnSettings.unité = settings.unite;
        }
        if (settings.taille !== undefined) {
            this.documentColumnSettings.taille = settings.taille;
        }
        if (settings.prixUnitaire !== undefined) {
            this.documentColumnSettings.prixUnitaire = settings.prixUnitaire;
            this.documentColumnSettings.prix_unitaire = settings.prixUnitaire;
        }
        if (settings.tva !== undefined) {
            this.documentColumnSettings.tva = settings.tva;
        }
        if (settings.remise !== undefined) {
            this.documentColumnSettings.remise = settings.remise;
        }
        if (settings.afficherMontantsTTC !== undefined) {
            this.documentColumnSettings.afficherMontantsTTC = settings.afficherMontantsTTC;
            this.documentColumnSettings.aff_montant_ttc = settings.afficherMontantsTTC;
        }
        if (settings.afficherCodeBarres !== undefined) {
            this.documentColumnSettings.afficherCodeBarres = settings.afficherCodeBarres;
            this.documentColumnSettings.aff_code_bar = settings.afficherCodeBarres;
        }
        if (settings.afficherDateEcheance !== undefined) {
            this.documentColumnSettings.afficherDateEcheance = settings.afficherDateEcheance;
            this.documentColumnSettings.aff_date_echeance = settings.afficherDateEcheance;
        }
        if (settings.afficherDateLivraison !== undefined) {
            this.documentColumnSettings.afficherDateLivraison = settings.afficherDateLivraison;
            this.documentColumnSettings.aff_date_liv = settings.afficherDateLivraison;
        }
        if (settings.afficherMontantTotal !== undefined) {
            this.documentColumnSettings.afficherMontantTotal = settings.afficherMontantTotal;
            this.documentColumnSettings.aff_montant_total = settings.afficherMontantTotal;
        }
        if (settings.afficherCoordonneesClients !== undefined) {
            this.documentColumnSettings.afficherCoordonneesClients = settings.afficherCoordonneesClients;
            this.documentColumnSettings.aff_coordonnees = settings.afficherCoordonneesClients;
        }
        if (settings.parametrage_doc) {
            if (settings.parametrage_doc.color !== undefined) {
                this.primaryColor = settings.parametrage_doc.color;
            }
            if (settings.parametrage_doc.label !== undefined && settings.parametrage_doc.label !== '') {
                this.documentLabel = settings.parametrage_doc.label;
            }
            if (settings.parametrage_doc.date_echeance !== undefined) {
                this.dateFrequency = settings.parametrage_doc.date_echeance;
            }
            if (settings.parametrage_doc.nbr_date !== undefined) {
                this.nbrDate = settings.parametrage_doc.nbr_date;
            }
        }

        this.documentColumnSettings = {...this.documentColumnSettings};

        this.cdr.detectChanges();
    }

    onTaxesUpdated(): void {
        this.loadTaxes();
        this.cdr.detectChanges();
    }

    getUniteLibelle(item: any): string {
        if (item.unite_libelle) {
            return item.unite_libelle;
        }

        if (item.product_id) {
            const cached = this.products.find(p => p.id === item.product_id);
            if (cached?.unite?.libelle) {
                item.unite_libelle = cached.unite.libelle;
                return item.unite_libelle;
            }
        }

        return '--';
    }

    openAddWarehouseModal(target: 'single' | 'initial' | 'destination' = 'single'): void {
        this.warehouseModalTarget = target;
        this.editWarehouseModal.warehouseData = null;
        this.editWarehouseModal.openModal();
    }
    openViewWarehouseInitialModal(): void {
        if (this.selectedWarehouseInitialId == null) {
            this.toastr.warning('Veuillez sélectionner un entrepôt initial', 'Entrepôt initial');
            return;
        }
        const warehouse = this.warehouses?.find((w: any) => w.id === this.selectedWarehouseInitialId);
        if (!warehouse) {
            this.toastr.warning('Entrepôt initial introuvable', 'Entrepôt initial');
            return;
        }
        this.editWarehouseModal.warehouseData = {
            id: warehouse.id,
            nom: warehouse.nom,
            adresse: warehouse.adresse,
            ville: warehouse.ville,
            code_postal: warehouse.code_postal,
            pays: warehouse.pays
        };
        this.editWarehouseModal.openModal();
    }

    openAddProduct():void{
        if (!this.warehouses?.length) {
            this.loadWarehouses();
        }
        this.addProductModal.openModal();
    }

    onWarehouseSaved(apiResponse?: any): void {
        const newId = this.extractWarehouseIdFromSaveResponse(apiResponse);
        this.loadWarehouses(newId);
    }

    onWarehouseChange(): void {
        if (this.shouldFilterStockByEntrepot()) {
            console.log(`🔄 [onWarehouseChange] Entrepôt changé pour ${this.documentType}, rechargement des quantités de stock...`);
            this.stockQuantitiesCache.clear();
            this.selectOptionStockByCacheKey.clear();
            this.selectOptionStockLoadingKeys.clear();
            this.items.forEach(item => {
                if (item && 'availableQuantity' in item) {
                    (item as Item).availableQuantity = undefined;
                }
            });
            this.products.forEach(p => {
                (p as any).availableQuantity = undefined;
            });
            this.reloadStockQuantitiesForAllProducts();
            if (this.products.length > 0) {
                this.preloadStockQuantitiesForAllProducts();
            }
            this.preloadSelectStockTotalsForDocumentOptions();
        }
        this.updateApproveButtonState();
        this.cdr.detectChanges();
    }

    getColspan(): number {

        const settings = this.documentColumnSettings || {};

        let count = 1;

        if (settings.reference) {
            count++;
        }
        if (settings.taille) {
            count++;
        }
        if (this.showQuantiteDisponibleColumn()) {
            count++;
        }
        if (settings.quantite) {
            count++;
        }
        if (settings.unite) {
            count++;
        }
        if (settings.prixUnitaire) {
            count++;
        }
        if (settings.tva) {
            count++;
        }
        if (settings.remise) {
            count++;
        }
        if (settings.afficherMontantsTTC) {
            count++;
        }

        count++;
        return count || 8;
    }

    getProductLineTailleDisplay(item: any): string {
        if (!item) {
            return '--';
        }
        const t = String(item.taille ?? '').trim();
        return t || '--';
    }

    getActiveTaxesForProduct(item: any): any[] {
        if (!item.product_id || !this.taxes?.length) {
            return [];
        }
        return this.taxes.filter((taxe: any) => {
            const appliqueTva = taxe.applique_tva === true || taxe.applique_tva === 1 || taxe.applique_a_la_tva === true || taxe.applique_a_la_tva === 1;
            const taxeSurProduits = taxe.taxe_applique_sur_produits === true || taxe.taxe_applique_sur_produits === 1 || taxe.taxe_applique_sur_produits === '1' || taxe.taxe_applique_sur_produits === 'true';
            return this.isTaxActiveForDocument(taxe) && !appliqueTva && taxeSurProduits;
        });
    }

    isTaxeAssignedToProduct(item: any, taxe: any): boolean {
        return (item['taxesProduit'] || []).some((t: any) =>
            t.id === taxe.id || (t.taxes_id != null && t.taxes_id === taxe.id)
        );
    }
    toggleTaxeForLine(lineIndex: number, taxe: any): void {
        const item = this.items[lineIndex];
        if (!item || item.type !== 'product') return;
        const list = (item['taxesProduit'] || []) as any[];
        const isAssigned = list.some((t: any) => t.id === taxe.id || (t.taxes_id != null && t.taxes_id === taxe.id));
        if (isAssigned) {
            item['taxesProduit'] = list.filter((t: any) => t.id !== taxe.id && t.taxes_id !== taxe.id);
        } else {
            const toAdd = this.taxes?.find((t: any) => t.id === taxe.id) || { ...taxe, id: taxe.id };
            item['taxesProduit'] = [...list, toAdd];
        }
        item['fodecApplique'] = (item['taxesProduit'] || []).some((tax: any) =>
            tax.nom?.toLowerCase().includes('fodec') || tax.label?.toLowerCase().includes('fodec')
        );
        this.calculateLine(lineIndex);
        this.calculateTotals();
        this.cdr.detectChanges();
        if (this.documentId && (this.mode === 'edit' || this.isEditing)) {
            this.updateDocument().subscribe({
                next: () => this.toastr.success('Taxe mise à jour'),
                error: (err) => this.toastr.error(err?.error?.message || 'Erreur lors de la mise à jour de la taxe')
            });
        }
    }

    private saveAndExecute(action: () => void): void {
        if (this.mode !== 'edit' || !this.documentId) {
            action();
            return;
        }
        if (!this.currentStatutId && this.documentId) {
            this.documentService.getDocumentById(this.documentId).subscribe({
                next: (response) => {
                    const doc = response?.data?.document || response?.data || response;
                    if (doc && doc.statut_id) {
                        this.currentStatutId = doc.statut_id;
                    }
                    this.performSaveAndExecute(action);
                },
                error: () => {
                    this.performSaveAndExecute(action);
                }
            });
        } else {
            this.performSaveAndExecute(action);
        }
    }

    private performSaveAndExecute(action: () => void): void {
        this.isSubmitting = true;

        this.recalculateAll();

        const statutToUse = this.currentStatutId || undefined;
        this.updateDocument(statutToUse).subscribe({
            next: () => {
                this.toastr.success('Modifications sauvegardées !');
                this.isSubmitting = false;
                action();
            },
            error: () => {
                this.isSubmitting = false;
                this.toastr.error('Erreur de sauvegarde');
                if (confirm('Continuer sans sauvegarder ?')) action();
            }
        });
    }

    private changeStatutAndSave(newStatutId: number): void {
        if (this.isSubmitting) {
            return;
        }
        if (!this.documentId || !this.stationId) {
            this.toastr.error('ID du document ou station manquant.');
            return;
        }
        // BR « Reçu » / BL « Livré » : entrepôt ERP requis avant mouvement stock.
        if (
            ((this.documentType === 'BON RECEPTION' && newStatutId === this.statutIdMap['Reçu']) ||
                (this.documentType === 'BON DE LIVRAISON' && newStatutId === this.statutIdMap['Livré'])) &&
            !this.selectedWarehouseId
        ) {
            this.toastr.error(
                'Sélectionnez un entrepôt ERP avant de continuer (le stock sera mis à jour sur cet entrepôt).',
                'Entrepôt requis'
            );
            return;
        }

        this.isSubmitting = true;
        this.recalculateAll();
        this.updateDocument(newStatutId).subscribe({
            next: () => {
                this.currentStatutId = newStatutId;
                this.refreshConversionLockForSourceDocument(() => this.updateHeaderConfig());
                this.toastr.success('Document mis à jour !');
                const docId = this.documentId;
                const isBrRecu =
                    this.documentType === 'BON RECEPTION' &&
                    newStatutId === this.statutIdMap['Reçu'] &&
                    docId != null;
                const isBlLivre =
                    this.documentType === 'BON DE LIVRAISON' &&
                    newStatutId === this.statutIdMap['Livré'] &&
                    docId != null;
                if (isBrRecu) {
                    this.updateStockForDocument(docId!, () => {
                        this.schedulePostDocumentStockAlerts();
                        this.isSubmitting = false;
                        this.retour();
                    });
                } else if (isBlLivre) {
                    this.updateLcStockForBonLivraisonAfterLivre(docId!, () => {
                        this.schedulePostDocumentStockAlerts();
                        this.isSubmitting = false;
                        this.retour();
                    });
                } else if (
                    this.documentType === 'BON RECEPTION' &&
                    newStatutId === this.statutIdMap['Annulé']
                ) {
                    this.isSubmitting = false;
                    this.retour();
                } else if (newStatutId === this.statutIdMap['Annulé'] && docId != null) {
                    this.isSubmitting = false;
                    this.router.navigate([this.getBasePath(), 'action', 'validation'], {
                        queryParams: { id: docId }
                    });
                } else {
                    this.isSubmitting = false;
                    this.retour();
                }
            },
            error: () => {
                this.isSubmitting = false;
                this.toastr.error('Erreur lors de la mise à jour');
            }
        });
    }

    /** Depuis Annulé : repasse en Brouillon et reste sur l’écran document (édition). */
    private remettreEnBrouillonFromAnnule(): void {
        if (this.documentType === 'BON RECEPTION') {
            this.toastr.warning(
                'Un bon de réception ne peut pas être remis en brouillon.',
                'Action impossible'
            );
            return;
        }
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;
        this.recalculateAll();
        const brouillonId = this.statutIdMap['Brouillon'];
        this.updateDocument(brouillonId).subscribe({
            next: () => {
                this.currentStatutId = brouillonId;
                this.mode = 'edit';
                this.isEditing = true;
                this.updateHeaderConfig();
                this.toastr.success('Document remis en brouillon');
                this.isSubmitting = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.isSubmitting = false;
                this.toastr.error('Erreur lors de la remise en brouillon');
            }
        });
    }

    private recalculateAll(): void {
        this.items.forEach((item, index) => {
            if (item.type === 'product') {
                this.calculateTotal(index);
            }
        });
        this.calculateTotals();
        this.cdr.detectChanges();
    }

    onProductLineQuantityChange(index: number, value: string | number | null | undefined): void {
        if (this.isProductLineQuantityReadonly(index)) {
            return;
        }
        const item = this.items[index];
        if (!item || item.type !== 'product') {
            return;
        }
        const raw = Number(value);
        item.quantity = Number.isFinite(raw) ? Math.max(0, raw) : 0;
        this.calculateTotal(index);
        this.cdr.detectChanges();
    }

    getLineTotalHT(item: any): number {
        if (!item || item.type !== 'product') {
            return 0;
        }
        if (item.htNet != null && Number.isFinite(Number(item.htNet))) {
            return Number(item.htNet);
        }
        const prixHT = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
            ? (Number(item.valeur_unitaire) || 0)
            : (Number(item.priceHT) || 0);
        const qteRaw = Number(item.quantity);
        const quantite = Number.isFinite(qteRaw) ? qteRaw : 0;
        const remisePourcent = Number(item.remise) || 0;
        let totalBrut = prixHT * quantite;
        if (remisePourcent > 0) {
            totalBrut = totalBrut * (1 - remisePourcent / 100);
        }
        return Number(totalBrut.toFixed(3));
    }

    onProductAdded(event: any): void {
        if (event.success && event.product) {
            this.products.unshift(event.product);
            this.rebuildProductsForDocumentSelect();
            const lastItem = this.items[this.items.length - 1];
            if (lastItem && lastItem.type === 'product' && !lastItem.designation) {
                this.onProductSelect(this.items.length - 1, event.product);
            }
        }
    }

    getLineTotalTTC(item: any): number {
        if (!item || item.type !== 'product') {
            return 0;
        }

        if (item.ttcLigne !== undefined) {
            return Number(item.ttcLigne);
        }

        const quantity = item.quantity !== null && item.quantity !== undefined ? Number(item.quantity) : 0;
        const priceHT = (this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT')
            ? (Number(item.valeur_unitaire) || 0)
            : (Number(item.priceHT) || 0);
        const remisePourcent = Number(item.remise || 0);

        let htBrut = priceHT * quantity;
        let htApresRemise = htBrut * (1 - remisePourcent / 100);

        let totalTaxesAvantTVA = 0;
        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const taux = parseFloat(taxe.valeur || '0');
            if (isNaN(taux) || taux === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (appliqueAvantTVA) {
                totalTaxesAvantTVA += htApresRemise * (taux / 100);
            }
        });

        const baseTVA = htApresRemise + totalTaxesAvantTVA;
        const tauxTVA = Number(item.tva || 0);
        const montantTVA = baseTVA * (tauxTVA / 100);

        let totalTaxesApresTVA = 0;
        (item['taxesProduit'] || []).forEach((taxe: any) => {
            const taux = parseFloat(taxe.valeur || '0');
            if (isNaN(taux) || taux === 0) return;

            const appliqueAvantTVA = taxe.applique_avant_tva === true ||
                taxe.appliquee_avant_tva === true ||
                (taxe.nom?.toLowerCase().includes('fodec') || taxe.label?.toLowerCase().includes('fodec'));

            if (!appliqueAvantTVA) {
                const baseApres = baseTVA + montantTVA;
                totalTaxesApresTVA += baseApres * (taux / 100);
            }
        });

        const ttc = baseTVA + montantTVA + totalTaxesApresTVA;
        return Number(ttc.toFixed(3));
    }

    deselectClient() {
        this.selectedClient = null;
        this.selectedClientId = null;
        this.clientId = null;
        this.editMode = {
            nomClient: false,
            identifiant: false,
            numeroIdentification: false,
            adresse: false,
            email: false
        };
        this.cdr.detectChanges();
    }

    deselectFournisseur() {
        this.selectedFournisseur = null;
        this.selectedFournisseurId = null;
        this.clientId = null;
        this.editModeFournisseur = {
            nomEntreprise: false,
            numeroIdentification: false,
            responsable: false,
            telephone: false,
            adresse: false
        };
        this.cdr.detectChanges();
    }

    toggleEdit(field: 'nomClient' | 'identifiant' | 'numeroIdentification' | 'adresse' | 'email'): void {
        this.modifiedClientFields[field] = !this.modifiedClientFields[field];
        this.saveModifiedFields();
        this.cdr.detectChanges();
        this.replaceFeatherIconsNow();
    }

    
    private updateFeatherIconForClickedButton(element: HTMLElement, field: 'nomClient' | 'identifiant' | 'adresse' | 'email'): void {
        if (this.isInitializingIcons) {
            return;
        }
        let button = element.closest('button');
        if (!button && element.tagName === 'BUTTON') {
            button = element as HTMLButtonElement;
        }
        if (!button) return;
        
        const icon = button.querySelector('i[data-feather]') as HTMLElement;
        if (!icon) return;
        const isHidden = this.modifiedClientFields[field] === true;
        const newIconName = isHidden ? 'eye-off' : 'eye';
        icon.setAttribute('data-feather', newIconName);
        requestAnimationFrame(() => {
            const svgs = button!.querySelectorAll('svg');
            svgs.forEach(svg => svg.remove());
            setTimeout(() => {
                feather.replace();
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            }, 10);
        });
    }
    
    private updateFeatherIconForField(field: 'nomClient' | 'identifiant' | 'adresse' | 'email'): void {
        if (this.isInitializingIcons) {
            return;
        }
        requestAnimationFrame(() => {
            const container = document.querySelector('app-document');
            if (!container) {
                return;
            }
            setTimeout(() => {
                const allIcons = container.querySelectorAll('.btn-icon-eye i[data-feather]');

                if (allIcons.length > 0) {
                    const buttons = container.querySelectorAll('.btn-icon-eye');
                    buttons.forEach(btn => {
                        const svgs = btn.querySelectorAll('svg');
                        svgs.forEach(svg => svg.remove());
                    });
                    setTimeout(() => {
                        feather.replace();
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }, 20);
                }
            }, 50);
        });
    }

    private refreshEyeIconsOnly(): void {
        this.initializeFeatherIcons();
    }

    prepareAndToggle(field: 'adresse' | 'email'): void {

        if (field === 'adresse' && !this.editMode.adresse) {
            const adresseString = this.getAdresseString(this.selectedClient?.adresses) || '';
            this.tempAdresse = adresseString;
        }
        if (field === 'email' && !this.editMode.email) {
            const emailString = this.getEmailString(this.selectedClient?.emails) || '';
            this.tempEmail = emailString;
        }

        this.toggleEdit(field);
    }

    saveAdresse(): void {
        if (!this.selectedClient || !this.tempAdresse.trim()) return;

        const parts = this.tempAdresse.split(',').map(p => p.trim());
        const adresseObj: Partial<Address> = {
            adresse: parts[0] || '',
            code_postal: parts[1] || '',
            region: parts[2] || '',
            pays: parts[3] || ''
        };

        if (!this.selectedClient.adresses || this.selectedClient.adresses.length === 0) {
            this.selectedClient.adresses = [adresseObj as Address];
        } else {
            this.selectedClient.adresses[0] = { ...this.selectedClient.adresses[0], ...adresseObj };
        }
        this.modifiedClientFields['adresse'] = true;
        this.saveModifiedFields();
    }

    saveEmail(): void {
        if (!this.selectedClient || !this.tempEmail.trim()) return;

        const emailObj: Partial<Email> = { email: this.tempEmail.trim() };

        if (!this.selectedClient.emails || this.selectedClient.emails.length === 0) {
            this.selectedClient.emails = [emailObj as Email];
        } else {
            this.selectedClient.emails[0] = emailObj as Email;
        }
        this.modifiedClientFields['email'] = true;
        this.saveModifiedFields();
    }
    toggleEditFournisseur(field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse', _event?: Event): void {
        this.modifiedFournisseurFields[field] = !this.modifiedFournisseurFields[field];
        this.saveModifiedFields();
        this.cdr.detectChanges();
        this.cdr.markForCheck();
        this.replaceFeatherIconsNow();
    }

    private updateFeatherIconForClickedButtonFournisseur(element: HTMLElement, field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse'): void {
        if (this.isInitializingIcons) {
            return;
        }
        let button = element.closest('button');
        if (!button && element.tagName === 'BUTTON') {
            button = element as HTMLButtonElement;
        }
        if (!button) return;

        const icon = button.querySelector('i[data-feather]') as HTMLElement;
        if (!icon) return;
        const isHidden = this.modifiedFournisseurFields[field] === true;
        const newIconName = isHidden ? 'eye-off' : 'eye';
        icon.setAttribute('data-feather', newIconName);
        requestAnimationFrame(() => {
            const svgs = button!.querySelectorAll('svg');
            svgs.forEach(svg => svg.remove());
            setTimeout(() => {
                feather.replace();
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            }, 10);
        });
    }

    private updateFeatherIconForFournisseurField(field: 'nomEntreprise' | 'numeroIdentification' | 'responsable' | 'telephone' | 'adresse'): void {
        if (this.isInitializingIcons) {
            return;
        }
        requestAnimationFrame(() => {
            const container = document.querySelector('app-document');
            if (!container) {
                return;
            }
            setTimeout(() => {
                const allIcons = container.querySelectorAll('.btn-icon-eye i[data-feather]');

                if (allIcons.length > 0) {
                    const buttons = container.querySelectorAll('.btn-icon-eye');
                    buttons.forEach(btn => {
                        const svgs = btn.querySelectorAll('svg');
                        svgs.forEach(svg => svg.remove());
                    });
                    setTimeout(() => {
                        feather.replace();
                        this.cdr.markForCheck();
                        this.cdr.detectChanges();
                    }, 20);
                }
            }, 50);
        });
    }

    prepareAndToggleFournisseur(field: 'adresse' | 'telephone'): void {
        if (field === 'adresse' && !this.editModeFournisseur.adresse) {
            this.tempAdresseFournisseur = this.getAdresseString(this.selectedFournisseur?.adresses) || '';
        }
        if (field === 'telephone' && !this.editModeFournisseur.telephone) {
            this.tempTelephoneFournisseur = this.getTelephoneString(this.selectedFournisseur?.telephones) || '';
        }
        this.toggleEditFournisseur(field);
    }

    saveAdresseFournisseur(): void {
        if (!this.selectedFournisseur || !this.tempAdresseFournisseur.trim()) return;

        const parts = this.tempAdresseFournisseur.split(',').map(p => p.trim());
        const adresseObj: Partial<Address> = {
            adresse: parts[0] || '',
            code_postal: parts[1] || '',
            region: parts[2] || '',
            pays: parts[3] || ''
        };

        if (!this.selectedFournisseur.adresses || this.selectedFournisseur.adresses.length === 0) {
            this.selectedFournisseur.adresses = [adresseObj as Address];
        } else {
            this.selectedFournisseur.adresses[0] = { ...this.selectedFournisseur.adresses[0], ...adresseObj };
        }

        this.modifiedFournisseurFields['adresse'] = true;
        this.saveModifiedFields();
    }

    updateResponsableFournisseur(event: any): void {
        if (this.selectedFournisseur) {
            (this.selectedFournisseur as any).responsable = event.target.value;
            this.modifiedFournisseurFields['responsable'] = true;
            this.saveModifiedFields();
        }
    }
    private saveModifiedFields(): void {
        const key = this.documentId 
            ? `modifiedFields_doc_${this.documentId}` 
            : `modifiedFields_temp_${this.selectedClientId || this.selectedFournisseurId || 'new'}`;
        
        const data = {
            clientFields: this.modifiedClientFields,
            fournisseurFields: this.modifiedFournisseurFields,
            documentId: this.documentId,
            timestamp: new Date().toISOString()
        };
        
        localStorage.setItem(key, JSON.stringify(data));
    }

    private loadModifiedFields(): void {
        // Valeurs par défaut (tous les champs affichés)
        const defaultClientFields = {
            nomClient: false,
            identifiant: false,
            numeroIdentification: false,
            adresse: false,
            email: false
        };
        
        const defaultFournisseurFields = {
            nomEntreprise: false,
            numeroIdentification: false,
            responsable: false,
            telephone: false,
            adresse: false
        };
        if (this.documentId) {
            const key = `modifiedFields_doc_${this.documentId}`;
            const saved = localStorage.getItem(key);
            
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }
                    
                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés:', e);
                }
            }
        }
        const clientId = this.selectedClientId || this.selectedClient?.id;
        const fournisseurId = this.selectedFournisseurId || this.selectedFournisseur?.id;
        
        if (clientId) {
            const key = `modifiedFields_temp_${clientId}`;
            const saved = localStorage.getItem(key);
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }

                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés (temp):', e);
                }
            }
        }
        
        if (fournisseurId) {
            const key = `modifiedFields_temp_${fournisseurId}`;
            const saved = localStorage.getItem(key);
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    if (Array.isArray(data.clientFields)) {
                        const clientFieldsObj: { [key: string]: boolean } = { ...defaultClientFields };
                        data.clientFields.forEach((field: string) => {
                            clientFieldsObj[field] = true;
                        });
                        this.modifiedClientFields = clientFieldsObj;
                    } else {
                        this.modifiedClientFields = { ...defaultClientFields, ...(data.clientFields || {}) };
                    }

                    if (Array.isArray(data.fournisseurFields)) {
                        const fournisseurFieldsObj: { [key: string]: boolean } = { ...defaultFournisseurFields };
                        data.fournisseurFields.forEach((field: string) => {
                            fournisseurFieldsObj[field] = true;
                        });
                        this.modifiedFournisseurFields = fournisseurFieldsObj;
                    } else {
                        this.modifiedFournisseurFields = { ...defaultFournisseurFields, ...(data.fournisseurFields || {}) };
                    }
                    return;
                } catch (e) {
                    console.error('Erreur lors du chargement des champs modifiés (temp):', e);
                }
            }
        }
        this.modifiedClientFields = { ...defaultClientFields };
        this.modifiedFournisseurFields = { ...defaultFournisseurFields };
    }

    isClientFieldModified(field: string): boolean {
        if (!this.modifiedClientFields || !(field in this.modifiedClientFields)) {
            return false;
        }
        return this.modifiedClientFields[field] === true;
    }

    isFournisseurFieldModified(field: string): boolean {
        if (!this.modifiedFournisseurFields || !(field in this.modifiedFournisseurFields)) {
            return false;
        }
        return this.modifiedFournisseurFields[field] === true;
    }

    toggleProductDescription(index: number): void {
        const item = this.items[index];
        if (!item || !item.product_id) {
            return;
        }

        this.showProductDescription[index] = !this.showProductDescription[index];
        if (this.showProductDescription[index] && (this.productDescriptions[index] === '' || this.productDescriptions[index] === undefined)) {
            this.loadProductDescription(index);
        } else {
            this.cdr.detectChanges();
        }
    }

    private loadProductDescription(index: number): void {
        const item = this.items[index];
        if (!item || !item.product_id) {
            return;
        }

        const product = this.products.find(p => p.id === item.product_id);
        if (product && product.description) {
            this.productDescriptions[index] = product.description || '';
            this.showProductDescription[index] = true;
            this.cdr.detectChanges();
            return;
        }

        this.productsService.getDetailsProduct(item.product_id).subscribe({
            next: (res: any) => {
                const productData = res.data || res;
                this.productDescriptions[index] = productData.description || '';
                this.showProductDescription[index] = true;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.productDescriptions[index] = '';
                this.showProductDescription[index] = true;
                this.cdr.detectChanges();
            }
        });
    }

    private normalizeWarehouseLabelForErp(s: string): string {
        return String(s ?? '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
    }

    private findErpEntrepotIdByLibelle(
        rows: Array<{ id?: number; libelle?: string; nom?: string }>,
        labelFromDocument: string
    ): number | null {
        const target = this.normalizeWarehouseLabelForErp(labelFromDocument);
        if (!target) {
            return null;
        }
        const row = rows.find((r) => {
            const l = r.libelle ?? r.nom ?? '';
            return this.normalizeWarehouseLabelForErp(l) === target;
        });
        const id = row?.id;
        return id != null && Number.isFinite(Number(id)) ? Number(id) : null;
    }

    private buildStockTransfertsPayloadForBonTransfert(
        entrepot_id_depart: number,
        entrepot_id_reception: number
    ): {
        user_id: number;
        station_id: number;
        date_transfert: string;
        entrepot_id_depart: number;
        entrepot_id_reception: number;
        origine: string;
        note: string;
        lignes: Array<{
            libelle_article: string;
            reference: string;
            allocations: Array<{ quantite: number; product_id: number; code_barre: string }>;
        }>;
    } | null {
        if (this.documentType !== 'BON TRANSFERT') {
            return null;
        }
        if (!Number.isFinite(entrepot_id_depart) || !Number.isFinite(entrepot_id_reception)) {
            return null;
        }
        const dateRaw = (this.documentDate || this.getTodayLocal()).trim();
        let d: Date;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateRaw)) {
            d = new Date(`${dateRaw}T12:00:00`);
        } else {
            d = new Date(dateRaw);
        }
        const date_transfert = !isNaN(d.getTime()) ? d.toISOString() : new Date().toISOString();

        const lignes: Array<{
            libelle_article: string;
            reference: string;
            allocations: Array<{ quantite: number; product_id: number; code_barre: string }>;
        }> = [];

        for (const it of this.items) {
            if (it.type !== 'product' || !it.designation?.trim() || it.product_id == null) {
                continue;
            }
            const q = Number(it.quantity);
            if (!Number.isFinite(q) || q <= 0) {
                continue;
            }
            const pid = Number(it.product_id);
            if (!Number.isFinite(pid) || pid <= 0) {
                continue;
            }
            const refLine =
                it.reference != null && String(it.reference).trim() !== ''
                    ? String(it.reference).trim()
                    : '-';
            const cb = String(it.code_barre ?? '').trim();
            lignes.push({
                libelle_article: it.designation.trim(),
                reference: refLine,
                allocations: [
                    {
                        quantite: q,
                        product_id: pid,
                        code_barre: cb
                    }
                ]
            });
        }

        if (lignes.length === 0) {
            return null;
        }

        return {
            user_id: 1,
            station_id: 1,
            date_transfert,
            entrepot_id_depart,
            entrepot_id_reception,
            origine: 'manuelle',
            note: (this.note ?? '').trim(),
            lignes
        };
    }

    private postStockTransfertsApiForBonTransfert(): Observable<unknown> {
        const depSel = this.selectedWarehouseInitialId;
        const recSel = this.selectedWarehouseDestinationId;
        if (depSel == null || recSel == null || Number.isNaN(Number(depSel)) || Number.isNaN(Number(recSel))) {
            return of(null);
        }
        const whDep = this.warehouses.find((w: any) => Number(w?.id) === Number(depSel));
        const whRec = this.warehouses.find((w: any) => Number(w?.id) === Number(recSel));
        const nomDep = String(whDep?.nom ?? '').trim();
        const nomRec = String(whRec?.nom ?? '').trim();
        if (!nomDep || !nomRec) {

            return of(null);
        }
        return this.warehouseService.getAllEntrepotsErpForStockTransfert().pipe(
            switchMap((rows) => {
                const idDep = this.findErpEntrepotIdByLibelle(rows, nomDep);
                const idRec = this.findErpEntrepotIdByLibelle(rows, nomRec);
                if (idDep == null || idRec == null) {

                    return of(null);
                }
                const payload = this.buildStockTransfertsPayloadForBonTransfert(idDep, idRec);
                if (!payload) {
                    return of(null);
                }
                return this.stockService.createStockTransfert(payload);
            })
        );
    }

    private readonly documentImportTvaLogPrefix = '[Document import XLSX · TVA]';

    private getDocumentProductImportOwnerUserId(): number {
        const raw = this.currentUser?.id ?? (this.currentUser as any)?.user_id;
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : 0;
    }

    private getDocumentProductImportStationId(): number {
        const fromComp = Number(this.stationId);
        if (Number.isFinite(fromComp) && fromComp > 0) {
            return fromComp;
        }
        const fromLs = Number(getStationIdFromLocalStorage());
        return Number.isFinite(fromLs) && fromLs > 0 ? fromLs : 0;
    }

    triggerDocumentProductImport(): void {
        const hasClient =
            (this.selectedClientId !== null && this.selectedClientId !== undefined) ||
            (this.selectedClient !== null && this.selectedClient !== undefined);
        const hasFournisseur =
            (this.selectedFournisseurId !== null && this.selectedFournisseurId !== undefined) ||
            (this.selectedFournisseur !== null && this.selectedFournisseur !== undefined);
        const isStockDocument = this.documentType === 'INVENTAIRE' || this.documentType === 'BON TRANSFERT';
        if (!hasClient && !hasFournisseur && !isStockDocument) {
            this.modalRef = this.modalService.open(this.warningModal, {
                ariaLabelledBy: 'modal-warning-title',
                centered: true,
                size: 'sm',
                windowClass: 'warning-modal-centered'
            });
            return;
        }
        const el = this.documentProductImportInput?.nativeElement;
        if (el) {
            el.value = '';
            el.click();
        }
    }

    onDocumentProductImportFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }
        if (file.size > 1024 * 1024) {
            this.toastr.error('Fichier trop volumineux (max 1 Mo)', 'Import');
            input.value = '';
            return;
        }
        if (!file.name.toLowerCase().endsWith('.xlsx')) {
            this.toastr.error('Seuls les fichiers .xlsx sont autorisés', 'Import');
            input.value = '';
            return;
        }
        const ownerId = this.getDocumentProductImportOwnerUserId();
        const stId = this.getDocumentProductImportStationId();
        if (!ownerId || !stId) {
            this.toastr.error('Utilisateur ou station non valide.', 'Import');
            input.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            const buf = e.target?.result;
            if (!(buf instanceof ArrayBuffer)) {
                this.zone.run(() => this.toastr.error('Lecture du fichier impossible.', 'Import'));
                return;
            }
            this.zone.run(() => this.runDocumentProductImportFromArrayBuffer(buf));
        };
        reader.onerror = () => {
            this.zone.run(() => this.toastr.error('Erreur de lecture du fichier', 'Import'));
        };
        reader.readAsArrayBuffer(file);
        input.value = '';
    }

    private runDocumentProductImportFromArrayBuffer(arrayBuffer: ArrayBuffer): void {
        const parsed = parseProductXlsxImportSheet(arrayBuffer);
        if ('error' in parsed && (parsed as { error: string }).error) {
            this.toastr.error(String((parsed as { error: string }).error), 'Import XLSX');
            return;
        }
        const pr = parsed as { headerMap: Record<string, number>; dataRows: any[][]; missingLabels: string[] };
        if (pr.missingLabels?.length > 0) {
            this.toastr.error(
                'Colonnes obligatoires manquantes : ' +
                    pr.missingLabels.join(', ') +
                    '. (nom, type, prix unitaire, ref_interne)',
                'Import XLSX'
            );
            return;
        }
        const { headerMap, dataRows } = pr;
        if (!dataRows?.length) {
            this.toastr.warning('Aucune ligne de données dans le fichier.', 'Import XLSX');
            return;
        }

        const stationIdNum = this.getDocumentProductImportStationId();
        const clientIdNum = this.getDocumentProductImportOwnerUserId();
        if (!stationIdNum || !clientIdNum) {
            this.toastr.error('Utilisateur ou station non valide.', 'Import');
            return;
        }

        forkJoin({
            tvaListe: this.tvaService.getTvaList(stationIdNum).pipe(
                map((r) => r?.tvaListe || []),
                catchError(() => of([] as Tva[]))
            ),
            taxes: this.taxeService.getTaxeList(stationIdNum).pipe(
                map((r: any) => r?.taxes || []),
                catchError(() => of([] as Taxe[]))
            ),
            categories: this.categorieService.getCategoriePerStation(stationIdNum).pipe(
                catchError(() => of([] as Categorie[]))
            ),
            marques: this.marqueService.getMarquePerStation(stationIdNum).pipe(
                catchError(() => of([] as Marque[]))
            ),
            unites: this.uniteService.getUnitePerStation(stationIdNum).pipe(
                catchError(() => of([] as Unite[]))
            )
        }).subscribe({
            next: async (refs) => {
                const tvaCache = [...refs.tvaListe];
                const taxeCache = [...refs.taxes];
                const catCache = [...refs.categories];
                const marqueCache = [...refs.marques];
                const uniteCache = [...refs.unites];

                const lineErrors: string[] = [];
                let successCount = 0;

                for (let i = 0; i < dataRows.length; i++) {
                    const row = dataRows[i];
                    const lineNo = i + 2;
                    try {
                        const cellStr = (key: string): string | null => {
                            return readImportCellTrimmed(row, headerMap, key);
                        };
                        const cellNum = (key: string): number | null => {
                            const s = cellStr(key);
                            if (s == null || s === '') {
                                return null;
                            }
                            const n = parseFloat(s.replace(',', '.'));
                            return isNaN(n) ? null : n;
                        };

                        const nom =
                            headerMap.nom >= 0 && row[headerMap.nom] != null
                                ? String(row[headerMap.nom]).trim()
                                : '';
                        const type =
                            headerMap.type >= 0 && row[headerMap.type] != null
                                ? String(row[headerMap.type]).trim().toLowerCase()
                                : 'matériel';
                        const prix_unitaire =
                            headerMap.prix >= 0 && row[headerMap.prix] != null
                                ? parseFloat(String(row[headerMap.prix]).replace(',', '.'))
                                : 0;
                        const ref_interne =
                            headerMap.ref_interne >= 0 && row[headerMap.ref_interne] != null
                                ? String(row[headerMap.ref_interne]).trim()
                                : '';
                        const description =
                            headerMap.description >= 0 && row[headerMap.description] != null
                                ? String(row[headerMap.description]).trim()
                                : null;

                        if (!nom) {
                            lineErrors.push(`Ligne ${lineNo} : le nom est obligatoire`);
                            continue;
                        }

                        const codeBarreImport = cellStr('code_barre');
                        if (this.isBarcodeEmptyOrZeroForSelect({ code_barre: codeBarreImport ?? '' })) {
                            continue;
                        }

                        const resultTtc = cellNum('result_ttc');
                        const resultHt = cellNum('result_ht');

                        const product: Record<string, any> = {
                            type,
                            nom,
                            station_id: stationIdNum,
                            client_id: clientIdNum,
                            ...(prix_unitaire > 0 && { prix_unitaires: prix_unitaire }),
                            ...(ref_interne && { ref_interne: ref_interne }),
                            ...(cellStr('ref_fabricant') && { ref_fabricant: cellStr('ref_fabricant') }),
                            ...(description && { description }),
                            ...(cellStr('code_barre') && { code_barre: cellStr('code_barre') }),
                            ...(cellStr('couleur') && { couleur: cellStr('couleur') }),
                            ...(cellStr('taille') && { taille: cellStr('taille') }),
                            ...(cellStr('rayon') && { rayon: cellStr('rayon') }),
                            ...(cellStr('famille') && { famille: cellStr('famille') }),
                            ...(cellStr('sous_famille') && { sous_famille: cellStr('sous_famille') }),
                            ...(resultTtc != null && { result_ttc: resultTtc }),
                            ...(resultHt != null && { result_ht: resultHt })
                        };

                        const tvaCell = readImportCellTrimmed(row, headerMap, 'tva');
                        if (tvaCell != null && tvaCell !== '') {
                            const idTva = await this.rxFirst(
                                this.resolveDocImportedProductTvaId(
                                    tvaCell,
                                    tvaCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                            const idNum = Number(idTva);
                            if (!Number.isFinite(idNum) || idNum <= 0) {
                                throw new Error(
                                    `TVA non résolue pour « ${tvaCell} » (vérifiez la valeur et l’API by-valeur).`
                                );
                            }
                            product.tva_id = idNum;
                        }

                        if (cellStr('taxe')) {
                            product.taxe_id = await this.rxFirst(
                                this.resolveOrCreateDocTaxeId(
                                    cellStr('taxe')!,
                                    taxeCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('categorie')) {
                            product.categories_id = await this.rxFirst(
                                this.resolveOrCreateDocCategorieId(
                                    cellStr('categorie')!,
                                    catCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('marque')) {
                            product.marque_id = await this.rxFirst(
                                this.resolveOrCreateDocMarqueId(
                                    cellStr('marque')!,
                                    marqueCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }
                        if (cellStr('unite')) {
                            product.unite_id = await this.rxFirst(
                                this.resolveOrCreateDocUniteId(
                                    cellStr('unite')!,
                                    uniteCache,
                                    stationIdNum,
                                    clientIdNum
                                )
                            );
                        }

                        for (let p = 1; p <= 12; p++) {
                            const pk = `param${p}`;
                            const pv = cellStr(pk);
                            if (pv) {
                                product[pk] = pv;
                            }
                        }

                        applyDocumentImportProductApiShape(product, clientIdNum, stationIdNum);

                        let catalog = this.findCatalogProductForDocImport(product);
                        if (!catalog) {
                            const body = this.stripDocProductImportMeta(product);
                            const addRes = await this.rxFirst(
                                this.productsService.addProduct(stationIdNum, body).pipe(
                                    catchError((err) => {
                                        throw new Error(this.extractDocImportErrorMessage(err));
                                    })
                                )
                            );
                            const newId = this.extractProductIdFromAddResponse(addRes);
                            if (newId == null) {
                                throw new Error('Création produit : id non reçu.');
                            }
                            const detailRes: any = await this.rxFirst(
                                this.productsService.getDetailsProduct(newId).pipe(
                                    catchError(() => of(null))
                                )
                            );
                            const rawPd = detailRes?.data ?? detailRes;
                            if (!rawPd || typeof rawPd !== 'object') {
                                throw new Error('Impossible de recharger le produit créé.');
                            }
                            catalog = this.mapLoadedApiProductToProduct(rawPd);
                            this.products.unshift(catalog);
                            this.invalidateBarcodePickerItemsCache();
                            this.rebuildProductsForDocumentSelect();
                        }

                        const qRaw = readImportCellTrimmed(row, headerMap, 'quantite');
                        let qty = 1;
                        if (qRaw != null && qRaw !== '') {
                            const n = parseFloat(String(qRaw).replace(',', '.'));
                            if (Number.isFinite(n) && n > 0) {
                                qty = n;
                            }
                        }

                        this.items.push(this.createEmptyProductLineItem());
                        const idx = this.items.length - 1;
                        this.applyProductSelectionToLine(idx, catalog, qty);
                        successCount++;
                    } catch (rowErr: any) {
                        lineErrors.push(`Ligne ${lineNo} : ${rowErr?.message || String(rowErr)}`);
                    }
                }

                this.syncBarcodePickerModelForVisibleProductLines();
                this.calculateTotals();
                this.updateTvaSummary();
                this.reloadStockQuantitiesForAllProducts();
                this.updateApproveButtonState();
                this.applyVenteAchatProductDescriptionDefaults();
                this.cdr.detectChanges();
                this.refreshFeatherIcons();

                if (successCount === 0) {
                    const msg =
                        lineErrors.length > 5
                            ? lineErrors.slice(0, 5).join(' ; ') + ` … (+${lineErrors.length - 5})`
                            : lineErrors.join(' ; ');
                    this.toastr.error(msg || 'Aucune ligne importée.', 'Import XLSX');
                } else if (lineErrors.length > 0) {
                    this.toastr.warning(
                        `${successCount} ligne(s) ajoutée(s). ${lineErrors.length} erreur(s).`,
                        'Import XLSX',
                        { timeOut: 10000 }
                    );
                } else {
                    this.toastr.success(
                        `${successCount} ligne(s) produit ajoutée(s) depuis le fichier.`,
                        'Import XLSX'
                    );
                }
            },
            error: () => {
                this.toastr.error(
                    'Impossible de charger les référentiels (TVA, taxes, catégories, marques, unités).',
                    'Import XLSX'
                );
            }
        });
    }

    private rxFirst<T>(source: Observable<T>): Promise<T> {
        return source.pipe(take(1)).toPromise() as Promise<T>;
    }

    private stripDocProductImportMeta(p: Record<string, any>): Record<string, any> {
        const { __importLine, ...rest } = p;
        return rest;
    }

    private extractDocImportErrorMessage(err: any): string {
        if (err?.error?.errors && Array.isArray(err.error.errors)) {
            return err.error.errors.map((e: any) => e.message || e).join(', ');
        }
        if (err?.error?.message) {
            return String(err.error.message);
        }
        return err?.message ? String(err.message) : 'Erreur API produit';
    }

    private extractProductIdFromAddResponse(res: any): number | null {
        const raw = res?.data?.id ?? res?.data?.product?.id ?? res?.id;
        if (raw == null || raw === '') {
            return null;
        }
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : null;
    }

    private mapLoadedApiProductToProduct(apiProduct: any): Product {
        const prixUnitairesBrut = apiProduct.prix_unitaires;
        const valeurUnitaireBrut = apiProduct.valeur_unitaire;
        const prixUnitairesParse = parseFloat(prixUnitairesBrut) || 0;
        const valeurUnitaireParse = parseFloat(valeurUnitaireBrut) || 0;
        return {
            ...apiProduct,
            prix_unitaires: prixUnitairesParse,
            valeur_unitaire: valeurUnitaireParse,
            liste_prix: apiProduct.liste_prix?.length > 0 ? apiProduct.liste_prix[0] : null,
            informations_logistique: apiProduct.informations_logistique || []
        } as Product;
    }

    private findCatalogProductForDocImport(payload: Record<string, any>): Product | undefined {
        const ref = payload.ref_interne != null ? String(payload.ref_interne).trim() : '';
        const cbRaw = payload.code_barre != null ? String(payload.code_barre).trim() : '';
        const cb = cbRaw.replace(/\s/g, '');
        if (ref) {
            const byRef = this.products.find(
                (p) => p.ref_interne != null && String(p.ref_interne).trim() === ref
            );
            if (byRef) {
                return byRef;
            }
        }
        if (cb && cb !== '0') {
            const byCb = this.products.find((p) => {
                const c = p.code_barre != null ? String(p.code_barre).replace(/\s/g, '').trim() : '';
                return c === cb;
            });
            if (byCb) {
                return byCb;
            }
        }
        return undefined;
    }

    private docImportLabelEquals(a: string, b: string): boolean {
        return normalizeImportHeaderLabel(a) === normalizeImportHeaderLabel(b);
    }

    private tvaListeEntryMatchesCellDoc(t: Tva, parsedFile: number | null, rawTrimmed: string): boolean {
        const apiNum = Number(t.valeur);
        if (parsedFile !== null && !isNaN(apiNum)) {
            return Math.abs(apiNum - parsedFile) < 1e-4;
        }
        const norm = (v: unknown) =>
            String(v ?? '')
                .trim()
                .replace(/%/g, '')
                .replace(/\s/g, '')
                .replace(',', '.');
        return norm(t.valeur) === norm(rawTrimmed);
    }

    private extractTvaIdFromByValeurResponseDoc(res: any): number | null {
        if (res == null || typeof res === 'string') {
            return null;
        }

        const toId = (v: unknown): number | null => {
            if (v == null || v === '') {
                return null;
            }
            const n = Number(v);
            return Number.isFinite(n) && n > 0 ? n : null;
        };

        const envelope =
            res?.data != null && typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : res;
        if (envelope?.success === true && Array.isArray(envelope.tvaListe) && envelope.tvaListe.length > 0) {
            const first = envelope.tvaListe[0];
            const rid = toId(first?.id);
            if (rid != null) {
                return rid;
            }
        }

        const fromObj = (o: any): number | null => {
            if (!o || typeof o !== 'object') {
                return null;
            }
            return toId(o.id) ?? toId(o.tva_id) ?? toId((o as any).ID) ?? null;
        };

        let id = fromObj(res);
        if (id != null) {
            return id;
        }

        id =
            fromObj(res.tva) ??
            fromObj(res.data) ??
            fromObj(res.result) ??
            fromObj(res.payload) ??
            fromObj(res.record);
        if (id != null) {
            return id;
        }

        if (typeof res.tva_id === 'number' || (typeof res.tva_id === 'string' && res.tva_id !== '')) {
            return toId(res.tva_id);
        }

        if (Array.isArray(res)) {
            id = fromObj(res[0]);
            if (id != null) {
                return id;
            }
        }

        const liste = res.tvaListe ?? res.tvas ?? res.data?.tvaListe;
        if (Array.isArray(liste) && liste.length > 0) {
            id = fromObj(liste[0]);
            if (id != null) {
                return id;
            }
        }

        if (res.id != null && (res.valeur !== undefined || res.type !== undefined || res.statut !== undefined)) {
            return toId(res.id);
        }

        const attrId = res?.data?.attributes?.id ?? res?.data?.id ?? res?.attributes?.id;
        if (attrId != null) {
            return toId(attrId);
        }

        return null;
    }

    private getTvaIdFromByValeurApiDoc(stationId: number, valeurNumeric: number): Observable<number | null> {
        return this.tvaService.getTvaByValeur(stationId, valeurNumeric).pipe(
            map((res) => this.extractTvaIdFromByValeurResponseDoc(res)),
            catchError(() => of(null as number | null))
        );
    }

    private resolveDocImportedProductTvaId(
        raw: string,
        cache: Tva[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const trimmed = raw.trim();
        const parsedFile = parseTvaImportValue(trimmed);

        const lookupFromByValeur$ =
            parsedFile !== null
                ? this.getTvaIdFromByValeurApiDoc(stationId, parsedFile)
                : of(null as number | null);

        return lookupFromByValeur$.pipe(
            switchMap((idFromApi) => {
                const idNum = idFromApi != null ? Number(idFromApi) : NaN;
                if (Number.isFinite(idNum) && idNum > 0) {
                    return of(idNum);
                }
                const byListe = cache.find((t) =>
                    this.tvaListeEntryMatchesCellDoc(t, parsedFile, trimmed)
                );
                if (byListe?.id != null) {
                    return of(Number(byListe.id));
                }
                const valeur = parsedFile !== null ? parsedFile : 0;
                const body: Tva = {
                    client_id: clientId,
                    station_id: stationId,
                    valeur,
                    type: '+',
                    restriction: 'Pourcentage',
                    statut: true
                };
                return this.tvaService.createTva(body, stationId).pipe(
                    map((res) => {
                        const t = res?.tva;
                        if (t?.id != null) {
                            cache.push(t);
                            return Number(t.id);
                        }
                        throw new Error('Réponse TVA invalide');
                    })
                );
            })
        );
    }

    private resolveOrCreateDocTaxeId(
        raw: string,
        cache: Taxe[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const t = raw.trim();
        const found = cache.find(
            (x) =>
                (x.nom && this.docImportLabelEquals(x.nom, t)) ||
                (x.label && this.docImportLabelEquals(x.label, t))
        );
        if (found?.id) {
            return of(found.id);
        }
        const newTaxe: Taxe = {
            id: 0,
            client_id: clientId,
            station_id: stationId,
            nom: t,
            label: t,
            valeur: 0,
            valeur_fixe: false,
            valeur_pourcentage: true,
            applique_avant_tva: false,
            applique_apres_tva: true,
            taxe_applique_sur_produits: true,
            type: '+',
            applique_sur_product: true,
            applique_sur_tous_document: false,
            statut: true
        };
        return this.taxeService.createTaxe(newTaxe, stationId).pipe(
            map((res) => {
                const tx = res?.taxe;
                if (tx?.id) {
                    cache.push(tx);
                    return tx.id;
                }
                throw new Error('Réponse taxe invalide');
            })
        );
    }

    private resolveOrCreateDocCategorieId(
        raw: string,
        cache: Categorie[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((c) => c.libelle && this.docImportLabelEquals(c.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const cat: Categorie = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.categorieService.addCategorie(cat).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateDocMarqueId(
        raw: string,
        cache: Marque[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((m) => m.libelle && this.docImportLabelEquals(m.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const marque: Marque = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.marqueService.addMarque(marque).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateDocUniteId(
        raw: string,
        cache: Unite[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((u) => u.libelle && this.docImportLabelEquals(u.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const unite: Unite = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.uniteService.addUnite(unite).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    openEmailModal(): void {
        if (this.emailComposeComponent) {
            this.emailComposeComponent.openModal();
        }
    }

    getFormattedTotal(): string {
        const total = this.totals.netAPayer || this.totals.totalTTC || 0;
        return `${total.toFixed(3)} TND`;
    }
}
